/**
 * @license
 * Video.js 7.12.1 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */
! function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self).videojs = t()
}(this, function () {
  "use strict";
  var d = "7.12.1",
    e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function t(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e
  }

  function i(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports
  }
  for (var n, h = "undefined" != typeof window ? window : "undefined" != typeof e ? e : "undefined" != typeof self ? self : {}, r = {}, a = "undefined" != typeof e ? e : "undefined" != typeof window ? window : {}, p = "undefined" != typeof document ? document : a["__GLOBAL_DOCUMENT_CACHE@4"] || (a["__GLOBAL_DOCUMENT_CACHE@4"] = r), f = {
      prefixed: !0
    }, s = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror", "-moz-full-screen"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError", "-ms-fullscreen"]
    ], o = s[0], u = 0; u < s.length; u++)
    if (s[u][1] in p) {
      n = s[u];
      break
    } if (n) {
    for (var l = 0; l < n.length; l++) f[o[l]] = n[l];
    f.prefixed = n[0] !== o[0]
  }
  var c = [],
    m = function (o, u) {
      return function (e, t, i) {
        var n = u.levels[t],
          r = new RegExp("^(" + n + ")$");
        if ("log" !== e && i.unshift(e.toUpperCase() + ":"), i.unshift(o + ":"), c) {
          c.push([].concat(i));
          var a = c.length - 1e3;
          c.splice(0, 0 < a ? a : 0)
        }
        if (h.console) {
          var s = h.console[e];
          s || "debug" !== e || (s = h.console.info || h.console.log), s && n && r.test(e) && s[Array.isArray(i) ? "apply" : "call"](h.console, i)
        }
      }
    };
  var g = function t(i) {
      function n() {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        r("log", a, t)
      }
      var r, a = "info";
      return r = m(i, n), n.createLogger = function (e) {
        return t(i + ": " + e)
      }, n.levels = {
        all: "debug|log|warn|error",
        off: "",
        debug: "debug|log|warn|error",
        info: "log|warn|error",
        warn: "warn|error",
        error: "error",
        DEFAULT: a
      }, n.level = function (e) {
        if ("string" == typeof e) {
          if (!n.levels.hasOwnProperty(e)) throw new Error('"' + e + '" in not a valid log level');
          a = e
        }
        return a
      }, (n.history = function () {
        return c ? [].concat(c) : []
      }).filter = function (t) {
        return (c || []).filter(function (e) {
          return new RegExp(".*" + t + ".*").test(e[0])
        })
      }, n.history.clear = function () {
        c && (c.length = 0)
      }, n.history.disable = function () {
        null !== c && (c.length = 0, c = null)
      }, n.history.enable = function () {
        null === c && (c = [])
      }, n.error = function () {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        return r("error", a, t)
      }, n.warn = function () {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        return r("warn", a, t)
      }, n.debug = function () {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        return r("debug", a, t)
      }, n
    }("VIDEOJS"),
    v = g.createLogger,
    y = i(function (e) {
      function t() {
        return e.exports = t = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = arguments[t];
            for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n])
          }
          return e
        }, t.apply(this, arguments)
      }
      e.exports = t
    }),
    _ = Object.prototype.toString,
    b = function (e) {
      return E(e) ? Object.keys(e) : []
    };

  function T(t, i) {
    b(t).forEach(function (e) {
      return i(t[e], e)
    })
  }

  function S(i) {
    for (var e = arguments.length, t = new Array(1 < e ? e - 1 : 0), n = 1; n < e; n++) t[n - 1] = arguments[n];
    return Object.assign ? y.apply(void 0, [i].concat(t)) : (t.forEach(function (e) {
      e && T(e, function (e, t) {
        i[t] = e
      })
    }), i)
  }

  function E(e) {
    return !!e && "object" == typeof e
  }

  function k(e) {
    return E(e) && "[object Object]" === _.call(e) && e.constructor === Object
  }

  function w(e, t) {
    if (!e || !t) return "";
    if ("function" != typeof h.getComputedStyle) return "";
    var i = h.getComputedStyle(e);
    return i ? i.getPropertyValue(t) || i[t] : ""
  }
  var C, I, x, A, P = h.navigator && h.navigator.userAgent || "",
    L = /AppleWebKit\/([\d.]+)/i.exec(P),
    O = L ? parseFloat(L.pop()) : null,
    D = /iPod/i.test(P),
    R = (C = P.match(/OS (\d+)_/i)) && C[1] ? C[1] : null,
    M = /Android/i.test(P),
    N = function () {
      var e = P.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
      if (!e) return null;
      var t = e[1] && parseFloat(e[1]),
        i = e[2] && parseFloat(e[2]);
      return t && i ? parseFloat(e[1] + "." + e[2]) : t || null
    }(),
    U = M && N < 5 && O < 537,
    B = /Firefox/i.test(P),
    F = /Edg/i.test(P),
    j = !F && (/Chrome/i.test(P) || /CriOS/i.test(P)),
    H = (I = P.match(/(Chrome|CriOS)\/(\d+)/)) && I[2] ? parseFloat(I[2]) : null,
    V = (x = /MSIE\s(\d+)\.\d/.exec(P), !(A = x && parseFloat(x[1])) && /Trident\/7.0/i.test(P) && /rv:11.0/.test(P) && (A = 11), A),
    q = /Safari/i.test(P) && !j && !M && !F,
    W = /Windows/i.test(P),
    z = Boolean(Z() && ("ontouchstart" in h || h.navigator.maxTouchPoints || h.DocumentTouch && h.document instanceof h.DocumentTouch)),
    G = /iPad/i.test(P) || q && z && !/iPhone/i.test(P),
    X = /iPhone/i.test(P) && !G,
    K = X || G || D,
    Y = (q || K) && !j,
    Q = Object.freeze({
      __proto__: null,
      IS_IPOD: D,
      IOS_VERSION: R,
      IS_ANDROID: M,
      ANDROID_VERSION: N,
      IS_NATIVE_ANDROID: U,
      IS_FIREFOX: B,
      IS_EDGE: F,
      IS_CHROME: j,
      CHROME_VERSION: H,
      IE_VERSION: V,
      IS_SAFARI: q,
      IS_WINDOWS: W,
      TOUCH_ENABLED: z,
      IS_IPAD: G,
      IS_IPHONE: X,
      IS_IOS: K,
      IS_ANY_SAFARI: Y
    });

  function $(e) {
    return "string" == typeof e && Boolean(e.trim())
  }

  function J(e) {
    if (0 <= e.indexOf(" ")) throw new Error("class has illegal whitespace characters")
  }

  function Z() {
    return p === h.document
  }

  function ee(e) {
    return E(e) && 1 === e.nodeType
  }

  function te() {
    try {
      return h.parent !== h.self
    } catch (e) {
      return !0
    }
  }

  function ie(n) {
    return function (e, t) {
      if (!$(e)) return p[n](null);
      $(t) && (t = p.querySelector(t));
      var i = ee(t) ? t : p;
      return i[n] && i[n](e)
    }
  }

  function ne(e, i, t, n) {
    void 0 === e && (e = "div"), void 0 === i && (i = {}), void 0 === t && (t = {});
    var r = p.createElement(e);
    return Object.getOwnPropertyNames(i).forEach(function (e) {
      var t = i[e]; - 1 !== e.indexOf("aria-") || "role" === e || "type" === e ? (g.warn("Setting attributes in the second argument of createEl()\nhas been deprecated. Use the third argument instead.\ncreateEl(type, properties, attributes). Attempting to set " + e + " to " + t + "."), r.setAttribute(e, t)) : "textContent" === e ? re(r, t) : r[e] === t && "tabIndex" !== e || (r[e] = t)
    }), Object.getOwnPropertyNames(t).forEach(function (e) {
      r.setAttribute(e, t[e])
    }), n && Ee(r, n), r
  }

  function re(e, t) {
    return "undefined" == typeof e.textContent ? e.innerText = t : e.textContent = t, e
  }

  function ae(e, t) {
    t.firstChild ? t.insertBefore(e, t.firstChild) : t.appendChild(e)
  }

  function se(e, t) {
    return J(t), e.classList ? e.classList.contains(t) : function (e) {
      return new RegExp("(^|\\s)" + e + "($|\\s)")
    }(t).test(e.className)
  }

  function oe(e, t) {
    return e.classList ? e.classList.add(t) : se(e, t) || (e.className = (e.className + " " + t).trim()), e
  }

  function ue(e, t) {
    return e.classList ? e.classList.remove(t) : (J(t), e.className = e.className.split(/\s+/).filter(function (e) {
      return e !== t
    }).join(" ")), e
  }

  function le(e, t, i) {
    var n = se(e, t);
    if ("function" == typeof i && (i = i(e, t)), "boolean" != typeof i && (i = !n), i !== n) return i ? oe(e, t) : ue(e, t), e
  }

  function ce(i, n) {
    Object.getOwnPropertyNames(n).forEach(function (e) {
      var t = n[e];
      null === t || "undefined" == typeof t || !1 === t ? i.removeAttribute(e) : i.setAttribute(e, !0 === t ? "" : t)
    })
  }

  function de(e) {
    var t = {},
      i = ",autoplay,controls,playsinline,loop,muted,default,defaultMuted,";
    if (e && e.attributes && 0 < e.attributes.length)
      for (var n = e.attributes, r = n.length - 1; 0 <= r; r--) {
        var a = n[r].name,
          s = n[r].value;
        "boolean" != typeof e[a] && -1 === i.indexOf("," + a + ",") || (s = null !== s), t[a] = s
      }
    return t
  }

  function he(e, t) {
    return e.getAttribute(t)
  }

  function pe(e, t, i) {
    e.setAttribute(t, i)
  }

  function fe(e, t) {
    e.removeAttribute(t)
  }

  function me() {
    p.body.focus(), p.onselectstart = function () {
      return !1
    }
  }

  function ge() {
    p.onselectstart = function () {
      return !0
    }
  }

  function ve(e) {
    if (e && e.getBoundingClientRect && e.parentNode) {
      var t = e.getBoundingClientRect(),
        i = {};
      return ["bottom", "height", "left", "right", "top", "width"].forEach(function (e) {
        void 0 !== t[e] && (i[e] = t[e])
      }), i.height || (i.height = parseFloat(w(e, "height"))), i.width || (i.width = parseFloat(w(e, "width"))), i
    }
  }

  function ye(e) {
    if (!e || e && !e.offsetParent) return {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
    for (var t = e.offsetWidth, i = e.offsetHeight, n = 0, r = 0; e.offsetParent && e !== p[f.fullscreenElement];) n += e.offsetLeft, r += e.offsetTop, e = e.offsetParent;
    return {
      left: n,
      top: r,
      width: t,
      height: i
    }
  }

  function _e(e, t) {
    var i = {
      x: 0,
      y: 0
    };
    if (K)
      for (var n = e; n && "html" !== n.nodeName.toLowerCase();) {
        var r = w(n, "transform");
        if (/^matrix/.test(r)) {
          var a = r.slice(7, -1).split(/,\s/).map(Number);
          i.x += a[4], i.y += a[5]
        } else if (/^matrix3d/.test(r)) {
          var s = r.slice(9, -1).split(/,\s/).map(Number);
          i.x += s[12], i.y += s[13]
        }
        n = n.parentNode
      }
    var o = {},
      u = ye(t.target),
      l = ye(e),
      c = l.width,
      d = l.height,
      h = t.offsetY - (l.top - u.top),
      p = t.offsetX - (l.left - u.left);
    return t.changedTouches && (p = t.changedTouches[0].pageX - l.left, h = t.changedTouches[0].pageY + l.top, K && (p -= i.x, h -= i.y)), o.y = 1 - Math.max(0, Math.min(1, h / d)), o.x = Math.max(0, Math.min(1, p / c)), o
  }

  function be(e) {
    return E(e) && 3 === e.nodeType
  }

  function Te(e) {
    for (; e.firstChild;) e.removeChild(e.firstChild);
    return e
  }

  function Se(e) {
    return "function" == typeof e && (e = e()), (Array.isArray(e) ? e : [e]).map(function (e) {
      return "function" == typeof e && (e = e()), ee(e) || be(e) ? e : "string" == typeof e && /\S/.test(e) ? p.createTextNode(e) : void 0
    }).filter(function (e) {
      return e
    })
  }

  function Ee(t, e) {
    return Se(e).forEach(function (e) {
      return t.appendChild(e)
    }), t
  }

  function ke(e, t) {
    return Ee(Te(e), t)
  }

  function we(e) {
    return void 0 === e.button && void 0 === e.buttons || (0 === e.button && void 0 === e.buttons || ("mouseup" === e.type && 0 === e.button && 0 === e.buttons || 0 === e.button && 1 === e.buttons))
  }
  var Ce, Ie = ie("querySelector"),
    xe = ie("querySelectorAll"),
    Ae = Object.freeze({
      __proto__: null,
      isReal: Z,
      isEl: ee,
      isInFrame: te,
      createEl: ne,
      textContent: re,
      prependTo: ae,
      hasClass: se,
      addClass: oe,
      removeClass: ue,
      toggleClass: le,
      setAttributes: ce,
      getAttributes: de,
      getAttribute: he,
      setAttribute: pe,
      removeAttribute: fe,
      blockTextSelection: me,
      unblockTextSelection: ge,
      getBoundingClientRect: ve,
      findPosition: ye,
      getPointerPosition: _e,
      isTextNode: be,
      emptyEl: Te,
      normalizeContent: Se,
      appendContent: Ee,
      insertContent: ke,
      isSingleLeftClick: we,
      $: Ie,
      $$: xe
    }),
    Pe = !1,
    Le = function () {
      if (Z() && !1 !== Ce.options.autoSetup) {
        var e = Array.prototype.slice.call(p.getElementsByTagName("video")),
          t = Array.prototype.slice.call(p.getElementsByTagName("audio")),
          i = Array.prototype.slice.call(p.getElementsByTagName("video-js")),
          n = e.concat(t, i);
        if (n && 0 < n.length)
          for (var r = 0, a = n.length; r < a; r++) {
            var s = n[r];
            if (!s || !s.getAttribute) {
              Oe(1);
              break
            }
            void 0 === s.player && null !== s.getAttribute("data-setup") && Ce(s)
          } else Pe || Oe(1)
      }
    };

  function Oe(e, t) {
    t && (Ce = t), h.setTimeout(Le, e)
  }

  function De() {
    Pe = !0, h.removeEventListener("load", De)
  }
  Z() && ("complete" === p.readyState ? De() : h.addEventListener("load", De));

  function Re(e) {
    var t = p.createElement("style");
    return t.className = e, t
  }

  function Me(e, t) {
    e.styleSheet ? e.styleSheet.cssText = t : e.textContent = t
  }
  var Ne, Ue = 3;

  function Be() {
    return Ue++
  }
  h.WeakMap || (Ne = function () {
    function e() {
      this.vdata = "vdata" + Math.floor(h.performance && h.performance.now() || Date.now()), this.data = {}
    }
    var t = e.prototype;
    return t.set = function (e, t) {
      var i = e[this.vdata] || Be();
      return e[this.vdata] || (e[this.vdata] = i), this.data[i] = t, this
    }, t.get = function (e) {
      var t = e[this.vdata];
      if (t) return this.data[t];
      g("We have no data for this element", e)
    }, t.has = function (e) {
      return e[this.vdata] in this.data
    }, t.delete = function (e) {
      var t = e[this.vdata];
      t && (delete this.data[t], delete e[this.vdata])
    }, e
  }());
  var Fe, je = h.WeakMap ? new WeakMap : new Ne;

  function He(e, t) {
    if (je.has(e)) {
      var i = je.get(e);
      0 === i.handlers[t].length && (delete i.handlers[t], e.removeEventListener ? e.removeEventListener(t, i.dispatcher, !1) : e.detachEvent && e.detachEvent("on" + t, i.dispatcher)), Object.getOwnPropertyNames(i.handlers).length <= 0 && (delete i.handlers, delete i.dispatcher, delete i.disabled), 0 === Object.getOwnPropertyNames(i).length && je.delete(e)
    }
  }

  function Ve(t, i, e, n) {
    e.forEach(function (e) {
      t(i, e, n)
    })
  }

  function qe(e) {
    if (e.fixed_) return e;

    function t() {
      return !0
    }

    function i() {
      return !1
    }
    if (!e || !e.isPropagationStopped) {
      var n = e || h.event;
      for (var r in e = {}, n) "layerX" !== r && "layerY" !== r && "keyLocation" !== r && "webkitMovementX" !== r && "webkitMovementY" !== r && ("returnValue" === r && n.preventDefault || (e[r] = n[r]));
      if (e.target || (e.target = e.srcElement || p), e.relatedTarget || (e.relatedTarget = e.fromElement === e.target ? e.toElement : e.fromElement), e.preventDefault = function () {
          n.preventDefault && n.preventDefault(), e.returnValue = !1, n.returnValue = !1, e.defaultPrevented = !0
        }, e.defaultPrevented = !1, e.stopPropagation = function () {
          n.stopPropagation && n.stopPropagation(), e.cancelBubble = !0, n.cancelBubble = !0, e.isPropagationStopped = t
        }, e.isPropagationStopped = i, e.stopImmediatePropagation = function () {
          n.stopImmediatePropagation && n.stopImmediatePropagation(), e.isImmediatePropagationStopped = t, e.stopPropagation()
        }, e.isImmediatePropagationStopped = i, null !== e.clientX && void 0 !== e.clientX) {
        var a = p.documentElement,
          s = p.body;
        e.pageX = e.clientX + (a && a.scrollLeft || s && s.scrollLeft || 0) - (a && a.clientLeft || s && s.clientLeft || 0), e.pageY = e.clientY + (a && a.scrollTop || s && s.scrollTop || 0) - (a && a.clientTop || s && s.clientTop || 0)
      }
      e.which = e.charCode || e.keyCode, null !== e.button && void 0 !== e.button && (e.button = 1 & e.button ? 0 : 4 & e.button ? 1 : 2 & e.button ? 2 : 0)
    }
    return e.fixed_ = !0, e
  }
  var We = function () {
      if ("boolean" != typeof Fe) {
        Fe = !1;
        try {
          var e = Object.defineProperty({}, "passive", {
            get: function () {
              Fe = !0
            }
          });
          h.addEventListener("test", null, e), h.removeEventListener("test", null, e)
        } catch (e) {}
      }
      return Fe
    },
    ze = ["touchstart", "touchmove"];

  function Ge(s, e, t) {
    if (Array.isArray(e)) return Ve(Ge, s, e, t);
    je.has(s) || je.set(s, {});
    var o = je.get(s);
    if (o.handlers || (o.handlers = {}), o.handlers[e] || (o.handlers[e] = []), t.guid || (t.guid = Be()), o.handlers[e].push(t), o.dispatcher || (o.disabled = !1, o.dispatcher = function (e, t) {
        if (!o.disabled) {
          e = qe(e);
          var i = o.handlers[e.type];
          if (i)
            for (var n = i.slice(0), r = 0, a = n.length; r < a && !e.isImmediatePropagationStopped(); r++) try {
              n[r].call(s, e, t)
            } catch (e) {
              g.error(e)
            }
        }
      }), 1 === o.handlers[e].length)
      if (s.addEventListener) {
        var i = !1;
        We() && -1 < ze.indexOf(e) && (i = {
          passive: !0
        }), s.addEventListener(e, o.dispatcher, i)
      } else s.attachEvent && s.attachEvent("on" + e, o.dispatcher)
  }

  function Xe(e, t, i) {
    if (je.has(e)) {
      var n = je.get(e);
      if (n.handlers) {
        if (Array.isArray(t)) return Ve(Xe, e, t, i);
        var r = function (e, t) {
          n.handlers[t] = [], He(e, t)
        };
        if (void 0 !== t) {
          var a = n.handlers[t];
          if (a)
            if (i) {
              if (i.guid)
                for (var s = 0; s < a.length; s++) a[s].guid === i.guid && a.splice(s--, 1);
              He(e, t)
            } else r(e, t)
        } else
          for (var o in n.handlers) Object.prototype.hasOwnProperty.call(n.handlers || {}, o) && r(e, o)
      }
    }
  }

  function Ke(e, t, i) {
    var n = je.has(e) ? je.get(e) : {},
      r = e.parentNode || e.ownerDocument;
    if ("string" == typeof t ? t = {
        type: t,
        target: e
      } : t.target || (t.target = e), t = qe(t), n.dispatcher && n.dispatcher.call(e, t, i), r && !t.isPropagationStopped() && !0 === t.bubbles) Ke.call(null, r, t, i);
    else if (!r && !t.defaultPrevented && t.target && t.target[t.type]) {
      je.has(t.target) || je.set(t.target, {});
      var a = je.get(t.target);
      t.target[t.type] && (a.disabled = !0, "function" == typeof t.target[t.type] && t.target[t.type](), a.disabled = !1)
    }
    return !t.defaultPrevented
  }

  function Ye(e, t, i) {
    if (Array.isArray(t)) return Ve(Ye, e, t, i);

    function n() {
      Xe(e, t, n), i.apply(this, arguments)
    }
    n.guid = i.guid = i.guid || Be(), Ge(e, t, n)
  }

  function Qe(e, t, i) {
    function n() {
      Xe(e, t, n), i.apply(this, arguments)
    }
    n.guid = i.guid = i.guid || Be(), Ge(e, t, n)
  }

  function $e(e, t, i) {
    t.guid || (t.guid = Be());
    var n = t.bind(e);
    return n.guid = i ? i + "_" + t.guid : t.guid, n
  }

  function Je(t, i) {
    var n = h.performance.now();
    return function () {
      var e = h.performance.now();
      i <= e - n && (t.apply(void 0, arguments), n = e)
    }
  }

  function Ze() {}
  var et, tt = Object.freeze({
    __proto__: null,
    fixEvent: qe,
    on: Ge,
    off: Xe,
    trigger: Ke,
    one: Ye,
    any: Qe
  });
  Ze.prototype.allowedEvents_ = {}, Ze.prototype.addEventListener = Ze.prototype.on = function (e, t) {
    var i = this.addEventListener;
    this.addEventListener = function () {}, Ge(this, e, t), this.addEventListener = i
  }, Ze.prototype.removeEventListener = Ze.prototype.off = function (e, t) {
    Xe(this, e, t)
  }, Ze.prototype.one = function (e, t) {
    var i = this.addEventListener;
    this.addEventListener = function () {}, Ye(this, e, t), this.addEventListener = i
  }, Ze.prototype.any = function (e, t) {
    var i = this.addEventListener;
    this.addEventListener = function () {}, Qe(this, e, t), this.addEventListener = i
  }, Ze.prototype.dispatchEvent = Ze.prototype.trigger = function (e) {
    var t = e.type || e;
    "string" == typeof e && (e = {
      type: t
    }), e = qe(e), this.allowedEvents_[t] && this["on" + t] && this["on" + t](e), Ke(this, e)
  }, Ze.prototype.queueTrigger = function (e) {
    var t = this;
    et = et || new Map;
    var i = e.type || e,
      n = et.get(this);
    n || (n = new Map, et.set(this, n));
    var r = n.get(i);
    n.delete(i), h.clearTimeout(r);
    var a = h.setTimeout(function () {
      0 === n.size && (n = null, et.delete(t)), t.trigger(e)
    }, 0);
    n.set(i, a)
  };

  function it(e) {
    return "function" == typeof e.name ? e.name() : "string" == typeof e.name ? e.name : e.name_ ? e.name_ : e.constructor && e.constructor.name ? e.constructor.name : typeof e
  }

  function nt(e) {
    return "string" == typeof e && /\S/.test(e) || Array.isArray(e) && !!e.length
  }

  function rt(e, t, i) {
    if (!e || !e.nodeName && !lt(e)) throw new Error("Invalid target for " + it(t) + "#" + i + "; must be a DOM node or evented object.")
  }

  function at(e, t, i) {
    if (!nt(e)) throw new Error("Invalid event type for " + it(t) + "#" + i + "; must be a non-empty string or array.")
  }

  function st(e, t, i) {
    if ("function" != typeof e) throw new Error("Invalid listener for " + it(t) + "#" + i + "; must be a function.")
  }

  function ot(e, t, i) {
    var n, r, a, s = t.length < 3 || t[0] === e || t[0] === e.eventBusEl_;
    return a = s ? (n = e.eventBusEl_, 3 <= t.length && t.shift(), r = t[0], t[1]) : (n = t[0], r = t[1], t[2]), rt(n, e, i), at(r, e, i), st(a, e, i), {
      isTargetingSelf: s,
      target: n,
      type: r,
      listener: a = $e(e, a)
    }
  }

  function ut(e, t, i, n) {
    rt(e, e, t), e.nodeName ? tt[t](e, i, n) : e[t](i, n)
  }
  var lt = function (t) {
      return t instanceof Ze || !!t.eventBusEl_ && ["on", "one", "off", "trigger"].every(function (e) {
        return "function" == typeof t[e]
      })
    },
    ct = {
      on: function () {
        for (var e = this, t = arguments.length, i = new Array(t), n = 0; n < t; n++) i[n] = arguments[n];
        var r = ot(this, i, "on"),
          a = r.isTargetingSelf,
          s = r.target,
          o = r.type,
          u = r.listener;
        if (ut(s, "on", o, u), !a) {
          var l = function () {
            return e.off(s, o, u)
          };
          l.guid = u.guid;
          var c = function () {
            return e.off("dispose", l)
          };
          c.guid = u.guid, ut(this, "on", "dispose", l), ut(s, "on", "dispose", c)
        }
      },
      one: function () {
        for (var r = this, e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        var n = ot(this, t, "one"),
          a = n.isTargetingSelf,
          s = n.target,
          o = n.type,
          u = n.listener;
        if (a) ut(s, "one", o, u);
        else {
          var l = function e() {
            r.off(s, o, e);
            for (var t = arguments.length, i = new Array(t), n = 0; n < t; n++) i[n] = arguments[n];
            u.apply(null, i)
          };
          l.guid = u.guid, ut(s, "one", o, l)
        }
      },
      any: function () {
        for (var r = this, e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        var n = ot(this, t, "any"),
          a = n.isTargetingSelf,
          s = n.target,
          o = n.type,
          u = n.listener;
        if (a) ut(s, "any", o, u);
        else {
          var l = function e() {
            r.off(s, o, e);
            for (var t = arguments.length, i = new Array(t), n = 0; n < t; n++) i[n] = arguments[n];
            u.apply(null, i)
          };
          l.guid = u.guid, ut(s, "any", o, l)
        }
      },
      off: function (e, t, i) {
        if (!e || nt(e)) Xe(this.eventBusEl_, e, t);
        else {
          var n = e,
            r = t;
          rt(n, this, "off"), at(r, this, "off"), st(i, this, "off"), i = $e(this, i), this.off("dispose", i), n.nodeName ? (Xe(n, r, i), Xe(n, "dispose", i)) : lt(n) && (n.off(r, i), n.off("dispose", i))
        }
      },
      trigger: function (e, t) {
        rt(this.eventBusEl_, this, "trigger");
        var i = e && "string" != typeof e ? e.type : e;
        if (!nt(i)) {
          var n = "Invalid event type for " + it(this) + "#trigger; must be a non-empty string or object with a type key that has a non-empty value.";
          if (!e) throw new Error(n);
          (this.log || g).error(n)
        }
        return Ke(this.eventBusEl_, e, t)
      }
    };

  function dt(e, t) {
    void 0 === t && (t = {});
    var i = t.eventBusKey;
    if (i) {
      if (!e[i].nodeName) throw new Error('The eventBusKey "' + i + '" does not refer to an element.');
      e.eventBusEl_ = e[i]
    } else e.eventBusEl_ = ne("span", {
      className: "vjs-event-bus"
    });
    return S(e, ct), e.eventedCallbacks && e.eventedCallbacks.forEach(function (e) {
      e()
    }), e.on("dispose", function () {
      e.off(), h.setTimeout(function () {
        e.eventBusEl_ = null
      }, 0)
    }), e
  }
  var ht = {
    state: {},
    setState: function (e) {
      var i, n = this;
      return "function" == typeof e && (e = e()), T(e, function (e, t) {
        n.state[t] !== e && ((i = i || {})[t] = {
          from: n.state[t],
          to: e
        }), n.state[t] = e
      }), i && lt(this) && this.trigger({
        changes: i,
        type: "statechanged"
      }), i
    }
  };

  function pt(e, t) {
    return S(e, ht), e.state = S({}, e.state, t), "function" == typeof e.handleStateChanged && lt(e) && e.on("statechanged", e.handleStateChanged), e
  }

  function ft(e) {
    return "string" != typeof e ? e : e.replace(/./, function (e) {
      return e.toLowerCase()
    })
  }

  function mt(e) {
    return "string" != typeof e ? e : e.replace(/./, function (e) {
      return e.toUpperCase()
    })
  }

  function gt() {
    for (var i = {}, e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
    return t.forEach(function (e) {
      e && T(e, function (e, t) {
        k(e) ? (k(i[t]) || (i[t] = {}), i[t] = gt(i[t], e)) : i[t] = e
      })
    }), i
  }
  var vt = function () {
      function e() {
        this.map_ = {}
      }
      var t = e.prototype;
      return t.has = function (e) {
        return e in this.map_
      }, t.delete = function (e) {
        var t = this.has(e);
        return delete this.map_[e], t
      }, t.set = function (e, t) {
        return this.map_[e] = t, this
      }, t.forEach = function (e, t) {
        for (var i in this.map_) e.call(t, this.map_[i], i, this)
      }, e
    }(),
    yt = h.Map ? h.Map : vt,
    _t = function () {
      function e() {
        this.set_ = {}
      }
      var t = e.prototype;
      return t.has = function (e) {
        return e in this.set_
      }, t.delete = function (e) {
        var t = this.has(e);
        return delete this.set_[e], t
      }, t.add = function (e) {
        return this.set_[e] = 1, this
      }, t.forEach = function (e, t) {
        for (var i in this.set_) e.call(t, i, i, this)
      }, e
    }(),
    bt = h.Set ? h.Set : _t,
    Tt = function () {
      function l(e, t, i) {
        if (!e && this.play ? this.player_ = e = this : this.player_ = e, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = gt({}, this.options_), t = this.options_ = gt(this.options_, t), this.id_ = t.id || t.el && t.el.id, !this.id_) {
          var n = e && e.id && e.id() || "no_player";
          this.id_ = n + "_component_" + Be()
        }
        this.name_ = t.name || null, t.el ? this.el_ = t.el : !1 !== t.createEl && (this.el_ = this.createEl()), !1 !== t.evented && (dt(this, {
          eventBusKey: this.el_ ? "el_" : null
        }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), pt(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = new bt, this.setIntervalIds_ = new bt, this.rafIds_ = new bt, this.namedRafs_ = new yt, (this.clearingTimersOnDispose_ = !1) !== t.initChildren && this.initChildren(), this.ready(i), !1 !== t.reportTouchActivity && this.enableTouchActivity()
      }
      var e = l.prototype;
      return e.dispose = function () {
        if (!this.isDisposed_) {
          if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
              type: "dispose",
              bubbles: !1
            }), this.isDisposed_ = !0, this.children_)
            for (var e = this.children_.length - 1; 0 <= e; e--) this.children_[e].dispose && this.children_[e].dispose();
          this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && this.el_.parentNode.removeChild(this.el_), je.has(this.el_) && je.delete(this.el_), this.el_ = null), this.player_ = null
        }
      }, e.isDisposed = function () {
        return Boolean(this.isDisposed_)
      }, e.player = function () {
        return this.player_
      }, e.options = function (e) {
        return e && (this.options_ = gt(this.options_, e)), this.options_
      }, e.el = function () {
        return this.el_
      }, e.createEl = function (e, t, i) {
        return ne(e, t, i)
      }, e.localize = function (e, r, t) {
        void 0 === t && (t = e);
        var i = this.player_.language && this.player_.language(),
          n = this.player_.languages && this.player_.languages(),
          a = n && n[i],
          s = i && i.split("-")[0],
          o = n && n[s],
          u = t;
        return a && a[e] ? u = a[e] : o && o[e] && (u = o[e]), r && (u = u.replace(/\{(\d+)\}/g, function (e, t) {
          var i = r[t - 1],
            n = i;
          return "undefined" == typeof i && (n = e), n
        })), u
      }, e.handleLanguagechange = function () {}, e.contentEl = function () {
        return this.contentEl_ || this.el_
      }, e.id = function () {
        return this.id_
      }, e.name = function () {
        return this.name_
      }, e.children = function () {
        return this.children_
      }, e.getChildById = function (e) {
        return this.childIndex_[e]
      }, e.getChild = function (e) {
        if (e) return this.childNameIndex_[e]
      }, e.getDescendant = function () {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        t = t.reduce(function (e, t) {
          return e.concat(t)
        }, []);
        for (var n = this, r = 0; r < t.length; r++)
          if (!(n = n.getChild(t[r])) || !n.getChild) return;
        return n
      }, e.addChild = function (e, t, i) {
        var n, r;
        if (void 0 === t && (t = {}), void 0 === i && (i = this.children_.length), "string" == typeof e) {
          r = mt(e);
          var a = t.componentClass || r;
          t.name = r;
          var s = l.getComponent(a);
          if (!s) throw new Error("Component " + a + " does not exist");
          if ("function" != typeof s) return null;
          n = new s(this.player_ || this, t)
        } else n = e;
        if (n.parentComponent_ && n.parentComponent_.removeChild(n), this.children_.splice(i, 0, n), n.parentComponent_ = this, "function" == typeof n.id && (this.childIndex_[n.id()] = n), (r = r || n.name && mt(n.name())) && (this.childNameIndex_[r] = n, this.childNameIndex_[ft(r)] = n), "function" == typeof n.el && n.el()) {
          var o = null;
          this.children_[i + 1] && (this.children_[i + 1].el_ ? o = this.children_[i + 1].el_ : ee(this.children_[i + 1]) && (o = this.children_[i + 1])), this.contentEl().insertBefore(n.el(), o)
        }
        return n
      }, e.removeChild = function (e) {
        if ("string" == typeof e && (e = this.getChild(e)), e && this.children_) {
          for (var t = !1, i = this.children_.length - 1; 0 <= i; i--)
            if (this.children_[i] === e) {
              t = !0, this.children_.splice(i, 1);
              break
            } if (t) {
            e.parentComponent_ = null, this.childIndex_[e.id()] = null, this.childNameIndex_[mt(e.name())] = null, this.childNameIndex_[ft(e.name())] = null;
            var n = e.el();
            n && n.parentNode === this.contentEl() && this.contentEl().removeChild(e.el())
          }
        }
      }, e.initChildren = function () {
        var r = this,
          n = this.options_.children;
        if (n) {
          var e, a = this.options_,
            i = l.getComponent("Tech");
          (e = Array.isArray(n) ? n : Object.keys(n)).concat(Object.keys(this.options_).filter(function (t) {
            return !e.some(function (e) {
              return "string" == typeof e ? t === e : t === e.name
            })
          })).map(function (e) {
            var t, i;
            return i = "string" == typeof e ? n[t = e] || r.options_[t] || {} : (t = e.name, e), {
              name: t,
              opts: i
            }
          }).filter(function (e) {
            var t = l.getComponent(e.opts.componentClass || mt(e.name));
            return t && !i.isTech(t)
          }).forEach(function (e) {
            var t = e.name,
              i = e.opts;
            if (void 0 !== a[t] && (i = a[t]), !1 !== i) {
              !0 === i && (i = {}), i.playerOptions = r.options_.playerOptions;
              var n = r.addChild(t, i);
              n && (r[t] = n)
            }
          })
        }
      }, e.buildCSSClass = function () {
        return ""
      }, e.ready = function (e, t) {
        if (void 0 === t && (t = !1), e) return this.isReady_ ? void(t ? e.call(this) : this.setTimeout(e, 1)) : (this.readyQueue_ = this.readyQueue_ || [], void this.readyQueue_.push(e))
      }, e.triggerReady = function () {
        this.isReady_ = !0, this.setTimeout(function () {
          var e = this.readyQueue_;
          this.readyQueue_ = [], e && 0 < e.length && e.forEach(function (e) {
            e.call(this)
          }, this), this.trigger("ready")
        }, 1)
      }, e.$ = function (e, t) {
        return Ie(e, t || this.contentEl())
      }, e.$$ = function (e, t) {
        return xe(e, t || this.contentEl())
      }, e.hasClass = function (e) {
        return se(this.el_, e)
      }, e.addClass = function (e) {
        oe(this.el_, e)
      }, e.removeClass = function (e) {
        ue(this.el_, e)
      }, e.toggleClass = function (e, t) {
        le(this.el_, e, t)
      }, e.show = function () {
        this.removeClass("vjs-hidden")
      }, e.hide = function () {
        this.addClass("vjs-hidden")
      }, e.lockShowing = function () {
        this.addClass("vjs-lock-showing")
      }, e.unlockShowing = function () {
        this.removeClass("vjs-lock-showing")
      }, e.getAttribute = function (e) {
        return he(this.el_, e)
      }, e.setAttribute = function (e, t) {
        pe(this.el_, e, t)
      }, e.removeAttribute = function (e) {
        fe(this.el_, e)
      }, e.width = function (e, t) {
        return this.dimension("width", e, t)
      }, e.height = function (e, t) {
        return this.dimension("height", e, t)
      }, e.dimensions = function (e, t) {
        this.width(e, !0), this.height(t)
      }, e.dimension = function (e, t, i) {
        if (void 0 !== t) return null !== t && t == t || (t = 0), -1 !== ("" + t).indexOf("%") || -1 !== ("" + t).indexOf("px") ? this.el_.style[e] = t : this.el_.style[e] = "auto" === t ? "" : t + "px", void(i || this.trigger("componentresize"));
        if (!this.el_) return 0;
        var n = this.el_.style[e],
          r = n.indexOf("px");
        return -1 !== r ? parseInt(n.slice(0, r), 10) : parseInt(this.el_["offset" + mt(e)], 10)
      }, e.currentDimension = function (e) {
        var t = 0;
        if ("width" !== e && "height" !== e) throw new Error("currentDimension only accepts width or height value");
        if (t = w(this.el_, e), 0 === (t = parseFloat(t)) || isNaN(t)) {
          var i = "offset" + mt(e);
          t = this.el_[i]
        }
        return t
      }, e.currentDimensions = function () {
        return {
          width: this.currentDimension("width"),
          height: this.currentDimension("height")
        }
      }, e.currentWidth = function () {
        return this.currentDimension("width")
      }, e.currentHeight = function () {
        return this.currentDimension("height")
      }, e.focus = function () {
        this.el_.focus()
      }, e.blur = function () {
        this.el_.blur()
      }, e.handleKeyDown = function (e) {
        this.player_ && (e.stopPropagation(), this.player_.handleKeyDown(e))
      }, e.handleKeyPress = function (e) {
        this.handleKeyDown(e)
      }, e.emitTapEvents = function () {
        var n, t = 0,
          r = null;
        this.on("touchstart", function (e) {
          1 === e.touches.length && (r = {
            pageX: e.touches[0].pageX,
            pageY: e.touches[0].pageY
          }, t = h.performance.now(), n = !0)
        }), this.on("touchmove", function (e) {
          if (1 < e.touches.length) n = !1;
          else if (r) {
            var t = e.touches[0].pageX - r.pageX,
              i = e.touches[0].pageY - r.pageY;
            10 < Math.sqrt(t * t + i * i) && (n = !1)
          }
        });

        function e() {
          n = !1
        }
        this.on("touchleave", e), this.on("touchcancel", e), this.on("touchend", function (e) {
          !(r = null) === n && h.performance.now() - t < 200 && (e.preventDefault(), this.trigger("tap"))
        })
      }, e.enableTouchActivity = function () {
        if (this.player() && this.player().reportUserActivity) {
          var t, i = $e(this.player(), this.player().reportUserActivity);
          this.on("touchstart", function () {
            i(), this.clearInterval(t), t = this.setInterval(i, 250)
          });
          var e = function (e) {
            i(), this.clearInterval(t)
          };
          this.on("touchmove", i), this.on("touchend", e), this.on("touchcancel", e)
        }
      }, e.setTimeout = function (e, t) {
        var i, n = this;
        return e = $e(this, e), this.clearTimersOnDispose_(), i = h.setTimeout(function () {
          n.setTimeoutIds_.has(i) && n.setTimeoutIds_.delete(i), e()
        }, t), this.setTimeoutIds_.add(i), i
      }, e.clearTimeout = function (e) {
        return this.setTimeoutIds_.has(e) && (this.setTimeoutIds_.delete(e), h.clearTimeout(e)), e
      }, e.setInterval = function (e, t) {
        e = $e(this, e), this.clearTimersOnDispose_();
        var i = h.setInterval(e, t);
        return this.setIntervalIds_.add(i), i
      }, e.clearInterval = function (e) {
        return this.setIntervalIds_.has(e) && (this.setIntervalIds_.delete(e), h.clearInterval(e)), e
      }, e.requestAnimationFrame = function (e) {
        var t, i = this;
        return this.supportsRaf_ ? (this.clearTimersOnDispose_(), e = $e(this, e), t = h.requestAnimationFrame(function () {
          i.rafIds_.has(t) && i.rafIds_.delete(t), e()
        }), this.rafIds_.add(t), t) : this.setTimeout(e, 1e3 / 60)
      }, e.requestNamedAnimationFrame = function (e, t) {
        var i = this;
        if (!this.namedRafs_.has(e)) {
          this.clearTimersOnDispose_(), t = $e(this, t);
          var n = this.requestAnimationFrame(function () {
            t(), i.namedRafs_.has(e) && i.namedRafs_.delete(e)
          });
          return this.namedRafs_.set(e, n), e
        }
      }, e.cancelNamedAnimationFrame = function (e) {
        this.namedRafs_.has(e) && (this.cancelAnimationFrame(this.namedRafs_.get(e)), this.namedRafs_.delete(e))
      }, e.cancelAnimationFrame = function (e) {
        return this.supportsRaf_ ? (this.rafIds_.has(e) && (this.rafIds_.delete(e), h.cancelAnimationFrame(e)), e) : this.clearTimeout(e)
      }, e.clearTimersOnDispose_ = function () {
        var n = this;
        this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", function () {
          [
            ["namedRafs_", "cancelNamedAnimationFrame"],
            ["rafIds_", "cancelAnimationFrame"],
            ["setTimeoutIds_", "clearTimeout"],
            ["setIntervalIds_", "clearInterval"]
          ].forEach(function (e) {
            var t = e[0],
              i = e[1];
            n[t].forEach(function (e, t) {
              return n[i](t)
            })
          }), n.clearingTimersOnDispose_ = !1
        }))
      }, l.registerComponent = function (e, t) {
        if ("string" != typeof e || !e) throw new Error('Illegal component name, "' + e + '"; must be a non-empty string.');
        var i, n = l.getComponent("Tech"),
          r = n && n.isTech(t),
          a = l === t || l.prototype.isPrototypeOf(t.prototype);
        if (r || !a) throw i = r ? "techs must be registered using Tech.registerTech()" : "must be a Component subclass", new Error('Illegal component, "' + e + '"; ' + i + ".");
        e = mt(e), l.components_ || (l.components_ = {});
        var s = l.getComponent("Player");
        if ("Player" === e && s && s.players) {
          var o = s.players,
            u = Object.keys(o);
          if (o && 0 < u.length && u.map(function (e) {
              return o[e]
            }).every(Boolean)) throw new Error("Can not register Player component after player has been created.")
        }
        return l.components_[e] = t, l.components_[ft(e)] = t
      }, l.getComponent = function (e) {
        if (e && l.components_) return l.components_[e]
      }, l
    }();
  Tt.prototype.supportsRaf_ = "function" == typeof h.requestAnimationFrame && "function" == typeof h.cancelAnimationFrame, Tt.registerComponent("Component", Tt);
  var St = function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e
  };
  i(function (t) {
    function i(e) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? t.exports = i = function (e) {
        return typeof e
      } : t.exports = i = function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
      }, i(e)
    }
    t.exports = i
  }), i(function (t) {
    function i(e) {
      return t.exports = i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e)
      }, i(e)
    }
    t.exports = i
  });
  var Et = function (e, t) {
    e.prototype = Object.create(t.prototype), (e.prototype.constructor = e).__proto__ = t
  };

  function kt(e, t, i, n) {
    return function (e, t, i) {
      if ("number" != typeof t || t < 0 || i < t) throw new Error("Failed to execute '" + e + "' on 'TimeRanges': The index provided (" + t + ") is non-numeric or out of bounds (0-" + i + ").")
    }(e, n, i.length - 1), i[n][t]
  }

  function wt(e) {
    return void 0 === e || 0 === e.length ? {
      length: 0,
      start: function () {
        throw new Error("This TimeRanges object is empty")
      },
      end: function () {
        throw new Error("This TimeRanges object is empty")
      }
    } : {
      length: e.length,
      start: kt.bind(null, "start", 0, e),
      end: kt.bind(null, "end", 1, e)
    }
  }

  function Ct(e, t) {
    return Array.isArray(e) ? wt(e) : void 0 === e || void 0 === t ? wt() : wt([
      [e, t]
    ])
  }

  function It(e, t) {
    var i, n, r = 0;
    if (!t) return 0;
    e && e.length || (e = Ct(0, 0));
    for (var a = 0; a < e.length; a++) i = e.start(a), t < (n = e.end(a)) && (n = t), r += n - i;
    return r / t
  }

  function xt(e) {
    if (e instanceof xt) return e;
    "number" == typeof e ? this.code = e : "string" == typeof e ? this.message = e : E(e) && ("number" == typeof e.code && (this.code = e.code), S(this, e)), this.message || (this.message = xt.defaultMessages[this.code] || "")
  }
  xt.prototype.code = 0, xt.prototype.message = "", xt.prototype.status = null, xt.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"], xt.defaultMessages = {
    1: "You aborted the media playback",
    2: "A network error caused the media download to fail part-way.",
    3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
    4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
    5: "The media is encrypted and we do not have the keys to decrypt it."
  };
  for (var At = 0; At < xt.errorTypes.length; At++) xt[xt.errorTypes[At]] = At, xt.prototype[xt.errorTypes[At]] = At;
  var Pt = function (e, t) {
    var i, n = null;
    try {
      i = JSON.parse(e, t)
    } catch (e) {
      n = e
    }
    return [n, i]
  };

  function Lt(e) {
    return null != e && "function" == typeof e.then
  }

  function Ot(e) {
    Lt(e) && e.then(null, function (e) {})
  }

  function Dt(n) {
    return ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce(function (e, t, i) {
      return n[t] && (e[t] = n[t]), e
    }, {
      cues: n.cues && Array.prototype.map.call(n.cues, function (e) {
        return {
          startTime: e.startTime,
          endTime: e.endTime,
          text: e.text,
          id: e.id
        }
      })
    })
  }
  var Rt = function (e) {
      var t = e.$$("track"),
        i = Array.prototype.map.call(t, function (e) {
          return e.track
        });
      return Array.prototype.map.call(t, function (e) {
        var t = Dt(e.track);
        return e.src && (t.src = e.src), t
      }).concat(Array.prototype.filter.call(e.textTracks(), function (e) {
        return -1 === i.indexOf(e)
      }).map(Dt))
    },
    Mt = function (e, i) {
      return e.forEach(function (e) {
        var t = i.addRemoteTextTrack(e).track;
        !e.src && e.cues && e.cues.forEach(function (e) {
          return t.addCue(e)
        })
      }), i.textTracks()
    },
    Nt = i(function (e, t) {
      function i(e) {
        if (e && "object" == typeof e) {
          var t = e.which || e.keyCode || e.charCode;
          t && (e = t)
        }
        if ("number" == typeof e) return s[e];
        var i, n = String(e);
        return (i = r[n.toLowerCase()]) ? i : (i = a[n.toLowerCase()]) || (1 === n.length ? n.charCodeAt(0) : void 0)
      }
      i.isEventKey = function (e, t) {
        if (e && "object" == typeof e) {
          var i = e.which || e.keyCode || e.charCode;
          if (null == i) return !1;
          if ("string" == typeof t) {
            var n;
            if (n = r[t.toLowerCase()]) return n === i;
            if (n = a[t.toLowerCase()]) return n === i
          } else if ("number" == typeof t) return t === i;
          return !1
        }
      };
      var r = (t = e.exports = i).code = t.codes = {
          backspace: 8,
          tab: 9,
          enter: 13,
          shift: 16,
          ctrl: 17,
          alt: 18,
          "pause/break": 19,
          "caps lock": 20,
          esc: 27,
          space: 32,
          "page up": 33,
          "page down": 34,
          end: 35,
          home: 36,
          left: 37,
          up: 38,
          right: 39,
          down: 40,
          insert: 45,
          delete: 46,
          command: 91,
          "left command": 91,
          "right command": 93,
          "numpad *": 106,
          "numpad +": 107,
          "numpad -": 109,
          "numpad .": 110,
          "numpad /": 111,
          "num lock": 144,
          "scroll lock": 145,
          "my computer": 182,
          "my calculator": 183,
          ";": 186,
          "=": 187,
          ",": 188,
          "-": 189,
          ".": 190,
          "/": 191,
          "`": 192,
          "[": 219,
          "\\": 220,
          "]": 221,
          "'": 222
        },
        a = t.aliases = {
          windows: 91,
          "⇧": 16,
          "⌥": 18,
          "⌃": 17,
          "⌘": 91,
          ctl: 17,
          control: 17,
          option: 18,
          pause: 19,
          break: 19,
          caps: 20,
          return: 13,
          escape: 27,
          spc: 32,
          spacebar: 32,
          pgup: 33,
          pgdn: 34,
          ins: 45,
          del: 46,
          cmd: 91
        };
      for (n = 97; n < 123; n++) r[String.fromCharCode(n)] = n - 32;
      for (var n = 48; n < 58; n++) r[n - 48] = n;
      for (n = 1; n < 13; n++) r["f" + n] = n + 111;
      for (n = 0; n < 10; n++) r["numpad " + n] = n + 96;
      var s = t.names = t.title = {};
      for (n in r) s[r[n]] = n;
      for (var o in a) r[o] = a[o]
    }),
    Ut = (Nt.code, Nt.codes, Nt.aliases, Nt.names, Nt.title, "vjs-modal-dialog"),
    Bt = function (n) {
      function e(e, t) {
        var i;
        return (i = n.call(this, e, t) || this).handleKeyDown_ = function (e) {
          return i.handleKeyDown(e)
        }, i.close_ = function (e) {
          return i.close(e)
        }, i.opened_ = i.hasBeenOpened_ = i.hasBeenFilled_ = !1, i.closeable(!i.options_.uncloseable), i.content(i.options_.content), i.contentEl_ = ne("div", {
          className: Ut + "-content"
        }, {
          role: "document"
        }), i.descEl_ = ne("p", {
          className: Ut + "-description vjs-control-text",
          id: i.el().getAttribute("aria-describedby")
        }), re(i.descEl_, i.description()), i.el_.appendChild(i.descEl_), i.el_.appendChild(i.contentEl_), i
      }
      Et(e, n);
      var t = e.prototype;
      return t.createEl = function () {
        return n.prototype.createEl.call(this, "div", {
          className: this.buildCSSClass(),
          tabIndex: -1
        }, {
          "aria-describedby": this.id() + "_description",
          "aria-hidden": "true",
          "aria-label": this.label(),
          role: "dialog"
        })
      }, t.dispose = function () {
        this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, n.prototype.dispose.call(this)
      }, t.buildCSSClass = function () {
        return Ut + " vjs-hidden " + n.prototype.buildCSSClass.call(this)
      }, t.label = function () {
        return this.localize(this.options_.label || "Modal Window")
      }, t.description = function () {
        var e = this.options_.description || this.localize("This is a modal window.");
        return this.closeable() && (e += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), e
      }, t.open = function () {
        if (!this.opened_) {
          var e = this.player();
          this.trigger("beforemodalopen"), this.opened_ = !0, !this.options_.fillAlways && (this.hasBeenOpened_ || this.hasBeenFilled_) || this.fill(), this.wasPlaying_ = !e.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && e.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = e.controls(), e.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0
        }
      }, t.opened = function (e) {
        return "boolean" == typeof e && this[e ? "open" : "close"](), this.opened_
      }, t.close = function () {
        if (this.opened_) {
          var e = this.player();
          this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && e.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && e.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger("modalclose"), this.conditionalBlur_(), this.options_.temporary && this.dispose()
        }
      }, t.closeable = function (e) {
        if ("boolean" == typeof e) {
          var t = this.closeable_ = !!e,
            i = this.getChild("closeButton");
          if (t && !i) {
            var n = this.contentEl_;
            this.contentEl_ = this.el_, i = this.addChild("closeButton", {
              controlText: "Close Modal Dialog"
            }), this.contentEl_ = n, this.on(i, "close", this.close_)
          }!t && i && (this.off(i, "close", this.close_), this.removeChild(i), i.dispose())
        }
        return this.closeable_
      }, t.fill = function () {
        this.fillWith(this.content())
      }, t.fillWith = function (e) {
        var t = this.contentEl(),
          i = t.parentNode,
          n = t.nextSibling;
        this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, i.removeChild(t), this.empty(), ke(t, e), this.trigger("modalfill"), n ? i.insertBefore(t, n) : i.appendChild(t);
        var r = this.getChild("closeButton");
        r && i.appendChild(r.el_)
      }, t.empty = function () {
        this.trigger("beforemodalempty"), Te(this.contentEl()), this.trigger("modalempty")
      }, t.content = function (e) {
        return "undefined" != typeof e && (this.content_ = e), this.content_
      }, t.conditionalFocus_ = function () {
        var e = p.activeElement,
          t = this.player_.el_;
        this.previouslyActiveEl_ = null, !t.contains(e) && t !== e || (this.previouslyActiveEl_ = e, this.focus())
      }, t.conditionalBlur_ = function () {
        this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null)
      }, t.handleKeyDown = function (e) {
        if (e.stopPropagation(), Nt.isEventKey(e, "Escape") && this.closeable()) return e.preventDefault(), void this.close();
        if (Nt.isEventKey(e, "Tab")) {
          for (var t, i = this.focusableEls_(), n = this.el_.querySelector(":focus"), r = 0; r < i.length; r++)
            if (n === i[r]) {
              t = r;
              break
            } p.activeElement === this.el_ && (t = 0), e.shiftKey && 0 === t ? (i[i.length - 1].focus(), e.preventDefault()) : e.shiftKey || t !== i.length - 1 || (i[0].focus(), e.preventDefault())
        }
      }, t.focusableEls_ = function () {
        var e = this.el_.querySelectorAll("*");
        return Array.prototype.filter.call(e, function (e) {
          return (e instanceof h.HTMLAnchorElement || e instanceof h.HTMLAreaElement) && e.hasAttribute("href") || (e instanceof h.HTMLInputElement || e instanceof h.HTMLSelectElement || e instanceof h.HTMLTextAreaElement || e instanceof h.HTMLButtonElement) && !e.hasAttribute("disabled") || e instanceof h.HTMLIFrameElement || e instanceof h.HTMLObjectElement || e instanceof h.HTMLEmbedElement || e.hasAttribute("tabindex") && -1 !== e.getAttribute("tabindex") || e.hasAttribute("contenteditable")
        })
      }, e
    }(Tt);
  Bt.prototype.options_ = {
    pauseOnOpen: !0,
    temporary: !0
  }, Tt.registerComponent("ModalDialog", Bt);
  var Ft = function (n) {
    function e(e) {
      var t;
      void 0 === e && (e = []), (t = n.call(this) || this).tracks_ = [], Object.defineProperty(St(t), "length", {
        get: function () {
          return this.tracks_.length
        }
      });
      for (var i = 0; i < e.length; i++) t.addTrack(e[i]);
      return t
    }
    Et(e, n);
    var t = e.prototype;
    return t.addTrack = function (e) {
      var t = this,
        i = this.tracks_.length;
      "" + i in this || Object.defineProperty(this, i, {
        get: function () {
          return this.tracks_[i]
        }
      }), -1 === this.tracks_.indexOf(e) && (this.tracks_.push(e), this.trigger({
        track: e,
        type: "addtrack",
        target: this
      })), e.labelchange_ = function () {
        t.trigger({
          track: e,
          type: "labelchange",
          target: t
        })
      }, lt(e) && e.addEventListener("labelchange", e.labelchange_)
    }, t.removeTrack = function (e) {
      for (var t, i = 0, n = this.length; i < n; i++)
        if (this[i] === e) {
          (t = this[i]).off && t.off(), this.tracks_.splice(i, 1);
          break
        } t && this.trigger({
        track: t,
        type: "removetrack",
        target: this
      })
    }, t.getTrackById = function (e) {
      for (var t = null, i = 0, n = this.length; i < n; i++) {
        var r = this[i];
        if (r.id === e) {
          t = r;
          break
        }
      }
      return t
    }, e
  }(Ze);
  for (var jt in Ft.prototype.allowedEvents_ = {
      change: "change",
      addtrack: "addtrack",
      removetrack: "removetrack",
      labelchange: "labelchange"
    }, Ft.prototype.allowedEvents_) Ft.prototype["on" + jt] = null;

  function Ht(e, t) {
    for (var i = 0; i < e.length; i++) Object.keys(e[i]).length && t.id !== e[i].id && (e[i].enabled = !1)
  }

  function Vt(e, t) {
    for (var i = 0; i < e.length; i++) Object.keys(e[i]).length && t.id !== e[i].id && (e[i].selected = !1)
  }

  function qt(e) {
    var t = ["protocol", "hostname", "port", "pathname", "search", "hash", "host"],
      i = p.createElement("a");
    i.href = e;
    var n, r = "" === i.host && "file:" !== i.protocol;
    r && ((n = p.createElement("div")).innerHTML = '<a href="' + e + '"></a>', i = n.firstChild, n.setAttribute("style", "display:none; position:absolute;"), p.body.appendChild(n));
    for (var a = {}, s = 0; s < t.length; s++) a[t[s]] = i[t[s]];
    return "http:" === a.protocol && (a.host = a.host.replace(/:80$/, "")), "https:" === a.protocol && (a.host = a.host.replace(/:443$/, "")), a.protocol || (a.protocol = h.location.protocol), r && p.body.removeChild(n), a
  }

  function Wt(e) {
    if (!e.match(/^https?:\/\//)) {
      var t = p.createElement("div");
      t.innerHTML = '<a href="' + e + '">x</a>', e = t.firstChild.href
    }
    return e
  }

  function zt(e) {
    if ("string" == typeof e) {
      var t = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/.exec(e);
      if (t) return t.pop().toLowerCase()
    }
    return ""
  }

  function Gt(e, t) {
    void 0 === t && (t = h.location);
    var i = qt(e);
    return (":" === i.protocol ? t.protocol : i.protocol) + i.host !== t.protocol + t.host
  }
  var Xt = function (n) {
      function e(e) {
        var t;
        void 0 === e && (e = []);
        for (var i = e.length - 1; 0 <= i; i--)
          if (e[i].enabled) {
            Ht(e, e[i]);
            break
          } return (t = n.call(this, e) || this).changing_ = !1, t
      }
      Et(e, n);
      var t = e.prototype;
      return t.addTrack = function (e) {
        var t = this;
        e.enabled && Ht(this, e), n.prototype.addTrack.call(this, e), e.addEventListener && (e.enabledChange_ = function () {
          t.changing_ || (t.changing_ = !0, Ht(t, e), t.changing_ = !1, t.trigger("change"))
        }, e.addEventListener("enabledchange", e.enabledChange_))
      }, t.removeTrack = function (e) {
        n.prototype.removeTrack.call(this, e), e.removeEventListener && e.enabledChange_ && (e.removeEventListener("enabledchange", e.enabledChange_), e.enabledChange_ = null)
      }, e
    }(Ft),
    Kt = function (n) {
      function e(e) {
        var t;
        void 0 === e && (e = []);
        for (var i = e.length - 1; 0 <= i; i--)
          if (e[i].selected) {
            Vt(e, e[i]);
            break
          } return (t = n.call(this, e) || this).changing_ = !1, Object.defineProperty(St(t), "selectedIndex", {
          get: function () {
            for (var e = 0; e < this.length; e++)
              if (this[e].selected) return e;
            return -1
          },
          set: function () {}
        }), t
      }
      Et(e, n);
      var t = e.prototype;
      return t.addTrack = function (e) {
        var t = this;
        e.selected && Vt(this, e), n.prototype.addTrack.call(this, e), e.addEventListener && (e.selectedChange_ = function () {
          t.changing_ || (t.changing_ = !0, Vt(t, e), t.changing_ = !1, t.trigger("change"))
        }, e.addEventListener("selectedchange", e.selectedChange_))
      }, t.removeTrack = function (e) {
        n.prototype.removeTrack.call(this, e), e.removeEventListener && e.selectedChange_ && (e.removeEventListener("selectedchange", e.selectedChange_), e.selectedChange_ = null)
      }, e
    }(Ft),
    Yt = function (i) {
      function e() {
        return i.apply(this, arguments) || this
      }
      Et(e, i);
      var t = e.prototype;
      return t.addTrack = function (e) {
        var t = this;
        i.prototype.addTrack.call(this, e), this.queueChange_ || (this.queueChange_ = function () {
          return t.queueTrigger("change")
        }), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = function () {
          return t.trigger("selectedlanguagechange")
        }), e.addEventListener("modechange", this.queueChange_); - 1 === ["metadata", "chapters"].indexOf(e.kind) && e.addEventListener("modechange", this.triggerSelectedlanguagechange_)
      }, t.removeTrack = function (e) {
        i.prototype.removeTrack.call(this, e), e.removeEventListener && (this.queueChange_ && e.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && e.removeEventListener("modechange", this.triggerSelectedlanguagechange_))
      }, e
    }(Ft),
    Qt = function () {
      function e(e) {
        void 0 === e && (e = []), this.trackElements_ = [], Object.defineProperty(this, "length", {
          get: function () {
            return this.trackElements_.length
          }
        });
        for (var t = 0, i = e.length; t < i; t++) this.addTrackElement_(e[t])
      }
      var t = e.prototype;
      return t.addTrackElement_ = function (e) {
        var t = this.trackElements_.length;
        "" + t in this || Object.defineProperty(this, t, {
          get: function () {
            return this.trackElements_[t]
          }
        }), -1 === this.trackElements_.indexOf(e) && this.trackElements_.push(e)
      }, t.getTrackElementByTrack_ = function (e) {
        for (var t, i = 0, n = this.trackElements_.length; i < n; i++)
          if (e === this.trackElements_[i].track) {
            t = this.trackElements_[i];
            break
          } return t
      }, t.removeTrackElement_ = function (e) {
        for (var t = 0, i = this.trackElements_.length; t < i; t++)
          if (e === this.trackElements_[t]) {
            this.trackElements_[t].track && "function" == typeof this.trackElements_[t].track.off && this.trackElements_[t].track.off(), "function" == typeof this.trackElements_[t].off && this.trackElements_[t].off(), this.trackElements_.splice(t, 1);
            break
          }
      }, e
    }(),
    $t = function () {
      function t(e) {
        t.prototype.setCues_.call(this, e), Object.defineProperty(this, "length", {
          get: function () {
            return this.length_
          }
        })
      }
      var e = t.prototype;
      return e.setCues_ = function (e) {
        var t = this.length || 0,
          i = 0,
          n = e.length;
        this.cues_ = e, this.length_ = e.length;

        function r(e) {
          "" + e in this || Object.defineProperty(this, "" + e, {
            get: function () {
              return this.cues_[e]
            }
          })
        }
        if (t < n)
          for (i = t; i < n; i++) r.call(this, i)
      }, e.getCueById = function (e) {
        for (var t = null, i = 0, n = this.length; i < n; i++) {
          var r = this[i];
          if (r.id === e) {
            t = r;
            break
          }
        }
        return t
      }, t
    }(),
    Jt = {
      alternative: "alternative",
      captions: "captions",
      main: "main",
      sign: "sign",
      subtitles: "subtitles",
      commentary: "commentary"
    },
    Zt = {
      alternative: "alternative",
      descriptions: "descriptions",
      main: "main",
      "main-desc": "main-desc",
      translation: "translation",
      commentary: "commentary"
    },
    ei = {
      subtitles: "subtitles",
      captions: "captions",
      descriptions: "descriptions",
      chapters: "chapters",
      metadata: "metadata"
    },
    ti = {
      disabled: "disabled",
      hidden: "hidden",
      showing: "showing"
    },
    ii = function (s) {
      function e(e) {
        var t;
        void 0 === e && (e = {}), t = s.call(this) || this;

        function i(e) {
          Object.defineProperty(St(t), e, {
            get: function () {
              return n[e]
            },
            set: function () {}
          })
        }
        var n = {
            id: e.id || "vjs_track_" + Be(),
            kind: e.kind || "",
            language: e.language || ""
          },
          r = e.label || "";
        for (var a in n) i(a);
        return Object.defineProperty(St(t), "label", {
          get: function () {
            return r
          },
          set: function (e) {
            e !== r && (r = e, this.trigger("labelchange"))
          }
        }), t
      }
      return Et(e, s), e
    }(Ze),
    ni = Object.freeze({
      __proto__: null,
      parseUrl: qt,
      getAbsoluteURL: Wt,
      getFileExtension: zt,
      isCrossOrigin: Gt
    }),
    ri = "undefined" != typeof window ? window : "undefined" != typeof e ? e : "undefined" != typeof self ? self : {},
    ai = function (e) {
      var t = si.call(e);
      return "[object Function]" === t || "function" == typeof e && "[object RegExp]" !== t || "undefined" != typeof window && (e === window.setTimeout || e === window.alert || e === window.confirm || e === window.prompt)
    }
    /**
     * @license
     * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
     * Copyright (c) 2014 David Björklund
     * Available under the MIT license
     * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
     */
    ,
    si = Object.prototype.toString;
  var oi = function (e) {
      var r = {};
      return e && e.trim().split("\n").forEach(function (e) {
        var t = e.indexOf(":"),
          i = e.slice(0, t).trim().toLowerCase(),
          n = e.slice(t + 1).trim();
        "undefined" == typeof r[i] ? r[i] = n : Array.isArray(r[i]) ? r[i].push(n) : r[i] = [r[i], n]
      }), r
    },
    ui = di,
    li = di;

  function ci(e, t, i) {
    var n = e;
    return ai(t) ? (i = t, "string" == typeof e && (n = {
      uri: e
    })) : n = y({}, t, {
      uri: e
    }), n.callback = i, n
  }

  function di(e, t, i) {
    return hi(t = ci(e, t, i))
  }

  function hi(n) {
    if ("undefined" == typeof n.callback) throw new Error("callback argument missing");
    var r = !1,
      a = function (e, t, i) {
        r || (r = !0, n.callback(e, t, i))
      };

    function t(e) {
      return clearTimeout(o), e instanceof Error || (e = new Error("" + (e || "Unknown XMLHttpRequest Error"))), e.statusCode = 0, a(e, m)
    }

    function e() {
      if (!s) {
        var e;
        clearTimeout(o), e = n.useXDR && void 0 === u.status ? 200 : 1223 === u.status ? 204 : u.status;
        var t = m,
          i = null;
        return 0 !== e ? (t = {
          body: function () {
            var e = void 0;
            if (e = u.response ? u.response : u.responseText || function (e) {
                try {
                  if ("document" === e.responseType) return e.responseXML;
                  var t = e.responseXML && "parsererror" === e.responseXML.documentElement.nodeName;
                  if ("" === e.responseType && !t) return e.responseXML
                } catch (e) {}
                return null
              }(u), f) try {
              e = JSON.parse(e)
            } catch (e) {}
            return e
          }(),
          statusCode: e,
          method: c,
          headers: {},
          url: l,
          rawRequest: u
        }, u.getAllResponseHeaders && (t.headers = oi(u.getAllResponseHeaders()))) : i = new Error("Internal XMLHttpRequest Error"), a(i, t, t.body)
      }
    }
    var i, s, o, u = n.xhr || null,
      l = (u = u || (n.cors || n.useXDR ? new di.XDomainRequest : new di.XMLHttpRequest)).url = n.uri || n.url,
      c = u.method = n.method || "GET",
      d = n.body || n.data,
      h = u.headers = n.headers || {},
      p = !!n.sync,
      f = !1,
      m = {
        body: void 0,
        headers: {},
        statusCode: 0,
        method: c,
        url: l,
        rawRequest: u
      };
    if ("json" in n && !1 !== n.json && (f = !0, h.accept || h.Accept || (h.Accept = "application/json"), "GET" !== c && "HEAD" !== c && (h["content-type"] || h["Content-Type"] || (h["Content-Type"] = "application/json"), d = JSON.stringify(!0 === n.json ? d : n.json))), u.onreadystatechange = function () {
        4 === u.readyState && setTimeout(e, 0)
      }, u.onload = e, u.onerror = t, u.onprogress = function () {}, u.onabort = function () {
        s = !0
      }, u.ontimeout = t, u.open(c, l, !p, n.username, n.password), p || (u.withCredentials = !!n.withCredentials), !p && 0 < n.timeout && (o = setTimeout(function () {
        if (!s) {
          s = !0, u.abort("timeout");
          var e = new Error("XMLHttpRequest timeout");
          e.code = "ETIMEDOUT", t(e)
        }
      }, n.timeout)), u.setRequestHeader)
      for (i in h) h.hasOwnProperty(i) && u.setRequestHeader(i, h[i]);
    else if (n.headers && ! function (e) {
        for (var t in e)
          if (e.hasOwnProperty(t)) return !1;
        return !0
      }(n.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");
    return "responseType" in n && (u.responseType = n.responseType), "beforeSend" in n && "function" == typeof n.beforeSend && n.beforeSend(u), u.send(d || null), u
  }
  di.XMLHttpRequest = ri.XMLHttpRequest || function () {}, di.XDomainRequest = "withCredentials" in new di.XMLHttpRequest ? di.XMLHttpRequest : ri.XDomainRequest,
    function (e, t) {
      for (var i = 0; i < e.length; i++) t(e[i])
    }(["get", "put", "post", "patch", "head", "delete"], function (n) {
      di["delete" === n ? "del" : n] = function (e, t, i) {
        return (t = ci(e, t, i)).method = n.toUpperCase(), hi(t)
      }
    }), ui.default = li;

  function pi(e, t) {
    var i = new h.WebVTT.Parser(h, h.vttjs, h.WebVTT.StringDecoder()),
      n = [];
    i.oncue = function (e) {
      t.addCue(e)
    }, i.onparsingerror = function (e) {
      n.push(e)
    }, i.onflush = function () {
      t.trigger({
        type: "loadeddata",
        target: t
      })
    }, i.parse(e), 0 < n.length && (h.console && h.console.groupCollapsed && h.console.groupCollapsed("Text Track parsing errors for " + t.src), n.forEach(function (e) {
      return g.error(e)
    }), h.console && h.console.groupEnd && h.console.groupEnd()), i.flush()
  }

  function fi(e, n) {
    var t = {
        uri: e
      },
      i = Gt(e);
    i && (t.cors = i);
    var r = "use-credentials" === n.tech_.crossOrigin();
    r && (t.withCredentials = r), ui(t, $e(this, function (e, t, i) {
      if (e) return g.error(e, t);
      n.loaded_ = !0, "function" != typeof h.WebVTT ? n.tech_ && n.tech_.any(["vttjsloaded", "vttjserror"], function (e) {
        if ("vttjserror" !== e.type) return pi(i, n);
        g.error("vttjs failed to load, stopping trying to process " + n.src)
      }) : pi(i, n)
    }))
  }
  var mi = function (l) {
    function e(e) {
      var t;
      if (void 0 === e && (e = {}), !e.tech) throw new Error("A tech was not provided.");
      var i = gt(e, {
          kind: ei[e.kind] || "subtitles",
          language: e.language || e.srclang || ""
        }),
        n = ti[i.mode] || "disabled",
        r = i.default;
      "metadata" !== i.kind && "chapters" !== i.kind || (n = "hidden"), (t = l.call(this, i) || this).tech_ = i.tech, t.cues_ = [], t.activeCues_ = [], t.preload_ = !1 !== t.tech_.preloadTextTracks;
      var a = new $t(t.cues_),
        s = new $t(t.activeCues_),
        o = !1,
        u = $e(St(t), function () {
          this.tech_.isReady_ && !this.tech_.isDisposed() && (this.activeCues = this.activeCues, o && (this.trigger("cuechange"), o = !1))
        });
      return t.tech_.one("dispose", function () {
        t.tech_.off("timeupdate", u)
      }), "disabled" !== n && t.tech_.on("timeupdate", u), Object.defineProperties(St(t), {
        default: {
          get: function () {
            return r
          },
          set: function () {}
        },
        mode: {
          get: function () {
            return n
          },
          set: function (e) {
            ti[e] && n !== e && (n = e, this.preload_ || "disabled" === n || 0 !== this.cues.length || fi(this.src, this), this.tech_.off("timeupdate", u), "disabled" !== n && this.tech_.on("timeupdate", u), this.trigger("modechange"))
          }
        },
        cues: {
          get: function () {
            return this.loaded_ ? a : null
          },
          set: function () {}
        },
        activeCues: {
          get: function () {
            if (!this.loaded_) return null;
            if (0 === this.cues.length) return s;
            for (var e = this.tech_.currentTime(), t = [], i = 0, n = this.cues.length; i < n; i++) {
              var r = this.cues[i];
              r.startTime <= e && r.endTime >= e ? t.push(r) : r.startTime === r.endTime && r.startTime <= e && r.startTime + .5 >= e && t.push(r)
            }
            if (o = !1, t.length !== this.activeCues_.length) o = !0;
            else
              for (var a = 0; a < t.length; a++) - 1 === this.activeCues_.indexOf(t[a]) && (o = !0);
            return this.activeCues_ = t, s.setCues_(this.activeCues_), s
          },
          set: function () {}
        }
      }), i.src ? (t.src = i.src, t.preload_ || (t.loaded_ = !0), (t.preload_ || "subtitles" !== i.kind && "captions" !== i.kind) && fi(t.src, St(t))) : t.loaded_ = !0, t
    }
    Et(e, l);
    var t = e.prototype;
    return t.addCue = function (e) {
      var t = e;
      if (h.vttjs && !(e instanceof h.vttjs.VTTCue)) {
        for (var i in t = new h.vttjs.VTTCue(e.startTime, e.endTime, e.text), e) i in t || (t[i] = e[i]);
        t.id = e.id, t.originalCue_ = e
      }
      for (var n = this.tech_.textTracks(), r = 0; r < n.length; r++) n[r] !== this && n[r].removeCue(t);
      this.cues_.push(t), this.cues.setCues_(this.cues_)
    }, t.removeCue = function (e) {
      for (var t = this.cues_.length; t--;) {
        var i = this.cues_[t];
        if (i === e || i.originalCue_ && i.originalCue_ === e) {
          this.cues_.splice(t, 1), this.cues.setCues_(this.cues_);
          break
        }
      }
    }, e
  }(ii);
  mi.prototype.allowedEvents_ = {
    cuechange: "cuechange"
  };
  var gi = function (r) {
      function e(e) {
        var t;
        void 0 === e && (e = {});
        var i = gt(e, {
          kind: Zt[e.kind] || ""
        });
        t = r.call(this, i) || this;
        var n = !1;
        return Object.defineProperty(St(t), "enabled", {
          get: function () {
            return n
          },
          set: function (e) {
            "boolean" == typeof e && e !== n && (n = e, this.trigger("enabledchange"))
          }
        }), i.enabled && (t.enabled = i.enabled), t.loaded_ = !0, t
      }
      return Et(e, r), e
    }(ii),
    vi = function (r) {
      function e(e) {
        var t;
        void 0 === e && (e = {});
        var i = gt(e, {
          kind: Jt[e.kind] || ""
        });
        t = r.call(this, i) || this;
        var n = !1;
        return Object.defineProperty(St(t), "selected", {
          get: function () {
            return n
          },
          set: function (e) {
            "boolean" == typeof e && e !== n && (n = e, this.trigger("selectedchange"))
          }
        }), i.selected && (t.selected = i.selected), t
      }
      return Et(e, r), e
    }(ii),
    yi = function (r) {
      function e(e) {
        var t, i;
        void 0 === e && (e = {}), t = r.call(this) || this;
        var n = new mi(e);
        return t.kind = n.kind, t.src = n.src, t.srclang = n.language, t.label = n.label, t.default = n.default, Object.defineProperties(St(t), {
          readyState: {
            get: function () {
              return i
            }
          },
          track: {
            get: function () {
              return n
            }
          }
        }), i = 0, n.addEventListener("loadeddata", function () {
          i = 2, t.trigger({
            type: "load",
            target: St(t)
          })
        }), t
      }
      return Et(e, r), e
    }(Ze);
  yi.prototype.allowedEvents_ = {
    load: "load"
  }, yi.NONE = 0, yi.LOADING = 1, yi.LOADED = 2, yi.ERROR = 3;
  var _i = {
    audio: {
      ListClass: Xt,
      TrackClass: gi,
      capitalName: "Audio"
    },
    video: {
      ListClass: Kt,
      TrackClass: vi,
      capitalName: "Video"
    },
    text: {
      ListClass: Yt,
      TrackClass: mi,
      capitalName: "Text"
    }
  };
  Object.keys(_i).forEach(function (e) {
    _i[e].getterName = e + "Tracks", _i[e].privateName = e + "Tracks_"
  });
  var bi = {
      remoteText: {
        ListClass: Yt,
        TrackClass: mi,
        capitalName: "RemoteText",
        getterName: "remoteTextTracks",
        privateName: "remoteTextTracks_"
      },
      remoteTextEl: {
        ListClass: Qt,
        TrackClass: yi,
        capitalName: "RemoteTextTrackEls",
        getterName: "remoteTextTrackEls",
        privateName: "remoteTextTrackEls_"
      }
    },
    Ti = y({}, _i, bi);
  bi.names = Object.keys(bi), _i.names = Object.keys(_i), Ti.names = [].concat(bi.names).concat(_i.names);
  var Si = Object.create || function (e) {
    if (1 !== arguments.length) throw new Error("Object.create shim only accepts one parameter.");
    return Ei.prototype = e, new Ei
  };

  function Ei() {}

  function ki(e, t) {
    this.name = "ParsingError", this.code = e.code, this.message = t || e.message
  }

  function wi(e) {
    function t(e, t, i, n) {
      return 3600 * (0 | e) + 60 * (0 | t) + (0 | i) + (0 | n) / 1e3
    }
    var i = e.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
    return i ? i[3] ? t(i[1], i[2], i[3].replace(":", ""), i[4]) : 59 < i[1] ? t(i[1], i[2], 0, i[4]) : t(0, i[1], i[2], i[4]) : null
  }

  function Ci() {
    this.values = Si(null)
  }

  function Ii(e, t, i, n) {
    var r = n ? e.split(n) : [e];
    for (var a in r)
      if ("string" == typeof r[a]) {
        var s = r[a].split(i);
        if (2 === s.length) t(s[0], s[1])
      }
  }

  function xi(t, e, s) {
    var i = t;

    function n() {
      var e = wi(t);
      if (null === e) throw new ki(ki.Errors.BadTimeStamp, "Malformed timestamp: " + i);
      return t = t.replace(/^[^\sa-zA-Z-]+/, ""), e
    }

    function r() {
      t = t.replace(/^\s+/, "")
    }
    if (r(), e.startTime = n(), r(), "--\x3e" !== t.substr(0, 3)) throw new ki(ki.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '--\x3e'): " + i);
    t = t.substr(3), r(), e.endTime = n(), r(),
      function (e, t) {
        var a = new Ci;
        Ii(e, function (e, t) {
          switch (e) {
            case "region":
              for (var i = s.length - 1; 0 <= i; i--)
                if (s[i].id === t) {
                  a.set(e, s[i].region);
                  break
                } break;
            case "vertical":
              a.alt(e, t, ["rl", "lr"]);
              break;
            case "line":
              var n = t.split(","),
                r = n[0];
              a.integer(e, r), a.percent(e, r) && a.set("snapToLines", !1), a.alt(e, r, ["auto"]), 2 === n.length && a.alt("lineAlign", n[1], ["start", "center", "end"]);
              break;
            case "position":
              n = t.split(","), a.percent(e, n[0]), 2 === n.length && a.alt("positionAlign", n[1], ["start", "center", "end"]);
              break;
            case "size":
              a.percent(e, t);
              break;
            case "align":
              a.alt(e, t, ["start", "center", "end", "left", "right"])
          }
        }, /:/, /\s/), t.region = a.get("region", null), t.vertical = a.get("vertical", "");
        try {
          t.line = a.get("line", "auto")
        } catch (e) {}
        t.lineAlign = a.get("lineAlign", "start"), t.snapToLines = a.get("snapToLines", !0), t.size = a.get("size", 100);
        try {
          t.align = a.get("align", "center")
        } catch (e) {
          t.align = a.get("align", "middle")
        }
        try {
          t.position = a.get("position", "auto")
        } catch (e) {
          t.position = a.get("position", {
            start: 0,
            left: 0,
            center: 50,
            middle: 50,
            end: 100,
            right: 100
          }, t.align)
        }
        t.positionAlign = a.get("positionAlign", {
          start: "start",
          left: "start",
          center: "center",
          middle: "center",
          end: "end",
          right: "end"
        }, t.align)
      }(t, e)
  }((ki.prototype = Si(Error.prototype)).constructor = ki).Errors = {
    BadSignature: {
      code: 0,
      message: "Malformed WebVTT signature."
    },
    BadTimeStamp: {
      code: 1,
      message: "Malformed time stamp."
    }
  }, Ci.prototype = {
    set: function (e, t) {
      this.get(e) || "" === t || (this.values[e] = t)
    },
    get: function (e, t, i) {
      return i ? this.has(e) ? this.values[e] : t[i] : this.has(e) ? this.values[e] : t
    },
    has: function (e) {
      return e in this.values
    },
    alt: function (e, t, i) {
      for (var n = 0; n < i.length; ++n)
        if (t === i[n]) {
          this.set(e, t);
          break
        }
    },
    integer: function (e, t) {
      /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10))
    },
    percent: function (e, t) {
      return !!(t.match(/^([\d]{1,3})(\.[\d]*)?%$/) && 0 <= (t = parseFloat(t)) && t <= 100) && (this.set(e, t), !0)
    }
  };
  var Ai = p.createElement && p.createElement("textarea"),
    Pi = {
      c: "span",
      i: "i",
      b: "b",
      u: "u",
      ruby: "ruby",
      rt: "rt",
      v: "span",
      lang: "span"
    },
    Li = {
      white: "rgba(255,255,255,1)",
      lime: "rgba(0,255,0,1)",
      cyan: "rgba(0,255,255,1)",
      red: "rgba(255,0,0,1)",
      yellow: "rgba(255,255,0,1)",
      magenta: "rgba(255,0,255,1)",
      blue: "rgba(0,0,255,1)",
      black: "rgba(0,0,0,1)"
    },
    Oi = {
      v: "title",
      lang: "lang"
    },
    Di = {
      rt: "ruby"
    };

  function Ri(a, i) {
    function e() {
      if (!i) return null;
      var e, t = i.match(/^([^<]*)(<[^>]*>?)?/);
      return e = t[1] ? t[1] : t[2], i = i.substr(e.length), e
    }

    function t(e, t) {
      var i = Pi[e];
      if (!i) return null;
      var n = a.document.createElement(i),
        r = Oi[e];
      return r && t && (n[r] = t.trim()), n
    }
    for (var n, r, s, o, u = a.document.createElement("div"), l = u, c = []; null !== (n = e());)
      if ("<" !== n[0]) l.appendChild(a.document.createTextNode((r = n, Ai.innerHTML = r, r = Ai.textContent, Ai.textContent = "", r)));
      else {
        if ("/" === n[1]) {
          c.length && c[c.length - 1] === n.substr(2).replace(">", "") && (c.pop(), l = l.parentNode);
          continue
        }
        var d, h = wi(n.substr(1, n.length - 2));
        if (h) {
          d = a.document.createProcessingInstruction("timestamp", h), l.appendChild(d);
          continue
        }
        var p = n.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
        if (!p) continue;
        if (!(d = t(p[1], p[3]))) continue;
        if (s = l, Di[(o = d).localName] && Di[o.localName] !== s.localName) continue;
        if (p[2]) {
          var f = p[2].split(".");
          f.forEach(function (e) {
            var t = /^bg_/.test(e),
              i = t ? e.slice(3) : e;
            if (Li.hasOwnProperty(i)) {
              var n = t ? "background-color" : "color",
                r = Li[i];
              d.style[n] = r
            }
          }), d.className = f.join(" ")
        }
        c.push(p[1]), l.appendChild(d), l = d
      } return u
  }
  var Mi = [
    [1470, 1470],
    [1472, 1472],
    [1475, 1475],
    [1478, 1478],
    [1488, 1514],
    [1520, 1524],
    [1544, 1544],
    [1547, 1547],
    [1549, 1549],
    [1563, 1563],
    [1566, 1610],
    [1645, 1647],
    [1649, 1749],
    [1765, 1766],
    [1774, 1775],
    [1786, 1805],
    [1807, 1808],
    [1810, 1839],
    [1869, 1957],
    [1969, 1969],
    [1984, 2026],
    [2036, 2037],
    [2042, 2042],
    [2048, 2069],
    [2074, 2074],
    [2084, 2084],
    [2088, 2088],
    [2096, 2110],
    [2112, 2136],
    [2142, 2142],
    [2208, 2208],
    [2210, 2220],
    [8207, 8207],
    [64285, 64285],
    [64287, 64296],
    [64298, 64310],
    [64312, 64316],
    [64318, 64318],
    [64320, 64321],
    [64323, 64324],
    [64326, 64449],
    [64467, 64829],
    [64848, 64911],
    [64914, 64967],
    [65008, 65020],
    [65136, 65140],
    [65142, 65276],
    [67584, 67589],
    [67592, 67592],
    [67594, 67637],
    [67639, 67640],
    [67644, 67644],
    [67647, 67669],
    [67671, 67679],
    [67840, 67867],
    [67872, 67897],
    [67903, 67903],
    [67968, 68023],
    [68030, 68031],
    [68096, 68096],
    [68112, 68115],
    [68117, 68119],
    [68121, 68147],
    [68160, 68167],
    [68176, 68184],
    [68192, 68223],
    [68352, 68405],
    [68416, 68437],
    [68440, 68466],
    [68472, 68479],
    [68608, 68680],
    [126464, 126467],
    [126469, 126495],
    [126497, 126498],
    [126500, 126500],
    [126503, 126503],
    [126505, 126514],
    [126516, 126519],
    [126521, 126521],
    [126523, 126523],
    [126530, 126530],
    [126535, 126535],
    [126537, 126537],
    [126539, 126539],
    [126541, 126543],
    [126545, 126546],
    [126548, 126548],
    [126551, 126551],
    [126553, 126553],
    [126555, 126555],
    [126557, 126557],
    [126559, 126559],
    [126561, 126562],
    [126564, 126564],
    [126567, 126570],
    [126572, 126578],
    [126580, 126583],
    [126585, 126588],
    [126590, 126590],
    [126592, 126601],
    [126603, 126619],
    [126625, 126627],
    [126629, 126633],
    [126635, 126651],
    [1114109, 1114109]
  ];

  function Ni(e) {
    for (var t = 0; t < Mi.length; t++) {
      var i = Mi[t];
      if (e >= i[0] && e <= i[1]) return !0
    }
    return !1
  }

  function Ui() {}

  function Bi(e, t, i) {
    Ui.call(this), this.cue = t, this.cueDiv = Ri(e, t.text);
    var n = {
      color: "rgba(255, 255, 255, 1)",
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      position: "relative",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: "inline",
      writingMode: "" === t.vertical ? "horizontal-tb" : "lr" === t.vertical ? "vertical-lr" : "vertical-rl",
      unicodeBidi: "plaintext"
    };
    this.applyStyles(n, this.cueDiv), this.div = e.document.createElement("div"), n = {
      direction: function (e) {
        var t = [],
          i = "";
        if (!e || !e.childNodes) return "ltr";

        function r(e, t) {
          for (var i = t.childNodes.length - 1; 0 <= i; i--) e.push(t.childNodes[i])
        }

        function a(e) {
          if (!e || !e.length) return null;
          var t = e.pop(),
            i = t.textContent || t.innerText;
          if (i) {
            var n = i.match(/^.*(\n|\r)/);
            return n ? n[e.length = 0] : i
          }
          return "ruby" === t.tagName ? a(e) : t.childNodes ? (r(e, t), a(e)) : void 0
        }
        for (r(t, e); i = a(t);)
          for (var n = 0; n < i.length; n++)
            if (Ni(i.charCodeAt(n))) return "rtl";
        return "ltr"
      }(this.cueDiv),
      writingMode: "" === t.vertical ? "horizontal-tb" : "lr" === t.vertical ? "vertical-lr" : "vertical-rl",
      unicodeBidi: "plaintext",
      textAlign: "middle" === t.align ? "center" : t.align,
      font: i.font,
      whiteSpace: "pre-line",
      position: "absolute"
    }, this.applyStyles(n), this.div.appendChild(this.cueDiv);
    var r = 0;
    switch (t.positionAlign) {
      case "start":
        r = t.position;
        break;
      case "center":
        r = t.position - t.size / 2;
        break;
      case "end":
        r = t.position - t.size
    }
    "" === t.vertical ? this.applyStyles({
      left: this.formatStyle(r, "%"),
      width: this.formatStyle(t.size, "%")
    }) : this.applyStyles({
      top: this.formatStyle(r, "%"),
      height: this.formatStyle(t.size, "%")
    }), this.move = function (e) {
      this.applyStyles({
        top: this.formatStyle(e.top, "px"),
        bottom: this.formatStyle(e.bottom, "px"),
        left: this.formatStyle(e.left, "px"),
        right: this.formatStyle(e.right, "px"),
        height: this.formatStyle(e.height, "px"),
        width: this.formatStyle(e.width, "px")
      })
    }
  }

  function Fi(e) {
    var t, i, n, r;
    if (e.div) {
      i = e.div.offsetHeight, n = e.div.offsetWidth, r = e.div.offsetTop;
      var a = (a = e.div.childNodes) && (a = a[0]) && a.getClientRects && a.getClientRects();
      e = e.div.getBoundingClientRect(), t = a ? Math.max(a[0] && a[0].height || 0, e.height / a.length) : 0
    }
    this.left = e.left, this.right = e.right, this.top = e.top || r, this.height = e.height || i, this.bottom = e.bottom || r + (e.height || i), this.width = e.width || n, this.lineHeight = void 0 !== t ? t : e.lineHeight
  }

  function ji(e, t, o, u) {
    var i = new Fi(t),
      n = t.cue,
      r = function (e) {
        if ("number" == typeof e.line && (e.snapToLines || 0 <= e.line && e.line <= 100)) return e.line;
        if (!e.track || !e.track.textTrackList || !e.track.textTrackList.mediaElement) return -1;
        for (var t = e.track, i = t.textTrackList, n = 0, r = 0; r < i.length && i[r] !== t; r++) "showing" === i[r].mode && n++;
        return -1 * ++n
      }(n),
      a = [];
    if (n.snapToLines) {
      var s;
      switch (n.vertical) {
        case "":
          a = ["+y", "-y"], s = "height";
          break;
        case "rl":
          a = ["+x", "-x"], s = "width";
          break;
        case "lr":
          a = ["-x", "+x"], s = "width"
      }
      var l = i.lineHeight,
        c = l * Math.round(r),
        d = o[s] + l,
        h = a[0];
      Math.abs(c) > d && (c = c < 0 ? -1 : 1, c *= Math.ceil(d / l) * l), r < 0 && (c += "" === n.vertical ? o.height : o.width, a = a.reverse()), i.move(h, c)
    } else {
      var p = i.lineHeight / o.height * 100;
      switch (n.lineAlign) {
        case "center":
          r -= p / 2;
          break;
        case "end":
          r -= p
      }
      switch (n.vertical) {
        case "":
          t.applyStyles({
            top: t.formatStyle(r, "%")
          });
          break;
        case "rl":
          t.applyStyles({
            left: t.formatStyle(r, "%")
          });
          break;
        case "lr":
          t.applyStyles({
            right: t.formatStyle(r, "%")
          })
      }
      a = ["+y", "-x", "+x", "-y"], i = new Fi(t)
    }
    var f = function (e, t) {
      for (var i, n = new Fi(e), r = 1, a = 0; a < t.length; a++) {
        for (; e.overlapsOppositeAxis(o, t[a]) || e.within(o) && e.overlapsAny(u);) e.move(t[a]);
        if (e.within(o)) return e;
        var s = e.intersectPercentage(o);
        s < r && (i = new Fi(e), r = s), e = new Fi(n)
      }
      return i || n
    }(i, a);
    t.move(f.toCSSCompatValues(o))
  }

  function Hi() {}
  Ui.prototype.applyStyles = function (e, t) {
    for (var i in t = t || this.div, e) e.hasOwnProperty(i) && (t.style[i] = e[i])
  }, Ui.prototype.formatStyle = function (e, t) {
    return 0 === e ? 0 : e + t
  }, (Bi.prototype = Si(Ui.prototype)).constructor = Bi, Fi.prototype.move = function (e, t) {
    switch (t = void 0 !== t ? t : this.lineHeight, e) {
      case "+x":
        this.left += t, this.right += t;
        break;
      case "-x":
        this.left -= t, this.right -= t;
        break;
      case "+y":
        this.top += t, this.bottom += t;
        break;
      case "-y":
        this.top -= t, this.bottom -= t
    }
  }, Fi.prototype.overlaps = function (e) {
    return this.left < e.right && this.right > e.left && this.top < e.bottom && this.bottom > e.top
  }, Fi.prototype.overlapsAny = function (e) {
    for (var t = 0; t < e.length; t++)
      if (this.overlaps(e[t])) return !0;
    return !1
  }, Fi.prototype.within = function (e) {
    return this.top >= e.top && this.bottom <= e.bottom && this.left >= e.left && this.right <= e.right
  }, Fi.prototype.overlapsOppositeAxis = function (e, t) {
    switch (t) {
      case "+x":
        return this.left < e.left;
      case "-x":
        return this.right > e.right;
      case "+y":
        return this.top < e.top;
      case "-y":
        return this.bottom > e.bottom
    }
  }, Fi.prototype.intersectPercentage = function (e) {
    return Math.max(0, Math.min(this.right, e.right) - Math.max(this.left, e.left)) * Math.max(0, Math.min(this.bottom, e.bottom) - Math.max(this.top, e.top)) / (this.height * this.width)
  }, Fi.prototype.toCSSCompatValues = function (e) {
    return {
      top: this.top - e.top,
      bottom: e.bottom - this.bottom,
      left: this.left - e.left,
      right: e.right - this.right,
      height: this.height,
      width: this.width
    }
  }, Fi.getSimpleBoxPosition = function (e) {
    var t = e.div ? e.div.offsetHeight : e.tagName ? e.offsetHeight : 0,
      i = e.div ? e.div.offsetWidth : e.tagName ? e.offsetWidth : 0,
      n = e.div ? e.div.offsetTop : e.tagName ? e.offsetTop : 0;
    return {
      left: (e = e.div ? e.div.getBoundingClientRect() : e.tagName ? e.getBoundingClientRect() : e).left,
      right: e.right,
      top: e.top || n,
      height: e.height || t,
      bottom: e.bottom || n + (e.height || t),
      width: e.width || i
    }
  }, Hi.StringDecoder = function () {
    return {
      decode: function (e) {
        if (!e) return "";
        if ("string" != typeof e) throw new Error("Error - expected string data.");
        return decodeURIComponent(encodeURIComponent(e))
      }
    }
  }, Hi.convertCueToDOMTree = function (e, t) {
    return e && t ? Ri(e, t) : null
  };
  Hi.processCues = function (n, r, e) {
    if (!n || !r || !e) return null;
    for (; e.firstChild;) e.removeChild(e.firstChild);
    var a = n.document.createElement("div");
    if (a.style.position = "absolute", a.style.left = "0", a.style.right = "0", a.style.top = "0", a.style.bottom = "0", a.style.margin = "1.5%", e.appendChild(a), function (e) {
        for (var t = 0; t < e.length; t++)
          if (e[t].hasBeenReset || !e[t].displayState) return !0;
        return !1
      }(r)) {
      var s = [],
        o = Fi.getSimpleBoxPosition(a),
        u = {
          font: Math.round(.05 * o.height * 100) / 100 + "px sans-serif"
        };
      ! function () {
        for (var e, t, i = 0; i < r.length; i++) t = r[i], e = new Bi(n, t, u), a.appendChild(e.div), ji(0, e, o, s), t.displayState = e.div, s.push(Fi.getSimpleBoxPosition(e))
      }()
    } else
      for (var t = 0; t < r.length; t++) a.appendChild(r[t].displayState)
  }, (Hi.Parser = function (e, t, i) {
    i || (i = t, t = {}), t = t || {}, this.window = e, this.vttjs = t, this.state = "INITIAL", this.buffer = "", this.decoder = i || new TextDecoder("utf8"), this.regionList = []
  }).prototype = {
    reportOrThrowError: function (e) {
      if (!(e instanceof ki)) throw e;
      this.onparsingerror && this.onparsingerror(e)
    },
    parse: function (e) {
      var n = this;

      function t() {
        for (var e = n.buffer, t = 0; t < e.length && "\r" !== e[t] && "\n" !== e[t];) ++t;
        var i = e.substr(0, t);
        return "\r" === e[t] && ++t, "\n" === e[t] && ++t, n.buffer = e.substr(t), i
      }

      function i(e) {
        e.match(/X-TIMESTAMP-MAP/) ? Ii(e, function (e, t) {
          switch (e) {
            case "X-TIMESTAMP-MAP":
              ! function (e) {
                var i = new Ci;
                Ii(e, function (e, t) {
                  switch (e) {
                    case "MPEGT":
                      i.integer(e + "S", t);
                      break;
                    case "LOCA":
                      i.set(e + "L", wi(t))
                  }
                }, /[^\d]:/, /,/), n.ontimestampmap && n.ontimestampmap({
                  MPEGTS: i.get("MPEGTS"),
                  LOCAL: i.get("LOCAL")
                })
              }(t)
          }
        }, /=/) : Ii(e, function (e, t) {
          switch (e) {
            case "Region":
              ! function (e) {
                var r = new Ci;
                if (Ii(e, function (e, t) {
                    switch (e) {
                      case "id":
                        r.set(e, t);
                        break;
                      case "width":
                        r.percent(e, t);
                        break;
                      case "lines":
                        r.integer(e, t);
                        break;
                      case "regionanchor":
                      case "viewportanchor":
                        var i = t.split(",");
                        if (2 !== i.length) break;
                        var n = new Ci;
                        if (n.percent("x", i[0]), n.percent("y", i[1]), !n.has("x") || !n.has("y")) break;
                        r.set(e + "X", n.get("x")), r.set(e + "Y", n.get("y"));
                        break;
                      case "scroll":
                        r.alt(e, t, ["up"])
                    }
                  }, /=/, /\s/), r.has("id")) {
                  var t = new(n.vttjs.VTTRegion || n.window.VTTRegion);
                  t.width = r.get("width", 100), t.lines = r.get("lines", 3), t.regionAnchorX = r.get("regionanchorX", 0), t.regionAnchorY = r.get("regionanchorY", 100), t.viewportAnchorX = r.get("viewportanchorX", 0), t.viewportAnchorY = r.get("viewportanchorY", 100), t.scroll = r.get("scroll", ""), n.onregion && n.onregion(t), n.regionList.push({
                    id: r.get("id"),
                    region: t
                  })
                }
              }(t)
          }
        }, /:/)
      }
      e && (n.buffer += n.decoder.decode(e, {
        stream: !0
      }));
      try {
        var r;
        if ("INITIAL" === n.state) {
          if (!/\r\n|\n/.test(n.buffer)) return this;
          var a = (r = t()).match(/^WEBVTT([ \t].*)?$/);
          if (!a || !a[0]) throw new ki(ki.Errors.BadSignature);
          n.state = "HEADER"
        }
        for (var s = !1; n.buffer;) {
          if (!/\r\n|\n/.test(n.buffer)) return this;
          switch (s ? s = !1 : r = t(), n.state) {
            case "HEADER":
              /:/.test(r) ? i(r) : r || (n.state = "ID");
              continue;
            case "NOTE":
              r || (n.state = "ID");
              continue;
            case "ID":
              if (/^NOTE($|[ \t])/.test(r)) {
                n.state = "NOTE";
                break
              }
              if (!r) continue;
              n.cue = new(n.vttjs.VTTCue || n.window.VTTCue)(0, 0, "");
              try {
                n.cue.align = "center"
              } catch (e) {
                n.cue.align = "middle"
              }
              if (n.state = "CUE", -1 === r.indexOf("--\x3e")) {
                n.cue.id = r;
                continue
              }
              case "CUE":
                try {
                  xi(r, n.cue, n.regionList)
                } catch (e) {
                  n.reportOrThrowError(e), n.cue = null, n.state = "BADCUE";
                  continue
                }
                n.state = "CUETEXT";
                continue;
              case "CUETEXT":
                var o = -1 !== r.indexOf("--\x3e");
                if (!r || o && (s = !0)) {
                  n.oncue && n.oncue(n.cue), n.cue = null, n.state = "ID";
                  continue
                }
                n.cue.text && (n.cue.text += "\n"), n.cue.text += r.replace(/\u2028/g, "\n").replace(/u2029/g, "\n");
                continue;
              case "BADCUE":
                r || (n.state = "ID");
                continue
          }
        }
      } catch (e) {
        n.reportOrThrowError(e), "CUETEXT" === n.state && n.cue && n.oncue && n.oncue(n.cue), n.cue = null, n.state = "INITIAL" === n.state ? "BADWEBVTT" : "BADCUE"
      }
      return this
    },
    flush: function () {
      var t = this;
      try {
        if (t.buffer += t.decoder.decode(), !t.cue && "HEADER" !== t.state || (t.buffer += "\n\n", t.parse()), "INITIAL" === t.state) throw new ki(ki.Errors.BadSignature)
      } catch (e) {
        t.reportOrThrowError(e)
      }
      return t.onflush && t.onflush(), this
    }
  };
  var Vi = Hi,
    qi = {
      "": 1,
      lr: 1,
      rl: 1
    },
    Wi = {
      start: 1,
      center: 1,
      end: 1,
      left: 1,
      right: 1,
      auto: 1,
      "line-left": 1,
      "line-right": 1
    };

  function zi(e) {
    return "string" == typeof e && (!!Wi[e.toLowerCase()] && e.toLowerCase())
  }

  function Gi(e, t, i) {
    this.hasBeenReset = !1;
    var n = "",
      r = !1,
      a = e,
      s = t,
      o = i,
      u = null,
      l = "",
      c = !0,
      d = "auto",
      h = "start",
      p = "auto",
      f = "auto",
      m = 100,
      g = "center";
    Object.defineProperties(this, {
      id: {
        enumerable: !0,
        get: function () {
          return n
        },
        set: function (e) {
          n = "" + e
        }
      },
      pauseOnExit: {
        enumerable: !0,
        get: function () {
          return r
        },
        set: function (e) {
          r = !!e
        }
      },
      startTime: {
        enumerable: !0,
        get: function () {
          return a
        },
        set: function (e) {
          if ("number" != typeof e) throw new TypeError("Start time must be set to a number.");
          a = e, this.hasBeenReset = !0
        }
      },
      endTime: {
        enumerable: !0,
        get: function () {
          return s
        },
        set: function (e) {
          if ("number" != typeof e) throw new TypeError("End time must be set to a number.");
          s = e, this.hasBeenReset = !0
        }
      },
      text: {
        enumerable: !0,
        get: function () {
          return o
        },
        set: function (e) {
          o = "" + e, this.hasBeenReset = !0
        }
      },
      region: {
        enumerable: !0,
        get: function () {
          return u
        },
        set: function (e) {
          u = e, this.hasBeenReset = !0
        }
      },
      vertical: {
        enumerable: !0,
        get: function () {
          return l
        },
        set: function (e) {
          var t = function (e) {
            return "string" == typeof e && (!!qi[e.toLowerCase()] && e.toLowerCase())
          }(e);
          if (!1 === t) throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
          l = t, this.hasBeenReset = !0
        }
      },
      snapToLines: {
        enumerable: !0,
        get: function () {
          return c
        },
        set: function (e) {
          c = !!e, this.hasBeenReset = !0
        }
      },
      line: {
        enumerable: !0,
        get: function () {
          return d
        },
        set: function (e) {
          if ("number" != typeof e && "auto" !== e) throw new SyntaxError("Line: an invalid number or illegal string was specified.");
          d = e, this.hasBeenReset = !0
        }
      },
      lineAlign: {
        enumerable: !0,
        get: function () {
          return h
        },
        set: function (e) {
          var t = zi(e);
          t && (h = t, this.hasBeenReset = !0)
        }
      },
      position: {
        enumerable: !0,
        get: function () {
          return p
        },
        set: function (e) {
          if (e < 0 || 100 < e) throw new Error("Position must be between 0 and 100.");
          p = e, this.hasBeenReset = !0
        }
      },
      positionAlign: {
        enumerable: !0,
        get: function () {
          return f
        },
        set: function (e) {
          var t = zi(e);
          t && (f = t, this.hasBeenReset = !0)
        }
      },
      size: {
        enumerable: !0,
        get: function () {
          return m
        },
        set: function (e) {
          if (e < 0 || 100 < e) throw new Error("Size must be between 0 and 100.");
          m = e, this.hasBeenReset = !0
        }
      },
      align: {
        enumerable: !0,
        get: function () {
          return g
        },
        set: function (e) {
          var t = zi(e);
          if (!t) throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
          g = t, this.hasBeenReset = !0
        }
      }
    }), this.displayState = void 0
  }
  Gi.prototype.getCueAsHTML = function () {
    return WebVTT.convertCueToDOMTree(window, this.text)
  };
  var Xi = Gi,
    Ki = {
      "": !0,
      up: !0
    };

  function Yi(e) {
    return "number" == typeof e && 0 <= e && e <= 100
  }

  function Qi() {
    var t = 100,
      i = 3,
      n = 0,
      r = 100,
      a = 0,
      s = 100,
      o = "";
    Object.defineProperties(this, {
      width: {
        enumerable: !0,
        get: function () {
          return t
        },
        set: function (e) {
          if (!Yi(e)) throw new Error("Width must be between 0 and 100.");
          t = e
        }
      },
      lines: {
        enumerable: !0,
        get: function () {
          return i
        },
        set: function (e) {
          if ("number" != typeof e) throw new TypeError("Lines must be set to a number.");
          i = e
        }
      },
      regionAnchorY: {
        enumerable: !0,
        get: function () {
          return r
        },
        set: function (e) {
          if (!Yi(e)) throw new Error("RegionAnchorX must be between 0 and 100.");
          r = e
        }
      },
      regionAnchorX: {
        enumerable: !0,
        get: function () {
          return n
        },
        set: function (e) {
          if (!Yi(e)) throw new Error("RegionAnchorY must be between 0 and 100.");
          n = e
        }
      },
      viewportAnchorY: {
        enumerable: !0,
        get: function () {
          return s
        },
        set: function (e) {
          if (!Yi(e)) throw new Error("ViewportAnchorY must be between 0 and 100.");
          s = e
        }
      },
      viewportAnchorX: {
        enumerable: !0,
        get: function () {
          return a
        },
        set: function (e) {
          if (!Yi(e)) throw new Error("ViewportAnchorX must be between 0 and 100.");
          a = e
        }
      },
      scroll: {
        enumerable: !0,
        get: function () {
          return o
        },
        set: function (e) {
          var t = function (e) {
            return "string" == typeof e && (!!Ki[e.toLowerCase()] && e.toLowerCase())
          }(e);
          !1 === t || (o = t)
        }
      }
    })
  }
  var $i = i(function (e) {
    var t = e.exports = {
      WebVTT: Vi,
      VTTCue: Xi,
      VTTRegion: Qi
    };
    h.vttjs = t, h.WebVTT = t.WebVTT;
    var i = t.VTTCue,
      n = t.VTTRegion,
      r = h.VTTCue,
      a = h.VTTRegion;
    t.shim = function () {
      h.VTTCue = i, h.VTTRegion = n
    }, t.restore = function () {
      h.VTTCue = r, h.VTTRegion = a
    }, h.VTTCue || t.shim()
  });
  $i.WebVTT, $i.VTTCue, $i.VTTRegion;
  var Ji = function (t) {
    function i(i, e) {
      var n;
      return void 0 === i && (i = {}), void 0 === e && (e = function () {}), i.reportTouchActivity = !1, (n = t.call(this, null, i, e) || this).onDurationChange_ = function (e) {
        return n.onDurationChange(e)
      }, n.trackProgress_ = function (e) {
        return n.trackProgress(e)
      }, n.trackCurrentTime_ = function (e) {
        return n.trackCurrentTime(e)
      }, n.stopTrackingCurrentTime_ = function (e) {
        return n.stopTrackingCurrentTime(e)
      }, n.disposeSourceHandler_ = function (e) {
        return n.disposeSourceHandler(e)
      }, n.hasStarted_ = !1, n.on("playing", function () {
        this.hasStarted_ = !0
      }), n.on("loadstart", function () {
        this.hasStarted_ = !1
      }), Ti.names.forEach(function (e) {
        var t = Ti[e];
        i && i[t.getterName] && (n[t.privateName] = i[t.getterName])
      }), n.featuresProgressEvents || n.manualProgressOn(), n.featuresTimeupdateEvents || n.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach(function (e) {
        !1 === i["native" + e + "Tracks"] && (n["featuresNative" + e + "Tracks"] = !1)
      }), !1 === i.nativeCaptions || !1 === i.nativeTextTracks ? n.featuresNativeTextTracks = !1 : !0 !== i.nativeCaptions && !0 !== i.nativeTextTracks || (n.featuresNativeTextTracks = !0), n.featuresNativeTextTracks || n.emulateTextTracks(), n.preloadTextTracks = !1 !== i.preloadTextTracks, n.autoRemoteTextTracks_ = new Ti.text.ListClass, n.initTrackListeners(), i.nativeControlsForTouch || n.emitTapEvents(), n.constructor && (n.name_ = n.constructor.name || "Unknown Tech"), n
    }
    Et(i, t);
    var e = i.prototype;
    return e.triggerSourceset = function (e) {
      var t = this;
      this.isReady_ || this.one("ready", function () {
        return t.setTimeout(function () {
          return t.triggerSourceset(e)
        }, 1)
      }), this.trigger({
        src: e,
        type: "sourceset"
      })
    }, e.manualProgressOn = function () {
      this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_)
    }, e.manualProgressOff = function () {
      this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_)
    }, e.trackProgress = function (e) {
      this.stopTrackingProgress(), this.progressInterval = this.setInterval($e(this, function () {
        var e = this.bufferedPercent();
        this.bufferedPercent_ !== e && this.trigger("progress"), 1 === (this.bufferedPercent_ = e) && this.stopTrackingProgress()
      }), 500)
    }, e.onDurationChange = function (e) {
      this.duration_ = this.duration()
    }, e.buffered = function () {
      return Ct(0, 0)
    }, e.bufferedPercent = function () {
      return It(this.buffered(), this.duration_)
    }, e.stopTrackingProgress = function () {
      this.clearInterval(this.progressInterval)
    }, e.manualTimeUpdatesOn = function () {
      this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_)
    }, e.manualTimeUpdatesOff = function () {
      this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_)
    }, e.trackCurrentTime = function () {
      this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function () {
        this.trigger({
          type: "timeupdate",
          target: this,
          manuallyTriggered: !0
        })
      }, 250)
    }, e.stopTrackingCurrentTime = function () {
      this.clearInterval(this.currentTimeInterval), this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      })
    }, e.dispose = function () {
      this.clearTracks(_i.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), t.prototype.dispose.call(this)
    }, e.clearTracks = function (e) {
      var r = this;
      (e = [].concat(e)).forEach(function (e) {
        for (var t = r[e + "Tracks"]() || [], i = t.length; i--;) {
          var n = t[i];
          "text" === e && r.removeRemoteTextTrack(n), t.removeTrack(n)
        }
      })
    }, e.cleanupAutoTextTracks = function () {
      for (var e = this.autoRemoteTextTracks_ || [], t = e.length; t--;) {
        var i = e[t];
        this.removeRemoteTextTrack(i)
      }
    }, e.reset = function () {}, e.crossOrigin = function () {}, e.setCrossOrigin = function () {}, e.error = function (e) {
      return void 0 !== e && (this.error_ = new xt(e), this.trigger("error")), this.error_
    }, e.played = function () {
      return this.hasStarted_ ? Ct(0, 0) : Ct()
    }, e.play = function () {}, e.setScrubbing = function () {}, e.scrubbing = function () {}, e.setCurrentTime = function () {
      this.manualTimeUpdates && this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      })
    }, e.initTrackListeners = function () {
      var r = this;
      _i.names.forEach(function (e) {
        function t() {
          r.trigger(e + "trackchange")
        }
        var i = _i[e],
          n = r[i.getterName]();
        n.addEventListener("removetrack", t), n.addEventListener("addtrack", t), r.on("dispose", function () {
          n.removeEventListener("removetrack", t), n.removeEventListener("addtrack", t)
        })
      })
    }, e.addWebVttScript_ = function () {
      var e = this;
      if (!h.WebVTT)
        if (p.body.contains(this.el())) {
          if (!this.options_["vtt.js"] && k($i) && 0 < Object.keys($i).length) return void this.trigger("vttjsloaded");
          var t = p.createElement("script");
          t.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", t.onload = function () {
            e.trigger("vttjsloaded")
          }, t.onerror = function () {
            e.trigger("vttjserror")
          }, this.on("dispose", function () {
            t.onload = null, t.onerror = null
          }), h.WebVTT = !0, this.el().parentNode.appendChild(t)
        } else this.ready(this.addWebVttScript_)
    }, e.emulateTextTracks = function () {
      function t(e) {
        return n.addTrack(e.track)
      }

      function i(e) {
        return n.removeTrack(e.track)
      }
      var e = this,
        n = this.textTracks(),
        r = this.remoteTextTracks();
      r.on("addtrack", t), r.on("removetrack", i), this.addWebVttScript_();

      function a() {
        return e.trigger("texttrackchange")
      }

      function s() {
        a();
        for (var e = 0; e < n.length; e++) {
          var t = n[e];
          t.removeEventListener("cuechange", a), "showing" === t.mode && t.addEventListener("cuechange", a)
        }
      }
      s(), n.addEventListener("change", s), n.addEventListener("addtrack", s), n.addEventListener("removetrack", s), this.on("dispose", function () {
        r.off("addtrack", t), r.off("removetrack", i), n.removeEventListener("change", s), n.removeEventListener("addtrack", s), n.removeEventListener("removetrack", s);
        for (var e = 0; e < n.length; e++) {
          n[e].removeEventListener("cuechange", a)
        }
      })
    }, e.addTextTrack = function (e, t, i) {
      if (!e) throw new Error("TextTrack kind is required but was not provided");
      return function (e, t, i, n, r) {
        void 0 === r && (r = {});
        var a = e.textTracks();
        r.kind = t, i && (r.label = i), n && (r.language = n), r.tech = e;
        var s = new Ti.text.TrackClass(r);
        return a.addTrack(s), s
      }(this, e, t, i)
    }, e.createRemoteTextTrack = function (e) {
      var t = gt(e, {
        tech: this
      });
      return new bi.remoteTextEl.TrackClass(t)
    }, e.addRemoteTextTrack = function (e, t) {
      var i = this;
      void 0 === e && (e = {});
      var n = this.createRemoteTextTrack(e);
      return !0 !== t && !1 !== t && (g.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js'), t = !0), this.remoteTextTrackEls().addTrackElement_(n), this.remoteTextTracks().addTrack(n.track), !0 !== t && this.ready(function () {
        return i.autoRemoteTextTracks_.addTrack(n.track)
      }), n
    }, e.removeRemoteTextTrack = function (e) {
      var t = this.remoteTextTrackEls().getTrackElementByTrack_(e);
      this.remoteTextTrackEls().removeTrackElement_(t), this.remoteTextTracks().removeTrack(e), this.autoRemoteTextTracks_.removeTrack(e)
    }, e.getVideoPlaybackQuality = function () {
      return {}
    }, e.requestPictureInPicture = function () {
      var e = this.options_.Promise || h.Promise;
      if (e) return e.reject()
    }, e.disablePictureInPicture = function () {
      return !0
    }, e.setDisablePictureInPicture = function () {}, e.setPoster = function () {}, e.playsinline = function () {}, e.setPlaysinline = function () {}, e.overrideNativeAudioTracks = function () {}, e.overrideNativeVideoTracks = function () {}, e.canPlayType = function () {
      return ""
    }, i.canPlayType = function () {
      return ""
    }, i.canPlaySource = function (e, t) {
      return i.canPlayType(e.type)
    }, i.isTech = function (e) {
      return e.prototype instanceof i || e instanceof i || e === i
    }, i.registerTech = function (e, t) {
      if (i.techs_ || (i.techs_ = {}), !i.isTech(t)) throw new Error("Tech " + e + " must be a Tech");
      if (!i.canPlayType) throw new Error("Techs must have a static canPlayType method on them");
      if (!i.canPlaySource) throw new Error("Techs must have a static canPlaySource method on them");
      return e = mt(e), i.techs_[e] = t, i.techs_[ft(e)] = t, "Tech" !== e && i.defaultTechOrder_.push(e), t
    }, i.getTech = function (e) {
      if (e) return i.techs_ && i.techs_[e] ? i.techs_[e] : (e = mt(e), h && h.videojs && h.videojs[e] ? (g.warn("The " + e + " tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)"), h.videojs[e]) : void 0)
    }, i
  }(Tt);
  Ti.names.forEach(function (e) {
    var t = Ti[e];
    Ji.prototype[t.getterName] = function () {
      return this[t.privateName] = this[t.privateName] || new t.ListClass, this[t.privateName]
    }
  }), Ji.prototype.featuresVolumeControl = !0, Ji.prototype.featuresMuteControl = !0, Ji.prototype.featuresFullscreenResize = !1, Ji.prototype.featuresPlaybackRate = !1, Ji.prototype.featuresProgressEvents = !1, Ji.prototype.featuresSourceset = !1, Ji.prototype.featuresTimeupdateEvents = !1, Ji.prototype.featuresNativeTextTracks = !1, Ji.withSourceHandlers = function (r) {
    r.registerSourceHandler = function (e, t) {
      var i = r.sourceHandlers;
      i = i || (r.sourceHandlers = []), void 0 === t && (t = i.length), i.splice(t, 0, e)
    }, r.canPlayType = function (e) {
      for (var t, i = r.sourceHandlers || [], n = 0; n < i.length; n++)
        if (t = i[n].canPlayType(e)) return t;
      return ""
    }, r.selectSourceHandler = function (e, t) {
      for (var i = r.sourceHandlers || [], n = 0; n < i.length; n++)
        if (i[n].canHandleSource(e, t)) return i[n];
      return null
    }, r.canPlaySource = function (e, t) {
      var i = r.selectSourceHandler(e, t);
      return i ? i.canHandleSource(e, t) : ""
    };
    ["seekable", "seeking", "duration"].forEach(function (e) {
      var t = this[e];
      "function" == typeof t && (this[e] = function () {
        return this.sourceHandler_ && this.sourceHandler_[e] ? this.sourceHandler_[e].apply(this.sourceHandler_, arguments) : t.apply(this, arguments)
      })
    }, r.prototype), r.prototype.setSource = function (e) {
      var t = r.selectSourceHandler(e, this.options_);
      t || (r.nativeSourceHandler ? t = r.nativeSourceHandler : g.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), t !== r.nativeSourceHandler && (this.currentSource_ = e), this.sourceHandler_ = t.handleSource(e, this, this.options_), this.one("dispose", this.disposeSourceHandler_)
    }, r.prototype.disposeSourceHandler = function () {
      this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null)
    }
  }, Tt.registerComponent("Tech", Ji), Ji.registerTech("Tech", Ji), Ji.defaultTechOrder_ = [];
  var Zi = {},
    en = {},
    tn = {};

  function nn(e, t, i) {
    e.setTimeout(function () {
      return function i(n, e, r, a, s, o) {
        void 0 === n && (n = {});
        void 0 === e && (e = []);
        void 0 === s && (s = []);
        void 0 === o && (o = !1);
        var t = e,
          u = t[0],
          l = t.slice(1);
        if ("string" == typeof u) i(n, Zi[u], r, a, s, o);
        else if (u) {
          var c = ln(a, u);
          if (!c.setSource) return s.push(c), i(n, l, r, a, s, o);
          c.setSource(S({}, n), function (e, t) {
            if (e) return i(n, l, r, a, s, o);
            s.push(c), i(t, n.type === t.type ? l : Zi[t.type], r, a, s, o)
          })
        } else l.length ? i(n, l, r, a, s, o) : o ? r(n, s) : i(n, Zi["*"], r, a, s, !0)
      }(t, Zi[t.type], i, e)
    }, 1)
  }

  function rn(e, t, i, n) {
    void 0 === n && (n = null);
    var r = "call" + mt(i),
      a = e.reduce(un(r), n),
      s = a === tn,
      o = s ? null : t[i](a);
    return function (e, t, i, n) {
      for (var r = e.length - 1; 0 <= r; r--) {
        var a = e[r];
        a[t] && a[t](n, i)
      }
    }(e, i, o, s), o
  }
  var an = {
      buffered: 1,
      currentTime: 1,
      duration: 1,
      muted: 1,
      played: 1,
      paused: 1,
      seekable: 1,
      volume: 1
    },
    sn = {
      setCurrentTime: 1,
      setMuted: 1,
      setVolume: 1
    },
    on = {
      play: 1,
      pause: 1
    };

  function un(i) {
    return function (e, t) {
      return e === tn ? tn : t[i] ? t[i](e) : e
    }
  }

  function ln(e, t) {
    var i = en[e.id()],
      n = null;
    if (null == i) return n = t(e), en[e.id()] = [
      [t, n]
    ], n;
    for (var r = 0; r < i.length; r++) {
      var a = i[r],
        s = a[0],
        o = a[1];
      s === t && (n = o)
    }
    return null === n && (n = t(e), i.push([t, n])), n
  }

  function cn(e) {
    void 0 === e && (e = "");
    var t = zt(e);
    return dn[t.toLowerCase()] || ""
  }
  var dn = {
    opus: "video/ogg",
    ogv: "video/ogg",
    mp4: "video/mp4",
    mov: "video/mp4",
    m4v: "video/mp4",
    mkv: "video/x-matroska",
    m4a: "audio/mp4",
    mp3: "audio/mpeg",
    aac: "audio/aac",
    caf: "audio/x-caf",
    flac: "audio/flac",
    oga: "audio/ogg",
    wav: "audio/wav",
    m3u8: "application/x-mpegURL",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    gif: "image/gif",
    png: "image/png",
    svg: "image/svg+xml",
    webp: "image/webp"
  };

  function hn(e) {
    if (!e.type) {
      var t = cn(e.src);
      t && (e.type = t)
    }
    return e
  }
  var pn = function (l) {
    function e(e, t, i) {
      var n, r = gt({
        createEl: !1
      }, t);
      if (n = l.call(this, e, r, i) || this, t.playerOptions.sources && 0 !== t.playerOptions.sources.length) e.src(t.playerOptions.sources);
      else
        for (var a = 0, s = t.playerOptions.techOrder; a < s.length; a++) {
          var o = mt(s[a]),
            u = Ji.getTech(o);
          if (o || (u = Tt.getComponent(o)), u && u.isSupported()) {
            e.loadTech_(o);
            break
          }
        }
      return n
    }
    return Et(e, l), e
  }(Tt);
  Tt.registerComponent("MediaLoader", pn);
  var fn = function (r) {
    function e(e, t) {
      var i;
      return (i = r.call(this, e, t) || this).handleMouseOver_ = function (e) {
        return i.handleMouseOver(e)
      }, i.handleMouseOut_ = function (e) {
        return i.handleMouseOut(e)
      }, i.handleClick_ = function (e) {
        return i.handleClick(e)
      }, i.handleKeyDown_ = function (e) {
        return i.handleKeyDown(e)
      }, i.emitTapEvents(), i.enable(), i
    }
    Et(e, r);
    var t = e.prototype;
    return t.createEl = function (e, t, i) {
      void 0 === e && (e = "div"), void 0 === t && (t = {}), void 0 === i && (i = {}), t = S({
        innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>',
        className: this.buildCSSClass(),
        tabIndex: 0
      }, t), "button" === e && g.error("Creating a ClickableComponent with an HTML element of " + e + " is not supported; use a Button instead."), i = S({
        role: "button"
      }, i), this.tabIndex_ = t.tabIndex;
      var n = r.prototype.createEl.call(this, e, t, i);
      return this.createControlTextEl(n), n
    }, t.dispose = function () {
      this.controlTextEl_ = null, r.prototype.dispose.call(this)
    }, t.createControlTextEl = function (e) {
      return this.controlTextEl_ = ne("span", {
        className: "vjs-control-text"
      }, {
        "aria-live": "polite"
      }), e && e.appendChild(this.controlTextEl_), this.controlText(this.controlText_, e), this.controlTextEl_
    }, t.controlText = function (e, t) {
      if (void 0 === t && (t = this.el()), void 0 === e) return this.controlText_ || "Need Text";
      var i = this.localize(e);
      this.controlText_ = e, re(this.controlTextEl_, i), this.nonIconControl || this.player_.options_.noUITitleAttributes || t.setAttribute("title", i)
    }, t.buildCSSClass = function () {
      return "vjs-control vjs-button " + r.prototype.buildCSSClass.call(this)
    }, t.enable = function () {
      this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), "undefined" != typeof this.tabIndex_ && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_))
    }, t.disable = function () {
      this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), "undefined" != typeof this.tabIndex_ && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_)
    }, t.handleLanguagechange = function () {
      this.controlText(this.controlText_)
    }, t.handleClick = function (e) {
      this.options_.clickHandler && this.options_.clickHandler.call(this, arguments)
    }, t.handleKeyDown = function (e) {
      Nt.isEventKey(e, "Space") || Nt.isEventKey(e, "Enter") ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : r.prototype.handleKeyDown.call(this, e)
    }, e
  }(Tt);
  Tt.registerComponent("ClickableComponent", fn);
  var mn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).update(), i.update_ = function (e) {
        return i.update(e)
      }, e.on("posterchange", i.update_), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.dispose = function () {
      this.player().off("posterchange", this.update_), n.prototype.dispose.call(this)
    }, t.createEl = function () {
      return ne("div", {
        className: "vjs-poster",
        tabIndex: -1
      })
    }, t.update = function (e) {
      var t = this.player().poster();
      this.setSrc(t), t ? this.show() : this.hide()
    }, t.setSrc = function (e) {
      var t = "";
      e && (t = 'url("' + e + '")'), this.el_.style.backgroundImage = t
    }, t.handleClick = function (e) {
      if (this.player_.controls()) {
        var t = this.player_.usingPlugin("eme") && this.player_.eme.sessions && 0 < this.player_.eme.sessions.length;
        !this.player_.tech(!0) || (V || F) && t || this.player_.tech(!0).focus(), this.player_.paused() ? Ot(this.player_.play()) : this.player_.pause()
      }
    }, e
  }(fn);
  Tt.registerComponent("PosterImage", mn);
  var gn = "#222",
    vn = {
      monospace: "monospace",
      sansSerif: "sans-serif",
      serif: "serif",
      monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
      monospaceSerif: '"Courier New", monospace',
      proportionalSansSerif: "sans-serif",
      proportionalSerif: "serif",
      casual: '"Comic Sans MS", Impact, fantasy',
      script: '"Monotype Corsiva", cursive',
      smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
    };

  function yn(e, t) {
    var i;
    if (4 === e.length) i = e[1] + e[1] + e[2] + e[2] + e[3] + e[3];
    else {
      if (7 !== e.length) throw new Error("Invalid color code provided, " + e + "; must be formatted as e.g. #f0e or #f604e2.");
      i = e.slice(1)
    }
    return "rgba(" + parseInt(i.slice(0, 2), 16) + "," + parseInt(i.slice(2, 4), 16) + "," + parseInt(i.slice(4, 6), 16) + "," + t + ")"
  }

  function _n(e, t, i) {
    try {
      e.style[t] = i
    } catch (e) {
      return
    }
  }
  var bn = function (a) {
    function e(i, e, t) {
      var n;
      n = a.call(this, i, e, t) || this;

      function r(e) {
        return n.updateDisplay(e)
      }
      return i.on("loadstart", function (e) {
        return n.toggleDisplay(e)
      }), i.on("texttrackchange", r), i.on("loadedmetadata", function (e) {
        return n.preselectTrack(e)
      }), i.ready($e(St(n), function () {
        if (i.tech_ && i.tech_.featuresNativeTextTracks) this.hide();
        else {
          i.on("fullscreenchange", r), i.on("playerresize", r), h.addEventListener("orientationchange", r), i.on("dispose", function () {
            return h.removeEventListener("orientationchange", r)
          });
          for (var e = this.options_.playerOptions.tracks || [], t = 0; t < e.length; t++) this.player_.addRemoteTextTrack(e[t], !0);
          this.preselectTrack()
        }
      })), n
    }
    Et(e, a);
    var t = e.prototype;
    return t.preselectTrack = function () {
      for (var e, t, i, n = {
          captions: 1,
          subtitles: 1
        }, r = this.player_.textTracks(), a = this.player_.cache_.selectedLanguage, s = 0; s < r.length; s++) {
        var o = r[s];
        a && a.enabled && a.language && a.language === o.language && o.kind in n ? i = o.kind === a.kind ? o : i || o : a && !a.enabled ? t = e = i = null : o.default && ("descriptions" !== o.kind || e ? o.kind in n && !t && (t = o) : e = o)
      }
      i ? i.mode = "showing" : t ? t.mode = "showing" : e && (e.mode = "showing")
    }, t.toggleDisplay = function () {
      this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show()
    }, t.createEl = function () {
      return a.prototype.createEl.call(this, "div", {
        className: "vjs-text-track-display"
      }, {
        "aria-live": "off",
        "aria-atomic": "true"
      })
    }, t.clearDisplay = function () {
      "function" == typeof h.WebVTT && h.WebVTT.processCues(h, [], this.el_)
    }, t.updateDisplay = function () {
      var e = this.player_.textTracks(),
        t = this.options_.allowMultipleShowingTracks;
      if (this.clearDisplay(), t) {
        for (var i = [], n = 0; n < e.length; ++n) {
          var r = e[n];
          "showing" === r.mode && i.push(r)
        }
        this.updateForTrack(i)
      } else {
        for (var a = null, s = null, o = e.length; o--;) {
          var u = e[o];
          "showing" === u.mode && ("descriptions" === u.kind ? a = u : s = u)
        }
        s ? ("off" !== this.getAttribute("aria-live") && this.setAttribute("aria-live", "off"), this.updateForTrack(s)) : a && ("assertive" !== this.getAttribute("aria-live") && this.setAttribute("aria-live", "assertive"), this.updateForTrack(a))
      }
    }, t.updateDisplayState = function (e) {
      for (var t = this.player_.textTrackSettings.getValues(), i = e.activeCues, n = i.length; n--;) {
        var r = i[n];
        if (r) {
          var a = r.displayState;
          if (t.color && (a.firstChild.style.color = t.color), t.textOpacity && _n(a.firstChild, "color", yn(t.color || "#fff", t.textOpacity)), t.backgroundColor && (a.firstChild.style.backgroundColor = t.backgroundColor), t.backgroundOpacity && _n(a.firstChild, "backgroundColor", yn(t.backgroundColor || "#000", t.backgroundOpacity)), t.windowColor && (t.windowOpacity ? _n(a, "backgroundColor", yn(t.windowColor, t.windowOpacity)) : a.style.backgroundColor = t.windowColor), t.edgeStyle && ("dropshadow" === t.edgeStyle ? a.firstChild.style.textShadow = "2px 2px 3px #222, 2px 2px 4px #222, 2px 2px 5px " + gn : "raised" === t.edgeStyle ? a.firstChild.style.textShadow = "1px 1px #222, 2px 2px #222, 3px 3px " + gn : "depressed" === t.edgeStyle ? a.firstChild.style.textShadow = "1px 1px #ccc, 0 1px #ccc, -1px -1px #222, 0 -1px " + gn : "uniform" === t.edgeStyle && (a.firstChild.style.textShadow = "0 0 4px #222, 0 0 4px #222, 0 0 4px #222, 0 0 4px " + gn)), t.fontPercent && 1 !== t.fontPercent) {
            var s = h.parseFloat(a.style.fontSize);
            a.style.fontSize = s * t.fontPercent + "px", a.style.height = "auto", a.style.top = "auto"
          }
          t.fontFamily && "default" !== t.fontFamily && ("small-caps" === t.fontFamily ? a.firstChild.style.fontVariant = "small-caps" : a.firstChild.style.fontFamily = vn[t.fontFamily])
        }
      }
    }, t.updateForTrack = function (e) {
      if (Array.isArray(e) || (e = [e]), "function" == typeof h.WebVTT && !e.every(function (e) {
          return !e.activeCues
        })) {
        for (var t = [], i = 0; i < e.length; ++i)
          for (var n = e[i], r = 0; r < n.activeCues.length; ++r) t.push(n.activeCues[r]);
        h.WebVTT.processCues(h, t, this.el_);
        for (var a = 0; a < e.length; ++a) {
          for (var s = e[a], o = 0; o < s.activeCues.length; ++o) {
            var u = s.activeCues[o].displayState;
            oe(u, "vjs-text-track-cue"), oe(u, "vjs-text-track-cue-" + (s.language ? s.language : a))
          }
          this.player_.textTrackSettings && this.updateDisplayState(s)
        }
      }
    }, e
  }(Tt);
  Tt.registerComponent("TextTrackDisplay", bn);
  var Tn = function (r) {
    function e() {
      return r.apply(this, arguments) || this
    }
    return Et(e, r), e.prototype.createEl = function () {
      var e = this.player_.isAudio(),
        t = this.localize(e ? "Audio Player" : "Video Player"),
        i = ne("span", {
          className: "vjs-control-text",
          innerHTML: this.localize("{1} is loading.", [t])
        }),
        n = r.prototype.createEl.call(this, "div", {
          className: "vjs-loading-spinner",
          dir: "ltr"
        });
      return n.appendChild(i), n
    }, e
  }(Tt);
  Tt.registerComponent("LoadingSpinner", Tn);
  var Sn = function (t) {
    function e() {
      return t.apply(this, arguments) || this
    }
    Et(e, t);
    var i = e.prototype;
    return i.createEl = function (e, t, i) {
      void 0 === t && (t = {}), void 0 === i && (i = {}), t = S({
        innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>',
        className: this.buildCSSClass()
      }, t), i = S({
        type: "button"
      }, i);
      var n = Tt.prototype.createEl.call(this, "button", t, i);
      return this.createControlTextEl(n), n
    }, i.addChild = function (e, t) {
      void 0 === t && (t = {});
      var i = this.constructor.name;
      return g.warn("Adding an actionable (user controllable) child to a Button (" + i + ") is not supported; use a ClickableComponent instead."), Tt.prototype.addChild.call(this, e, t)
    }, i.enable = function () {
      t.prototype.enable.call(this), this.el_.removeAttribute("disabled")
    }, i.disable = function () {
      t.prototype.disable.call(this), this.el_.setAttribute("disabled", "disabled")
    }, i.handleKeyDown = function (e) {
      Nt.isEventKey(e, "Space") || Nt.isEventKey(e, "Enter") ? e.stopPropagation() : t.prototype.handleKeyDown.call(this, e)
    }, e
  }(fn);
  Tt.registerComponent("Button", Sn);
  var En = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).mouseused_ = !1, i.on("mousedown", function (e) {
        return i.handleMouseDown(e)
      }), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-big-play-button"
    }, t.handleClick = function (e) {
      var t = this.player_.play();
      if (this.mouseused_ && e.clientX && e.clientY) {
        var i = this.player_.usingPlugin("eme") && this.player_.eme.sessions && 0 < this.player_.eme.sessions.length;
        return Ot(t), void(!this.player_.tech(!0) || (V || F) && i || this.player_.tech(!0).focus())
      }
      var n = this.player_.getChild("controlBar"),
        r = n && n.getChild("playToggle");
      if (r) {
        var a = function () {
          return r.focus()
        };
        Lt(t) ? t.then(a, function () {}) : this.setTimeout(a, 1)
      } else this.player_.tech(!0).focus()
    }, t.handleKeyDown = function (e) {
      this.mouseused_ = !1, n.prototype.handleKeyDown.call(this, e)
    }, t.handleMouseDown = function (e) {
      this.mouseused_ = !0
    }, e
  }(Sn);
  En.prototype.controlText_ = "Play Video", Tt.registerComponent("BigPlayButton", En);
  var kn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).controlText(t && t.controlText || i.localize("Close")), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-close-button " + n.prototype.buildCSSClass.call(this)
    }, t.handleClick = function (e) {
      this.trigger({
        type: "close",
        bubbles: !1
      })
    }, t.handleKeyDown = function (e) {
      Nt.isEventKey(e, "Esc") ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : n.prototype.handleKeyDown.call(this, e)
    }, e
  }(Sn);
  Tt.registerComponent("CloseButton", kn);
  var wn = function (n) {
    function e(e, t) {
      var i;
      return void 0 === t && (t = {}), i = n.call(this, e, t) || this, t.replay = void 0 === t.replay || t.replay, i.on(e, "play", function (e) {
        return i.handlePlay(e)
      }), i.on(e, "pause", function (e) {
        return i.handlePause(e)
      }), t.replay && i.on(e, "ended", function (e) {
        return i.handleEnded(e)
      }), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-play-control " + n.prototype.buildCSSClass.call(this)
    }, t.handleClick = function (e) {
      this.player_.paused() ? this.player_.play() : this.player_.pause()
    }, t.handleSeeked = function (e) {
      this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(e) : this.handlePlay(e)
    }, t.handlePlay = function (e) {
      this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.controlText("Pause")
    }, t.handlePause = function (e) {
      this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.controlText("Play")
    }, t.handleEnded = function (e) {
      var t = this;
      this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.controlText("Replay"), this.one(this.player_, "seeked", function (e) {
        return t.handleSeeked(e)
      })
    }, e
  }(Sn);
  wn.prototype.controlText_ = "Play", Tt.registerComponent("PlayToggle", wn);

  function Cn(e, t) {
    e = e < 0 ? 0 : e;
    var i = Math.floor(e % 60),
      n = Math.floor(e / 60 % 60),
      r = Math.floor(e / 3600),
      a = Math.floor(t / 60 % 60),
      s = Math.floor(t / 3600);
    return !isNaN(e) && e !== 1 / 0 || (r = n = i = "-"), (r = 0 < r || 0 < s ? r + ":" : "") + (n = ((r || 10 <= a) && n < 10 ? "0" + n : n) + ":") + (i = i < 10 ? "0" + i : i)
  }
  var In = Cn;

  function xn(e, t) {
    return void 0 === t && (t = e), In(e, t)
  }
  var An = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).on(e, ["timeupdate", "ended"], function (e) {
        return i.updateContent(e)
      }), i.updateTextNode_(), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      var e = this.buildCSSClass(),
        t = n.prototype.createEl.call(this, "div", {
          className: e + " vjs-time-control vjs-control",
          innerHTML: '<span class="vjs-control-text" role="presentation">' + this.localize(this.labelText_) + " </span>"
        });
      return this.contentEl_ = ne("span", {
        className: e + "-display"
      }, {
        "aria-live": "off",
        role: "presentation"
      }), t.appendChild(this.contentEl_), t
    }, t.dispose = function () {
      this.contentEl_ = null, this.textNode_ = null, n.prototype.dispose.call(this)
    }, t.updateTextNode_ = function (e) {
      var t = this;
      void 0 === e && (e = 0), e = xn(e), this.formattedTime_ !== e && (this.formattedTime_ = e, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", function () {
        if (t.contentEl_) {
          var e = t.textNode_;
          e && t.contentEl_.firstChild !== e && (e = null, g.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), t.textNode_ = p.createTextNode(t.formattedTime_), t.textNode_ && (e ? t.contentEl_.replaceChild(t.textNode_, e) : t.contentEl_.appendChild(t.textNode_))
        }
      }))
    }, t.updateContent = function (e) {}, e
  }(Tt);
  An.prototype.labelText_ = "Time", An.prototype.controlText_ = "Time", Tt.registerComponent("TimeDisplay", An);
  var Pn = function (e) {
    function t() {
      return e.apply(this, arguments) || this
    }
    Et(t, e);
    var i = t.prototype;
    return i.buildCSSClass = function () {
      return "vjs-current-time"
    }, i.updateContent = function (e) {
      var t;
      t = this.player_.ended() ? this.player_.duration() : this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(t)
    }, t
  }(An);
  Pn.prototype.labelText_ = "Current Time", Pn.prototype.controlText_ = "Current Time", Tt.registerComponent("CurrentTimeDisplay", Pn);
  var Ln = function (r) {
    function e(e, t) {
      function i(e) {
        return n.updateContent(e)
      }
      var n;
      return (n = r.call(this, e, t) || this).on(e, "durationchange", i), n.on(e, "loadstart", i), n.on(e, "loadedmetadata", i), n
    }
    Et(e, r);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-duration"
    }, t.updateContent = function (e) {
      var t = this.player_.duration();
      this.updateTextNode_(t)
    }, e
  }(An);
  Ln.prototype.labelText_ = "Duration", Ln.prototype.controlText_ = "Duration", Tt.registerComponent("DurationDisplay", Ln);
  var On = function (e) {
    function t() {
      return e.apply(this, arguments) || this
    }
    return Et(t, e), t.prototype.createEl = function () {
      return e.prototype.createEl.call(this, "div", {
        className: "vjs-time-control vjs-time-divider",
        innerHTML: "<div><span>/</span></div>"
      }, {
        "aria-hidden": !0
      })
    }, t
  }(Tt);
  Tt.registerComponent("TimeDivider", On);
  var Dn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).on(e, "durationchange", function (e) {
        return i.updateContent(e)
      }), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-remaining-time"
    }, t.createEl = function () {
      var e = n.prototype.createEl.call(this);
      return e.insertBefore(ne("span", {}, {
        "aria-hidden": !0
      }, "-"), this.contentEl_), e
    }, t.updateContent = function (e) {
      var t;
      "number" == typeof this.player_.duration() && (t = this.player_.ended() ? 0 : this.player_.remainingTimeDisplay ? this.player_.remainingTimeDisplay() : this.player_.remainingTime(), this.updateTextNode_(t))
    }, e
  }(An);
  Dn.prototype.labelText_ = "Remaining Time", Dn.prototype.controlText_ = "Remaining Time", Tt.registerComponent("RemainingTimeDisplay", Dn);
  var Rn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).updateShowing(), i.on(i.player(), "durationchange", function (e) {
        return i.updateShowing(e)
      }), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      var e = n.prototype.createEl.call(this, "div", {
        className: "vjs-live-control vjs-control"
      });
      return this.contentEl_ = ne("div", {
        className: "vjs-live-display",
        innerHTML: '<span class="vjs-control-text">' + this.localize("Stream Type") + " </span>" + this.localize("LIVE")
      }, {
        "aria-live": "off"
      }), e.appendChild(this.contentEl_), e
    }, t.dispose = function () {
      this.contentEl_ = null, n.prototype.dispose.call(this)
    }, t.updateShowing = function (e) {
      this.player().duration() === 1 / 0 ? this.show() : this.hide()
    }, e
  }(Tt);
  Tt.registerComponent("LiveDisplay", Rn);
  var Mn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).updateLiveEdgeStatus(), i.player_.liveTracker && (i.updateLiveEdgeStatusHandler_ = function (e) {
        return i.updateLiveEdgeStatus(e)
      }, i.on(i.player_.liveTracker, "liveedgechange", i.updateLiveEdgeStatusHandler_)), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      var e = n.prototype.createEl.call(this, "button", {
        className: "vjs-seek-to-live-control vjs-control"
      });
      return this.textEl_ = ne("span", {
        className: "vjs-seek-to-live-text",
        innerHTML: this.localize("LIVE")
      }, {
        "aria-hidden": "true"
      }), e.appendChild(this.textEl_), e
    }, t.updateLiveEdgeStatus = function () {
      !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"))
    }, t.handleClick = function () {
      this.player_.liveTracker.seekToLiveEdge()
    }, t.dispose = function () {
      this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, n.prototype.dispose.call(this)
    }, e
  }(Sn);
  Mn.prototype.controlText_ = "Seek to live, currently playing live", Tt.registerComponent("SeekToLive", Mn);

  function Nn(e, t, i) {
    return e = Number(e), Math.min(i, Math.max(t, isNaN(e) ? t : e))
  }
  var Un = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).handleMouseDown_ = function (e) {
        return i.handleMouseDown(e)
      }, i.handleMouseUp_ = function (e) {
        return i.handleMouseUp(e)
      }, i.handleKeyDown_ = function (e) {
        return i.handleKeyDown(e)
      }, i.handleClick_ = function (e) {
        return i.handleClick(e)
      }, i.handleMouseMove_ = function (e) {
        return i.handleMouseMove(e)
      }, i.update_ = function (e) {
        return i.update(e)
      }, i.bar = i.getChild(i.options_.barName), i.vertical(!!i.options_.vertical), i.enable(), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.enabled = function () {
      return this.enabled_
    }, t.enable = function () {
      this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0)
    }, t.disable = function () {
      if (this.enabled()) {
        var e = this.bar.el_.ownerDocument;
        this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(e, "mousemove", this.handleMouseMove_), this.off(e, "mouseup", this.handleMouseUp_), this.off(e, "touchmove", this.handleMouseMove_), this.off(e, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1
      }
    }, t.createEl = function (e, t, i) {
      return void 0 === t && (t = {}), void 0 === i && (i = {}), t.className = t.className + " vjs-slider", t = S({
        tabIndex: 0
      }, t), i = S({
        role: "slider",
        "aria-valuenow": 0,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        tabIndex: 0
      }, i), n.prototype.createEl.call(this, e, t, i)
    }, t.handleMouseDown = function (e) {
      var t = this.bar.el_.ownerDocument;
      "mousedown" === e.type && e.preventDefault(), "touchstart" !== e.type || j || e.preventDefault(), me(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(t, "mousemove", this.handleMouseMove_), this.on(t, "mouseup", this.handleMouseUp_), this.on(t, "touchmove", this.handleMouseMove_), this.on(t, "touchend", this.handleMouseUp_), this.handleMouseMove(e)
    }, t.handleMouseMove = function (e) {}, t.handleMouseUp = function () {
      var e = this.bar.el_.ownerDocument;
      ge(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(e, "mousemove", this.handleMouseMove_), this.off(e, "mouseup", this.handleMouseUp_), this.off(e, "touchmove", this.handleMouseMove_), this.off(e, "touchend", this.handleMouseUp_), this.update()
    }, t.update = function () {
      var t = this;
      if (this.el_ && this.bar) {
        var i = this.getProgress();
        return i === this.progress_ || (this.progress_ = i, this.requestNamedAnimationFrame("Slider#update", function () {
          var e = t.vertical() ? "height" : "width";
          t.bar.el().style[e] = (100 * i).toFixed(2) + "%"
        })), i
      }
    }, t.getProgress = function () {
      return Number(Nn(this.getPercent(), 0, 1).toFixed(4))
    }, t.calculateDistance = function (e) {
      var t = _e(this.el_, e);
      return this.vertical() ? t.y : t.x
    }, t.handleKeyDown = function (e) {
      Nt.isEventKey(e, "Left") || Nt.isEventKey(e, "Down") ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : Nt.isEventKey(e, "Right") || Nt.isEventKey(e, "Up") ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : n.prototype.handleKeyDown.call(this, e)
    }, t.handleClick = function (e) {
      e.stopPropagation(), e.preventDefault()
    }, t.vertical = function (e) {
      if (void 0 === e) return this.vertical_ || !1;
      this.vertical_ = !!e, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal")
    }, e
  }(Tt);
  Tt.registerComponent("Slider", Un);

  function Bn(e, t) {
    return Nn(e / t * 100, 0, 100).toFixed(2) + "%"
  }
  var Fn = function (r) {
    function e(e, t) {
      var i;
      return (i = r.call(this, e, t) || this).partEls_ = [], i.on(e, "progress", function (e) {
        return i.update(e)
      }), i
    }
    Et(e, r);
    var t = e.prototype;
    return t.createEl = function () {
      var e = r.prototype.createEl.call(this, "div", {
          className: "vjs-load-progress"
        }),
        t = ne("span", {
          className: "vjs-control-text"
        }),
        i = ne("span", {
          textContent: this.localize("Loaded")
        }),
        n = p.createTextNode(": ");
      return this.percentageEl_ = ne("span", {
        className: "vjs-control-text-loaded-percentage",
        textContent: "0%"
      }), e.appendChild(t), t.appendChild(i), t.appendChild(n), t.appendChild(this.percentageEl_), e
    }, t.dispose = function () {
      this.partEls_ = null, this.percentageEl_ = null, r.prototype.dispose.call(this)
    }, t.update = function (e) {
      var d = this;
      this.requestNamedAnimationFrame("LoadProgressBar#update", function () {
        var e = d.player_.liveTracker,
          t = d.player_.buffered(),
          i = e && e.isLive() ? e.seekableEnd() : d.player_.duration(),
          n = d.player_.bufferedEnd(),
          r = d.partEls_,
          a = Bn(n, i);
        d.percent_ !== a && (d.el_.style.width = a, re(d.percentageEl_, a), d.percent_ = a);
        for (var s = 0; s < t.length; s++) {
          var o = t.start(s),
            u = t.end(s),
            l = r[s];
          l || (l = d.el_.appendChild(ne()), r[s] = l), l.dataset.start === o && l.dataset.end === u || (l.dataset.start = o, l.dataset.end = u, l.style.left = Bn(o, n), l.style.width = Bn(u - o, n))
        }
        for (var c = r.length; c > t.length; c--) d.el_.removeChild(r[c - 1]);
        r.length = t.length
      })
    }, e
  }(Tt);
  Tt.registerComponent("LoadProgressBar", Fn);
  var jn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).update = Je($e(St(i), i.update), 30), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      return n.prototype.createEl.call(this, "div", {
        className: "vjs-time-tooltip"
      }, {
        "aria-hidden": "true"
      })
    }, t.update = function (e, t, i) {
      var n = ye(this.el_),
        r = ve(this.player_.el()),
        a = e.width * t;
      if (r && n) {
        var s = e.left - r.left + a,
          o = e.width - a + (r.right - e.right),
          u = n.width / 2;
        s < u ? u += u - s : o < u && (u = o), u < 0 ? u = 0 : u > n.width && (u = n.width), u = Math.round(u), this.el_.style.right = "-" + u + "px", this.write(i)
      }
    }, t.write = function (e) {
      re(this.el_, e)
    }, t.updateTime = function (r, a, s, o) {
      var u = this;
      this.requestNamedAnimationFrame("TimeTooltip#updateTime", function () {
        var e, t = u.player_.duration();
        if (u.player_.liveTracker && u.player_.liveTracker.isLive()) {
          var i = u.player_.liveTracker.liveWindow(),
            n = i - a * i;
          e = (n < 1 ? "" : "-") + xn(n, i)
        } else e = xn(s, t);
        u.update(r, a, e), o && o()
      })
    }, e
  }(Tt);
  Tt.registerComponent("TimeTooltip", jn);
  var Hn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).update = Je($e(St(i), i.update), 30), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      return n.prototype.createEl.call(this, "div", {
        className: "vjs-play-progress vjs-slider-bar"
      }, {
        "aria-hidden": "true"
      })
    }, t.update = function (e, t) {
      var i = this.getChild("timeTooltip");
      if (i) {
        var n = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
        i.updateTime(e, t, n)
      }
    }, e
  }(Tt);
  Hn.prototype.options_ = {
    children: []
  }, K || M || Hn.prototype.options_.children.push("timeTooltip"), Tt.registerComponent("PlayProgressBar", Hn);
  var Vn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).update = Je($e(St(i), i.update), 30), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      return n.prototype.createEl.call(this, "div", {
        className: "vjs-mouse-display"
      })
    }, t.update = function (e, t) {
      var i = this,
        n = t * this.player_.duration();
      this.getChild("timeTooltip").updateTime(e, t, n, function () {
        i.el_.style.left = e.width * t + "px"
      })
    }, e
  }(Tt);
  Vn.prototype.options_ = {
    children: ["timeTooltip"]
  }, Tt.registerComponent("MouseTimeDisplay", Vn);
  var qn = function (a) {
    function e(e, t) {
      var i;
      return (i = a.call(this, e, t) || this).setEventHandlers_(), i
    }
    Et(e, a);
    var t = e.prototype;
    return t.setEventHandlers_ = function () {
      var t = this;
      this.update_ = $e(this, this.update), this.update = Je(this.update_, 30), this.on(this.player_, ["ended", "durationchange", "timeupdate"], this.update), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = function (e) {
        return t.enableInterval_(e)
      }, this.disableIntervalHandler_ = function (e) {
        return t.disableInterval_(e)
      }, this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in p && "visibilityState" in p && this.on(p, "visibilitychange", this.toggleVisibility_)
    }, t.toggleVisibility_ = function (e) {
      "hidden" === p.visibilityState ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(e)) : (this.player_.ended() || this.player_.paused() || this.enableInterval_(), this.update())
    }, t.enableInterval_ = function () {
      this.updateInterval || (this.updateInterval = this.setInterval(this.update, 30))
    }, t.disableInterval_ = function (e) {
      this.player_.liveTracker && this.player_.liveTracker.isLive() && e && "ended" !== e.type || this.updateInterval && (this.clearInterval(this.updateInterval), this.updateInterval = null)
    }, t.createEl = function () {
      return a.prototype.createEl.call(this, "div", {
        className: "vjs-progress-holder"
      }, {
        "aria-label": this.localize("Progress Bar")
      })
    }, t.update = function (e) {
      var n = this;
      if ("hidden" !== p.visibilityState) {
        var r = a.prototype.update.call(this);
        return this.requestNamedAnimationFrame("SeekBar#update", function () {
          var e = n.player_.ended() ? n.player_.duration() : n.getCurrentTime_(),
            t = n.player_.liveTracker,
            i = n.player_.duration();
          t && t.isLive() && (i = n.player_.liveTracker.liveCurrentTime()), n.percent_ !== r && (n.el_.setAttribute("aria-valuenow", (100 * r).toFixed(2)), n.percent_ = r), n.currentTime_ === e && n.duration_ === i || (n.el_.setAttribute("aria-valuetext", n.localize("progress bar timing: currentTime={1} duration={2}", [xn(e, i), xn(i, i)], "{1} of {2}")), n.currentTime_ = e, n.duration_ = i), n.bar && n.bar.update(ve(n.el()), n.getProgress())
        }), r
      }
    }, t.getCurrentTime_ = function () {
      return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime()
    }, t.getPercent = function () {
      var e, t = this.getCurrentTime_(),
        i = this.player_.liveTracker;
      return i && i.isLive() ? (e = (t - i.seekableStart()) / i.liveWindow(), i.atLiveEdge() && (e = 1)) : e = t / this.player_.duration(), e
    }, t.handleMouseDown = function (e) {
      we(e) && (e.stopPropagation(), this.player_.scrubbing(!0), this.videoWasPlaying = !this.player_.paused(), this.player_.pause(), a.prototype.handleMouseDown.call(this, e))
    }, t.handleMouseMove = function (e) {
      if (we(e)) {
        var t, i = this.calculateDistance(e),
          n = this.player_.liveTracker;
        if (n && n.isLive()) {
          if (.99 <= i) return void n.seekToLiveEdge();
          var r = n.seekableStart(),
            a = n.liveCurrentTime();
          if (a <= (t = r + i * n.liveWindow()) && (t = a), t <= r && (t = r + .1), t === 1 / 0) return
        } else(t = i * this.player_.duration()) === this.player_.duration() && (t -= .1);
        this.player_.currentTime(t)
      }
    }, t.enable = function () {
      a.prototype.enable.call(this);
      var e = this.getChild("mouseTimeDisplay");
      e && e.show()
    }, t.disable = function () {
      a.prototype.disable.call(this);
      var e = this.getChild("mouseTimeDisplay");
      e && e.hide()
    }, t.handleMouseUp = function (e) {
      a.prototype.handleMouseUp.call(this, e), e && e.stopPropagation(), this.player_.scrubbing(!1), this.player_.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      }), this.videoWasPlaying ? Ot(this.player_.play()) : this.update_()
    }, t.stepForward = function () {
      this.player_.currentTime(this.player_.currentTime() + 5)
    }, t.stepBack = function () {
      this.player_.currentTime(this.player_.currentTime() - 5)
    }, t.handleAction = function (e) {
      this.player_.paused() ? this.player_.play() : this.player_.pause()
    }, t.handleKeyDown = function (e) {
      if (Nt.isEventKey(e, "Space") || Nt.isEventKey(e, "Enter")) e.preventDefault(), e.stopPropagation(), this.handleAction(e);
      else if (Nt.isEventKey(e, "Home")) e.preventDefault(), e.stopPropagation(), this.player_.currentTime(0);
      else if (Nt.isEventKey(e, "End")) e.preventDefault(), e.stopPropagation(), this.player_.currentTime(this.player_.duration());
      else if (/^[0-9]$/.test(Nt(e))) {
        e.preventDefault(), e.stopPropagation();
        var t = 10 * (Nt.codes[Nt(e)] - Nt.codes[0]) / 100;
        this.player_.currentTime(this.player_.duration() * t)
      } else Nt.isEventKey(e, "PgDn") ? (e.preventDefault(), e.stopPropagation(), this.player_.currentTime(this.player_.currentTime() - 60)) : Nt.isEventKey(e, "PgUp") ? (e.preventDefault(), e.stopPropagation(), this.player_.currentTime(this.player_.currentTime() + 60)) : a.prototype.handleKeyDown.call(this, e)
    }, t.dispose = function () {
      this.disableInterval_(), this.off(this.player_, ["ended", "durationchange", "timeupdate"], this.update), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in p && "visibilityState" in p && this.off(p, "visibilitychange", this.toggleVisibility_), a.prototype.dispose.call(this)
    }, e
  }(Un);
  qn.prototype.options_ = {
    children: ["loadProgressBar", "playProgressBar"],
    barName: "playProgressBar"
  }, K || M || qn.prototype.options_.children.splice(1, 0, "mouseTimeDisplay"), Tt.registerComponent("SeekBar", qn);
  var Wn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).handleMouseMove = Je($e(St(i), i.handleMouseMove), 30), i.throttledHandleMouseSeek = Je($e(St(i), i.handleMouseSeek), 30), i.handleMouseUpHandler_ = function (e) {
        return i.handleMouseUp(e)
      }, i.handleMouseDownHandler_ = function (e) {
        return i.handleMouseDown(e)
      }, i.enable(), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      return n.prototype.createEl.call(this, "div", {
        className: "vjs-progress-control vjs-control"
      })
    }, t.handleMouseMove = function (e) {
      var t = this.getChild("seekBar");
      if (t) {
        var i = t.getChild("playProgressBar"),
          n = t.getChild("mouseTimeDisplay");
        if (i || n) {
          var r = t.el(),
            a = ye(r),
            s = _e(r, e).x;
          s = Nn(s, 0, 1), n && n.update(a, s), i && i.update(a, t.getProgress())
        }
      }
    }, t.handleMouseSeek = function (e) {
      var t = this.getChild("seekBar");
      t && t.handleMouseMove(e)
    }, t.enabled = function () {
      return this.enabled_
    }, t.disable = function () {
      if (this.children().forEach(function (e) {
          return e.disable && e.disable()
        }), this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, "mousemove", this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
        var e = this.getChild("seekBar");
        this.player_.scrubbing(!1), e.videoWasPlaying && Ot(this.player_.play())
      }
    }, t.enable = function () {
      this.children().forEach(function (e) {
        return e.enable && e.enable()
      }), this.enabled() || (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, "mousemove", this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0)
    }, t.removeListenersAddedOnMousedownAndTouchstart = function () {
      var e = this.el_.ownerDocument;
      this.off(e, "mousemove", this.throttledHandleMouseSeek), this.off(e, "touchmove", this.throttledHandleMouseSeek), this.off(e, "mouseup", this.handleMouseUpHandler_), this.off(e, "touchend", this.handleMouseUpHandler_)
    }, t.handleMouseDown = function (e) {
      var t = this.el_.ownerDocument,
        i = this.getChild("seekBar");
      i && i.handleMouseDown(e), this.on(t, "mousemove", this.throttledHandleMouseSeek), this.on(t, "touchmove", this.throttledHandleMouseSeek), this.on(t, "mouseup", this.handleMouseUpHandler_), this.on(t, "touchend", this.handleMouseUpHandler_)
    }, t.handleMouseUp = function (e) {
      var t = this.getChild("seekBar");
      t && t.handleMouseUp(e), this.removeListenersAddedOnMousedownAndTouchstart()
    }, e
  }(Tt);
  Wn.prototype.options_ = {
    children: ["seekBar"]
  }, Tt.registerComponent("ProgressControl", Wn);
  var zn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).on(e, ["enterpictureinpicture", "leavepictureinpicture"], function (e) {
        return i.handlePictureInPictureChange(e)
      }), i.on(e, ["disablepictureinpicturechanged", "loadedmetadata"], function (e) {
        return i.handlePictureInPictureEnabledChange(e)
      }), i.disable(), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-picture-in-picture-control " + n.prototype.buildCSSClass.call(this)
    }, t.handlePictureInPictureEnabledChange = function () {
      p.pictureInPictureEnabled && !1 === this.player_.disablePictureInPicture() ? this.enable() : this.disable()
    }, t.handlePictureInPictureChange = function (e) {
      this.player_.isInPictureInPicture() ? this.controlText("Exit Picture-in-Picture") : this.controlText("Picture-in-Picture"), this.handlePictureInPictureEnabledChange()
    }, t.handleClick = function (e) {
      this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture()
    }, e
  }(Sn);
  zn.prototype.controlText_ = "Picture-in-Picture", Tt.registerComponent("PictureInPictureToggle", zn);
  var Gn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).on(e, "fullscreenchange", function (e) {
        return i.handleFullscreenChange(e)
      }), !1 === p[e.fsApi_.fullscreenEnabled] && i.disable(), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-fullscreen-control " + n.prototype.buildCSSClass.call(this)
    }, t.handleFullscreenChange = function (e) {
      this.player_.isFullscreen() ? this.controlText("Non-Fullscreen") : this.controlText("Fullscreen")
    }, t.handleClick = function (e) {
      this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen()
    }, e
  }(Sn);
  Gn.prototype.controlText_ = "Fullscreen", Tt.registerComponent("FullscreenToggle", Gn);
  var Xn = function (e) {
    function t() {
      return e.apply(this, arguments) || this
    }
    return Et(t, e), t.prototype.createEl = function () {
      return e.prototype.createEl.call(this, "div", {
        className: "vjs-volume-level",
        innerHTML: '<span class="vjs-control-text"></span>'
      })
    }, t
  }(Tt);
  Tt.registerComponent("VolumeLevel", Xn);
  var Kn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).update = Je($e(St(i), i.update), 30), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      return n.prototype.createEl.call(this, "div", {
        className: "vjs-volume-tooltip"
      }, {
        "aria-hidden": "true"
      })
    }, t.update = function (e, t, i, n) {
      if (!i) {
        var r = ve(this.el_),
          a = ve(this.player_.el()),
          s = e.width * t;
        if (!a || !r) return;
        var o = e.left - a.left + s,
          u = e.width - s + (a.right - e.right),
          l = r.width / 2;
        o < l ? l += l - o : u < l && (l = u), l < 0 ? l = 0 : l > r.width && (l = r.width), this.el_.style.right = "-" + l + "px"
      }
      this.write(n + "%")
    }, t.write = function (e) {
      re(this.el_, e)
    }, t.updateVolume = function (e, t, i, n, r) {
      var a = this;
      this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", function () {
        a.update(e, t, i, n.toFixed(0)), r && r()
      })
    }, e
  }(Tt);
  Tt.registerComponent("VolumeLevelTooltip", Kn);
  var Yn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).update = Je($e(St(i), i.update), 30), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      return n.prototype.createEl.call(this, "div", {
        className: "vjs-mouse-display"
      })
    }, t.update = function (e, t, i) {
      var n = this,
        r = 100 * t;
      this.getChild("volumeLevelTooltip").updateVolume(e, t, i, r, function () {
        i ? n.el_.style.bottom = e.height * t + "px" : n.el_.style.left = e.width * t + "px"
      })
    }, e
  }(Tt);
  Yn.prototype.options_ = {
    children: ["volumeLevelTooltip"]
  }, Tt.registerComponent("MouseVolumeLevelDisplay", Yn);
  var Qn = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).on("slideractive", function (e) {
        return i.updateLastVolume_(e)
      }), i.on(e, "volumechange", function (e) {
        return i.updateARIAAttributes(e)
      }), e.ready(function () {
        return i.updateARIAAttributes()
      }), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      return n.prototype.createEl.call(this, "div", {
        className: "vjs-volume-bar vjs-slider-bar"
      }, {
        "aria-label": this.localize("Volume Level"),
        "aria-live": "polite"
      })
    }, t.handleMouseDown = function (e) {
      we(e) && n.prototype.handleMouseDown.call(this, e)
    }, t.handleMouseMove = function (e) {
      var t = this.getChild("mouseVolumeLevelDisplay");
      if (t) {
        var i = this.el(),
          n = ve(i),
          r = this.vertical(),
          a = _e(i, e);
        a = r ? a.y : a.x, a = Nn(a, 0, 1), t.update(n, a, r)
      }
      we(e) && (this.checkMuted(), this.player_.volume(this.calculateDistance(e)))
    }, t.checkMuted = function () {
      this.player_.muted() && this.player_.muted(!1)
    }, t.getPercent = function () {
      return this.player_.muted() ? 0 : this.player_.volume()
    }, t.stepForward = function () {
      this.checkMuted(), this.player_.volume(this.player_.volume() + .1)
    }, t.stepBack = function () {
      this.checkMuted(), this.player_.volume(this.player_.volume() - .1)
    }, t.updateARIAAttributes = function (e) {
      var t = this.player_.muted() ? 0 : this.volumeAsPercentage_();
      this.el_.setAttribute("aria-valuenow", t), this.el_.setAttribute("aria-valuetext", t + "%")
    }, t.volumeAsPercentage_ = function () {
      return Math.round(100 * this.player_.volume())
    }, t.updateLastVolume_ = function () {
      var e = this,
        t = this.player_.volume();
      this.one("sliderinactive", function () {
        0 === e.player_.volume() && e.player_.lastVolume_(t)
      })
    }, e
  }(Un);
  Qn.prototype.options_ = {
    children: ["volumeLevel"],
    barName: "volumeLevel"
  }, K || M || Qn.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay"), Qn.prototype.playerEvent = "volumechange", Tt.registerComponent("VolumeBar", Qn);
  var $n = function (n) {
    function e(e, t) {
      var i;
      return void 0 === t && (t = {}), t.vertical = t.vertical || !1, "undefined" != typeof t.volumeBar && !k(t.volumeBar) || (t.volumeBar = t.volumeBar || {}, t.volumeBar.vertical = t.vertical), i = n.call(this, e, t) || this,
        function (e, t) {
          t.tech_ && !t.tech_.featuresVolumeControl && e.addClass("vjs-hidden"), e.on(t, "loadstart", function () {
            t.tech_.featuresVolumeControl ? e.removeClass("vjs-hidden") : e.addClass("vjs-hidden")
          })
        }(St(i), e), i.throttledHandleMouseMove = Je($e(St(i), i.handleMouseMove), 30), i.handleMouseUpHandler_ = function (e) {
          return i.handleMouseUp(e)
        }, i.on("mousedown", function (e) {
          return i.handleMouseDown(e)
        }), i.on("touchstart", function (e) {
          return i.handleMouseDown(e)
        }), i.on("mousemove", function (e) {
          return i.handleMouseMove(e)
        }), i.on(i.volumeBar, ["focus", "slideractive"], function () {
          i.volumeBar.addClass("vjs-slider-active"), i.addClass("vjs-slider-active"), i.trigger("slideractive")
        }), i.on(i.volumeBar, ["blur", "sliderinactive"], function () {
          i.volumeBar.removeClass("vjs-slider-active"), i.removeClass("vjs-slider-active"), i.trigger("sliderinactive")
        }), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      var e = "vjs-volume-horizontal";
      return this.options_.vertical && (e = "vjs-volume-vertical"), n.prototype.createEl.call(this, "div", {
        className: "vjs-volume-control vjs-control " + e
      })
    }, t.handleMouseDown = function (e) {
      var t = this.el_.ownerDocument;
      this.on(t, "mousemove", this.throttledHandleMouseMove), this.on(t, "touchmove", this.throttledHandleMouseMove), this.on(t, "mouseup", this.handleMouseUpHandler_), this.on(t, "touchend", this.handleMouseUpHandler_)
    }, t.handleMouseUp = function (e) {
      var t = this.el_.ownerDocument;
      this.off(t, "mousemove", this.throttledHandleMouseMove), this.off(t, "touchmove", this.throttledHandleMouseMove), this.off(t, "mouseup", this.handleMouseUpHandler_), this.off(t, "touchend", this.handleMouseUpHandler_)
    }, t.handleMouseMove = function (e) {
      this.volumeBar.handleMouseMove(e)
    }, e
  }(Tt);
  $n.prototype.options_ = {
    children: ["volumeBar"]
  }, Tt.registerComponent("VolumeControl", $n);
  var Jn = function (n) {
    function e(e, t) {
      var i;
      return i = n.call(this, e, t) || this,
        function (e, t) {
          t.tech_ && !t.tech_.featuresMuteControl && e.addClass("vjs-hidden"), e.on(t, "loadstart", function () {
            t.tech_.featuresMuteControl ? e.removeClass("vjs-hidden") : e.addClass("vjs-hidden")
          })
        }(St(i), e), i.on(e, ["loadstart", "volumechange"], function (e) {
          return i.update(e)
        }), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-mute-control " + n.prototype.buildCSSClass.call(this)
    }, t.handleClick = function (e) {
      var t = this.player_.volume(),
        i = this.player_.lastVolume_();
      if (0 === t) {
        var n = i < .1 ? .1 : i;
        this.player_.volume(n), this.player_.muted(!1)
      } else this.player_.muted(!this.player_.muted())
    }, t.update = function (e) {
      this.updateIcon_(), this.updateControlText_()
    }, t.updateIcon_ = function () {
      var e = this.player_.volume(),
        t = 3;
      K && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), 0 === e || this.player_.muted() ? t = 0 : e < .33 ? t = 1 : e < .67 && (t = 2);
      for (var i = 0; i < 4; i++) ue(this.el_, "vjs-vol-" + i);
      oe(this.el_, "vjs-vol-" + t)
    }, t.updateControlText_ = function () {
      var e = this.player_.muted() || 0 === this.player_.volume() ? "Unmute" : "Mute";
      this.controlText() !== e && this.controlText(e)
    }, e
  }(Sn);
  Jn.prototype.controlText_ = "Mute", Tt.registerComponent("MuteToggle", Jn);
  var Zn = function (n) {
    function e(e, t) {
      var i;
      return void 0 === t && (t = {}), "undefined" != typeof t.inline ? t.inline = t.inline : t.inline = !0, "undefined" != typeof t.volumeControl && !k(t.volumeControl) || (t.volumeControl = t.volumeControl || {}, t.volumeControl.vertical = !t.inline), (i = n.call(this, e, t) || this).handleKeyPressHandler_ = function (e) {
        return i.handleKeyPress(e)
      }, i.on(e, ["loadstart"], function (e) {
        return i.volumePanelState_(e)
      }), i.on(i.muteToggle, "keyup", function (e) {
        return i.handleKeyPress(e)
      }), i.on(i.volumeControl, "keyup", function (e) {
        return i.handleVolumeControlKeyUp(e)
      }), i.on("keydown", function (e) {
        return i.handleKeyPress(e)
      }), i.on("mouseover", function (e) {
        return i.handleMouseOver(e)
      }), i.on("mouseout", function (e) {
        return i.handleMouseOut(e)
      }), i.on(i.volumeControl, ["slideractive"], i.sliderActive_), i.on(i.volumeControl, ["sliderinactive"], i.sliderInactive_), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.sliderActive_ = function () {
      this.addClass("vjs-slider-active")
    }, t.sliderInactive_ = function () {
      this.removeClass("vjs-slider-active")
    }, t.volumePanelState_ = function () {
      this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only")
    }, t.createEl = function () {
      var e = "vjs-volume-panel-horizontal";
      return this.options_.inline || (e = "vjs-volume-panel-vertical"), n.prototype.createEl.call(this, "div", {
        className: "vjs-volume-panel vjs-control " + e
      })
    }, t.dispose = function () {
      this.handleMouseOut(), n.prototype.dispose.call(this)
    }, t.handleVolumeControlKeyUp = function (e) {
      Nt.isEventKey(e, "Esc") && this.muteToggle.focus()
    }, t.handleMouseOver = function (e) {
      this.addClass("vjs-hover"), Ge(p, "keyup", this.handleKeyPressHandler_)
    }, t.handleMouseOut = function (e) {
      this.removeClass("vjs-hover"), Xe(p, "keyup", this.handleKeyPressHandler_)
    }, t.handleKeyPress = function (e) {
      Nt.isEventKey(e, "Esc") && this.handleMouseOut()
    }, e
  }(Tt);
  Zn.prototype.options_ = {
    children: ["muteToggle", "volumeControl"]
  }, Tt.registerComponent("VolumePanel", Zn);
  var er = function (n) {
    function e(e, t) {
      var i;
      return i = n.call(this, e, t) || this, t && (i.menuButton_ = t.menuButton), i.focusedChild_ = -1, i.on("keydown", function (e) {
        return i.handleKeyDown(e)
      }), i.boundHandleBlur_ = function (e) {
        return i.handleBlur(e)
      }, i.boundHandleTapClick_ = function (e) {
        return i.handleTapClick(e)
      }, i
    }
    Et(e, n);
    var t = e.prototype;
    return t.addEventListenerForItem = function (e) {
      e instanceof Tt && (this.on(e, "blur", this.boundHandleBlur_), this.on(e, ["tap", "click"], this.boundHandleTapClick_))
    }, t.removeEventListenerForItem = function (e) {
      e instanceof Tt && (this.off(e, "blur", this.boundHandleBlur_), this.off(e, ["tap", "click"], this.boundHandleTapClick_))
    }, t.removeChild = function (e) {
      "string" == typeof e && (e = this.getChild(e)), this.removeEventListenerForItem(e), n.prototype.removeChild.call(this, e)
    }, t.addItem = function (e) {
      var t = this.addChild(e);
      t && this.addEventListenerForItem(t)
    }, t.createEl = function () {
      var e = this.options_.contentElType || "ul";
      this.contentEl_ = ne(e, {
        className: "vjs-menu-content"
      }), this.contentEl_.setAttribute("role", "menu");
      var t = n.prototype.createEl.call(this, "div", {
        append: this.contentEl_,
        className: "vjs-menu"
      });
      return t.appendChild(this.contentEl_), Ge(t, "click", function (e) {
        e.preventDefault(), e.stopImmediatePropagation()
      }), t
    }, t.dispose = function () {
      this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, n.prototype.dispose.call(this)
    }, t.handleBlur = function (e) {
      var t = e.relatedTarget || p.activeElement;
      if (!this.children().some(function (e) {
          return e.el() === t
        })) {
        var i = this.menuButton_;
        i && i.buttonPressed_ && t !== i.el().firstChild && i.unpressButton()
      }
    }, t.handleTapClick = function (t) {
      if (this.menuButton_) {
        this.menuButton_.unpressButton();
        var e = this.children();
        if (!Array.isArray(e)) return;
        var i = e.filter(function (e) {
          return e.el() === t.target
        })[0];
        if (!i) return;
        "CaptionSettingsMenuItem" !== i.name() && this.menuButton_.focus()
      }
    }, t.handleKeyDown = function (e) {
      Nt.isEventKey(e, "Left") || Nt.isEventKey(e, "Down") ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : (Nt.isEventKey(e, "Right") || Nt.isEventKey(e, "Up")) && (e.preventDefault(), e.stopPropagation(), this.stepBack())
    }, t.stepForward = function () {
      var e = 0;
      void 0 !== this.focusedChild_ && (e = this.focusedChild_ + 1), this.focus(e)
    }, t.stepBack = function () {
      var e = 0;
      void 0 !== this.focusedChild_ && (e = this.focusedChild_ - 1), this.focus(e)
    }, t.focus = function (e) {
      void 0 === e && (e = 0);
      var t = this.children().slice();
      t.length && t[0].hasClass("vjs-menu-title") && t.shift(), 0 < t.length && (e < 0 ? e = 0 : e >= t.length && (e = t.length - 1), t[this.focusedChild_ = e].el_.focus())
    }, e
  }(Tt);
  Tt.registerComponent("Menu", er);
  var tr = function (a) {
    function e(e, t) {
      var i;
      void 0 === t && (t = {}), (i = a.call(this, e, t) || this).menuButton_ = new Sn(e, t), i.menuButton_.controlText(i.controlText_), i.menuButton_.el_.setAttribute("aria-haspopup", "true");
      var n = Sn.prototype.buildCSSClass();
      i.menuButton_.el_.className = i.buildCSSClass() + " " + n, i.menuButton_.removeClass("vjs-control"), i.addChild(i.menuButton_), i.update(), i.enabled_ = !0;

      function r(e) {
        return i.handleClick(e)
      }
      return i.handleMenuKeyUp_ = function (e) {
        return i.handleMenuKeyUp(e)
      }, i.on(i.menuButton_, "tap", r), i.on(i.menuButton_, "click", r), i.on(i.menuButton_, "keydown", function (e) {
        return i.handleKeyDown(e)
      }), i.on(i.menuButton_, "mouseenter", function () {
        i.addClass("vjs-hover"), i.menu.show(), Ge(p, "keyup", i.handleMenuKeyUp_)
      }), i.on("mouseleave", function (e) {
        return i.handleMouseLeave(e)
      }), i.on("keydown", function (e) {
        return i.handleSubmenuKeyDown(e)
      }), i
    }
    Et(e, a);
    var t = e.prototype;
    return t.update = function () {
      var e = this.createMenu();
      this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = e, this.addChild(e), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? this.hide() : this.show()
    }, t.createMenu = function () {
      var e = new er(this.player_, {
        menuButton: this
      });
      if (this.hideThreshold_ = 0, this.options_.title) {
        var t = ne("li", {
          className: "vjs-menu-title",
          innerHTML: mt(this.options_.title),
          tabIndex: -1
        });
        this.hideThreshold_ += 1;
        var i = new Tt(this.player_, {
          el: t
        });
        e.addItem(i)
      }
      if (this.items = this.createItems(), this.items)
        for (var n = 0; n < this.items.length; n++) e.addItem(this.items[n]);
      return e
    }, t.createItems = function () {}, t.createEl = function () {
      return a.prototype.createEl.call(this, "div", {
        className: this.buildWrapperCSSClass()
      }, {})
    }, t.buildWrapperCSSClass = function () {
      var e = "vjs-menu-button";
      return !0 === this.options_.inline ? e += "-inline" : e += "-popup", "vjs-menu-button " + e + " " + Sn.prototype.buildCSSClass() + " " + a.prototype.buildCSSClass.call(this)
    }, t.buildCSSClass = function () {
      var e = "vjs-menu-button";
      return !0 === this.options_.inline ? e += "-inline" : e += "-popup", "vjs-menu-button " + e + " " + a.prototype.buildCSSClass.call(this)
    }, t.controlText = function (e, t) {
      return void 0 === t && (t = this.menuButton_.el()), this.menuButton_.controlText(e, t)
    }, t.dispose = function () {
      this.handleMouseLeave(), a.prototype.dispose.call(this)
    }, t.handleClick = function (e) {
      this.buttonPressed_ ? this.unpressButton() : this.pressButton()
    }, t.handleMouseLeave = function (e) {
      this.removeClass("vjs-hover"), Xe(p, "keyup", this.handleMenuKeyUp_)
    }, t.focus = function () {
      this.menuButton_.focus()
    }, t.blur = function () {
      this.menuButton_.blur()
    }, t.handleKeyDown = function (e) {
      Nt.isEventKey(e, "Esc") || Nt.isEventKey(e, "Tab") ? (this.buttonPressed_ && this.unpressButton(), Nt.isEventKey(e, "Tab") || (e.preventDefault(), this.menuButton_.focus())) : (Nt.isEventKey(e, "Up") || Nt.isEventKey(e, "Down")) && (this.buttonPressed_ || (e.preventDefault(), this.pressButton()))
    }, t.handleMenuKeyUp = function (e) {
      (Nt.isEventKey(e, "Esc") || Nt.isEventKey(e, "Tab")) && this.removeClass("vjs-hover")
    }, t.handleSubmenuKeyPress = function (e) {
      this.handleSubmenuKeyDown(e)
    }, t.handleSubmenuKeyDown = function (e) {
      (Nt.isEventKey(e, "Esc") || Nt.isEventKey(e, "Tab")) && (this.buttonPressed_ && this.unpressButton(), Nt.isEventKey(e, "Tab") || (e.preventDefault(), this.menuButton_.focus()))
    }, t.pressButton = function () {
      if (this.enabled_) {
        if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), K && te()) return;
        this.menu.focus()
      }
    }, t.unpressButton = function () {
      this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"))
    }, t.disable = function () {
      this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable()
    }, t.enable = function () {
      this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable()
    }, e
  }(Tt);
  Tt.registerComponent("MenuButton", tr);
  var ir = function (a) {
    function e(e, t) {
      var i, n = t.tracks;
      if ((i = a.call(this, e, t) || this).items.length <= 1 && i.hide(), !n) return St(i);
      var r = $e(St(i), i.update);
      return n.addEventListener("removetrack", r), n.addEventListener("addtrack", r), n.addEventListener("labelchange", r), i.player_.on("ready", r), i.player_.on("dispose", function () {
        n.removeEventListener("removetrack", r), n.removeEventListener("addtrack", r), n.removeEventListener("labelchange", r)
      }), i
    }
    return Et(e, a), e
  }(tr);
  Tt.registerComponent("TrackButton", ir);
  var nr = ["Tab", "Esc", "Up", "Down", "Right", "Left"],
    rr = function (n) {
      function e(e, t) {
        var i;
        return (i = n.call(this, e, t) || this).selectable = t.selectable, i.isSelected_ = t.selected || !1, i.multiSelectable = t.multiSelectable, i.selected(i.isSelected_), i.selectable ? i.multiSelectable ? i.el_.setAttribute("role", "menuitemcheckbox") : i.el_.setAttribute("role", "menuitemradio") : i.el_.setAttribute("role", "menuitem"), i
      }
      Et(e, n);
      var t = e.prototype;
      return t.createEl = function (e, t, i) {
        return this.nonIconControl = !0, n.prototype.createEl.call(this, "li", S({
          className: "vjs-menu-item",
          innerHTML: '<span class="vjs-menu-item-text">' + this.localize(this.options_.label) + "</span>",
          tabIndex: -1
        }, t), i)
      }, t.handleKeyDown = function (t) {
        nr.some(function (e) {
          return Nt.isEventKey(t, e)
        }) || n.prototype.handleKeyDown.call(this, t)
      }, t.handleClick = function (e) {
        this.selected(!0)
      }, t.selected = function (e) {
        this.selectable && (e ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1))
      }, e
    }(fn);
  Tt.registerComponent("MenuItem", rr);
  var ar = function (u) {
    function e(e, t) {
      var n, i = t.track,
        r = e.textTracks();
      t.label = i.label || i.language || "Unknown", t.selected = "showing" === i.mode, (n = u.call(this, e, t) || this).track = i, n.kinds = (t.kinds || [t.kind || n.track.kind]).filter(Boolean);

      function a() {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        n.handleTracksChange.apply(St(n), t)
      }

      function s() {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        n.handleSelectedLanguageChange.apply(St(n), t)
      }
      var o;
      e.on(["loadstart", "texttrackchange"], a), r.addEventListener("change", a), r.addEventListener("selectedlanguagechange", s), n.on("dispose", function () {
        e.off(["loadstart", "texttrackchange"], a), r.removeEventListener("change", a), r.removeEventListener("selectedlanguagechange", s)
      }), void 0 === r.onchange && n.on(["tap", "click"], function () {
        if ("object" != typeof h.Event) try {
          o = new h.Event("change")
        } catch (e) {}
        o || (o = p.createEvent("Event")).initEvent("change", !0, !0), r.dispatchEvent(o)
      });
      return n.handleTracksChange(), n
    }
    Et(e, u);
    var t = e.prototype;
    return t.handleClick = function (e) {
      var t = this.track,
        i = this.player_.textTracks();
      if (u.prototype.handleClick.call(this, e), i)
        for (var n = 0; n < i.length; n++) {
          var r = i[n]; - 1 !== this.kinds.indexOf(r.kind) && (r === t ? "showing" !== r.mode && (r.mode = "showing") : "disabled" !== r.mode && (r.mode = "disabled"))
        }
    }, t.handleTracksChange = function (e) {
      var t = "showing" === this.track.mode;
      t !== this.isSelected_ && this.selected(t)
    }, t.handleSelectedLanguageChange = function (e) {
      if ("showing" === this.track.mode) {
        var t = this.player_.cache_.selectedLanguage;
        if (t && t.enabled && t.language === this.track.language && t.kind !== this.track.kind) return;
        this.player_.cache_.selectedLanguage = {
          enabled: !0,
          language: this.track.language,
          kind: this.track.kind
        }
      }
    }, t.dispose = function () {
      this.track = null, u.prototype.dispose.call(this)
    }, e
  }(rr);
  Tt.registerComponent("TextTrackMenuItem", ar);
  var sr = function (i) {
    function e(e, t) {
      return t.track = {
        player: e,
        kind: t.kind,
        kinds: t.kinds,
        default: !1,
        mode: "disabled"
      }, t.kinds || (t.kinds = [t.kind]), t.label ? t.track.label = t.label : t.track.label = t.kinds.join(" and ") + " off", t.selectable = !0, t.multiSelectable = !1, i.call(this, e, t) || this
    }
    Et(e, i);
    var t = e.prototype;
    return t.handleTracksChange = function (e) {
      for (var t = this.player().textTracks(), i = !0, n = 0, r = t.length; n < r; n++) {
        var a = t[n];
        if (-1 < this.options_.kinds.indexOf(a.kind) && "showing" === a.mode) {
          i = !1;
          break
        }
      }
      i !== this.isSelected_ && this.selected(i)
    }, t.handleSelectedLanguageChange = function (e) {
      for (var t = this.player().textTracks(), i = !0, n = 0, r = t.length; n < r; n++) {
        var a = t[n];
        if (-1 < ["captions", "descriptions", "subtitles"].indexOf(a.kind) && "showing" === a.mode) {
          i = !1;
          break
        }
      }
      i && (this.player_.cache_.selectedLanguage = {
        enabled: !1
      })
    }, e
  }(ar);
  Tt.registerComponent("OffTextTrackMenuItem", sr);
  var or = function (i) {
    function e(e, t) {
      return void 0 === t && (t = {}), t.tracks = e.textTracks(), i.call(this, e, t) || this
    }
    return Et(e, i), e.prototype.createItems = function (e, t) {
      var i;
      void 0 === e && (e = []), void 0 === t && (t = ar), this.label_ && (i = this.label_ + " off"), e.push(new sr(this.player_, {
        kinds: this.kinds_,
        kind: this.kind_,
        label: i
      })), this.hideThreshold_ += 1;
      var n = this.player_.textTracks();
      Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
      for (var r = 0; r < n.length; r++) {
        var a = n[r];
        if (-1 < this.kinds_.indexOf(a.kind)) {
          var s = new t(this.player_, {
            track: a,
            kinds: this.kinds_,
            kind: this.kind_,
            selectable: !0,
            multiSelectable: !1
          });
          s.addClass("vjs-" + a.kind + "-menu-item"), e.push(s)
        }
      }
      return e
    }, e
  }(ir);
  Tt.registerComponent("TextTrackButton", or);
  var ur = function (s) {
    function e(e, t) {
      var i, n = t.track,
        r = t.cue,
        a = e.currentTime();
      return t.selectable = !0, t.multiSelectable = !1, t.label = r.text, t.selected = r.startTime <= a && a < r.endTime, (i = s.call(this, e, t) || this).track = n, i.cue = r, n.addEventListener("cuechange", $e(St(i), i.update)), i
    }
    Et(e, s);
    var t = e.prototype;
    return t.handleClick = function (e) {
      s.prototype.handleClick.call(this), this.player_.currentTime(this.cue.startTime), this.update(this.cue.startTime)
    }, t.update = function (e) {
      var t = this.cue,
        i = this.player_.currentTime();
      this.selected(t.startTime <= i && i < t.endTime)
    }, e
  }(rr);
  Tt.registerComponent("ChaptersTrackMenuItem", ur);
  var lr = function (n) {
    function e(e, t, i) {
      return n.call(this, e, t, i) || this
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-chapters-button " + n.prototype.buildCSSClass.call(this)
    }, t.buildWrapperCSSClass = function () {
      return "vjs-chapters-button " + n.prototype.buildWrapperCSSClass.call(this)
    }, t.update = function (e) {
      this.track_ && (!e || "addtrack" !== e.type && "removetrack" !== e.type) || this.setTrack(this.findChaptersTrack()), n.prototype.update.call(this)
    }, t.setTrack = function (e) {
      if (this.track_ !== e) {
        if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
          var t = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
          t && t.removeEventListener("load", this.updateHandler_), this.track_ = null
        }
        if (this.track_ = e, this.track_) {
          this.track_.mode = "hidden";
          var i = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
          i && i.addEventListener("load", this.updateHandler_)
        }
      }
    }, t.findChaptersTrack = function () {
      for (var e = this.player_.textTracks() || [], t = e.length - 1; 0 <= t; t--) {
        var i = e[t];
        if (i.kind === this.kind_) return i
      }
    }, t.getMenuCaption = function () {
      return this.track_ && this.track_.label ? this.track_.label : this.localize(mt(this.kind_))
    }, t.createMenu = function () {
      return this.options_.title = this.getMenuCaption(), n.prototype.createMenu.call(this)
    }, t.createItems = function () {
      var e = [];
      if (!this.track_) return e;
      var t = this.track_.cues;
      if (!t) return e;
      for (var i = 0, n = t.length; i < n; i++) {
        var r = t[i],
          a = new ur(this.player_, {
            track: this.track_,
            cue: r
          });
        e.push(a)
      }
      return e
    }, e
  }(or);
  lr.prototype.kind_ = "chapters", lr.prototype.controlText_ = "Chapters", Tt.registerComponent("ChaptersButton", lr);
  var cr = function (s) {
    function e(e, t, i) {
      var n;
      n = s.call(this, e, t, i) || this;
      var r = e.textTracks(),
        a = $e(St(n), n.handleTracksChange);
      return r.addEventListener("change", a), n.on("dispose", function () {
        r.removeEventListener("change", a)
      }), n
    }
    Et(e, s);
    var t = e.prototype;
    return t.handleTracksChange = function (e) {
      for (var t = this.player().textTracks(), i = !1, n = 0, r = t.length; n < r; n++) {
        var a = t[n];
        if (a.kind !== this.kind_ && "showing" === a.mode) {
          i = !0;
          break
        }
      }
      i ? this.disable() : this.enable()
    }, t.buildCSSClass = function () {
      return "vjs-descriptions-button " + s.prototype.buildCSSClass.call(this)
    }, t.buildWrapperCSSClass = function () {
      return "vjs-descriptions-button " + s.prototype.buildWrapperCSSClass.call(this)
    }, e
  }(or);
  cr.prototype.kind_ = "descriptions", cr.prototype.controlText_ = "Descriptions", Tt.registerComponent("DescriptionsButton", cr);
  var dr = function (n) {
    function e(e, t, i) {
      return n.call(this, e, t, i) || this
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-subtitles-button " + n.prototype.buildCSSClass.call(this)
    }, t.buildWrapperCSSClass = function () {
      return "vjs-subtitles-button " + n.prototype.buildWrapperCSSClass.call(this)
    }, e
  }(or);
  dr.prototype.kind_ = "subtitles", dr.prototype.controlText_ = "Subtitles", Tt.registerComponent("SubtitlesButton", dr);
  var hr = function (n) {
    function e(e, t) {
      var i;
      return t.track = {
        player: e,
        kind: t.kind,
        label: t.kind + " settings",
        selectable: !1,
        default: !1,
        mode: "disabled"
      }, t.selectable = !1, t.name = "CaptionSettingsMenuItem", (i = n.call(this, e, t) || this).addClass("vjs-texttrack-settings"), i.controlText(", opens " + t.kind + " settings dialog"), i
    }
    return Et(e, n), e.prototype.handleClick = function (e) {
      this.player().getChild("textTrackSettings").open()
    }, e
  }(ar);
  Tt.registerComponent("CaptionSettingsMenuItem", hr);
  var pr = function (n) {
    function e(e, t, i) {
      return n.call(this, e, t, i) || this
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-captions-button " + n.prototype.buildCSSClass.call(this)
    }, t.buildWrapperCSSClass = function () {
      return "vjs-captions-button " + n.prototype.buildWrapperCSSClass.call(this)
    }, t.createItems = function () {
      var e = [];
      return this.player().tech_ && this.player().tech_.featuresNativeTextTracks || !this.player().getChild("textTrackSettings") || (e.push(new hr(this.player_, {
        kind: this.kind_
      })), this.hideThreshold_ += 1), n.prototype.createItems.call(this, e)
    }, e
  }(or);
  pr.prototype.kind_ = "captions", pr.prototype.controlText_ = "Captions", Tt.registerComponent("CaptionsButton", pr);
  var fr = function (r) {
    function e() {
      return r.apply(this, arguments) || this
    }
    return Et(e, r), e.prototype.createEl = function (e, t, i) {
      var n = '<span class="vjs-menu-item-text">' + this.localize(this.options_.label);
      return "captions" === this.options_.track.kind && (n += '\n        <span aria-hidden="true" class="vjs-icon-placeholder"></span>\n        <span class="vjs-control-text"> ' + this.localize("Captions") + "</span>\n      "), n += "</span>", r.prototype.createEl.call(this, e, S({
        innerHTML: n
      }, t), i)
    }, e
  }(ar);
  Tt.registerComponent("SubsCapsMenuItem", fr);
  var mr = function (n) {
    function e(e, t) {
      var i;
      return void 0 === t && (t = {}), (i = n.call(this, e, t) || this).label_ = "subtitles", -1 < ["en", "en-us", "en-ca", "fr-ca"].indexOf(i.player_.language_) && (i.label_ = "captions"), i.menuButton_.controlText(mt(i.label_)), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-subs-caps-button " + n.prototype.buildCSSClass.call(this)
    }, t.buildWrapperCSSClass = function () {
      return "vjs-subs-caps-button " + n.prototype.buildWrapperCSSClass.call(this)
    }, t.createItems = function () {
      var e = [];
      return this.player().tech_ && this.player().tech_.featuresNativeTextTracks || !this.player().getChild("textTrackSettings") || (e.push(new hr(this.player_, {
        kind: this.label_
      })), this.hideThreshold_ += 1), e = n.prototype.createItems.call(this, e, fr)
    }, e
  }(or);
  mr.prototype.kinds_ = ["captions", "subtitles"], mr.prototype.controlText_ = "Subtitles", Tt.registerComponent("SubsCapsButton", mr);
  var gr = function (s) {
    function e(e, t) {
      var n, i = t.track,
        r = e.audioTracks();
      t.label = i.label || i.language || "Unknown", t.selected = i.enabled, (n = s.call(this, e, t) || this).track = i, n.addClass("vjs-" + i.kind + "-menu-item");

      function a() {
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        n.handleTracksChange.apply(St(n), t)
      }
      return r.addEventListener("change", a), n.on("dispose", function () {
        r.removeEventListener("change", a)
      }), n
    }
    Et(e, s);
    var t = e.prototype;
    return t.createEl = function (e, t, i) {
      var n = '<span class="vjs-menu-item-text">' + this.localize(this.options_.label);
      return "main-desc" === this.options_.track.kind && (n += '\n        <span aria-hidden="true" class="vjs-icon-placeholder"></span>\n        <span class="vjs-control-text"> ' + this.localize("Descriptions") + "</span>\n      "), n += "</span>", s.prototype.createEl.call(this, e, S({
        innerHTML: n
      }, t), i)
    }, t.handleClick = function (e) {
      s.prototype.handleClick.call(this, e), this.track.enabled = !0
    }, t.handleTracksChange = function (e) {
      this.selected(this.track.enabled)
    }, e
  }(rr);
  Tt.registerComponent("AudioTrackMenuItem", gr);
  var vr = function (i) {
    function e(e, t) {
      return void 0 === t && (t = {}), t.tracks = e.audioTracks(), i.call(this, e, t) || this
    }
    Et(e, i);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-audio-button " + i.prototype.buildCSSClass.call(this)
    }, t.buildWrapperCSSClass = function () {
      return "vjs-audio-button " + i.prototype.buildWrapperCSSClass.call(this)
    }, t.createItems = function (e) {
      void 0 === e && (e = []), this.hideThreshold_ = 1;
      for (var t = this.player_.audioTracks(), i = 0; i < t.length; i++) {
        var n = t[i];
        e.push(new gr(this.player_, {
          track: n,
          selectable: !0,
          multiSelectable: !1
        }))
      }
      return e
    }, e
  }(ir);
  vr.prototype.controlText_ = "Audio Track", Tt.registerComponent("AudioTrackButton", vr);
  var yr = function (a) {
    function e(e, t) {
      var i, n = t.rate,
        r = parseFloat(n, 10);
      return t.label = n, t.selected = 1 === r, t.selectable = !0, t.multiSelectable = !1, (i = a.call(this, e, t) || this).label = n, i.rate = r, i.on(e, "ratechange", function (e) {
        return i.update(e)
      }), i
    }
    Et(e, a);
    var t = e.prototype;
    return t.handleClick = function (e) {
      a.prototype.handleClick.call(this), this.player().playbackRate(this.rate)
    }, t.update = function (e) {
      this.selected(this.player().playbackRate() === this.rate)
    }, e
  }(rr);
  yr.prototype.contentElType = "button", Tt.registerComponent("PlaybackRateMenuItem", yr);
  var _r = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).updateVisibility(), i.updateLabel(), i.on(e, "loadstart", function (e) {
        return i.updateVisibility(e)
      }), i.on(e, "ratechange", function (e) {
        return i.updateLabel(e)
      }), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.createEl = function () {
      var e = n.prototype.createEl.call(this);
      return this.labelEl_ = ne("div", {
        className: "vjs-playback-rate-value",
        innerHTML: "1x"
      }), e.appendChild(this.labelEl_), e
    }, t.dispose = function () {
      this.labelEl_ = null, n.prototype.dispose.call(this)
    }, t.buildCSSClass = function () {
      return "vjs-playback-rate " + n.prototype.buildCSSClass.call(this)
    }, t.buildWrapperCSSClass = function () {
      return "vjs-playback-rate " + n.prototype.buildWrapperCSSClass.call(this)
    }, t.createMenu = function () {
      var e = new er(this.player()),
        t = this.playbackRates();
      if (t)
        for (var i = t.length - 1; 0 <= i; i--) e.addChild(new yr(this.player(), {
          rate: t[i] + "x"
        }));
      return e
    }, t.updateARIAAttributes = function () {
      this.el().setAttribute("aria-valuenow", this.player().playbackRate())
    }, t.handleClick = function (e) {
      for (var t = this.player().playbackRate(), i = this.playbackRates(), n = i[0], r = 0; r < i.length; r++)
        if (i[r] > t) {
          n = i[r];
          break
        } this.player().playbackRate(n)
    }, t.playbackRates = function () {
      return this.options_.playbackRates || this.options_.playerOptions && this.options_.playerOptions.playbackRates
    }, t.playbackRateSupported = function () {
      return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && 0 < this.playbackRates().length
    }, t.updateVisibility = function (e) {
      this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden")
    }, t.updateLabel = function (e) {
      this.playbackRateSupported() && (this.labelEl_.innerHTML = this.player().playbackRate() + "x")
    }, e
  }(tr);
  _r.prototype.controlText_ = "Playback Rate", Tt.registerComponent("PlaybackRateMenuButton", _r);
  var br = function (e) {
    function t() {
      return e.apply(this, arguments) || this
    }
    Et(t, e);
    var i = t.prototype;
    return i.buildCSSClass = function () {
      return "vjs-spacer " + e.prototype.buildCSSClass.call(this)
    }, i.createEl = function () {
      return e.prototype.createEl.call(this, "div", {
        className: this.buildCSSClass()
      })
    }, t
  }(Tt);
  Tt.registerComponent("Spacer", br);
  var Tr = function (t) {
    function e() {
      return t.apply(this, arguments) || this
    }
    Et(e, t);
    var i = e.prototype;
    return i.buildCSSClass = function () {
      return "vjs-custom-control-spacer " + t.prototype.buildCSSClass.call(this)
    }, i.createEl = function () {
      var e = t.prototype.createEl.call(this, {
        className: this.buildCSSClass()
      });
      return e.innerHTML = " ", e
    }, e
  }(br);
  Tt.registerComponent("CustomControlSpacer", Tr);
  var Sr = function (e) {
    function t() {
      return e.apply(this, arguments) || this
    }
    return Et(t, e), t.prototype.createEl = function () {
      return e.prototype.createEl.call(this, "div", {
        className: "vjs-control-bar",
        dir: "ltr"
      })
    }, t
  }(Tt);
  Sr.prototype.options_ = {
    children: ["playToggle", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "fullscreenToggle"]
  }, "exitPictureInPicture" in p && Sr.prototype.options_.children.splice(Sr.prototype.options_.children.length - 1, 0, "pictureInPictureToggle"), Tt.registerComponent("ControlBar", Sr);
  var Er = function (n) {
    function e(e, t) {
      var i;
      return (i = n.call(this, e, t) || this).on(e, "error", function (e) {
        return i.open(e)
      }), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.buildCSSClass = function () {
      return "vjs-error-display " + n.prototype.buildCSSClass.call(this)
    }, t.content = function () {
      var e = this.player().error();
      return e ? this.localize(e.message) : ""
    }, e
  }(Bt);
  Er.prototype.options_ = y({}, Bt.prototype.options_, {
    pauseOnOpen: !1,
    fillAlways: !0,
    temporary: !1,
    uncloseable: !0
  }), Tt.registerComponent("ErrorDisplay", Er);
  var kr = "vjs-text-track-settings",
    wr = ["#000", "Black"],
    Cr = ["#00F", "Blue"],
    Ir = ["#0FF", "Cyan"],
    xr = ["#0F0", "Green"],
    Ar = ["#F0F", "Magenta"],
    Pr = ["#F00", "Red"],
    Lr = ["#FFF", "White"],
    Or = ["#FF0", "Yellow"],
    Dr = ["1", "Opaque"],
    Rr = ["0.5", "Semi-Transparent"],
    Mr = ["0", "Transparent"],
    Nr = {
      backgroundColor: {
        selector: ".vjs-bg-color > select",
        id: "captions-background-color-%s",
        label: "Color",
        options: [wr, Lr, Pr, xr, Cr, Or, Ar, Ir]
      },
      backgroundOpacity: {
        selector: ".vjs-bg-opacity > select",
        id: "captions-background-opacity-%s",
        label: "Transparency",
        options: [Dr, Rr, Mr]
      },
      color: {
        selector: ".vjs-fg-color > select",
        id: "captions-foreground-color-%s",
        label: "Color",
        options: [Lr, wr, Pr, xr, Cr, Or, Ar, Ir]
      },
      edgeStyle: {
        selector: ".vjs-edge-style > select",
        id: "%s",
        label: "Text Edge Style",
        options: [
          ["none", "None"],
          ["raised", "Raised"],
          ["depressed", "Depressed"],
          ["uniform", "Uniform"],
          ["dropshadow", "Dropshadow"]
        ]
      },
      fontFamily: {
        selector: ".vjs-font-family > select",
        id: "captions-font-family-%s",
        label: "Font Family",
        options: [
          ["proportionalSansSerif", "Proportional Sans-Serif"],
          ["monospaceSansSerif", "Monospace Sans-Serif"],
          ["proportionalSerif", "Proportional Serif"],
          ["monospaceSerif", "Monospace Serif"],
          ["casual", "Casual"],
          ["script", "Script"],
          ["small-caps", "Small Caps"]
        ]
      },
      fontPercent: {
        selector: ".vjs-font-percent > select",
        id: "captions-font-size-%s",
        label: "Font Size",
        options: [
          ["0.50", "50%"],
          ["0.75", "75%"],
          ["1.00", "100%"],
          ["1.25", "125%"],
          ["1.50", "150%"],
          ["1.75", "175%"],
          ["2.00", "200%"],
          ["3.00", "300%"],
          ["4.00", "400%"]
        ],
        default: 2,
        parser: function (e) {
          return "1.00" === e ? null : Number(e)
        }
      },
      textOpacity: {
        selector: ".vjs-text-opacity > select",
        id: "captions-foreground-opacity-%s",
        label: "Transparency",
        options: [Dr, Rr]
      },
      windowColor: {
        selector: ".vjs-window-color > select",
        id: "captions-window-color-%s",
        label: "Color"
      },
      windowOpacity: {
        selector: ".vjs-window-opacity > select",
        id: "captions-window-opacity-%s",
        label: "Transparency",
        options: [Mr, Rr, Dr]
      }
    };

  function Ur(e, t) {
    if (t && (e = t(e)), e && "none" !== e) return e
  }
  Nr.windowColor.options = Nr.backgroundColor.options;
  var Br = function (n) {
    function e(e, t) {
      var i;
      return t.temporary = !1, (i = n.call(this, e, t) || this).updateDisplay = i.updateDisplay.bind(St(i)), i.fill(), i.hasBeenOpened_ = i.hasBeenFilled_ = !0, i.endDialog = ne("p", {
        className: "vjs-control-text",
        textContent: i.localize("End of dialog window.")
      }), i.el().appendChild(i.endDialog), i.setDefaults(), void 0 === t.persistTextTrackSettings && (i.options_.persistTextTrackSettings = i.options_.playerOptions.persistTextTrackSettings), i.on(i.$(".vjs-done-button"), "click", function () {
        i.saveSettings(), i.close()
      }), i.on(i.$(".vjs-default-button"), "click", function () {
        i.setDefaults(), i.updateDisplay()
      }), T(Nr, function (e) {
        i.on(i.$(e.selector), "change", i.updateDisplay)
      }), i.options_.persistTextTrackSettings && i.restoreSettings(), i
    }
    Et(e, n);
    var t = e.prototype;
    return t.dispose = function () {
      this.endDialog = null, n.prototype.dispose.call(this)
    }, t.createElSelect_ = function (e, t, i) {
      var n = this;
      void 0 === t && (t = ""), void 0 === i && (i = "label");
      var r = Nr[e],
        a = r.id.replace("%s", this.id_),
        s = [t, a].join(" ").trim();
      return ["<" + i + ' id="' + a + '" class="' + ("label" === i ? "vjs-label" : "") + '">', this.localize(r.label), "</" + i + ">", '<select aria-labelledby="' + s + '">'].concat(r.options.map(function (e) {
        var t = a + "-" + e[1].replace(/\W+/g, "");
        return ['<option id="' + t + '" value="' + e[0] + '" ', 'aria-labelledby="' + s + " " + t + '">', n.localize(e[1]), "</option>"].join("")
      })).concat("</select>").join("")
    }, t.createElFgColor_ = function () {
      var e = "captions-text-legend-" + this.id_;
      return ['<fieldset class="vjs-fg-color vjs-track-setting">', '<legend id="' + e + '">', this.localize("Text"), "</legend>", this.createElSelect_("color", e), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_("textOpacity", e), "</span>", "</fieldset>"].join("")
    }, t.createElBgColor_ = function () {
      var e = "captions-background-" + this.id_;
      return ['<fieldset class="vjs-bg-color vjs-track-setting">', '<legend id="' + e + '">', this.localize("Background"), "</legend>", this.createElSelect_("backgroundColor", e), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_("backgroundOpacity", e), "</span>", "</fieldset>"].join("")
    }, t.createElWinColor_ = function () {
      var e = "captions-window-" + this.id_;
      return ['<fieldset class="vjs-window-color vjs-track-setting">', '<legend id="' + e + '">', this.localize("Window"), "</legend>", this.createElSelect_("windowColor", e), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_("windowOpacity", e), "</span>", "</fieldset>"].join("")
    }, t.createElColors_ = function () {
      return ne("div", {
        className: "vjs-track-settings-colors",
        innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join("")
      })
    }, t.createElFont_ = function () {
      return ne("div", {
        className: "vjs-track-settings-font",
        innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_("fontPercent", "", "legend"), "</fieldset>", '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_("edgeStyle", "", "legend"), "</fieldset>", '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_("fontFamily", "", "legend"), "</fieldset>"].join("")
      })
    }, t.createElControls_ = function () {
      var e = this.localize("restore all settings to the default values");
      return ne("div", {
        className: "vjs-track-settings-controls",
        innerHTML: ['<button type="button" class="vjs-default-button" title="' + e + '">', this.localize("Reset"), '<span class="vjs-control-text"> ' + e + "</span>", "</button>", '<button type="button" class="vjs-done-button">' + this.localize("Done") + "</button>"].join("")
      })
    }, t.content = function () {
      return [this.createElColors_(), this.createElFont_(), this.createElControls_()]
    }, t.label = function () {
      return this.localize("Caption Settings Dialog")
    }, t.description = function () {
      return this.localize("Beginning of dialog window. Escape will cancel and close the window.")
    }, t.buildCSSClass = function () {
      return n.prototype.buildCSSClass.call(this) + " vjs-text-track-settings"
    }, t.getValues = function () {
      var r = this;
      return function (i, n, e) {
        return void 0 === e && (e = 0), b(i).reduce(function (e, t) {
          return n(e, i[t], t)
        }, e)
      }(Nr, function (e, t, i) {
        var n = function (e, t) {
          return Ur(e.options[e.options.selectedIndex].value, t)
        }(r.$(t.selector), t.parser);
        return void 0 !== n && (e[i] = n), e
      }, {})
    }, t.setValues = function (i) {
      var n = this;
      T(Nr, function (e, t) {
        ! function (e, t, i) {
          if (t)
            for (var n = 0; n < e.options.length; n++)
              if (Ur(e.options[n].value, i) === t) {
                e.selectedIndex = n;
                break
              }
        }(n.$(e.selector), i[t], e.parser)
      })
    }, t.setDefaults = function () {
      var i = this;
      T(Nr, function (e) {
        var t = e.hasOwnProperty("default") ? e.default : 0;
        i.$(e.selector).selectedIndex = t
      })
    }, t.restoreSettings = function () {
      var e;
      try {
        e = JSON.parse(h.localStorage.getItem(kr))
      } catch (e) {
        g.warn(e)
      }
      e && this.setValues(e)
    }, t.saveSettings = function () {
      if (this.options_.persistTextTrackSettings) {
        var e = this.getValues();
        try {
          Object.keys(e).length ? h.localStorage.setItem(kr, JSON.stringify(e)) : h.localStorage.removeItem(kr)
        } catch (e) {
          g.warn(e)
        }
      }
    }, t.updateDisplay = function () {
      var e = this.player_.getChild("textTrackDisplay");
      e && e.updateDisplay()
    }, t.conditionalBlur_ = function () {
      this.previouslyActiveEl_ = null;
      var e = this.player_.controlBar,
        t = e && e.subsCapsButton,
        i = e && e.captionsButton;
      t ? t.focus() : i && i.focus()
    }, e
  }(Bt);
  Tt.registerComponent("TextTrackSettings", Br);
  var Fr = function (a) {
    function e(e, t) {
      var i, n = t.ResizeObserver || h.ResizeObserver;
      null === t.ResizeObserver && (n = !1);
      var r = gt({
        createEl: !n,
        reportTouchActivity: !1
      }, t);
      return (i = a.call(this, e, r) || this).ResizeObserver = t.ResizeObserver || h.ResizeObserver, i.loadListener_ = null, i.resizeObserver_ = null, i.debouncedHandler_ = function (n, r, a, s) {
        var o;
        void 0 === s && (s = h);

        function e() {
          var e = this,
            t = arguments,
            i = function () {
              i = o = null, a || n.apply(e, t)
            };
          !o && a && n.apply(e, t), s.clearTimeout(o), o = s.setTimeout(i, r)
        }
        return e.cancel = function () {
          s.clearTimeout(o), o = null
        }, e
      }(function () {
        i.resizeHandler()
      }, 100, !1, St(i)), n ? (i.resizeObserver_ = new i.ResizeObserver(i.debouncedHandler_), i.resizeObserver_.observe(e.el())) : (i.loadListener_ = function () {
        if (i.el_ && i.el_.contentWindow) {
          var e = i.debouncedHandler_,
            t = i.unloadListener_ = function () {
              Xe(this, "resize", e), Xe(this, "unload", t), t = null
            };
          Ge(i.el_.contentWindow, "unload", t), Ge(i.el_.contentWindow, "resize", e)
        }
      }, i.one("load", i.loadListener_)), i
    }
    Et(e, a);
    var t = e.prototype;
    return t.createEl = function () {
      return a.prototype.createEl.call(this, "iframe", {
        className: "vjs-resize-manager",
        tabIndex: -1
      }, {
        "aria-hidden": "true"
      })
    }, t.resizeHandler = function () {
      this.player_ && this.player_.trigger && this.player_.trigger("playerresize")
    }, t.dispose = function () {
      this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, a.prototype.dispose.call(this)
    }, e
  }(Tt);
  Tt.registerComponent("ResizeManager", Fr);
  var jr = {
      trackingThreshold: 30,
      liveTolerance: 15
    },
    Hr = function (r) {
      function e(e, t) {
        var i, n = gt(jr, t, {
          createEl: !1
        });
        return (i = r.call(this, e, n) || this).handleVisibilityChange_ = function (e) {
          return i.handleVisibilityChange(e)
        }, i.trackLiveHandler_ = function () {
          return i.trackLive_()
        }, i.handlePlay_ = function (e) {
          return i.handlePlay(e)
        }, i.handleFirstTimeupdate_ = function (e) {
          return i.handleFirstTimeupdate(e)
        }, i.handleSeeked_ = function (e) {
          return i.handleSeeked(e)
        }, i.seekToLiveEdge_ = function (e) {
          return i.seekToLiveEdge(e)
        }, i.reset_(), i.on(i.player_, "durationchange", function (e) {
          return i.handleDurationchange(e)
        }), i.one(i.player_, "canplay", function () {
          return i.toggleTracking()
        }), V && "hidden" in p && "visibilityState" in p && i.on(p, "visibilitychange", i.handleVisibilityChange_), i
      }
      Et(e, r);
      var t = e.prototype;
      return t.handleVisibilityChange = function () {
        this.player_.duration() === 1 / 0 && (p.hidden ? this.stopTracking() : this.startTracking())
      }, t.trackLive_ = function () {
        var e = this.player_.seekable();
        if (e && e.length) {
          var t = Number(h.performance.now().toFixed(4)),
            i = -1 === this.lastTime_ ? 0 : (t - this.lastTime_) / 1e3;
          this.lastTime_ = t, this.pastSeekEnd_ = this.pastSeekEnd() + i;
          var n = this.liveCurrentTime(),
            r = this.player_.currentTime(),
            a = this.player_.paused() || this.seekedBehindLive_ || Math.abs(n - r) > this.options_.liveTolerance;
          this.timeupdateSeen_ && n !== 1 / 0 || (a = !1), a !== this.behindLiveEdge_ && (this.behindLiveEdge_ = a, this.trigger("liveedgechange"))
        }
      }, t.handleDurationchange = function () {
        this.toggleTracking()
      }, t.toggleTracking = function () {
        this.player_.duration() === 1 / 0 && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking())
      }, t.startTracking = function () {
        this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, 30), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)))
      }, t.handleFirstTimeupdate = function () {
        this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_)
      }, t.handleSeeked = function () {
        var e = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
        this.seekedBehindLive_ = !this.skipNextSeeked_ && 2 < e, this.skipNextSeeked_ = !1, this.trackLive_()
      }, t.handlePlay = function () {
        this.one(this.player_, "timeupdate", this.seekToLiveEdge_)
      }, t.reset_ = function () {
        this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.skipNextSeeked_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_)
      }, t.stopTracking = function () {
        this.isTracking() && (this.reset_(), this.trigger("liveedgechange"))
      }, t.seekableEnd = function () {
        for (var e = this.player_.seekable(), t = [], i = e ? e.length : 0; i--;) t.push(e.end(i));
        return t.length ? t.sort()[t.length - 1] : 1 / 0
      }, t.seekableStart = function () {
        for (var e = this.player_.seekable(), t = [], i = e ? e.length : 0; i--;) t.push(e.start(i));
        return t.length ? t.sort()[0] : 0
      }, t.liveWindow = function () {
        var e = this.liveCurrentTime();
        return e === 1 / 0 ? 0 : e - this.seekableStart()
      }, t.isLive = function () {
        return this.isTracking()
      }, t.atLiveEdge = function () {
        return !this.behindLiveEdge()
      }, t.liveCurrentTime = function () {
        return this.pastSeekEnd() + this.seekableEnd()
      }, t.pastSeekEnd = function () {
        var e = this.seekableEnd();
        return -1 !== this.lastSeekEnd_ && e !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = e, this.pastSeekEnd_
      }, t.behindLiveEdge = function () {
        return this.behindLiveEdge_
      }, t.isTracking = function () {
        return "number" == typeof this.trackingInterval_
      }, t.seekToLiveEdge = function () {
        this.seekedBehindLive_ = !1, this.atLiveEdge() || (this.skipNextSeeked_ = !0, this.player_.currentTime(this.liveCurrentTime()))
      }, t.dispose = function () {
        this.off(p, "visibilitychange", this.handleVisibilityChange_), this.stopTracking(), r.prototype.dispose.call(this)
      }, e
    }(Tt);
  Tt.registerComponent("LiveTracker", Hr);

  function Vr(e) {
    var t = e.el();
    if (t.hasAttribute("src")) return e.triggerSourceset(t.src), !0;
    var i = e.$$("source"),
      n = [],
      r = "";
    if (!i.length) return !1;
    for (var a = 0; a < i.length; a++) {
      var s = i[a].src;
      s && -1 === n.indexOf(s) && n.push(s)
    }
    return !!n.length && (1 === n.length && (r = n[0]), e.triggerSourceset(r), !0)
  }

  function qr(e, t) {
    for (var i = {}, n = 0; n < e.length && !((i = Object.getOwnPropertyDescriptor(e[n], t)) && i.set && i.get); n++);
    return i.enumerable = !0, i.configurable = !0, i
  }

  function Wr(a) {
    var s = a.el();
    if (!s.resetSourceWatch_) {
      var t = {},
        e = function (e) {
          return qr([e.el(), h.HTMLMediaElement.prototype, h.Element.prototype, Kr], "innerHTML")
        }(a),
        i = function (r) {
          return function () {
            for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
            var n = r.apply(s, t);
            return Vr(a), n
          }
        };
      ["append", "appendChild", "insertAdjacentHTML"].forEach(function (e) {
        s[e] && (t[e] = s[e], s[e] = i(t[e]))
      }), Object.defineProperty(s, "innerHTML", gt(e, {
        set: i(e.set)
      })), s.resetSourceWatch_ = function () {
        s.resetSourceWatch_ = null, Object.keys(t).forEach(function (e) {
          s[e] = t[e]
        }), Object.defineProperty(s, "innerHTML", e)
      }, a.one("sourceset", s.resetSourceWatch_)
    }
  }

  function zr(n) {
    if (n.featuresSourceset) {
      var r = n.el();
      if (!r.resetSourceset_) {
        var i = function (e) {
            return qr([e.el(), h.HTMLMediaElement.prototype, Yr], "src")
          }(n),
          a = r.setAttribute,
          t = r.load;
        Object.defineProperty(r, "src", gt(i, {
          set: function (e) {
            var t = i.set.call(r, e);
            return n.triggerSourceset(r.src), t
          }
        })), r.setAttribute = function (e, t) {
          var i = a.call(r, e, t);
          return /src/i.test(e) && n.triggerSourceset(r.src), i
        }, r.load = function () {
          var e = t.call(r);
          return Vr(n) || (n.triggerSourceset(""), Wr(n)), e
        }, r.currentSrc ? n.triggerSourceset(r.currentSrc) : Vr(n) || Wr(n), r.resetSourceset_ = function () {
          r.resetSourceset_ = null, r.load = t, r.setAttribute = a, Object.defineProperty(r, "src", i), r.resetSourceWatch_ && r.resetSourceWatch_()
        }
      }
    }
  }

  function Gr(t, i, n, e) {
    function r(e) {
      return Object.defineProperty(t, i, {
        value: e,
        enumerable: !0,
        writable: !0
      })
    }
    void 0 === e && (e = !0);
    var a = {
      configurable: !0,
      enumerable: !0,
      get: function () {
        var e = n();
        return r(e), e
      }
    };
    return e && (a.set = r), Object.defineProperty(t, i, a)
  }
  var Xr, Kr = Object.defineProperty({}, "innerHTML", {
      get: function () {
        return this.cloneNode(!0).innerHTML
      },
      set: function (e) {
        var t = p.createElement(this.nodeName.toLowerCase());
        t.innerHTML = e;
        for (var i = p.createDocumentFragment(); t.childNodes.length;) i.appendChild(t.childNodes[0]);
        return this.innerText = "", h.Element.prototype.appendChild.call(this, i), this.innerHTML
      }
    }),
    Yr = Object.defineProperty({}, "src", {
      get: function () {
        return this.hasAttribute("src") ? Wt(h.Element.prototype.getAttribute.call(this, "src")) : ""
      },
      set: function (e) {
        return h.Element.prototype.setAttribute.call(this, "src", e), e
      }
    }),
    Qr = function (c) {
      function o(e, t) {
        var i;
        i = c.call(this, e, t) || this;
        var n = e.source,
          r = !1;
        if (n && (i.el_.currentSrc !== n.src || e.tag && 3 === e.tag.initNetworkState_) ? i.setSource(n) : i.handleLateInit_(i.el_), e.enableSourceset && i.setupSourcesetHandling_(), i.isScrubbing_ = !1, i.el_.hasChildNodes()) {
          for (var a = i.el_.childNodes, s = a.length, o = []; s--;) {
            var u = a[s];
            "track" === u.nodeName.toLowerCase() && (i.featuresNativeTextTracks ? (i.remoteTextTrackEls().addTrackElement_(u), i.remoteTextTracks().addTrack(u.track), i.textTracks().addTrack(u.track), r || i.el_.hasAttribute("crossorigin") || !Gt(u.src) || (r = !0)) : o.push(u))
          }
          for (var l = 0; l < o.length; l++) i.el_.removeChild(o[l])
        }
        return i.proxyNativeTracks_(), i.featuresNativeTextTracks && r && g.warn("Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.\nThis may prevent text tracks from loading."), i.restoreMetadataTracksInIOSNativePlayer_(), (z || X || U) && !0 === e.nativeControlsForTouch && i.setControls(!0), i.proxyWebkitFullscreen_(), i.triggerReady(), i
      }
      Et(o, c);
      var e = o.prototype;
      return e.dispose = function () {
        this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), o.disposeMediaElement(this.el_), this.options_ = null, c.prototype.dispose.call(this)
      }, e.setupSourcesetHandling_ = function () {
        zr(this)
      }, e.restoreMetadataTracksInIOSNativePlayer_ = function () {
        function e() {
          i = [];
          for (var e = 0; e < n.length; e++) {
            var t = n[e];
            "metadata" === t.kind && i.push({
              track: t,
              storedMode: t.mode
            })
          }
        }
        var i, n = this.textTracks();
        e(), n.addEventListener("change", e), this.on("dispose", function () {
          return n.removeEventListener("change", e)
        });

        function r() {
          for (var e = 0; e < i.length; e++) {
            var t = i[e];
            "disabled" === t.track.mode && t.track.mode !== t.storedMode && (t.track.mode = t.storedMode)
          }
          n.removeEventListener("change", r)
        }
        this.on("webkitbeginfullscreen", function () {
          n.removeEventListener("change", e), n.removeEventListener("change", r), n.addEventListener("change", r)
        }), this.on("webkitendfullscreen", function () {
          n.removeEventListener("change", e), n.addEventListener("change", e), n.removeEventListener("change", r)
        })
      }, e.overrideNative_ = function (e, t) {
        var i = this;
        if (t === this["featuresNative" + e + "Tracks"]) {
          var n = e.toLowerCase();
          this[n + "TracksListeners_"] && Object.keys(this[n + "TracksListeners_"]).forEach(function (e) {
            i.el()[n + "Tracks"].removeEventListener(e, i[n + "TracksListeners_"][e])
          }), this["featuresNative" + e + "Tracks"] = !t, this[n + "TracksListeners_"] = null, this.proxyNativeTracksForType_(n)
        }
      }, e.overrideNativeAudioTracks = function (e) {
        this.overrideNative_("Audio", e)
      }, e.overrideNativeVideoTracks = function (e) {
        this.overrideNative_("Video", e)
      }, e.proxyNativeTracksForType_ = function (i) {
        var n = this,
          e = _i[i],
          r = this.el()[e.getterName],
          a = this[e.getterName]();
        if (this["featuresNative" + e.capitalName + "Tracks"] && r && r.addEventListener) {
          var s = {
              change: function (e) {
                var t = {
                  type: "change",
                  target: a,
                  currentTarget: a,
                  srcElement: a
                };
                a.trigger(t), "text" === i && n[bi.remoteText.getterName]().trigger(t)
              },
              addtrack: function (e) {
                a.addTrack(e.track)
              },
              removetrack: function (e) {
                a.removeTrack(e.track)
              }
            },
            t = function () {
              for (var e = [], t = 0; t < a.length; t++) {
                for (var i = !1, n = 0; n < r.length; n++)
                  if (r[n] === a[t]) {
                    i = !0;
                    break
                  } i || e.push(a[t])
              }
              for (; e.length;) a.removeTrack(e.shift())
            };
          this[e.getterName + "Listeners_"] = s, Object.keys(s).forEach(function (t) {
            var i = s[t];
            r.addEventListener(t, i), n.on("dispose", function (e) {
              return r.removeEventListener(t, i)
            })
          }), this.on("loadstart", t), this.on("dispose", function (e) {
            return n.off("loadstart", t)
          })
        }
      }, e.proxyNativeTracks_ = function () {
        var t = this;
        _i.names.forEach(function (e) {
          t.proxyNativeTracksForType_(e)
        })
      }, e.createEl = function () {
        var e = this.options_.tag;
        if (!e || !this.options_.playerElIngest && !this.movingMediaElementInDOM) {
          if (e) {
            var t = e.cloneNode(!0);
            e.parentNode && e.parentNode.insertBefore(t, e), o.disposeMediaElement(e), e = t
          } else {
            e = p.createElement("video");
            var i = gt({}, this.options_.tag && de(this.options_.tag));
            z && !0 === this.options_.nativeControlsForTouch || delete i.controls, ce(e, S(i, {
              id: this.options_.techId,
              class: "vjs-tech"
            }))
          }
          e.playerId = this.options_.playerId
        }
        "undefined" != typeof this.options_.preload && pe(e, "preload", this.options_.preload), void 0 !== this.options_.disablePictureInPicture && (e.disablePictureInPicture = this.options_.disablePictureInPicture);
        for (var n = ["loop", "muted", "playsinline", "autoplay"], r = 0; r < n.length; r++) {
          var a = n[r],
            s = this.options_[a];
          "undefined" != typeof s && (s ? pe(e, a, a) : fe(e, a), e[a] = s)
        }
        return e
      }, e.handleLateInit_ = function (e) {
        if (0 !== e.networkState && 3 !== e.networkState) {
          if (0 === e.readyState) {
            var t = !1,
              i = function () {
                t = !0
              };
            this.on("loadstart", i);
            var n = function () {
              t || this.trigger("loadstart")
            };
            return this.on("loadedmetadata", n), void this.ready(function () {
              this.off("loadstart", i), this.off("loadedmetadata", n), t || this.trigger("loadstart")
            })
          }
          var r = ["loadstart"];
          r.push("loadedmetadata"), 2 <= e.readyState && r.push("loadeddata"), 3 <= e.readyState && r.push("canplay"), 4 <= e.readyState && r.push("canplaythrough"), this.ready(function () {
            r.forEach(function (e) {
              this.trigger(e)
            }, this)
          })
        }
      }, e.setScrubbing = function (e) {
        this.isScrubbing_ = e
      }, e.scrubbing = function () {
        return this.isScrubbing_
      }, e.setCurrentTime = function (e) {
        try {
          this.isScrubbing_ && this.el_.fastSeek && Y ? this.el_.fastSeek(e) : this.el_.currentTime = e
        } catch (e) {
          g(e, "Video is not ready. (Video.js)")
        }
      }, e.duration = function () {
        var t = this;
        if (this.el_.duration === 1 / 0 && M && j && 0 === this.el_.currentTime) {
          return this.on("timeupdate", function e() {
            0 < t.el_.currentTime && (t.el_.duration === 1 / 0 && t.trigger("durationchange"), t.off("timeupdate", e))
          }), NaN
        }
        return this.el_.duration || NaN
      }, e.width = function () {
        return this.el_.offsetWidth
      }, e.height = function () {
        return this.el_.offsetHeight
      }, e.proxyWebkitFullscreen_ = function () {
        var e = this;
        if ("webkitDisplayingFullscreen" in this.el_) {
          var t = function () {
              this.trigger("fullscreenchange", {
                isFullscreen: !1
              })
            },
            i = function () {
              "webkitPresentationMode" in this.el_ && "picture-in-picture" !== this.el_.webkitPresentationMode && (this.one("webkitendfullscreen", t), this.trigger("fullscreenchange", {
                isFullscreen: !0,
                nativeIOSFullscreen: !0
              }))
            };
          this.on("webkitbeginfullscreen", i), this.on("dispose", function () {
            e.off("webkitbeginfullscreen", i), e.off("webkitendfullscreen", t)
          })
        }
      }, e.supportsFullScreen = function () {
        if ("function" == typeof this.el_.webkitEnterFullScreen) {
          var e = h.navigator && h.navigator.userAgent || "";
          if (/Android/.test(e) || !/Chrome|Mac OS X 10.5/.test(e)) return !0
        }
        return !1
      }, e.enterFullScreen = function () {
        var e = this.el_;
        if (e.paused && e.networkState <= e.HAVE_METADATA) Ot(this.el_.play()), this.setTimeout(function () {
          e.pause();
          try {
            e.webkitEnterFullScreen()
          } catch (e) {
            this.trigger("fullscreenerror", e)
          }
        }, 0);
        else try {
          e.webkitEnterFullScreen()
        } catch (e) {
          this.trigger("fullscreenerror", e)
        }
      }, e.exitFullScreen = function () {
        this.el_.webkitDisplayingFullscreen ? this.el_.webkitExitFullScreen() : this.trigger("fullscreenerror", new Error("The video is not fullscreen"))
      }, e.requestPictureInPicture = function () {
        return this.el_.requestPictureInPicture()
      }, e.src = function (e) {
        if (void 0 === e) return this.el_.src;
        this.setSrc(e)
      }, e.reset = function () {
        o.resetMediaElement(this.el_)
      }, e.currentSrc = function () {
        return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc
      }, e.setControls = function (e) {
        this.el_.controls = !!e
      }, e.addTextTrack = function (e, t, i) {
        return this.featuresNativeTextTracks ? this.el_.addTextTrack(e, t, i) : c.prototype.addTextTrack.call(this, e, t, i)
      }, e.createRemoteTextTrack = function (e) {
        if (!this.featuresNativeTextTracks) return c.prototype.createRemoteTextTrack.call(this, e);
        var t = p.createElement("track");
        return e.kind && (t.kind = e.kind), e.label && (t.label = e.label), (e.language || e.srclang) && (t.srclang = e.language || e.srclang), e.default && (t.default = e.default), e.id && (t.id = e.id), e.src && (t.src = e.src), t
      }, e.addRemoteTextTrack = function (e, t) {
        var i = c.prototype.addRemoteTextTrack.call(this, e, t);
        return this.featuresNativeTextTracks && this.el().appendChild(i), i
      }, e.removeRemoteTextTrack = function (e) {
        if (c.prototype.removeRemoteTextTrack.call(this, e), this.featuresNativeTextTracks)
          for (var t = this.$$("track"), i = t.length; i--;) e !== t[i] && e !== t[i].track || this.el().removeChild(t[i])
      }, e.getVideoPlaybackQuality = function () {
        if ("function" == typeof this.el().getVideoPlaybackQuality) return this.el().getVideoPlaybackQuality();
        var e = {};
        return "undefined" != typeof this.el().webkitDroppedFrameCount && "undefined" != typeof this.el().webkitDecodedFrameCount && (e.droppedVideoFrames = this.el().webkitDroppedFrameCount, e.totalVideoFrames = this.el().webkitDecodedFrameCount), h.performance && "function" == typeof h.performance.now ? e.creationTime = h.performance.now() : h.performance && h.performance.timing && "number" == typeof h.performance.timing.navigationStart && (e.creationTime = h.Date.now() - h.performance.timing.navigationStart), e
      }, o
    }(Ji);
  Gr(Qr, "TEST_VID", function () {
    if (Z()) {
      var e = p.createElement("video"),
        t = p.createElement("track");
      return t.kind = "captions", t.srclang = "en", t.label = "English", e.appendChild(t), e
    }
  }), Qr.isSupported = function () {
    try {
      Qr.TEST_VID.volume = .5
    } catch (e) {
      return !1
    }
    return !(!Qr.TEST_VID || !Qr.TEST_VID.canPlayType)
  }, Qr.canPlayType = function (e) {
    return Qr.TEST_VID.canPlayType(e)
  }, Qr.canPlaySource = function (e, t) {
    return Qr.canPlayType(e.type)
  }, Qr.canControlVolume = function () {
    try {
      var e = Qr.TEST_VID.volume;
      return Qr.TEST_VID.volume = e / 2 + .1, e !== Qr.TEST_VID.volume
    } catch (e) {
      return !1
    }
  }, Qr.canMuteVolume = function () {
    try {
      var e = Qr.TEST_VID.muted;
      return Qr.TEST_VID.muted = !e, Qr.TEST_VID.muted ? pe(Qr.TEST_VID, "muted", "muted") : fe(Qr.TEST_VID, "muted"), e !== Qr.TEST_VID.muted
    } catch (e) {
      return !1
    }
  }, Qr.canControlPlaybackRate = function () {
    if (M && j && H < 58) return !1;
    try {
      var e = Qr.TEST_VID.playbackRate;
      return Qr.TEST_VID.playbackRate = e / 2 + .1, e !== Qr.TEST_VID.playbackRate
    } catch (e) {
      return !1
    }
  }, Qr.canOverrideAttributes = function () {
    try {
      var e = function () {};
      Object.defineProperty(p.createElement("video"), "src", {
        get: e,
        set: e
      }), Object.defineProperty(p.createElement("audio"), "src", {
        get: e,
        set: e
      }), Object.defineProperty(p.createElement("video"), "innerHTML", {
        get: e,
        set: e
      }), Object.defineProperty(p.createElement("audio"), "innerHTML", {
        get: e,
        set: e
      })
    } catch (e) {
      return !1
    }
    return !0
  }, Qr.supportsNativeTextTracks = function () {
    return Y || K && j
  }, Qr.supportsNativeVideoTracks = function () {
    return !(!Qr.TEST_VID || !Qr.TEST_VID.videoTracks)
  }, Qr.supportsNativeAudioTracks = function () {
    return !(!Qr.TEST_VID || !Qr.TEST_VID.audioTracks)
  }, Qr.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"], [
    ["featuresVolumeControl", "canControlVolume"],
    ["featuresMuteControl", "canMuteVolume"],
    ["featuresPlaybackRate", "canControlPlaybackRate"],
    ["featuresSourceset", "canOverrideAttributes"],
    ["featuresNativeTextTracks", "supportsNativeTextTracks"],
    ["featuresNativeVideoTracks", "supportsNativeVideoTracks"],
    ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]
  ].forEach(function (e) {
    var t = e[0],
      i = e[1];
    Gr(Qr.prototype, t, function () {
      return Qr[i]()
    }, !0)
  }), Qr.prototype.movingMediaElementInDOM = !K, Qr.prototype.featuresFullscreenResize = !0, Qr.prototype.featuresProgressEvents = !0, Qr.prototype.featuresTimeupdateEvents = !0, Qr.patchCanPlayType = function () {
    4 <= N && !B && !j && (Xr = Qr.TEST_VID && Qr.TEST_VID.constructor.prototype.canPlayType, Qr.TEST_VID.constructor.prototype.canPlayType = function (e) {
      return e && /^application\/(?:x-|vnd\.apple\.)mpegurl/i.test(e) ? "maybe" : Xr.call(this, e)
    })
  }, Qr.unpatchCanPlayType = function () {
    var e = Qr.TEST_VID.constructor.prototype.canPlayType;
    return Xr && (Qr.TEST_VID.constructor.prototype.canPlayType = Xr), e
  }, Qr.patchCanPlayType(), Qr.disposeMediaElement = function (e) {
    if (e) {
      for (e.parentNode && e.parentNode.removeChild(e); e.hasChildNodes();) e.removeChild(e.firstChild);
      e.removeAttribute("src"), "function" == typeof e.load && function () {
        try {
          e.load()
        } catch (e) {}
      }()
    }
  }, Qr.resetMediaElement = function (e) {
    if (e) {
      for (var t = e.querySelectorAll("source"), i = t.length; i--;) e.removeChild(t[i]);
      e.removeAttribute("src"), "function" == typeof e.load && function () {
        try {
          e.load()
        } catch (e) {}
      }()
    }
  }, ["muted", "defaultMuted", "autoplay", "controls", "loop", "playsinline"].forEach(function (e) {
    Qr.prototype[e] = function () {
      return this.el_[e] || this.el_.hasAttribute(e)
    }
  }), ["muted", "defaultMuted", "autoplay", "loop", "playsinline"].forEach(function (t) {
    Qr.prototype["set" + mt(t)] = function (e) {
      (this.el_[t] = e) ? this.el_.setAttribute(t, t): this.el_.removeAttribute(t)
    }
  }), ["paused", "currentTime", "buffered", "volume", "poster", "preload", "error", "seeking", "seekable", "ended", "playbackRate", "defaultPlaybackRate", "disablePictureInPicture", "played", "networkState", "readyState", "videoWidth", "videoHeight", "crossOrigin"].forEach(function (e) {
    Qr.prototype[e] = function () {
      return this.el_[e]
    }
  }), ["volume", "src", "poster", "preload", "playbackRate", "defaultPlaybackRate", "disablePictureInPicture", "crossOrigin"].forEach(function (t) {
    Qr.prototype["set" + mt(t)] = function (e) {
      this.el_[t] = e
    }
  }), ["pause", "load", "play"].forEach(function (e) {
    Qr.prototype[e] = function () {
      return this.el_[e]()
    }
  }), Ji.withSourceHandlers(Qr), Qr.nativeSourceHandler = {}, Qr.nativeSourceHandler.canPlayType = function (e) {
    try {
      return Qr.TEST_VID.canPlayType(e)
    } catch (e) {
      return ""
    }
  }, Qr.nativeSourceHandler.canHandleSource = function (e, t) {
    if (e.type) return Qr.nativeSourceHandler.canPlayType(e.type);
    if (e.src) {
      var i = zt(e.src);
      return Qr.nativeSourceHandler.canPlayType("video/" + i)
    }
    return ""
  }, Qr.nativeSourceHandler.handleSource = function (e, t, i) {
    t.setSrc(e.src)
  }, Qr.nativeSourceHandler.dispose = function () {}, Qr.registerSourceHandler(Qr.nativeSourceHandler), Ji.registerTech("Html5", Qr);
  var $r = ["progress", "abort", "suspend", "emptied", "stalled", "loadedmetadata", "loadeddata", "timeupdate", "resize", "volumechange", "texttrackchange"],
    Jr = {
      canplay: "CanPlay",
      canplaythrough: "CanPlayThrough",
      playing: "Playing",
      seeked: "Seeked"
    },
    Zr = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"],
    ea = {};
  Zr.forEach(function (e) {
    var t = "x" === e.charAt(0) ? "x-" + e.substring(1) : e;
    ea[e] = "vjs-layout-" + t
  });
  var ta = {
      tiny: 210,
      xsmall: 320,
      small: 425,
      medium: 768,
      large: 1440,
      xlarge: 2560,
      huge: 1 / 0
    },
    ia = function (c) {
      function l(e, t, i) {
        var n;
        if (e.id = e.id || t.id || "vjs_video_" + Be(), (t = S(l.getTagSettings(e), t)).initChildren = !1, t.createEl = !1, t.evented = !1, t.reportTouchActivity = !1, !t.language)
          if ("function" == typeof e.closest) {
            var r = e.closest("[lang]");
            r && r.getAttribute && (t.language = r.getAttribute("lang"))
          } else
            for (var a = e; a && 1 === a.nodeType;) {
              if (de(a).hasOwnProperty("lang")) {
                t.language = a.getAttribute("lang");
                break
              }
              a = a.parentNode
            }
        if ((n = c.call(this, null, t, i) || this).boundDocumentFullscreenChange_ = function (e) {
            return n.documentFullscreenChange_(e)
          }, n.boundFullWindowOnEscKey_ = function (e) {
            return n.fullWindowOnEscKey(e)
          }, n.boundUpdateStyleEl_ = function (e) {
            return n.updateStyleEl_(e)
          }, n.boundApplyInitTime_ = function (e) {
            return n.applyInitTime_(e)
          }, n.boundUpdateCurrentBreakpoint_ = function (e) {
            return n.updateCurrentBreakpoint_(e)
          }, n.boundHandleTechClick_ = function (e) {
            return n.handleTechClick_(e)
          }, n.boundHandleTechDoubleClick_ = function (e) {
            return n.handleTechDoubleClick_(e)
          }, n.boundHandleTechTouchStart_ = function (e) {
            return n.handleTechTouchStart_(e)
          }, n.boundHandleTechTouchMove_ = function (e) {
            return n.handleTechTouchMove_(e)
          }, n.boundHandleTechTouchEnd_ = function (e) {
            return n.handleTechTouchEnd_(e)
          }, n.boundHandleTechTap_ = function (e) {
            return n.handleTechTap_(e)
          }, n.isFullscreen_ = !1, n.log = v(n.id_), n.fsApi_ = f, n.isPosterFromTech_ = !1, n.queuedCallbacks_ = [], n.isReady_ = !1, n.hasStarted_ = !1, n.userActive_ = !1, n.debugEnabled_ = !1, !n.options_ || !n.options_.techOrder || !n.options_.techOrder.length) throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
        if (n.tag = e, n.tagAttributes = e && de(e), n.language(n.options_.language), t.languages) {
          var s = {};
          Object.getOwnPropertyNames(t.languages).forEach(function (e) {
            s[e.toLowerCase()] = t.languages[e]
          }), n.languages_ = s
        } else n.languages_ = l.prototype.options_.languages;
        n.resetCache_(), n.poster_ = t.poster || "", n.controls_ = !!t.controls, e.controls = !1, e.removeAttribute("controls"), n.changingSrc_ = !1, n.playCallbacks_ = [], n.playTerminatedQueue_ = [], e.hasAttribute("autoplay") ? n.autoplay(!0) : n.autoplay(n.options_.autoplay), t.plugins && Object.keys(t.plugins).forEach(function (e) {
          if ("function" != typeof n[e]) throw new Error('plugin "' + e + '" does not exist')
        }), n.scrubbing_ = !1, n.el_ = n.createEl(), dt(St(n), {
          eventBusKey: "el_"
        }), n.fsApi_.requestFullscreen && (Ge(p, n.fsApi_.fullscreenchange, n.boundDocumentFullscreenChange_), n.on(n.fsApi_.fullscreenchange, n.boundDocumentFullscreenChange_)), n.fluid_ && n.on(["playerreset", "resize"], n.boundUpdateStyleEl_);
        var o = gt(n.options_);
        t.plugins && Object.keys(t.plugins).forEach(function (e) {
          n[e](t.plugins[e])
        }), t.debug && n.debug(!0), n.options_.playerOptions = o, n.middleware_ = [], n.initChildren(), n.isAudio("audio" === e.nodeName.toLowerCase()), n.controls() ? n.addClass("vjs-controls-enabled") : n.addClass("vjs-controls-disabled"), n.el_.setAttribute("role", "region"), n.isAudio() ? n.el_.setAttribute("aria-label", n.localize("Audio Player")) : n.el_.setAttribute("aria-label", n.localize("Video Player")), n.isAudio() && n.addClass("vjs-audio"), n.flexNotSupported_() && n.addClass("vjs-no-flex"), z && n.addClass("vjs-touch-enabled"), K || n.addClass("vjs-workinghover"), l.players[n.id_] = St(n);
        var u = d.split(".")[0];
        return n.addClass("vjs-v" + u), n.userActive(!0), n.reportUserActivity(), n.one("play", function (e) {
          return n.listenForUserActivity_(e)
        }), n.on("stageclick", function (e) {
          return n.handleStageClick_(e)
        }), n.on("keydown", function (e) {
          return n.handleKeyDown(e)
        }), n.on("languagechange", function (e) {
          return n.handleLanguagechange(e)
        }), n.breakpoints(n.options_.breakpoints), n.responsive(n.options_.responsive), n
      }
      Et(l, c);
      var e = l.prototype;
      return e.dispose = function () {
        var n = this;
        this.trigger("dispose"), this.off("dispose"), Xe(p, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), Xe(p, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), l.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null),
          function (e) {
            en[e.id()] = null
          }(this), Ti.names.forEach(function (e) {
            var t = Ti[e],
              i = n[t.getterName]();
            i && i.off && i.off()
          }), c.prototype.dispose.call(this)
      }, e.createEl = function () {
        var t, i = this.tag,
          e = this.playerElIngest_ = i.parentNode && i.parentNode.hasAttribute && i.parentNode.hasAttribute("data-vjs-player"),
          n = "video-js" === this.tag.tagName.toLowerCase();
        e ? t = this.el_ = i.parentNode : n || (t = this.el_ = c.prototype.createEl.call(this, "div"));
        var r = de(i);
        if (n) {
          for (t = this.el_ = i, i = this.tag = p.createElement("video"); t.children.length;) i.appendChild(t.firstChild);
          se(t, "video-js") || oe(t, "video-js"), t.appendChild(i), e = this.playerElIngest_ = t, Object.keys(t).forEach(function (e) {
            try {
              i[e] = t[e]
            } catch (e) {}
          })
        }
        if (i.setAttribute("tabindex", "-1"), r.tabindex = "-1", (V || j && W) && (i.setAttribute("role", "application"), r.role = "application"), i.removeAttribute("width"), i.removeAttribute("height"), "width" in r && delete r.width, "height" in r && delete r.height, Object.getOwnPropertyNames(r).forEach(function (e) {
            n && "class" === e || t.setAttribute(e, r[e]), n && i.setAttribute(e, r[e])
          }), i.playerId = i.id, i.id += "_html5_api", i.className = "vjs-tech", i.player = t.player = this, this.addClass("vjs-paused"), !0 !== h.VIDEOJS_NO_DYNAMIC_STYLE) {
          this.styleEl_ = Re("vjs-styles-dimensions");
          var a = Ie(".vjs-styles-defaults"),
            s = Ie("head");
          s.insertBefore(this.styleEl_, a ? a.nextSibling : s.firstChild)
        }
        this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
        for (var o = i.getElementsByTagName("a"), u = 0; u < o.length; u++) {
          var l = o.item(u);
          oe(l, "vjs-hidden"), l.setAttribute("hidden", "hidden")
        }
        return i.initNetworkState_ = i.networkState, i.parentNode && !e && i.parentNode.insertBefore(t, i), ae(i, t), this.children_.unshift(i), this.el_.setAttribute("lang", this.language_), this.el_ = t
      }, e.crossOrigin = function (e) {
        if (!e) return this.techGet_("crossOrigin");
        "anonymous" === e || "use-credentials" === e ? this.techCall_("setCrossOrigin", e) : g.warn('crossOrigin must be "anonymous" or "use-credentials", given "' + e + '"')
      }, e.width = function (e) {
        return this.dimension("width", e)
      }, e.height = function (e) {
        return this.dimension("height", e)
      }, e.dimension = function (e, t) {
        var i = e + "_";
        if (void 0 === t) return this[i] || 0;
        if ("" === t || "auto" === t) return this[i] = void 0, void this.updateStyleEl_();
        var n = parseFloat(t);
        isNaN(n) ? g.error('Improper value "' + t + '" supplied for for ' + e) : (this[i] = n, this.updateStyleEl_())
      }, e.fluid = function (e) {
        var t = this;
        if (void 0 === e) return !!this.fluid_;
        this.fluid_ = !!e, lt(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), e ? (this.addClass("vjs-fluid"), this.fill(!1), function (e, t) {
          lt(e) ? t() : (e.eventedCallbacks || (e.eventedCallbacks = []), e.eventedCallbacks.push(t))
        }(this, function () {
          t.on(["playerreset", "resize"], t.boundUpdateStyleEl_)
        })) : this.removeClass("vjs-fluid"), this.updateStyleEl_()
      }, e.fill = function (e) {
        if (void 0 === e) return !!this.fill_;
        this.fill_ = !!e, e ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill")
      }, e.aspectRatio = function (e) {
        if (void 0 === e) return this.aspectRatio_;
        if (!/^\d+\:\d+$/.test(e)) throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
        this.aspectRatio_ = e, this.fluid(!0), this.updateStyleEl_()
      }, e.updateStyleEl_ = function () {
        if (!0 !== h.VIDEOJS_NO_DYNAMIC_STYLE) {
          var e, t, i, n = (void 0 !== this.aspectRatio_ && "auto" !== this.aspectRatio_ ? this.aspectRatio_ : 0 < this.videoWidth() ? this.videoWidth() + ":" + this.videoHeight() : "16:9").split(":"),
            r = n[1] / n[0];
          e = void 0 !== this.width_ ? this.width_ : void 0 !== this.height_ ? this.height_ / r : this.videoWidth() || 300, t = void 0 !== this.height_ ? this.height_ : e * r, i = /^[^a-zA-Z]/.test(this.id()) ? "dimensions-" + this.id() : this.id() + "-dimensions", this.addClass(i), Me(this.styleEl_, "\n      ." + i + " {\n        width: " + e + "px;\n        height: " + t + "px;\n      }\n\n      ." + i + ".vjs-fluid {\n        padding-top: " + 100 * r + "%;\n      }\n    ")
        } else {
          var a = "number" == typeof this.width_ ? this.width_ : this.options_.width,
            s = "number" == typeof this.height_ ? this.height_ : this.options_.height,
            o = this.tech_ && this.tech_.el();
          o && (0 <= a && (o.width = a), 0 <= s && (o.height = s))
        }
      }, e.loadTech_ = function (e, t) {
        var i = this;
        this.tech_ && this.unloadTech_();
        var n = mt(e),
          r = e.charAt(0).toLowerCase() + e.slice(1);
        "Html5" !== n && this.tag && (Ji.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = n, this.isReady_ = !1;
        var a = {
          source: t,
          autoplay: "string" != typeof this.autoplay() && this.autoplay(),
          nativeControlsForTouch: this.options_.nativeControlsForTouch,
          playerId: this.id(),
          techId: this.id() + "_" + r + "_api",
          playsinline: this.options_.playsinline,
          preload: this.options_.preload,
          loop: this.options_.loop,
          disablePictureInPicture: this.options_.disablePictureInPicture,
          muted: this.options_.muted,
          poster: this.poster(),
          language: this.language(),
          playerElIngest: this.playerElIngest_ || !1,
          "vtt.js": this.options_["vtt.js"],
          canOverridePoster: !!this.options_.techCanOverridePoster,
          enableSourceset: this.options_.enableSourceset,
          Promise: this.options_.Promise
        };
        Ti.names.forEach(function (e) {
          var t = Ti[e];
          a[t.getterName] = i[t.privateName]
        }), S(a, this.options_[n]), S(a, this.options_[r]), S(a, this.options_[e.toLowerCase()]), this.tag && (a.tag = this.tag), t && t.src === this.cache_.src && 0 < this.cache_.currentTime && (a.startTime = this.cache_.currentTime);
        var s = Ji.getTech(e);
        if (!s) throw new Error("No Tech named '" + n + "' exists! '" + n + "' should be registered using videojs.registerTech()'");
        this.tech_ = new s(a), this.tech_.ready($e(this, this.handleTechReady_), !0), Mt(this.textTracksJson_ || [], this.tech_), $r.forEach(function (t) {
          i.on(i.tech_, t, function (e) {
            return i["handleTech" + mt(t) + "_"](e)
          })
        }), Object.keys(Jr).forEach(function (t) {
          i.on(i.tech_, t, function (e) {
            0 === i.tech_.playbackRate() && i.tech_.seeking() ? i.queuedCallbacks_.push({
              callback: i["handleTech" + Jr[t] + "_"].bind(i),
              event: e
            }) : i["handleTech" + Jr[t] + "_"](e)
          })
        }), this.on(this.tech_, "loadstart", function (e) {
          return i.handleTechLoadStart_(e)
        }), this.on(this.tech_, "sourceset", function (e) {
          return i.handleTechSourceset_(e)
        }), this.on(this.tech_, "waiting", function (e) {
          return i.handleTechWaiting_(e)
        }), this.on(this.tech_, "ended", function (e) {
          return i.handleTechEnded_(e)
        }), this.on(this.tech_, "seeking", function (e) {
          return i.handleTechSeeking_(e)
        }), this.on(this.tech_, "play", function (e) {
          return i.handleTechPlay_(e)
        }), this.on(this.tech_, "firstplay", function (e) {
          return i.handleTechFirstPlay_(e)
        }), this.on(this.tech_, "pause", function (e) {
          return i.handleTechPause_(e)
        }), this.on(this.tech_, "durationchange", function (e) {
          return i.handleTechDurationChange_(e)
        }), this.on(this.tech_, "fullscreenchange", function (e) {
          return i.handleTechFullscreenChange_(e)
        }), this.on(this.tech_, "fullscreenerror", function (e) {
          return i.handleTechFullscreenError_(e)
        }), this.on(this.tech_, "enterpictureinpicture", function (e) {
          return i.handleTechEnterPictureInPicture_(e)
        }), this.on(this.tech_, "leavepictureinpicture", function (e) {
          return i.handleTechLeavePictureInPicture_(e)
        }), this.on(this.tech_, "error", function (e) {
          return i.handleTechError_(e)
        }), this.on(this.tech_, "posterchange", function (e) {
          return i.handleTechPosterChange_(e)
        }), this.on(this.tech_, "textdata", function (e) {
          return i.handleTechTextData_(e)
        }), this.on(this.tech_, "ratechange", function (e) {
          return i.handleTechRateChange_(e)
        }), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode === this.el() || "Html5" === n && this.tag || ae(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null)
      }, e.unloadTech_ = function () {
        var i = this;
        Ti.names.forEach(function (e) {
          var t = Ti[e];
          i[t.privateName] = i[t.getterName]()
        }), this.textTracksJson_ = Rt(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1
      }, e.tech = function (e) {
        return void 0 === e && g.warn("Using the tech directly can be dangerous. I hope you know what you're doing.\nSee https://github.com/videojs/video.js/issues/2617 for more info.\n"), this.tech_
      }, e.addTechControlsListeners_ = function () {
        this.removeTechControlsListeners_(), this.on(this.tech_, "mouseup", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_)
      }, e.removeTechControlsListeners_ = function () {
        this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "mouseup", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_)
      }, e.handleTechReady_ = function () {
        this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_()
      }, e.handleTechLoadStart_ = function () {
        this.removeClass("vjs-ended"), this.removeClass("vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : (this.trigger("loadstart"), this.trigger("firstplay")), this.manualAutoplay_(this.autoplay())
      }, e.manualAutoplay_ = function (t) {
        var n = this;
        if (this.tech_ && "string" == typeof t) {
          var e, i = function () {
            var e = n.muted();
            n.muted(!0);

            function t() {
              n.muted(e)
            }
            n.playTerminatedQueue_.push(t);
            var i = n.play();
            if (Lt(i)) return i.catch(t)
          };
          if ("any" === t && !0 !== this.muted() ? Lt(e = this.play()) && (e = e.catch(i)) : e = "muted" === t && !0 !== this.muted() ? i() : this.play(), Lt(e)) return e.then(function () {
            n.trigger({
              type: "autoplay-success",
              autoplay: t
            })
          }).catch(function (e) {
            n.trigger({
              type: "autoplay-failure",
              autoplay: t
            })
          })
        }
      }, e.updateSourceCaches_ = function (e) {
        void 0 === e && (e = "");
        var t = e,
          i = "";
        "string" != typeof t && (t = e.src, i = e.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], t && !i && (i = function (e, t) {
          if (!t) return "";
          if (e.cache_.source.src === t && e.cache_.source.type) return e.cache_.source.type;
          var i = e.cache_.sources.filter(function (e) {
            return e.src === t
          });
          if (i.length) return i[0].type;
          for (var n = e.$$("source"), r = 0; r < n.length; r++) {
            var a = n[r];
            if (a.type && a.src && a.src === t) return a.type
          }
          return cn(t)
        }(this, t)), this.cache_.source = gt({}, e, {
          src: t,
          type: i
        });
        for (var n = this.cache_.sources.filter(function (e) {
            return e.src && e.src === t
          }), r = [], a = this.$$("source"), s = [], o = 0; o < a.length; o++) {
          var u = de(a[o]);
          r.push(u), u.src && u.src === t && s.push(u.src)
        }
        s.length && !n.length ? this.cache_.sources = r : n.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = t
      }, e.handleTechSourceset_ = function (e) {
        var i = this;
        if (!this.changingSrc_) {
          var t = function (e) {
              return i.updateSourceCaches_(e)
            },
            n = this.currentSource().src,
            r = e.src;
          n && !/^blob:/.test(n) && /^blob:/.test(r) && (this.lastSource_ && (this.lastSource_.tech === r || this.lastSource_.player === n) || (t = function () {})), t(r), e.src || this.tech_.any(["sourceset", "loadstart"], function (e) {
            if ("sourceset" !== e.type) {
              var t = i.techGet("currentSrc");
              i.lastSource_.tech = t, i.updateSourceCaches_(t)
            }
          })
        }
        this.lastSource_ = {
          player: this.currentSource().src,
          tech: e.src
        }, this.trigger({
          src: e.src,
          type: "sourceset"
        })
      }, e.hasStarted = function (e) {
        if (void 0 === e) return this.hasStarted_;
        e !== this.hasStarted_ && (this.hasStarted_ = e, this.hasStarted_ ? (this.addClass("vjs-has-started"), this.trigger("firstplay")) : this.removeClass("vjs-has-started"))
      }, e.handleTechPlay_ = function () {
        this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play")
      }, e.handleTechRateChange_ = function () {
        0 < this.tech_.playbackRate() && 0 === this.cache_.lastPlaybackRate && (this.queuedCallbacks_.forEach(function (e) {
          return e.callback(e.event)
        }), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange")
      }, e.handleTechWaiting_ = function () {
        var t = this;
        this.addClass("vjs-waiting"), this.trigger("waiting");
        var i = this.currentTime();
        this.on("timeupdate", function e() {
          i !== t.currentTime() && (t.removeClass("vjs-waiting"), t.off("timeupdate", e))
        })
      }, e.handleTechCanPlay_ = function () {
        this.removeClass("vjs-waiting"), this.trigger("canplay")
      }, e.handleTechCanPlayThrough_ = function () {
        this.removeClass("vjs-waiting"), this.trigger("canplaythrough")
      }, e.handleTechPlaying_ = function () {
        this.removeClass("vjs-waiting"), this.trigger("playing")
      }, e.handleTechSeeking_ = function () {
        this.addClass("vjs-seeking"), this.trigger("seeking")
      }, e.handleTechSeeked_ = function () {
        this.removeClass("vjs-seeking"), this.removeClass("vjs-ended"), this.trigger("seeked")
      }, e.handleTechFirstPlay_ = function () {
        this.options_.starttime && (g.warn("Passing the `starttime` option to the player will be deprecated in 6.0"), this.currentTime(this.options_.starttime)), this.addClass("vjs-has-started"), this.trigger("firstplay")
      }, e.handleTechPause_ = function () {
        this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause")
      }, e.handleTechEnded_ = function () {
        this.addClass("vjs-ended"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended")
      }, e.handleTechDurationChange_ = function () {
        this.duration(this.techGet_("duration"))
      }, e.handleTechClick_ = function (e) {
        we(e) && this.controls_ && (this.paused() ? Ot(this.play()) : this.pause())
      }, e.handleTechDoubleClick_ = function (t) {
        this.controls_ && (Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), function (e) {
          return e.contains(t.target)
        }) || void 0 !== this.options_ && void 0 !== this.options_.userActions && void 0 !== this.options_.userActions.doubleClick && !1 === this.options_.userActions.doubleClick || (void 0 !== this.options_ && void 0 !== this.options_.userActions && "function" == typeof this.options_.userActions.doubleClick ? this.options_.userActions.doubleClick.call(this, t) : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen()))
      }, e.handleTechTap_ = function () {
        this.userActive(!this.userActive())
      }, e.handleTechTouchStart_ = function () {
        this.userWasActive = this.userActive()
      }, e.handleTechTouchMove_ = function () {
        this.userWasActive && this.reportUserActivity()
      }, e.handleTechTouchEnd_ = function (e) {
        e.cancelable && e.preventDefault()
      }, e.handleStageClick_ = function () {
        this.reportUserActivity()
      }, e.toggleFullscreenClass_ = function () {
        this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen")
      }, e.documentFullscreenChange_ = function (e) {
        var t = e.target.player;
        if (!t || t === this) {
          var i = this.el(),
            n = p[this.fsApi_.fullscreenElement] === i;
          !n && i.matches ? n = i.matches(":" + this.fsApi_.fullscreen) : !n && i.msMatchesSelector && (n = i.msMatchesSelector(":" + this.fsApi_.fullscreen)), this.isFullscreen(n)
        }
      }, e.handleTechFullscreenChange_ = function (e, t) {
        t && (t.nativeIOSFullscreen && this.toggleClass("vjs-ios-native-fs"), this.isFullscreen(t.isFullscreen))
      }, e.handleTechFullscreenError_ = function (e, t) {
        this.trigger("fullscreenerror", t)
      }, e.togglePictureInPictureClass_ = function () {
        this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture")
      }, e.handleTechEnterPictureInPicture_ = function (e) {
        this.isInPictureInPicture(!0)
      }, e.handleTechLeavePictureInPicture_ = function (e) {
        this.isInPictureInPicture(!1)
      }, e.handleTechError_ = function () {
        var e = this.tech_.error();
        this.error(e)
      }, e.handleTechTextData_ = function (e, t) {
        var i = null;
        1 < arguments.length && (i = t), this.trigger("textdata", i)
      }, e.getCache = function () {
        return this.cache_
      }, e.resetCache_ = function () {
        this.cache_ = {
          currentTime: 0,
          initTime: 0,
          inactivityTimeout: this.options_.inactivityTimeout,
          duration: NaN,
          lastVolume: 1,
          lastPlaybackRate: this.defaultPlaybackRate(),
          media: null,
          src: "",
          source: {},
          sources: [],
          volume: 1
        }
      }, e.techCall_ = function (e, t) {
        this.ready(function () {
          if (e in sn) return function (e, t, i, n) {
            return t[i](e.reduce(un(i), n))
          }(this.middleware_, this.tech_, e, t);
          if (e in on) return rn(this.middleware_, this.tech_, e, t);
          try {
            this.tech_ && this.tech_[e](t)
          } catch (e) {
            throw g(e), e
          }
        }, !0)
      }, e.techGet_ = function (t) {
        if (this.tech_ && this.tech_.isReady_) {
          if (t in an) return function (e, t, i) {
            return e.reduceRight(un(i), t[i]())
          }(this.middleware_, this.tech_, t);
          if (t in on) return rn(this.middleware_, this.tech_, t);
          try {
            return this.tech_[t]()
          } catch (e) {
            if (void 0 === this.tech_[t]) throw g("Video.js: " + t + " method not defined for " + this.techName_ + " playback technology.", e), e;
            if ("TypeError" === e.name) throw g("Video.js: " + t + " unavailable on " + this.techName_ + " playback technology element.", e), this.tech_.isReady_ = !1, e;
            throw g(e), e
          }
        }
      }, e.play = function () {
        var t = this,
          e = this.options_.Promise || h.Promise;
        return e ? new e(function (e) {
          t.play_(e)
        }) : this.play_()
      }, e.play_ = function (e) {
        var t = this;
        void 0 === e && (e = Ot), this.playCallbacks_.push(e);
        var i = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
        if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !i) return this.waitToPlay_ = function (e) {
          t.play_()
        }, this.one(["ready", "loadstart"], this.waitToPlay_), void(i || !Y && !K || this.load());
        var n = this.techGet_("play");
        null === n ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(n)
      }, e.runPlayTerminatedQueue_ = function () {
        var e = this.playTerminatedQueue_.slice(0);
        this.playTerminatedQueue_ = [], e.forEach(function (e) {
          e()
        })
      }, e.runPlayCallbacks_ = function (t) {
        var e = this.playCallbacks_.slice(0);
        this.playCallbacks_ = [], this.playTerminatedQueue_ = [], e.forEach(function (e) {
          e(t)
        })
      }, e.pause = function () {
        this.techCall_("pause")
      }, e.paused = function () {
        return !1 !== this.techGet_("paused")
      }, e.played = function () {
        return this.techGet_("played") || Ct(0, 0)
      }, e.scrubbing = function (e) {
        if ("undefined" == typeof e) return this.scrubbing_;
        this.scrubbing_ = !!e, this.techCall_("setScrubbing", this.scrubbing_), e ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing")
      }, e.currentTime = function (e) {
        return "undefined" != typeof e ? (e < 0 && (e = 0), this.isReady_ && !this.changingSrc_ && this.tech_ && this.tech_.isReady_ ? (this.techCall_("setCurrentTime", e), void(this.cache_.initTime = 0)) : (this.cache_.initTime = e, this.off("canplay", this.boundApplyInitTime_), void this.one("canplay", this.boundApplyInitTime_))) : (this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime)
      }, e.applyInitTime_ = function () {
        this.currentTime(this.cache_.initTime)
      }, e.duration = function (e) {
        if (void 0 === e) return void 0 !== this.cache_.duration ? this.cache_.duration : NaN;
        (e = parseFloat(e)) < 0 && (e = 1 / 0), e !== this.cache_.duration && ((this.cache_.duration = e) === 1 / 0 ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(e) || this.trigger("durationchange"))
      }, e.remainingTime = function () {
        return this.duration() - this.currentTime()
      }, e.remainingTimeDisplay = function () {
        return Math.floor(this.duration()) - Math.floor(this.currentTime())
      }, e.buffered = function () {
        var e = this.techGet_("buffered");
        return e && e.length || (e = Ct(0, 0)), e
      }, e.bufferedPercent = function () {
        return It(this.buffered(), this.duration())
      }, e.bufferedEnd = function () {
        var e = this.buffered(),
          t = this.duration(),
          i = e.end(e.length - 1);
        return t < i && (i = t), i
      }, e.volume = function (e) {
        var t;
        return void 0 !== e ? (t = Math.max(0, Math.min(1, parseFloat(e))), this.cache_.volume = t, this.techCall_("setVolume", t), void(0 < t && this.lastVolume_(t))) : (t = parseFloat(this.techGet_("volume")), isNaN(t) ? 1 : t)
      }, e.muted = function (e) {
        if (void 0 === e) return this.techGet_("muted") || !1;
        this.techCall_("setMuted", e)
      }, e.defaultMuted = function (e) {
        return void 0 !== e ? this.techCall_("setDefaultMuted", e) : this.techGet_("defaultMuted") || !1
      }, e.lastVolume_ = function (e) {
        if (void 0 === e || 0 === e) return this.cache_.lastVolume;
        this.cache_.lastVolume = e
      }, e.supportsFullScreen = function () {
        return this.techGet_("supportsFullScreen") || !1
      }, e.isFullscreen = function (e) {
        if (void 0 === e) return this.isFullscreen_;
        var t = this.isFullscreen_;
        return this.isFullscreen_ = Boolean(e), this.isFullscreen_ !== t && this.fsApi_.prefixed && this.trigger("fullscreenchange"), void this.toggleFullscreenClass_()
      }, e.requestFullscreen = function (s) {
        var e = this.options_.Promise || h.Promise;
        if (e) {
          var o = this;
          return new e(function (e, i) {
            function n() {
              o.off("fullscreenerror", r), o.off("fullscreenchange", t)
            }

            function t() {
              n(), e()
            }

            function r(e, t) {
              n(), i(t)
            }
            o.one("fullscreenchange", t), o.one("fullscreenerror", r);
            var a = o.requestFullscreenHelper_(s);
            if (a) return a.then(n, n), a
          })
        }
        return this.requestFullscreenHelper_()
      }, e.requestFullscreenHelper_ = function (e) {
        var t, i = this;
        if (this.fsApi_.prefixed || (t = this.options_.fullscreen && this.options_.fullscreen.options || {}, void 0 !== e && (t = e)), this.fsApi_.requestFullscreen) {
          var n = this.el_[this.fsApi_.requestFullscreen](t);
          return n && n.then(function () {
            return i.isFullscreen(!0)
          }, function () {
            return i.isFullscreen(!1)
          }), n
        }
        this.tech_.supportsFullScreen() ? this.techCall_("enterFullScreen") : this.enterFullWindow()
      }, e.exitFullscreen = function () {
        var e = this.options_.Promise || h.Promise;
        if (e) {
          var s = this;
          return new e(function (e, i) {
            function n() {
              s.off("fullscreenerror", r), s.off("fullscreenchange", t)
            }

            function t() {
              n(), e()
            }

            function r(e, t) {
              n(), i(t)
            }
            s.one("fullscreenchange", t), s.one("fullscreenerror", r);
            var a = s.exitFullscreenHelper_();
            if (a) return a.then(n, n), a
          })
        }
        return this.exitFullscreenHelper_()
      }, e.exitFullscreenHelper_ = function () {
        var e = this;
        if (this.fsApi_.requestFullscreen) {
          var t = p[this.fsApi_.exitFullscreen]();
          return t && t.then(function () {
            return e.isFullscreen(!1)
          }), t
        }
        this.tech_.supportsFullScreen() ? this.techCall_("exitFullScreen") : this.exitFullWindow()
      }, e.enterFullWindow = function () {
        this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = p.documentElement.style.overflow, Ge(p, "keydown", this.boundFullWindowOnEscKey_), p.documentElement.style.overflow = "hidden", oe(p.body, "vjs-full-window"), this.trigger("enterFullWindow")
      }, e.fullWindowOnEscKey = function (e) {
        Nt.isEventKey(e, "Esc") && (!0 === this.isFullscreen() ? this.exitFullscreen() : this.exitFullWindow())
      }, e.exitFullWindow = function () {
        this.isFullscreen(!1), this.isFullWindow = !1, Xe(p, "keydown", this.boundFullWindowOnEscKey_), p.documentElement.style.overflow = this.docOrigOverflow, ue(p.body, "vjs-full-window"), this.trigger("exitFullWindow")
      }, e.disablePictureInPicture = function (e) {
        if (void 0 === e) return this.techGet_("disablePictureInPicture");
        this.techCall_("setDisablePictureInPicture", e), this.options_.disablePictureInPicture = e, this.trigger("disablepictureinpicturechanged")
      }, e.isInPictureInPicture = function (e) {
        return void 0 !== e ? (this.isInPictureInPicture_ = !!e, void this.togglePictureInPictureClass_()) : !!this.isInPictureInPicture_
      }, e.requestPictureInPicture = function () {
        if ("pictureInPictureEnabled" in p && !1 === this.disablePictureInPicture()) return this.techGet_("requestPictureInPicture")
      }, e.exitPictureInPicture = function () {
        if ("pictureInPictureEnabled" in p) return p.exitPictureInPicture()
      }, e.handleKeyDown = function (e) {
        var t = this.options_.userActions;
        if (t && t.hotkeys) {
          ! function (e) {
            var t = e.tagName.toLowerCase();
            if (e.isContentEditable) return !0;
            if ("input" === t) return -1 === ["button", "checkbox", "hidden", "radio", "reset", "submit"].indexOf(e.type);
            return -1 !== ["textarea"].indexOf(t)
          }(this.el_.ownerDocument.activeElement) && ("function" == typeof t.hotkeys ? t.hotkeys.call(this, e) : this.handleHotkeys(e))
        }
      }, e.handleHotkeys = function (e) {
        var t = this.options_.userActions ? this.options_.userActions.hotkeys : {},
          i = t.fullscreenKey,
          n = void 0 === i ? function (e) {
            return Nt.isEventKey(e, "f")
          } : i,
          r = t.muteKey,
          a = void 0 === r ? function (e) {
            return Nt.isEventKey(e, "m")
          } : r,
          s = t.playPauseKey,
          o = void 0 === s ? function (e) {
            return Nt.isEventKey(e, "k") || Nt.isEventKey(e, "Space")
          } : s;
        if (n.call(this, e)) {
          e.preventDefault(), e.stopPropagation();
          var u = Tt.getComponent("FullscreenToggle");
          !1 !== p[this.fsApi_.fullscreenEnabled] && u.prototype.handleClick.call(this, e)
        } else if (a.call(this, e)) {
          e.preventDefault(), e.stopPropagation(), Tt.getComponent("MuteToggle").prototype.handleClick.call(this, e)
        } else if (o.call(this, e)) {
          e.preventDefault(), e.stopPropagation(), Tt.getComponent("PlayToggle").prototype.handleClick.call(this, e)
        }
      }, e.canPlayType = function (e) {
        for (var t, i = 0, n = this.options_.techOrder; i < n.length; i++) {
          var r = n[i],
            a = Ji.getTech(r);
          if (a = a || Tt.getComponent(r)) {
            if (a.isSupported() && (t = a.canPlayType(e))) return t
          } else g.error('The "' + r + '" tech is undefined. Skipped browser support check for that tech.')
        }
        return ""
      }, e.selectSource = function (e) {
        function t(e, i, n) {
          var r;
          return e.some(function (t) {
            return i.some(function (e) {
              if (r = n(t, e)) return !0
            })
          }), r
        }

        function i(e, t) {
          var i = e[0];
          if (e[1].canPlaySource(t, r.options_[i.toLowerCase()])) return {
            source: t,
            tech: i
          }
        }
        var n, r = this,
          a = this.options_.techOrder.map(function (e) {
            return [e, Ji.getTech(e)]
          }).filter(function (e) {
            var t = e[0],
              i = e[1];
            return i ? i.isSupported() : (g.error('The "' + t + '" tech is undefined. Skipped browser support check for that tech.'), !1)
          });
        return (this.options_.sourceOrder ? t(e, a, (n = i, function (e, t) {
          return n(t, e)
        })) : t(a, e, i)) || !1
      }, e.handleSrc_ = function (e, i) {
        var n = this;
        if ("undefined" == typeof e) return this.cache_.src || "";
        this.resetRetryOnError_ && this.resetRetryOnError_();
        var r = function t(e) {
          if (Array.isArray(e)) {
            var i = [];
            e.forEach(function (e) {
              e = t(e), Array.isArray(e) ? i = i.concat(e) : E(e) && i.push(e)
            }), e = i
          } else e = "string" == typeof e && e.trim() ? [hn({
            src: e
          })] : E(e) && "string" == typeof e.src && e.src && e.src.trim() ? [hn(e)] : [];
          return e
        }(e);
        if (r.length) {
          if (this.changingSrc_ = !0, i || (this.cache_.sources = r), this.updateSourceCaches_(r[0]), nn(this, r[0], function (e, t) {
              if (n.middleware_ = t, i || (n.cache_.sources = r), n.updateSourceCaches_(e), n.src_(e)) return 1 < r.length ? n.handleSrc_(r.slice(1)) : (n.changingSrc_ = !1, n.setTimeout(function () {
                this.error({
                  code: 4,
                  message: this.localize(this.options_.notSupportedMessage)
                })
              }, 0), void n.triggerReady());
              ! function (e, t) {
                e.forEach(function (e) {
                  return e.setTech && e.setTech(t)
                })
              }(t, n.tech_)
            }), this.options_.retryOnError && 1 < r.length) {
            var t = function () {
                n.error(null), n.handleSrc_(r.slice(1), !0)
              },
              a = function () {
                n.off("error", t)
              };
            this.one("error", t), this.one("playing", a), this.resetRetryOnError_ = function () {
              n.off("error", t), n.off("playing", a)
            }
          }
        } else this.setTimeout(function () {
          this.error({
            code: 4,
            message: this.localize(this.options_.notSupportedMessage)
          })
        }, 0)
      }, e.src = function (e) {
        return this.handleSrc_(e, !1)
      }, e.src_ = function (e) {
        var t = this,
          i = this.selectSource([e]);
        return !i || (function (e, t) {
          return mt(e) === mt(t)
        }(i.tech, this.techName_) ? this.ready(function () {
          this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", e) : this.techCall_("src", e.src), this.changingSrc_ = !1
        }, !0) : (this.changingSrc_ = !0, this.loadTech_(i.tech, i.source), this.tech_.ready(function () {
          t.changingSrc_ = !1
        })), !1)
      }, e.load = function () {
        this.techCall_("load")
      }, e.reset = function () {
        var e = this,
          t = this.options_.Promise || h.Promise;
        this.paused() || !t ? this.doReset_() : Ot(this.play().then(function () {
          return e.doReset_()
        }))
      }, e.doReset_ = function () {
        this.tech_ && this.tech_.clearTracks("text"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), lt(this) && this.trigger("playerreset")
      }, e.resetControlBarUI_ = function () {
        this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_()
      }, e.resetProgressBar_ = function () {
        this.currentTime(0);
        var e = this.controlBar,
          t = e.durationDisplay,
          i = e.remainingTimeDisplay;
        t && t.updateContent(), i && i.updateContent()
      }, e.resetPlaybackRate_ = function () {
        this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_()
      }, e.resetVolumeBar_ = function () {
        this.volume(1), this.trigger("volumechange")
      }, e.currentSources = function () {
        var e = this.currentSource(),
          t = [];
        return 0 !== Object.keys(e).length && t.push(e), this.cache_.sources || t
      }, e.currentSource = function () {
        return this.cache_.source || {}
      }, e.currentSrc = function () {
        return this.currentSource() && this.currentSource().src || ""
      }, e.currentType = function () {
        return this.currentSource() && this.currentSource().type || ""
      }, e.preload = function (e) {
        return void 0 !== e ? (this.techCall_("setPreload", e), void(this.options_.preload = e)) : this.techGet_("preload")
      }, e.autoplay = function (e) {
        if (void 0 === e) return this.options_.autoplay || !1;
        var t;
        "string" == typeof e && /(any|play|muted)/.test(e) ? (this.options_.autoplay = e, this.manualAutoplay_(e), t = !1) : this.options_.autoplay = !!e, t = "undefined" == typeof t ? this.options_.autoplay : t, this.tech_ && this.techCall_("setAutoplay", t)
      }, e.playsinline = function (e) {
        return void 0 !== e ? (this.techCall_("setPlaysinline", e), this.options_.playsinline = e, this) : this.techGet_("playsinline")
      }, e.loop = function (e) {
        return void 0 !== e ? (this.techCall_("setLoop", e), void(this.options_.loop = e)) : this.techGet_("loop")
      }, e.poster = function (e) {
        if (void 0 === e) return this.poster_;
        (e = e || "") !== this.poster_ && (this.poster_ = e, this.techCall_("setPoster", e), this.isPosterFromTech_ = !1, this.trigger("posterchange"))
      }, e.handleTechPosterChange_ = function () {
        if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
          var e = this.tech_.poster() || "";
          e !== this.poster_ && (this.poster_ = e, this.isPosterFromTech_ = !0, this.trigger("posterchange"))
        }
      }, e.controls = function (e) {
        if (void 0 === e) return !!this.controls_;
        e = !!e, this.controls_ !== e && (this.controls_ = e, this.usingNativeControls() && this.techCall_("setControls", e), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()))
      }, e.usingNativeControls = function (e) {
        if (void 0 === e) return !!this.usingNativeControls_;
        e = !!e, this.usingNativeControls_ !== e && (this.usingNativeControls_ = e, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")))
      }, e.error = function (e) {
        if (void 0 === e) return this.error_ || null;
        if (this.options_.suppressNotSupportedError && e && 4 === e.code) {
          var t = function () {
            this.error(e)
          };
          return this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], t), void this.one("loadstart", function () {
            this.off(["click", "touchstart"], t)
          })
        }
        if (null === e) return this.error_ = e, this.removeClass("vjs-error"), void(this.errorDisplay && this.errorDisplay.close());
        this.error_ = new xt(e), this.addClass("vjs-error"), g.error("(CODE:" + this.error_.code + " " + xt.errorTypes[this.error_.code] + ")", this.error_.message, this.error_), this.trigger("error")
      }, e.reportUserActivity = function (e) {
        this.userActivity_ = !0
      }, e.userActive = function (e) {
        if (void 0 === e) return this.userActive_;
        if ((e = !!e) !== this.userActive_) {
          if (this.userActive_ = e, this.userActive_) return this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), void this.trigger("useractive");
          this.tech_ && this.tech_.one("mousemove", function (e) {
            e.stopPropagation(), e.preventDefault()
          }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive")
        }
      }, e.listenForUserActivity_ = function () {
        function e(e) {
          r(), this.clearInterval(t)
        }
        var t, i, n, r = $e(this, this.reportUserActivity);
        this.on("mousedown", function () {
          r(), this.clearInterval(t), t = this.setInterval(r, 250)
        }), this.on("mousemove", function (e) {
          e.screenX === i && e.screenY === n || (i = e.screenX, n = e.screenY, r())
        }), this.on("mouseup", e), this.on("mouseleave", e);
        var a, s = this.getChild("controlBar");
        !s || K || M || (s.on("mouseenter", function (e) {
          this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout, this.player().options_.inactivityTimeout = 0
        }), s.on("mouseleave", function (e) {
          this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout
        })), this.on("keydown", r), this.on("keyup", r), this.setInterval(function () {
          if (this.userActivity_) {
            this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(a);
            var e = this.options_.inactivityTimeout;
            e <= 0 || (a = this.setTimeout(function () {
              this.userActivity_ || this.userActive(!1)
            }, e))
          }
        }, 250)
      }, e.playbackRate = function (e) {
        if (void 0 === e) return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
        this.techCall_("setPlaybackRate", e)
      }, e.defaultPlaybackRate = function (e) {
        return void 0 !== e ? this.techCall_("setDefaultPlaybackRate", e) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1
      }, e.isAudio = function (e) {
        if (void 0 === e) return !!this.isAudio_;
        this.isAudio_ = !!e
      }, e.addTextTrack = function (e, t, i) {
        if (this.tech_) return this.tech_.addTextTrack(e, t, i)
      }, e.addRemoteTextTrack = function (e, t) {
        if (this.tech_) return this.tech_.addRemoteTextTrack(e, t)
      }, e.removeRemoteTextTrack = function (e) {
        void 0 === e && (e = {});
        var t = e.track;
        if (t = t || e, this.tech_) return this.tech_.removeRemoteTextTrack(t)
      }, e.getVideoPlaybackQuality = function () {
        return this.techGet_("getVideoPlaybackQuality")
      }, e.videoWidth = function () {
        return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0
      }, e.videoHeight = function () {
        return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0
      }, e.language = function (e) {
        if (void 0 === e) return this.language_;
        this.language_ !== String(e).toLowerCase() && (this.language_ = String(e).toLowerCase(), lt(this) && this.trigger("languagechange"))
      }, e.languages = function () {
        return gt(l.prototype.options_.languages, this.languages_)
      }, e.toJSON = function () {
        var e = gt(this.options_),
          t = e.tracks;
        e.tracks = [];
        for (var i = 0; i < t.length; i++) {
          var n = t[i];
          (n = gt(n)).player = void 0, e.tracks[i] = n
        }
        return e
      }, e.createModal = function (e, t) {
        var i = this;
        (t = t || {}).content = e || "";
        var n = new Bt(this, t);
        return this.addChild(n), n.on("dispose", function () {
          i.removeChild(n)
        }), n.open(), n
      }, e.updateCurrentBreakpoint_ = function () {
        if (this.responsive())
          for (var e = this.currentBreakpoint(), t = this.currentWidth(), i = 0; i < Zr.length; i++) {
            var n = Zr[i];
            if (t <= this.breakpoints_[n]) {
              if (e === n) return;
              e && this.removeClass(ea[e]), this.addClass(ea[n]), this.breakpoint_ = n;
              break
            }
          }
      }, e.removeCurrentBreakpoint_ = function () {
        var e = this.currentBreakpointClass();
        this.breakpoint_ = "", e && this.removeClass(e)
      }, e.breakpoints = function (e) {
        return void 0 === e || (this.breakpoint_ = "", this.breakpoints_ = S({}, ta, e), this.updateCurrentBreakpoint_()), S(this.breakpoints_)
      }, e.responsive = function (e) {
        return void 0 === e ? this.responsive_ : (e = Boolean(e)) !== this.responsive_ ? ((this.responsive_ = e) ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), e) : void 0
      }, e.currentBreakpoint = function () {
        return this.breakpoint_
      }, e.currentBreakpointClass = function () {
        return ea[this.breakpoint_] || ""
      }, e.loadMedia = function (e, t) {
        var i = this;
        if (e && "object" == typeof e) {
          this.reset(), this.cache_.media = gt(e);
          var n = this.cache_.media,
            r = n.artwork,
            a = n.poster,
            s = n.src,
            o = n.textTracks;
          !r && a && (this.cache_.media.artwork = [{
            src: a,
            type: cn(a)
          }]), s && this.src(s), a && this.poster(a), Array.isArray(o) && o.forEach(function (e) {
            return i.addRemoteTextTrack(e, !1)
          }), this.ready(t)
        }
      }, e.getMedia = function () {
        if (this.cache_.media) return gt(this.cache_.media);
        var e = this.poster(),
          t = {
            src: this.currentSources(),
            textTracks: Array.prototype.map.call(this.remoteTextTracks(), function (e) {
              return {
                kind: e.kind,
                label: e.label,
                language: e.language,
                src: e.src
              }
            })
          };
        return e && (t.poster = e, t.artwork = [{
          src: t.poster,
          type: cn(t.poster)
        }]), t
      }, l.getTagSettings = function (e) {
        var t = {
            sources: [],
            tracks: []
          },
          i = de(e),
          n = i["data-setup"];
        if (se(e, "vjs-fill") && (i.fill = !0), se(e, "vjs-fluid") && (i.fluid = !0), null !== n) {
          var r = Pt(n || "{}"),
            a = r[0],
            s = r[1];
          a && g.error(a), S(i, s)
        }
        if (S(t, i), e.hasChildNodes())
          for (var o = e.childNodes, u = 0, l = o.length; u < l; u++) {
            var c = o[u],
              d = c.nodeName.toLowerCase();
            "source" === d ? t.sources.push(de(c)) : "track" === d && t.tracks.push(de(c))
          }
        return t
      }, e.flexNotSupported_ = function () {
        var e = p.createElement("i");
        return !("flexBasis" in e.style || "webkitFlexBasis" in e.style || "mozFlexBasis" in e.style || "msFlexBasis" in e.style || "msFlexOrder" in e.style)
      }, e.debug = function (e) {
        if (void 0 === e) return this.debugEnabled_;
        e ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1)
      }, l
    }(Tt);
  Ti.names.forEach(function (e) {
    var t = Ti[e];
    ia.prototype[t.getterName] = function () {
      return this.tech_ ? this.tech_[t.getterName]() : (this[t.privateName] = this[t.privateName] || new t.ListClass, this[t.privateName])
    }
  }), ia.prototype.crossorigin = ia.prototype.crossOrigin, ia.players = {};
  var na = h.navigator;
  ia.prototype.options_ = {
    techOrder: Ji.defaultTechOrder_,
    html5: {},
    inactivityTimeout: 2e3,
    playbackRates: [],
    liveui: !1,
    children: ["mediaLoader", "posterImage", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
    language: na && (na.languages && na.languages[0] || na.userLanguage || na.language) || "en",
    languages: {},
    notSupportedMessage: "No compatible source was found for this media.",
    fullscreen: {
      options: {
        navigationUI: "hide"
      }
    },
    breakpoints: {},
    responsive: !1
  }, ["ended", "seeking", "seekable", "networkState", "readyState"].forEach(function (e) {
    ia.prototype[e] = function () {
      return this.techGet_(e)
    }
  }), $r.forEach(function (e) {
    ia.prototype["handleTech" + mt(e) + "_"] = function () {
      return this.trigger(e)
    }
  }), Tt.registerComponent("Player", ia);
  var ra = i(function (i) {
    function n(e, t) {
      return i.exports = n = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e
      }, n(e, t)
    }
    i.exports = n
  });

  function aa(e) {
    return fa.hasOwnProperty(e)
  }

  function sa(e) {
    return aa(e) ? fa[e] : void 0
  }

  function oa(e, t) {
    e[pa] = e[pa] || {}, e[pa][t] = !0
  }

  function ua(e, t, i) {
    var n = (i ? "before" : "") + "pluginsetup";
    e.trigger(n, t), e.trigger(n + ":" + t.name, t)
  }

  function la(r, a) {
    return a.prototype.name = r,
      function () {
        ua(this, {
          name: r,
          plugin: a,
          instance: null
        }, !0);
        for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
        var n = da(a, [this].concat(t));
        return this[r] = function () {
          return n
        }, ua(this, n.getEventHash()), n
      }
  }
  var ca = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0
      } catch (e) {
        return !1
      }
    },
    da = i(function (n) {
      function r(e, t, i) {
        return ca() ? n.exports = r = Reflect.construct : n.exports = r = function (e, t, i) {
          var n = [null];
          n.push.apply(n, t);
          var r = new(Function.bind.apply(e, n));
          return i && ra(r, i.prototype), r
        }, r.apply(null, arguments)
      }
      n.exports = r
    }),
    ha = "plugin",
    pa = "activePlugins_",
    fa = {},
    ma = function () {
      function i(e) {
        if (this.constructor === i) throw new Error("Plugin must be sub-classed; not directly instantiated.");
        this.player = e, this.log || (this.log = this.player.log.createLogger(this.name)), dt(this), delete this.trigger, pt(this, this.constructor.defaultState), oa(e, this.name), this.dispose = this.dispose.bind(this), e.on("dispose", this.dispose)
      }
      var e = i.prototype;
      return e.version = function () {
        return this.constructor.VERSION
      }, e.getEventHash = function (e) {
        return void 0 === e && (e = {}), e.name = this.name, e.plugin = this.constructor, e.instance = this, e
      }, e.trigger = function (e, t) {
        return void 0 === t && (t = {}), Ke(this.eventBusEl_, e, this.getEventHash(t))
      }, e.handleStateChanged = function (e) {}, e.dispose = function () {
        var e = this.name,
          t = this.player;
        this.trigger("dispose"), this.off(), t.off("dispose", this.dispose), t[pa][e] = !1, this.player = this.state = null, t[e] = la(e, fa[e])
      }, i.isBasic = function (e) {
        var t = "string" == typeof e ? sa(e) : e;
        return "function" == typeof t && !i.prototype.isPrototypeOf(t.prototype)
      }, i.registerPlugin = function (e, t) {
        if ("string" != typeof e) throw new Error('Illegal plugin name, "' + e + '", must be a string, was ' + typeof e + ".");
        if (aa(e)) g.warn('A plugin named "' + e + '" already exists. You may want to avoid re-registering plugins!');
        else if (ia.prototype.hasOwnProperty(e)) throw new Error('Illegal plugin name, "' + e + '", cannot share a name with an existing player method!');
        if ("function" != typeof t) throw new Error('Illegal plugin for "' + e + '", must be a function, was ' + typeof t + ".");
        return fa[e] = t, e !== ha && (i.isBasic(t) ? ia.prototype[e] = function (t, i) {
          function n() {
            ua(this, {
              name: t,
              plugin: i,
              instance: null
            }, !0);
            var e = i.apply(this, arguments);
            return oa(this, t), ua(this, {
              name: t,
              plugin: i,
              instance: e
            }), e
          }
          return Object.keys(i).forEach(function (e) {
            n[e] = i[e]
          }), n
        }(e, t) : ia.prototype[e] = la(e, t)), t
      }, i.deregisterPlugin = function (e) {
        if (e === ha) throw new Error("Cannot de-register base plugin.");
        aa(e) && (delete fa[e], delete ia.prototype[e])
      }, i.getPlugins = function (e) {
        var i;
        return void 0 === e && (e = Object.keys(fa)), e.forEach(function (e) {
          var t = sa(e);
          t && ((i = i || {})[e] = t)
        }), i
      }, i.getPluginVersion = function (e) {
        var t = sa(e);
        return t && t.VERSION || ""
      }, i
    }();
  ma.getPlugin = sa, ma.BASE_PLUGIN_NAME = ha, ma.registerPlugin(ha, ma), ia.prototype.usingPlugin = function (e) {
    return !!this[pa] && !0 === this[pa][e]
  }, ia.prototype.hasPlugin = function (e) {
    return !!aa(e)
  };
  var ga = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && ra(e, t)
    },
    va = function (e) {
      return 0 === e.indexOf("#") ? e.slice(1) : e
    };

  function ya(e, i, t) {
    var n = ya.getPlayer(e);
    if (n) return i && g.warn('Player "' + e + '" is already initialised. Options will not be applied.'), t && n.ready(t), n;
    var r = "string" == typeof e ? Ie("#" + va(e)) : e;
    if (!ee(r)) throw new TypeError("The element or ID supplied is not valid. (videojs)");
    r.ownerDocument.defaultView && r.ownerDocument.body.contains(r) || g.warn("The element supplied is not included in the DOM"), i = i || {}, ya.hooks("beforesetup").forEach(function (e) {
      var t = e(r, gt(i));
      E(t) && !Array.isArray(t) ? i = gt(i, t) : g.error("please return an object in beforesetup hooks")
    });
    var a = Tt.getComponent("Player");
    return n = new a(r, i, t), ya.hooks("setup").forEach(function (e) {
      return e(n)
    }), n
  }
  if (ya.hooks_ = {}, ya.hooks = function (e, t) {
      return ya.hooks_[e] = ya.hooks_[e] || [], t && (ya.hooks_[e] = ya.hooks_[e].concat(t)), ya.hooks_[e]
    }, ya.hook = function (e, t) {
      ya.hooks(e, t)
    }, ya.hookOnce = function (i, e) {
      ya.hooks(i, [].concat(e).map(function (t) {
        return function e() {
          return ya.removeHook(i, e), t.apply(void 0, arguments)
        }
      }))
    }, ya.removeHook = function (e, t) {
      var i = ya.hooks(e).indexOf(t);
      return !(i <= -1) && (ya.hooks_[e] = ya.hooks_[e].slice(), ya.hooks_[e].splice(i, 1), !0)
    }, !0 !== h.VIDEOJS_NO_DYNAMIC_STYLE && Z()) {
    var _a = Ie(".vjs-styles-defaults");
    if (!_a) {
      _a = Re("vjs-styles-defaults");
      var ba = Ie("head");
      ba && ba.insertBefore(_a, ba.firstChild), Me(_a, "\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid {\n        padding-top: 56.25%\n      }\n    ")
    }
  }
  Oe(1, ya), ya.VERSION = d, ya.options = ia.prototype.options_, ya.getPlayers = function () {
    return ia.players
  }, ya.getPlayer = function (e) {
    var t, i = ia.players;
    if ("string" == typeof e) {
      var n = va(e),
        r = i[n];
      if (r) return r;
      t = Ie("#" + n)
    } else t = e;
    if (ee(t)) {
      var a = t,
        s = a.player,
        o = a.playerId;
      if (s || i[o]) return s || i[o]
    }
  }, ya.getAllPlayers = function () {
    return Object.keys(ia.players).map(function (e) {
      return ia.players[e]
    }).filter(Boolean)
  }, ya.players = ia.players, ya.getComponent = Tt.getComponent, ya.registerComponent = function (e, t) {
    Ji.isTech(t) && g.warn("The " + e + " tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)"), Tt.registerComponent.call(Tt, e, t)
  }, ya.getTech = Ji.getTech, ya.registerTech = Ji.registerTech, ya.use = function (e, t) {
    Zi[e] = Zi[e] || [], Zi[e].push(t)
  }, Object.defineProperty(ya, "middleware", {
    value: {},
    writeable: !1,
    enumerable: !0
  }), Object.defineProperty(ya.middleware, "TERMINATOR", {
    value: tn,
    writeable: !1,
    enumerable: !0
  }), ya.browser = Q, ya.TOUCH_ENABLED = z, ya.extend = function (e, t) {
    void 0 === t && (t = {});
    var i = function () {
        e.apply(this, arguments)
      },
      n = {};
    for (var r in "object" == typeof t ? (t.constructor !== Object.prototype.constructor && (i = t.constructor), n = t) : "function" == typeof t && (i = t), ga(i, e), e && (i.super_ = e), n) n.hasOwnProperty(r) && (i.prototype[r] = n[r]);
    return i
  }, ya.mergeOptions = gt, ya.bind = $e, ya.registerPlugin = ma.registerPlugin, ya.deregisterPlugin = ma.deregisterPlugin, ya.plugin = function (e, t) {
    return g.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), ma.registerPlugin(e, t)
  }, ya.getPlugins = ma.getPlugins, ya.getPlugin = ma.getPlugin, ya.getPluginVersion = ma.getPluginVersion, ya.addLanguage = function (e, t) {
    var i;
    return e = ("" + e).toLowerCase(), ya.options.languages = gt(ya.options.languages, ((i = {})[e] = t, i)), ya.options.languages[e]
  }, ya.log = g, ya.createLogger = v, ya.createTimeRange = ya.createTimeRanges = Ct, ya.formatTime = xn, ya.setFormatTime = function (e) {
    In = e
  }, ya.resetFormatTime = function () {
    In = Cn
  }, ya.parseUrl = qt, ya.isCrossOrigin = Gt, ya.EventTarget = Ze, ya.on = Ge, ya.one = Ye, ya.off = Xe, ya.trigger = Ke, ya.xhr = ui, ya.TextTrack = mi, ya.AudioTrack = gi, ya.VideoTrack = vi, ["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach(function (e) {
    ya[e] = function () {
      return g.warn("videojs." + e + "() is deprecated; use videojs.dom." + e + "() instead"), Ae[e].apply(null, arguments)
    }
  }), ya.computedStyle = w, ya.dom = Ae, ya.url = ni, ya.defineLazyProperty = Gr;
  var Ta = t(i(function (e) {
      e.exports = function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
      }, e.exports.default = e.exports, e.exports.__esModule = !0
    })),
    Sa = i(function (i) {
      function n(e, t) {
        return i.exports = n = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e
        }, i.exports.default = i.exports, i.exports.__esModule = !0, n(e, t)
      }
      i.exports = n, i.exports.default = i.exports, i.exports.__esModule = !0
    });
  t(Sa);

  function Ea(e, t) {
    return /^[a-z]+:/i.test(t) ? t : (/\/\//i.test(e) || (e = xa.buildAbsoluteURL(Aa.location && Aa.location.href || "", e)), xa.buildAbsoluteURL(e, t))
  }
  var ka = t(i(function (e) {
      e.exports = function (e, t) {
        e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Sa(e, t)
      }, e.exports.default = e.exports, e.exports.__esModule = !0
    })),
    wa = "undefined" != typeof e ? e : "undefined" != typeof window ? window : {},
    Ca = "undefined" != typeof document ? document : wa["__GLOBAL_DOCUMENT_CACHE@4"] || (wa["__GLOBAL_DOCUMENT_CACHE@4"] = r),
    Ia = "undefined" != typeof window ? window : "undefined" != typeof e ? e : "undefined" != typeof self ? self : {},
    xa = i(function (e, t) {
      var i, c, n, r, d;
      i = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/?#]*\/)*[^;?#]*)?(;[^?#]*)?(\?[^#]*)?(#.*)?$/, c = /^([^\/?#]*)(.*)$/, n = /(?:\/|^)\.(?=\/)/g, r = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, d = {
        buildAbsoluteURL: function (e, t, i) {
          if (i = i || {}, e = e.trim(), !(t = t.trim())) {
            if (!i.alwaysNormalize) return e;
            var n = d.parseURL(e);
            if (!n) throw new Error("Error trying to parse base URL.");
            return n.path = d.normalizePath(n.path), d.buildURLFromParts(n)
          }
          var r = d.parseURL(t);
          if (!r) throw new Error("Error trying to parse relative URL.");
          if (r.scheme) return i.alwaysNormalize ? (r.path = d.normalizePath(r.path), d.buildURLFromParts(r)) : t;
          var a = d.parseURL(e);
          if (!a) throw new Error("Error trying to parse base URL.");
          if (!a.netLoc && a.path && "/" !== a.path[0]) {
            var s = c.exec(a.path);
            a.netLoc = s[1], a.path = s[2]
          }
          a.netLoc && !a.path && (a.path = "/");
          var o = {
            scheme: a.scheme,
            netLoc: r.netLoc,
            path: null,
            params: r.params,
            query: r.query,
            fragment: r.fragment
          };
          if (!r.netLoc && (o.netLoc = a.netLoc, "/" !== r.path[0]))
            if (r.path) {
              var u = a.path,
                l = u.substring(0, u.lastIndexOf("/") + 1) + r.path;
              o.path = d.normalizePath(l)
            } else o.path = a.path, r.params || (o.params = a.params, r.query || (o.query = a.query));
          return null === o.path && (o.path = i.alwaysNormalize ? d.normalizePath(r.path) : r.path), d.buildURLFromParts(o)
        },
        parseURL: function (e) {
          var t = i.exec(e);
          return t ? {
            scheme: t[1] || "",
            netLoc: t[2] || "",
            path: t[3] || "",
            params: t[4] || "",
            query: t[5] || "",
            fragment: t[6] || ""
          } : null
        },
        normalizePath: function (e) {
          for (e = e.split("").reverse().join("").replace(n, ""); e.length !== (e = e.replace(r, "")).length;);
          return e.split("").reverse().join("")
        },
        buildURLFromParts: function (e) {
          return e.scheme + e.netLoc + e.path + e.params + e.query + e.fragment
        }
      }, e.exports = d
    }),
    Aa = "undefined" != typeof window ? window : "undefined" != typeof e ? e : "undefined" != typeof self ? self : {},
    Pa = i(function (i) {
      function n(e, t) {
        return i.exports = n = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e
        }, i.exports.default = i.exports, i.exports.__esModule = !0, n(e, t)
      }
      i.exports = n, i.exports.default = i.exports, i.exports.__esModule = !0
    });
  t(Pa);
  var La = t(i(function (e) {
      e.exports = function (e, t) {
        e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Pa(e, t)
      }, e.exports.default = e.exports, e.exports.__esModule = !0
    })),
    Oa = function () {
      function e() {
        this.listeners = {}
      }
      var t = e.prototype;
      return t.on = function (e, t) {
        this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t)
      }, t.off = function (e, t) {
        if (!this.listeners[e]) return !1;
        var i = this.listeners[e].indexOf(t);
        return this.listeners[e] = this.listeners[e].slice(0), this.listeners[e].splice(i, 1), -1 < i
      }, t.trigger = function (e, t) {
        var i = this.listeners[e];
        if (i)
          if (2 === arguments.length)
            for (var n = i.length, r = 0; r < n; ++r) i[r].call(this, t);
          else
            for (var a = Array.prototype.slice.call(arguments, 1), s = i.length, o = 0; o < s; ++o) i[o].apply(this, a)
      }, t.dispose = function () {
        this.listeners = {}
      }, t.pipe = function (t) {
        this.on("data", function (e) {
          t.push(e)
        })
      }, e
    }(),
    Da = t(i(function (e) {
      function t() {
        return e.exports = t = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var i = arguments[t];
            for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n])
          }
          return e
        }, e.exports.default = e.exports, e.exports.__esModule = !0, t.apply(this, arguments)
      }
      e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0
    })),
    Ra = t(i(function (e) {
      e.exports = function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
      }, e.exports.default = e.exports, e.exports.__esModule = !0
    })),
    Ma = function (e) {
      return Aa.atob ? Aa.atob(e) : Buffer.from(e, "base64").toString("binary")
    };

  function Na(e) {
    for (var t = Ma(e), i = new Uint8Array(t.length), n = 0; n < t.length; n++) i[n] = t.charCodeAt(n);
    return i
  }
  /*! @name m3u8-parser @version 4.6.0 @license Apache-2.0 */
  function Ua(e) {
    var t = /([0-9.]*)?@?([0-9.]*)?/.exec(e || ""),
      i = {};
    return t[1] && (i.length = parseInt(t[1], 10)), t[2] && (i.offset = parseInt(t[2], 10)), i
  }

  function Ba(e) {
    for (var t, i = e.split(new RegExp('(?:^|,)((?:[^=]*)=(?:"[^"]*"|[^,]*))')), n = {}, r = i.length; r--;) "" !== i[r] && ((t = /([^=]*)=(.*)/.exec(i[r]).slice(1))[0] = t[0].replace(/^\s+|\s+$/g, ""), t[1] = t[1].replace(/^\s+|\s+$/g, ""), t[1] = t[1].replace(/^['"](.*)['"]$/g, "$1"), n[t[0]] = t[1]);
    return n
  }

  function Fa(t) {
    var i = {};
    return Object.keys(t).forEach(function (e) {
      i[function (e) {
        return e.toLowerCase().replace(/-(\w)/g, function (e) {
          return e[1].toUpperCase()
        })
      }(e)] = t[e]
    }), i
  }

  function ja(e) {
    var t = e.serverControl,
      i = e.targetDuration,
      n = e.partTargetDuration;
    if (t) {
      var r = "#EXT-X-SERVER-CONTROL",
        a = "holdBack",
        s = "partHoldBack",
        o = i && 3 * i,
        u = n && 2 * n;
      i && !t.hasOwnProperty(a) && (t[a] = o, this.trigger("info", {
        message: r + " defaulting HOLD-BACK to targetDuration * 3 (" + o + ")."
      })), o && t[a] < o && (this.trigger("warn", {
        message: r + " clamping HOLD-BACK (" + t[a] + ") to targetDuration * 3 (" + o + ")"
      }), t[a] = o), n && !t.hasOwnProperty(s) && (t[s] = 3 * n, this.trigger("info", {
        message: r + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + t[s] + ")."
      })), n && t[s] < u && (this.trigger("warn", {
        message: r + " clamping PART-HOLD-BACK (" + t[s] + ") to partTargetDuration * 2 (" + u + ")."
      }), t[s] = u)
    }
  }

  function Ha(e) {
    return e ? e.replace(/avc1\.(\d+)\.(\d+)/i, function (e, t, i) {
      return "avc1." + ("00" + Number(t).toString(16)).slice(-2) + "00" + ("00" + Number(i).toString(16)).slice(-2)
    }) : e
  }

  function Va(e) {
    void 0 === e && (e = "");
    var t = e.split(","),
      s = [];
    return t.forEach(function (r) {
      var a;
      r = r.trim(), Za.forEach(function (e) {
        var t = Ja[e].exec(r.toLowerCase());
        if (t && !(t.length <= 1)) {
          a = e;
          var i = r.substring(0, t[1].length),
            n = r.replace(i, "");
          s.push({
            type: i,
            details: n,
            mediaType: e
          })
        }
      }), a || s.push({
        type: r,
        details: "",
        mediaType: "unknown"
      })
    }), s
  }

  function qa(e) {
    return void 0 === e && (e = ""), Ja.audio.test(e.trim().toLowerCase())
  }

  function Wa(e) {
    if (e && "string" == typeof e) {
      var t = e.toLowerCase().split(",").map(function (e) {
          return Ha(e.trim())
        }),
        i = "video";
      1 === t.length && qa(t[0]) ? i = "audio" : 1 === t.length && function (e) {
        return void 0 === e && (e = ""), Ja.text.test(e.trim().toLowerCase())
      }(t[0]) && (i = "application");
      var n = "mp4";
      return t.every(function (e) {
        return Ja.mp4.test(e)
      }) ? n = "mp4" : t.every(function (e) {
        return Ja.webm.test(e)
      }) ? n = "webm" : t.every(function (e) {
        return Ja.ogg.test(e)
      }) && (n = "ogg"), i + "/" + n + ';codecs="' + e + '"'
    }
  }

  function za(e) {
    return void 0 === e && (e = ""), Aa.MediaSource && Aa.MediaSource.isTypeSupported && Aa.MediaSource.isTypeSupported(Wa(e)) || !1
  }

  function Ga(e) {
    return void 0 === e && (e = ""), e.toLowerCase().split(",").every(function (e) {
      e = e.trim();
      for (var t = 0; t < es.length; t++) {
        if (Ja["muxer" + es[t]].test(e)) return !0
      }
      return !1
    })
  }

  function Xa(e) {
    return is.test(e) ? "hls" : ns.test(e) ? "dash" : "application/vnd.videojs.vhs+json" === e ? "vhs-json" : null
  }
  var Ka = function (t) {
      function e() {
        var e;
        return (e = t.call(this) || this).buffer = "", e
      }
      return La(e, t), e.prototype.push = function (e) {
        var t;
        for (this.buffer += e, t = this.buffer.indexOf("\n"); - 1 < t; t = this.buffer.indexOf("\n")) this.trigger("data", this.buffer.substring(0, t)), this.buffer = this.buffer.substring(t + 1)
      }, e
    }(Oa),
    Ya = String.fromCharCode(9),
    Qa = function (t) {
      function e() {
        var e;
        return (e = t.call(this) || this).customParsers = [], e.tagMappers = [], e
      }
      La(e, t);
      var i = e.prototype;
      return i.push = function (n) {
        var a, s, o = this;
        0 !== (n = n.trim()).length && ("#" === n[0] ? this.tagMappers.reduce(function (e, t) {
          var i = t(n);
          return i === n ? e : e.concat([i])
        }, [n]).forEach(function (e) {
          for (var t = 0; t < o.customParsers.length; t++)
            if (o.customParsers[t].call(o, e)) return;
          if (0 === e.indexOf("#EXT"))
            if (e = e.replace("\r", ""), a = /^#EXTM3U/.exec(e)) o.trigger("data", {
              type: "tag",
              tagType: "m3u"
            });
            else {
              if (a = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(e)) return s = {
                type: "tag",
                tagType: "inf"
              }, a[1] && (s.duration = parseFloat(a[1])), a[2] && (s.title = a[2]), void o.trigger("data", s);
              if (a = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(e)) return s = {
                type: "tag",
                tagType: "targetduration"
              }, a[1] && (s.duration = parseInt(a[1], 10)), void o.trigger("data", s);
              if (a = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(e)) return s = {
                type: "tag",
                tagType: "version"
              }, a[1] && (s.version = parseInt(a[1], 10)), void o.trigger("data", s);
              if (a = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(e)) return s = {
                type: "tag",
                tagType: "media-sequence"
              }, a[1] && (s.number = parseInt(a[1], 10)), void o.trigger("data", s);
              if (a = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(e)) return s = {
                type: "tag",
                tagType: "discontinuity-sequence"
              }, a[1] && (s.number = parseInt(a[1], 10)), void o.trigger("data", s);
              if (a = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(e)) return s = {
                type: "tag",
                tagType: "playlist-type"
              }, a[1] && (s.playlistType = a[1]), void o.trigger("data", s);
              if (a = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(e)) return s = Da(Ua(a[1]), {
                type: "tag",
                tagType: "byterange"
              }), void o.trigger("data", s);
              if (a = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(e)) return s = {
                type: "tag",
                tagType: "allow-cache"
              }, a[1] && (s.allowed = !/NO/.test(a[1])), void o.trigger("data", s);
              if (a = /^#EXT-X-MAP:?(.*)$/.exec(e)) {
                if (s = {
                    type: "tag",
                    tagType: "map"
                  }, a[1]) {
                  var i = Ba(a[1]);
                  i.URI && (s.uri = i.URI), i.BYTERANGE && (s.byterange = Ua(i.BYTERANGE))
                }
                o.trigger("data", s)
              } else if (a = /^#EXT-X-STREAM-INF:?(.*)$/.exec(e)) {
                if (s = {
                    type: "tag",
                    tagType: "stream-inf"
                  }, a[1]) {
                  if (s.attributes = Ba(a[1]), s.attributes.RESOLUTION) {
                    var n = s.attributes.RESOLUTION.split("x"),
                      r = {};
                    n[0] && (r.width = parseInt(n[0], 10)), n[1] && (r.height = parseInt(n[1], 10)), s.attributes.RESOLUTION = r
                  }
                  s.attributes.BANDWIDTH && (s.attributes.BANDWIDTH = parseInt(s.attributes.BANDWIDTH, 10)), s.attributes["PROGRAM-ID"] && (s.attributes["PROGRAM-ID"] = parseInt(s.attributes["PROGRAM-ID"], 10))
                }
                o.trigger("data", s)
              } else {
                if (a = /^#EXT-X-MEDIA:?(.*)$/.exec(e)) return s = {
                  type: "tag",
                  tagType: "media"
                }, a[1] && (s.attributes = Ba(a[1])), void o.trigger("data", s);
                if (a = /^#EXT-X-ENDLIST/.exec(e)) o.trigger("data", {
                  type: "tag",
                  tagType: "endlist"
                });
                else if (a = /^#EXT-X-DISCONTINUITY/.exec(e)) o.trigger("data", {
                  type: "tag",
                  tagType: "discontinuity"
                });
                else {
                  if (a = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(e)) return s = {
                    type: "tag",
                    tagType: "program-date-time"
                  }, a[1] && (s.dateTimeString = a[1], s.dateTimeObject = new Date(a[1])), void o.trigger("data", s);
                  if (a = /^#EXT-X-KEY:?(.*)$/.exec(e)) return s = {
                    type: "tag",
                    tagType: "key"
                  }, a[1] && (s.attributes = Ba(a[1]), s.attributes.IV && ("0x" === s.attributes.IV.substring(0, 2).toLowerCase() && (s.attributes.IV = s.attributes.IV.substring(2)), s.attributes.IV = s.attributes.IV.match(/.{8}/g), s.attributes.IV[0] = parseInt(s.attributes.IV[0], 16), s.attributes.IV[1] = parseInt(s.attributes.IV[1], 16), s.attributes.IV[2] = parseInt(s.attributes.IV[2], 16), s.attributes.IV[3] = parseInt(s.attributes.IV[3], 16), s.attributes.IV = new Uint32Array(s.attributes.IV))), void o.trigger("data", s);
                  if (a = /^#EXT-X-START:?(.*)$/.exec(e)) return s = {
                    type: "tag",
                    tagType: "start"
                  }, a[1] && (s.attributes = Ba(a[1]), s.attributes["TIME-OFFSET"] = parseFloat(s.attributes["TIME-OFFSET"]), s.attributes.PRECISE = /YES/.test(s.attributes.PRECISE)), void o.trigger("data", s);
                  if (a = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(e)) return s = {
                    type: "tag",
                    tagType: "cue-out-cont"
                  }, a[1] ? s.data = a[1] : s.data = "", void o.trigger("data", s);
                  if (a = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(e)) return s = {
                    type: "tag",
                    tagType: "cue-out"
                  }, a[1] ? s.data = a[1] : s.data = "", void o.trigger("data", s);
                  if (a = /^#EXT-X-CUE-IN:?(.*)?$/.exec(e)) return s = {
                    type: "tag",
                    tagType: "cue-in"
                  }, a[1] ? s.data = a[1] : s.data = "", void o.trigger("data", s);
                  if ((a = /^#EXT-X-SKIP:(.*)$/.exec(e)) && a[1]) return (s = {
                    type: "tag",
                    tagType: "skip"
                  }).attributes = Ba(a[1]), s.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (s.attributes["SKIPPED-SEGMENTS"] = parseInt(s.attributes["SKIPPED-SEGMENTS"], 10)), s.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (s.attributes["RECENTLY-REMOVED-DATERANGES"] = s.attributes["RECENTLY-REMOVED-DATERANGES"].split(Ya)), void o.trigger("data", s);
                  if ((a = /^#EXT-X-PART:(.*)$/.exec(e)) && a[1]) return (s = {
                    type: "tag",
                    tagType: "part"
                  }).attributes = Ba(a[1]), ["DURATION"].forEach(function (e) {
                    s.attributes.hasOwnProperty(e) && (s.attributes[e] = parseFloat(s.attributes[e]))
                  }), ["INDEPENDENT", "GAP"].forEach(function (e) {
                    s.attributes.hasOwnProperty(e) && (s.attributes[e] = /YES/.test(s.attributes[e]))
                  }), s.attributes.hasOwnProperty("BYTERANGE") && (s.attributes.byterange = Ua(s.attributes.BYTERANGE)), void o.trigger("data", s);
                  if ((a = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(e)) && a[1]) return (s = {
                    type: "tag",
                    tagType: "server-control"
                  }).attributes = Ba(a[1]), ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function (e) {
                    s.attributes.hasOwnProperty(e) && (s.attributes[e] = parseFloat(s.attributes[e]))
                  }), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function (e) {
                    s.attributes.hasOwnProperty(e) && (s.attributes[e] = /YES/.test(s.attributes[e]))
                  }), void o.trigger("data", s);
                  if ((a = /^#EXT-X-PART-INF:(.*)$/.exec(e)) && a[1]) return (s = {
                    type: "tag",
                    tagType: "part-inf"
                  }).attributes = Ba(a[1]), ["PART-TARGET"].forEach(function (e) {
                    s.attributes.hasOwnProperty(e) && (s.attributes[e] = parseFloat(s.attributes[e]))
                  }), void o.trigger("data", s);
                  if ((a = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(e)) && a[1]) return (s = {
                    type: "tag",
                    tagType: "preload-hint"
                  }).attributes = Ba(a[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function (e) {
                    if (s.attributes.hasOwnProperty(e)) {
                      s.attributes[e] = parseInt(s.attributes[e], 10);
                      var t = "BYTERANGE-LENGTH" === e ? "length" : "offset";
                      s.attributes.byterange = s.attributes.byterange || {}, s.attributes.byterange[t] = s.attributes[e], delete s.attributes[e]
                    }
                  }), void o.trigger("data", s);
                  if ((a = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(e)) && a[1]) return (s = {
                    type: "tag",
                    tagType: "rendition-report"
                  }).attributes = Ba(a[1]), ["LAST-MSN", "LAST-PART"].forEach(function (e) {
                    s.attributes.hasOwnProperty(e) && (s.attributes[e] = parseInt(s.attributes[e], 10))
                  }), void o.trigger("data", s);
                  o.trigger("data", {
                    type: "tag",
                    data: e.slice(4)
                  })
                }
              }
            }
          else o.trigger("data", {
            type: "comment",
            text: e.slice(1)
          })
        }) : this.trigger("data", {
          type: "uri",
          uri: n
        }))
      }, i.addParser = function (e) {
        var t = this,
          i = e.expression,
          n = e.customType,
          r = e.dataParser,
          a = e.segment;
        "function" != typeof r && (r = function (e) {
          return e
        }), this.customParsers.push(function (e) {
          if (i.exec(e)) return t.trigger("data", {
            type: "custom",
            data: r(e),
            customType: n,
            segment: a
          }), !0
        })
      }, i.addTagMapper = function (e) {
        var t = e.expression,
          i = e.map;
        this.tagMappers.push(function (e) {
          return t.test(e) ? i(e) : e
        })
      }, e
    }(Oa),
    $a = function (t) {
      function e() {
        var e;
        (e = t.call(this) || this).lineStream = new Ka, e.parseStream = new Qa, e.lineStream.pipe(e.parseStream);
        var n, r, a = Ra(e),
          o = [],
          u = {},
          l = !1,
          c = {
            AUDIO: {},
            VIDEO: {},
            "CLOSED-CAPTIONS": {},
            SUBTITLES: {}
          },
          d = 0;
        e.manifest = {
          allowCache: !0,
          discontinuityStarts: [],
          segments: []
        };
        var h = 0,
          p = 0;
        return e.on("end", function () {
          u.uri || !u.parts && !u.preloadHints || (!u.map && n && (u.map = n), !u.key && r && (u.key = r), u.timeline || "number" != typeof d || (u.timeline = d), e.manifest.preloadSegment = u)
        }), e.parseStream.on("data", function (s) {
          var t, i;
          ({
            tag: function () {
              ({
                version: function () {
                  s.version && (this.manifest.version = s.version)
                },
                "allow-cache": function () {
                  this.manifest.allowCache = s.allowed, "allowed" in s || (this.trigger("info", {
                    message: "defaulting allowCache to YES"
                  }), this.manifest.allowCache = !0)
                },
                byterange: function () {
                  var e = {};
                  "length" in s && ((u.byterange = e).length = s.length, "offset" in s || (s.offset = h)), "offset" in s && ((u.byterange = e).offset = s.offset), h = e.offset + e.length
                },
                endlist: function () {
                  this.manifest.endList = !0
                },
                inf: function () {
                  "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                    message: "defaulting media sequence to zero"
                  })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                    message: "defaulting discontinuity sequence to zero"
                  })), 0 < s.duration && (u.duration = s.duration), 0 === s.duration && (u.duration = .01, this.trigger("info", {
                    message: "updating zero segment duration to a small value"
                  })), this.manifest.segments = o
                },
                key: function () {
                  if (s.attributes)
                    if ("NONE" !== s.attributes.METHOD)
                      if (s.attributes.URI) {
                        if ("urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed" === s.attributes.KEYFORMAT) {
                          return -1 === ["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"].indexOf(s.attributes.METHOD) ? void this.trigger("warn", {
                            message: "invalid key method provided for Widevine"
                          }) : ("SAMPLE-AES-CENC" === s.attributes.METHOD && this.trigger("warn", {
                            message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                          }), "data:text/plain;base64," !== s.attributes.URI.substring(0, 23) ? void this.trigger("warn", {
                            message: "invalid key URI provided for Widevine"
                          }) : s.attributes.KEYID && "0x" === s.attributes.KEYID.substring(0, 2) ? void(this.manifest.contentProtection = {
                            "com.widevine.alpha": {
                              attributes: {
                                schemeIdUri: s.attributes.KEYFORMAT,
                                keyId: s.attributes.KEYID.substring(2)
                              },
                              pssh: Na(s.attributes.URI.split(",")[1])
                            }
                          }) : void this.trigger("warn", {
                            message: "invalid key ID provided for Widevine"
                          }))
                        }
                        s.attributes.METHOD || this.trigger("warn", {
                          message: "defaulting key method to AES-128"
                        }), r = {
                          method: s.attributes.METHOD || "AES-128",
                          uri: s.attributes.URI
                        }, "undefined" != typeof s.attributes.IV && (r.iv = s.attributes.IV)
                      } else this.trigger("warn", {
                        message: "ignoring key declaration without URI"
                      });
                  else r = null;
                  else this.trigger("warn", {
                    message: "ignoring key declaration without attribute list"
                  })
                },
                "media-sequence": function () {
                  isFinite(s.number) ? this.manifest.mediaSequence = s.number : this.trigger("warn", {
                    message: "ignoring invalid media sequence: " + s.number
                  })
                },
                "discontinuity-sequence": function () {
                  isFinite(s.number) ? (this.manifest.discontinuitySequence = s.number, d = s.number) : this.trigger("warn", {
                    message: "ignoring invalid discontinuity sequence: " + s.number
                  })
                },
                "playlist-type": function () {
                  /VOD|EVENT/.test(s.playlistType) ? this.manifest.playlistType = s.playlistType : this.trigger("warn", {
                    message: "ignoring unknown playlist type: " + s.playlist
                  })
                },
                map: function () {
                  n = {}, s.uri && (n.uri = s.uri), s.byterange && (n.byterange = s.byterange)
                },
                "stream-inf": function () {
                  this.manifest.playlists = o, this.manifest.mediaGroups = this.manifest.mediaGroups || c, s.attributes ? (u.attributes || (u.attributes = {}), Da(u.attributes, s.attributes)) : this.trigger("warn", {
                    message: "ignoring empty stream-inf attributes"
                  })
                },
                media: function () {
                  if (this.manifest.mediaGroups = this.manifest.mediaGroups || c, s.attributes && s.attributes.TYPE && s.attributes["GROUP-ID"] && s.attributes.NAME) {
                    var e = this.manifest.mediaGroups[s.attributes.TYPE];
                    e[s.attributes["GROUP-ID"]] = e[s.attributes["GROUP-ID"]] || {}, t = e[s.attributes["GROUP-ID"]], (i = {
                      default: /yes/i.test(s.attributes.DEFAULT)
                    }).default ? i.autoselect = !0 : i.autoselect = /yes/i.test(s.attributes.AUTOSELECT), s.attributes.LANGUAGE && (i.language = s.attributes.LANGUAGE), s.attributes.URI && (i.uri = s.attributes.URI), s.attributes["INSTREAM-ID"] && (i.instreamId = s.attributes["INSTREAM-ID"]), s.attributes.CHARACTERISTICS && (i.characteristics = s.attributes.CHARACTERISTICS), s.attributes.FORCED && (i.forced = /yes/i.test(s.attributes.FORCED)), t[s.attributes.NAME] = i
                  } else this.trigger("warn", {
                    message: "ignoring incomplete or missing media group"
                  })
                },
                discontinuity: function () {
                  d += 1, u.discontinuity = !0, this.manifest.discontinuityStarts.push(o.length)
                },
                "program-date-time": function () {
                  "undefined" == typeof this.manifest.dateTimeString && (this.manifest.dateTimeString = s.dateTimeString, this.manifest.dateTimeObject = s.dateTimeObject), u.dateTimeString = s.dateTimeString, u.dateTimeObject = s.dateTimeObject
                },
                targetduration: function () {
                  !isFinite(s.duration) || s.duration < 0 ? this.trigger("warn", {
                    message: "ignoring invalid target duration: " + s.duration
                  }) : (this.manifest.targetDuration = s.duration, ja.call(this, this.manifest))
                },
                start: function () {
                  s.attributes && !isNaN(s.attributes["TIME-OFFSET"]) ? this.manifest.start = {
                    timeOffset: s.attributes["TIME-OFFSET"],
                    precise: s.attributes.PRECISE
                  } : this.trigger("warn", {
                    message: "ignoring start declaration without appropriate attribute list"
                  })
                },
                "cue-out": function () {
                  u.cueOut = s.data
                },
                "cue-out-cont": function () {
                  u.cueOutCont = s.data
                },
                "cue-in": function () {
                  u.cueIn = s.data
                },
                skip: function () {
                  this.manifest.skip = Fa(s.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", s.attributes, ["SKIPPED-SEGMENTS"])
                },
                part: function () {
                  var i = this;
                  l = !0;
                  var e = this.manifest.segments.length,
                    t = Fa(s.attributes);
                  u.parts = u.parts || [], u.parts.push(t), t.byterange && (t.byterange.hasOwnProperty("offset") || (t.byterange.offset = p), p = t.byterange.offset + t.byterange.length);
                  var n = u.parts.length - 1;
                  this.warnOnMissingAttributes_("#EXT-X-PART #" + n + " for segment #" + e, s.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach(function (e, t) {
                    e.hasOwnProperty("lastPart") || i.trigger("warn", {
                      message: "#EXT-X-RENDITION-REPORT #" + t + " lacks required attribute(s): LAST-PART"
                    })
                  })
                },
                "server-control": function () {
                  var e = this.manifest.serverControl = Fa(s.attributes);
                  e.hasOwnProperty("canBlockReload") || (e.canBlockReload = !1, this.trigger("info", {
                    message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
                  })), ja.call(this, this.manifest), e.canSkipDateranges && !e.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                    message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
                  })
                },
                "preload-hint": function () {
                  var e = this.manifest.segments.length,
                    t = Fa(s.attributes),
                    i = t.type && "PART" === t.type;
                  u.preloadHints = u.preloadHints || [], u.preloadHints.push(t), t.byterange && (t.byterange.hasOwnProperty("offset") || (t.byterange.offset = i ? p : 0, i && (p = t.byterange.offset + t.byterange.length)));
                  var n = u.preloadHints.length - 1;
                  if (this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + n + " for segment #" + e, s.attributes, ["TYPE", "URI"]), t.type)
                    for (var r = 0; r < u.preloadHints.length - 1; r++) {
                      var a = u.preloadHints[r];
                      a.type && a.type === t.type && this.trigger("warn", {
                        message: "#EXT-X-PRELOAD-HINT #" + n + " for segment #" + e + " has the same TYPE " + t.type + " as preload hint #" + r
                      })
                    }
                },
                "rendition-report": function () {
                  var e = Fa(s.attributes);
                  this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(e);
                  var t = this.manifest.renditionReports.length - 1,
                    i = ["LAST-MSN", "URI"];
                  l && i.push("LAST-PART"), this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + t, s.attributes, i)
                },
                "part-inf": function () {
                  this.manifest.partInf = Fa(s.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", s.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), ja.call(this, this.manifest)
                }
              } [s.tagType] || function () {}).call(a)
            },
            uri: function () {
              u.uri = s.uri, o.push(u), !this.manifest.targetDuration || "duration" in u || (this.trigger("warn", {
                message: "defaulting segment duration to the target duration"
              }), u.duration = this.manifest.targetDuration), r && (u.key = r), u.timeline = d, n && (u.map = n), p = 0, u = {}
            },
            comment: function () {},
            custom: function () {
              s.segment ? (u.custom = u.custom || {}, u.custom[s.customType] = s.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[s.customType] = s.data)
            }
          })[s.type].call(a)
        }), e
      }
      La(e, t);
      var i = e.prototype;
      return i.warnOnMissingAttributes_ = function (e, t, i) {
        var n = [];
        i.forEach(function (e) {
          t.hasOwnProperty(e) || n.push(e)
        }), n.length && this.trigger("warn", {
          message: e + " lacks required attribute(s): " + n.join(", ")
        })
      }, i.push = function (e) {
        this.lineStream.push(e)
      }, i.end = function () {
        this.lineStream.push("\n"), this.trigger("end")
      }, i.addParser = function (e) {
        this.parseStream.addParser(e)
      }, i.addTagMapper = function (e) {
        this.parseStream.addTagMapper(e)
      }, e
    }(Oa),
    Ja = {
      mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
      webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
      ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
      video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
      audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
      text: /^(stpp.ttml.im1t)/,
      muxerVideo: /^(avc0?1)/,
      muxerAudio: /^(mp4a)/,
      muxerText: /a^/
    },
    Za = ["video", "audio", "text"],
    es = ["Video", "Audio", "Text"],
    ts = "mp4a.40.2",
    is = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i,
    ns = /^application\/dash\+xml/i,
    rs = "undefined" != typeof window ? window : "undefined" != typeof e ? e : "undefined" != typeof self ? self : {},
    as = {
      entityMap: {
        lt: "<",
        gt: ">",
        amp: "&",
        quot: '"',
        apos: "'",
        Agrave: "À",
        Aacute: "Á",
        Acirc: "Â",
        Atilde: "Ã",
        Auml: "Ä",
        Aring: "Å",
        AElig: "Æ",
        Ccedil: "Ç",
        Egrave: "È",
        Eacute: "É",
        Ecirc: "Ê",
        Euml: "Ë",
        Igrave: "Ì",
        Iacute: "Í",
        Icirc: "Î",
        Iuml: "Ï",
        ETH: "Ð",
        Ntilde: "Ñ",
        Ograve: "Ò",
        Oacute: "Ó",
        Ocirc: "Ô",
        Otilde: "Õ",
        Ouml: "Ö",
        Oslash: "Ø",
        Ugrave: "Ù",
        Uacute: "Ú",
        Ucirc: "Û",
        Uuml: "Ü",
        Yacute: "Ý",
        THORN: "Þ",
        szlig: "ß",
        agrave: "à",
        aacute: "á",
        acirc: "â",
        atilde: "ã",
        auml: "ä",
        aring: "å",
        aelig: "æ",
        ccedil: "ç",
        egrave: "è",
        eacute: "é",
        ecirc: "ê",
        euml: "ë",
        igrave: "ì",
        iacute: "í",
        icirc: "î",
        iuml: "ï",
        eth: "ð",
        ntilde: "ñ",
        ograve: "ò",
        oacute: "ó",
        ocirc: "ô",
        otilde: "õ",
        ouml: "ö",
        oslash: "ø",
        ugrave: "ù",
        uacute: "ú",
        ucirc: "û",
        uuml: "ü",
        yacute: "ý",
        thorn: "þ",
        yuml: "ÿ",
        nbsp: " ",
        iexcl: "¡",
        cent: "¢",
        pound: "£",
        curren: "¤",
        yen: "¥",
        brvbar: "¦",
        sect: "§",
        uml: "¨",
        copy: "©",
        ordf: "ª",
        laquo: "«",
        not: "¬",
        shy: "­­",
        reg: "®",
        macr: "¯",
        deg: "°",
        plusmn: "±",
        sup2: "²",
        sup3: "³",
        acute: "´",
        micro: "µ",
        para: "¶",
        middot: "·",
        cedil: "¸",
        sup1: "¹",
        ordm: "º",
        raquo: "»",
        frac14: "¼",
        frac12: "½",
        frac34: "¾",
        iquest: "¿",
        times: "×",
        divide: "÷",
        forall: "∀",
        part: "∂",
        exist: "∃",
        empty: "∅",
        nabla: "∇",
        isin: "∈",
        notin: "∉",
        ni: "∋",
        prod: "∏",
        sum: "∑",
        minus: "−",
        lowast: "∗",
        radic: "√",
        prop: "∝",
        infin: "∞",
        ang: "∠",
        and: "∧",
        or: "∨",
        cap: "∩",
        cup: "∪",
        int: "∫",
        there4: "∴",
        sim: "∼",
        cong: "≅",
        asymp: "≈",
        ne: "≠",
        equiv: "≡",
        le: "≤",
        ge: "≥",
        sub: "⊂",
        sup: "⊃",
        nsub: "⊄",
        sube: "⊆",
        supe: "⊇",
        oplus: "⊕",
        otimes: "⊗",
        perp: "⊥",
        sdot: "⋅",
        Alpha: "Α",
        Beta: "Β",
        Gamma: "Γ",
        Delta: "Δ",
        Epsilon: "Ε",
        Zeta: "Ζ",
        Eta: "Η",
        Theta: "Θ",
        Iota: "Ι",
        Kappa: "Κ",
        Lambda: "Λ",
        Mu: "Μ",
        Nu: "Ν",
        Xi: "Ξ",
        Omicron: "Ο",
        Pi: "Π",
        Rho: "Ρ",
        Sigma: "Σ",
        Tau: "Τ",
        Upsilon: "Υ",
        Phi: "Φ",
        Chi: "Χ",
        Psi: "Ψ",
        Omega: "Ω",
        alpha: "α",
        beta: "β",
        gamma: "γ",
        delta: "δ",
        epsilon: "ε",
        zeta: "ζ",
        eta: "η",
        theta: "θ",
        iota: "ι",
        kappa: "κ",
        lambda: "λ",
        mu: "μ",
        nu: "ν",
        xi: "ξ",
        omicron: "ο",
        pi: "π",
        rho: "ρ",
        sigmaf: "ς",
        sigma: "σ",
        tau: "τ",
        upsilon: "υ",
        phi: "φ",
        chi: "χ",
        psi: "ψ",
        omega: "ω",
        thetasym: "ϑ",
        upsih: "ϒ",
        piv: "ϖ",
        OElig: "Œ",
        oelig: "œ",
        Scaron: "Š",
        scaron: "š",
        Yuml: "Ÿ",
        fnof: "ƒ",
        circ: "ˆ",
        tilde: "˜",
        ensp: " ",
        emsp: " ",
        thinsp: " ",
        zwnj: "‌",
        zwj: "‍",
        lrm: "‎",
        rlm: "‏",
        ndash: "–",
        mdash: "—",
        lsquo: "‘",
        rsquo: "’",
        sbquo: "‚",
        ldquo: "“",
        rdquo: "”",
        bdquo: "„",
        dagger: "†",
        Dagger: "‡",
        bull: "•",
        hellip: "…",
        permil: "‰",
        prime: "′",
        Prime: "″",
        lsaquo: "‹",
        rsaquo: "›",
        oline: "‾",
        euro: "€",
        trade: "™",
        larr: "←",
        uarr: "↑",
        rarr: "→",
        darr: "↓",
        harr: "↔",
        crarr: "↵",
        lceil: "⌈",
        rceil: "⌉",
        lfloor: "⌊",
        rfloor: "⌋",
        loz: "◊",
        spades: "♠",
        clubs: "♣",
        hearts: "♥",
        diams: "♦"
      }
    },
    ss = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,
    os = new RegExp("[\\-\\.0-9" + ss.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"),
    us = new RegExp("^" + ss.source + os.source + "*(?::" + ss.source + os.source + "*)?$"),
    ls = 0,
    cs = 1,
    ds = 2,
    hs = 3,
    ps = 4,
    fs = 5,
    ms = 6,
    gs = 7;

  function vs(e, t) {
    this.message = e, this.locator = t, Error.captureStackTrace && Error.captureStackTrace(this, vs)
  }

  function ys() {}

  function _s(e, t) {
    return t.lineNumber = e.lineNumber, t.columnNumber = e.columnNumber, t
  }

  function bs(e, t, n, i, r, a) {
    function s(e, t, i) {
      e in n.attributeNames && a.fatalError("Attribute " + e + " redefined"), n.addValue(e, t, i)
    }
    for (var o, u = ++t, l = ls;;) {
      var c = e.charAt(u);
      switch (c) {
        case "=":
          if (l === cs) o = e.slice(t, u), l = hs;
          else {
            if (l !== ds) throw new Error("attribute equal must after attrName");
            l = hs
          }
          break;
        case "'":
        case '"':
          if (l === hs || l === cs) {
            if (l === cs && (a.warning('attribute value must after "="'), o = e.slice(t, u)), t = u + 1, !(0 < (u = e.indexOf(c, t)))) throw new Error("attribute value no end '" + c + "' match");
            s(o, d = e.slice(t, u).replace(/&#?\w+;/g, r), t - 1), l = fs
          } else {
            if (l != ps) throw new Error('attribute value must after "="');
            s(o, d = e.slice(t, u).replace(/&#?\w+;/g, r), t), a.warning('attribute "' + o + '" missed start quot(' + c + ")!!"), t = u + 1, l = fs
          }
          break;
        case "/":
          switch (l) {
            case ls:
              n.setTagName(e.slice(t, u));
            case fs:
            case ms:
            case gs:
              l = gs, n.closed = !0;
            case ps:
            case cs:
            case ds:
              break;
            default:
              throw new Error("attribute invalid close char('/')")
          }
          break;
        case "":
          return a.error("unexpected end of input"), l == ls && n.setTagName(e.slice(t, u)), u;
        case ">":
          switch (l) {
            case ls:
              n.setTagName(e.slice(t, u));
            case fs:
            case ms:
            case gs:
              break;
            case ps:
            case cs:
              "/" === (d = e.slice(t, u)).slice(-1) && (n.closed = !0, d = d.slice(0, -1));
            case ds:
              l === ds && (d = o), l == ps ? (a.warning('attribute "' + d + '" missed quot(")!'), s(o, d.replace(/&#?\w+;/g, r), t)) : ("http://www.w3.org/1999/xhtml" === i[""] && d.match(/^(?:disabled|checked|selected)$/i) || a.warning('attribute "' + d + '" missed value!! "' + d + '" instead!!'), s(d, d, t));
              break;
            case hs:
              throw new Error("attribute value missed!!")
          }
          return u;
        case "":
          c = " ";
        default:
          if (c <= " ") switch (l) {
            case ls:
              n.setTagName(e.slice(t, u)), l = ms;
              break;
            case cs:
              o = e.slice(t, u), l = ds;
              break;
            case ps:
              var d = e.slice(t, u).replace(/&#?\w+;/g, r);
              a.warning('attribute "' + d + '" missed quot(")!!'), s(o, d, t);
            case fs:
              l = ms
          } else switch (l) {
            case ds:
              n.tagName;
              "http://www.w3.org/1999/xhtml" === i[""] && o.match(/^(?:disabled|checked|selected)$/i) || a.warning('attribute "' + o + '" missed value!! "' + o + '" instead2!!'), s(o, o, t), t = u, l = cs;
              break;
            case fs:
              a.warning('attribute space is required"' + o + '"!!');
            case ms:
              l = cs, t = u;
              break;
            case hs:
              l = ps, t = u;
              break;
            case gs:
              throw new Error("elements closed character '/' and '>' must be connected to")
          }
      }
      u++
    }
  }

  function Ts(e, t, i) {
    for (var n = e.tagName, r = null, a = e.length; a--;) {
      var s = e[a],
        o = s.qName,
        u = s.value;
      if (0 < (h = o.indexOf(":"))) var l = s.prefix = o.slice(0, h),
        c = o.slice(h + 1),
        d = "xmlns" === l && c;
      else l = null, d = "xmlns" === (c = o) && "";
      s.localName = c, !1 !== d && (null == r && (r = {}, ks(i, i = {})), i[d] = r[d] = u, s.uri = "http://www.w3.org/2000/xmlns/", t.startPrefixMapping(d, u))
    }
    for (a = e.length; a--;) {
      (l = (s = e[a]).prefix) && ("xml" === l && (s.uri = "http://www.w3.org/XML/1998/namespace"), "xmlns" !== l && (s.uri = i[l || ""]))
    }
    var h;
    c = 0 < (h = n.indexOf(":")) ? (l = e.prefix = n.slice(0, h), e.localName = n.slice(h + 1)) : (l = null, e.localName = n);
    var p = e.uri = i[l || ""];
    if (t.startElement(p, c, n, e), !e.closed) return e.currentNSMap = i, e.localNSMap = r, !0;
    if (t.endElement(p, c, n), r)
      for (l in r) t.endPrefixMapping(l)
  }

  function Ss(e, t, i, n, r) {
    if (/^(?:script|textarea)$/i.test(i)) {
      var a = e.indexOf("</" + i + ">", t),
        s = e.substring(t + 1, a);
      if (/[&<]/.test(s)) return /^script$/i.test(i) || (s = s.replace(/&#?\w+;/g, n)), r.characters(s, 0, s.length), a
    }
    return t + 1
  }

  function Es(e, t, i, n) {
    var r = n[i];
    return null == r && ((r = e.lastIndexOf("</" + i + ">")) < t && (r = e.lastIndexOf("</" + i)), n[i] = r), r < t
  }

  function ks(e, t) {
    for (var i in e) t[i] = e[i]
  }

  function ws(e, t, i, n) {
    switch (e.charAt(t + 2)) {
      case "-":
        return "-" !== e.charAt(t + 3) ? -1 : t < (r = e.indexOf("--\x3e", t + 4)) ? (i.comment(e, t + 4, r - t - 4), r + 3) : (n.error("Unclosed comment"), -1);
      default:
        if ("CDATA[" == e.substr(t + 3, 6)) {
          var r = e.indexOf("]]>", t + 9);
          return i.startCDATA(), i.characters(e, t + 9, r - t - 9), i.endCDATA(), r + 3
        }
        var a = function (e, t) {
            var i, n = [],
              r = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
            r.lastIndex = t, r.exec(e);
            for (; i = r.exec(e);)
              if (n.push(i), i[1]) return n
          }(e, t),
          s = a.length;
        if (1 < s && /!doctype/i.test(a[0][0])) {
          var o = a[1][0],
            u = !1,
            l = !1;
          3 < s && (/^public$/i.test(a[2][0]) ? (u = a[3][0], l = 4 < s && a[4][0]) : /^system$/i.test(a[2][0]) && (l = a[3][0]));
          var c = a[s - 1];
          return i.startDTD(o, u, l), i.endDTD(), c.index + c[0].length
        }
    }
    return -1
  }

  function Cs(e, t, i) {
    var n = e.indexOf("?>", t);
    if (n) {
      var r = e.substring(t, n).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
      if (r) {
        r[0].length;
        return i.processingInstruction(r[1], r[2]), n + 2
      }
      return -1
    }
    return -1
  }

  function Is() {
    this.attributeNames = {}
  }(vs.prototype = new Error).name = vs.name, ys.prototype = {
    parse: function (e, t, i) {
      var n = this.domBuilder;
      n.startDocument(), ks(t, t = {}),
        function (i, e, n, r, a) {
          function s(e) {
            var t = e.slice(1, -1);
            return t in n ? n[t] : "#" === t.charAt(0) ? function (e) {
              if (65535 < e) {
                var t = 55296 + ((e -= 65536) >> 10),
                  i = 56320 + (1023 & e);
                return String.fromCharCode(t, i)
              }
              return String.fromCharCode(e)
            }(parseInt(t.substr(1).replace("x", "0x"))) : (a.error("entity not found:" + e), e)
          }

          function t(e) {
            if (f < e) {
              var t = i.substring(f, e).replace(/&#?\w+;/g, s);
              d && o(f), r.characters(t, 0, e - f), f = e
            }
          }

          function o(e, t) {
            for (; l <= e && (t = c.exec(i));) u = t.index, l = u + t[0].length, d.lineNumber++;
            d.columnNumber = e - u + 1
          }
          var u = 0,
            l = 0,
            c = /.*(?:\r\n?|\n)|.*$/g,
            d = r.locator,
            h = [{
              currentNSMap: e
            }],
            p = {},
            f = 0;
          for (;;) {
            try {
              var m = i.indexOf("<", f);
              if (m < 0) {
                if (!i.substr(f).match(/^\s*$/)) {
                  var g = r.doc,
                    v = g.createTextNode(i.substr(f));
                  g.appendChild(v), r.currentElement = v
                }
                return
              }
              switch (f < m && t(m), i.charAt(m + 1)) {
                case "/":
                  var y = i.indexOf(">", m + 3),
                    _ = i.substring(m + 2, y),
                    b = h.pop();
                  y < 0 ? (_ = i.substring(m + 2).replace(/[\s<].*/, ""), a.error("end tag name: " + _ + " is not complete:" + b.tagName), y = m + 1 + _.length) : _.match(/\s</) && (_ = _.replace(/[\s<].*/, ""), a.error("end tag name: " + _ + " maybe not complete"), y = m + 1 + _.length);
                  var T = b.localNSMap,
                    S = b.tagName == _;
                  if (S || b.tagName && b.tagName.toLowerCase() == _.toLowerCase()) {
                    if (r.endElement(b.uri, b.localName, _), T)
                      for (var E in T) r.endPrefixMapping(E);
                    S || a.fatalError("end tag name: " + _ + " is not match the current start tagName:" + b.tagName)
                  } else h.push(b);
                  y++;
                  break;
                case "?":
                  d && o(m), y = Cs(i, m, r);
                  break;
                case "!":
                  d && o(m), y = ws(i, m, r, a);
                  break;
                default:
                  d && o(m);
                  var k = new Is,
                    w = h[h.length - 1].currentNSMap,
                    C = (y = bs(i, m, k, w, s, a), k.length);
                  if (!k.closed && Es(i, y, k.tagName, p) && (k.closed = !0, n.nbsp || a.warning("unclosed xml attribute")), d && C) {
                    for (var I = _s(d, {}), x = 0; x < C; x++) {
                      var A = k[x];
                      o(A.offset), A.locator = _s(d, {})
                    }
                    r.locator = I, Ts(k, r, w) && h.push(k), r.locator = d
                  } else Ts(k, r, w) && h.push(k);
                  "http://www.w3.org/1999/xhtml" !== k.uri || k.closed ? y++ : y = Ss(i, y, k.tagName, s, r)
              }
            } catch (e) {
              if (e instanceof vs) throw e;
              a.error("element parse error: " + e), y = -1
            }
            f < y ? f = y : t(Math.max(m, f) + 1)
          }
        }(e, t, i, n, this.errorHandler), n.endDocument()
    }
  }, Is.prototype = {
    setTagName: function (e) {
      if (!us.test(e)) throw new Error("invalid tagName:" + e);
      this.tagName = e
    },
    addValue: function (e, t, i) {
      if (!us.test(e)) throw new Error("invalid attribute:" + e);
      this.attributeNames[e] = this.length, this[this.length++] = {
        qName: e,
        value: t,
        offset: i
      }
    },
    length: 0,
    getLocalName: function (e) {
      return this[e].localName
    },
    getLocator: function (e) {
      return this[e].locator
    },
    getQName: function (e) {
      return this[e].qName
    },
    getURI: function (e) {
      return this[e].uri
    },
    getValue: function (e) {
      return this[e].value
    }
  };
  var xs = {
    XMLReader: ys,
    ParseError: vs
  };

  function As(e, t) {
    for (var i in e) t[i] = e[i]
  }

  function Ps(e, t) {
    var i = e.prototype;
    if (!(i instanceof t)) {
      var n = function () {};
      n.prototype = t.prototype, As(i, n = new n), e.prototype = i = n
    }
    i.constructor != e && (i.constructor = e)
  }
  var Ls = "http://www.w3.org/1999/xhtml",
    Os = {},
    Ds = Os.ELEMENT_NODE = 1,
    Rs = Os.ATTRIBUTE_NODE = 2,
    Ms = Os.TEXT_NODE = 3,
    Ns = Os.CDATA_SECTION_NODE = 4,
    Us = Os.ENTITY_REFERENCE_NODE = 5,
    Bs = Os.ENTITY_NODE = 6,
    Fs = Os.PROCESSING_INSTRUCTION_NODE = 7,
    js = Os.COMMENT_NODE = 8,
    Hs = Os.DOCUMENT_NODE = 9,
    Vs = Os.DOCUMENT_TYPE_NODE = 10,
    qs = Os.DOCUMENT_FRAGMENT_NODE = 11,
    Ws = Os.NOTATION_NODE = 12,
    zs = {},
    Gs = {},
    Xs = (zs.INDEX_SIZE_ERR = (Gs[1] = "Index size error", 1), zs.DOMSTRING_SIZE_ERR = (Gs[2] = "DOMString size error", 2), zs.HIERARCHY_REQUEST_ERR = (Gs[3] = "Hierarchy request error", 3)),
    Ks = (zs.WRONG_DOCUMENT_ERR = (Gs[4] = "Wrong document", 4), zs.INVALID_CHARACTER_ERR = (Gs[5] = "Invalid character", 5), zs.NO_DATA_ALLOWED_ERR = (Gs[6] = "No data allowed", 6), zs.NO_MODIFICATION_ALLOWED_ERR = (Gs[7] = "No modification allowed", 7), zs.NOT_FOUND_ERR = (Gs[8] = "Not found", 8)),
    Ys = (zs.NOT_SUPPORTED_ERR = (Gs[9] = "Not supported", 9), zs.INUSE_ATTRIBUTE_ERR = (Gs[10] = "Attribute in use", 10));
  zs.INVALID_STATE_ERR = (Gs[11] = "Invalid state", 11), zs.SYNTAX_ERR = (Gs[12] = "Syntax error", 12), zs.INVALID_MODIFICATION_ERR = (Gs[13] = "Invalid modification", 13), zs.NAMESPACE_ERR = (Gs[14] = "Invalid namespace", 14), zs.INVALID_ACCESS_ERR = (Gs[15] = "Invalid access", 15);

  function Qs(e, t) {
    if (t instanceof Error) var i = t;
    else i = this, Error.call(this, Gs[e]), this.message = Gs[e], Error.captureStackTrace && Error.captureStackTrace(this, Qs);
    return i.code = e, t && (this.message = this.message + ": " + t), i
  }

  function $s() {}

  function Js(e, t) {
    this._node = e, this._refresh = t, Zs(this)
  }

  function Zs(e) {
    var t = e._node._inc || e._node.ownerDocument._inc;
    if (e._inc != t) {
      var i = e._refresh(e._node);
      Po(e, "length", i.length), As(i, e), e._inc = t
    }
  }

  function eo() {}

  function to(e, t) {
    for (var i = e.length; i--;)
      if (e[i] === t) return i
  }

  function io(e, t, i, n) {
    if (n ? t[to(t, n)] = i : t[t.length++] = i, e) {
      var r = (i.ownerElement = e).ownerDocument;
      r && (n && lo(r, e, n), function (e, t, i) {
        e && e._inc++, "http://www.w3.org/2000/xmlns/" == i.namespaceURI && (t._nsMap[i.prefix ? i.localName : ""] = i.value)
      }(r, e, i))
    }
  }

  function no(e, t, i) {
    var n = to(t, i);
    if (!(0 <= n)) throw Qs(Ks, new Error(e.tagName + "@" + i));
    for (var r = t.length - 1; n < r;) t[n] = t[++n];
    if (t.length = r, e) {
      var a = e.ownerDocument;
      a && (lo(a, e, i), i.ownerElement = null)
    }
  }

  function ro(e) {
    if (this._features = {}, e)
      for (var t in e) this._features = e[t]
  }

  function ao() {}

  function so(e) {
    return ("<" == e ? "&lt;" : ">" == e && "&gt;") || "&" == e && "&amp;" || '"' == e && "&quot;" || "&#" + e.charCodeAt() + ";"
  }

  function oo(e, t) {
    if (t(e)) return !0;
    if (e = e.firstChild)
      do {
        if (oo(e, t)) return !0
      } while (e = e.nextSibling)
  }

  function uo() {}

  function lo(e, t, i) {
    e && e._inc++, "http://www.w3.org/2000/xmlns/" == i.namespaceURI && delete t._nsMap[i.prefix ? i.localName : ""]
  }

  function co(e, t, i) {
    if (e && e._inc) {
      e._inc++;
      var n = t.childNodes;
      if (i) n[n.length++] = i;
      else {
        for (var r = t.firstChild, a = 0; r;) r = (n[a++] = r).nextSibling;
        n.length = a
      }
    }
  }

  function ho(e, t) {
    var i = t.previousSibling,
      n = t.nextSibling;
    return i ? i.nextSibling = n : e.firstChild = n, n ? n.previousSibling = i : e.lastChild = i, co(e.ownerDocument, e), t
  }

  function po(e, t, i) {
    var n = t.parentNode;
    if (n && n.removeChild(t), t.nodeType === qs) {
      var r = t.firstChild;
      if (null == r) return t;
      var a = t.lastChild
    } else r = a = t;
    var s = i ? i.previousSibling : e.lastChild;
    for (r.previousSibling = s, a.nextSibling = i, s ? s.nextSibling = r : e.firstChild = r, null == i ? e.lastChild = a : i.previousSibling = a; r.parentNode = e, r !== a && (r = r.nextSibling););
    return co(e.ownerDocument || e, e), t.nodeType == qs && (t.firstChild = t.lastChild = null), t
  }

  function fo() {
    this._nsMap = {}
  }

  function mo() {}

  function go() {}

  function vo() {}

  function yo() {}

  function _o() {}

  function bo() {}

  function To() {}

  function So() {}

  function Eo() {}

  function ko() {}

  function wo() {}

  function Co() {}

  function Io(e, t) {
    var i = [],
      n = 9 == this.nodeType && this.documentElement || this,
      r = n.prefix,
      a = n.namespaceURI;
    if (a && null == r && null == (r = n.lookupPrefix(a))) var s = [{
      namespace: a,
      prefix: null
    }];
    return Ao(this, i, e, t, s), i.join("")
  }

  function xo(e, t, i) {
    var n = e.prefix || "",
      r = e.namespaceURI;
    if (!n && !r) return !1;
    if ("xml" === n && "http://www.w3.org/XML/1998/namespace" === r || "http://www.w3.org/2000/xmlns/" == r) return !1;
    for (var a = i.length; a--;) {
      var s = i[a];
      if (s.prefix == n) return s.namespace != r
    }
    return !0
  }

  function Ao(e, t, i, n, r) {
    if (n) {
      if (!(e = n(e))) return;
      if ("string" == typeof e) return void t.push(e)
    }
    switch (e.nodeType) {
      case Ds:
        r = r || [];
        var a = e.attributes,
          s = a.length,
          o = e.firstChild,
          u = e.tagName;
        i = Ls === e.namespaceURI || i, t.push("<", u);
        for (var l = 0; l < s; l++) {
          "xmlns" == (c = a.item(l)).prefix ? r.push({
            prefix: c.localName,
            namespace: c.value
          }) : "xmlns" == c.nodeName && r.push({
            prefix: "",
            namespace: c.value
          })
        }
        for (l = 0; l < s; l++) {
          var c;
          if (xo(c = a.item(l), 0, r)) {
            var d = c.prefix || "",
              h = c.namespaceURI,
              p = d ? " xmlns:" + d : " xmlns";
            t.push(p, '="', h, '"'), r.push({
              prefix: d,
              namespace: h
            })
          }
          Ao(c, t, i, n, r)
        }
        if (xo(e, 0, r)) {
          d = e.prefix || "", h = e.namespaceURI, p = d ? " xmlns:" + d : " xmlns";
          t.push(p, '="', h, '"'), r.push({
            prefix: d,
            namespace: h
          })
        }
        if (o || i && !/^(?:meta|link|img|br|hr|input)$/i.test(u)) {
          if (t.push(">"), i && /^script$/i.test(u))
            for (; o;) o.data ? t.push(o.data) : Ao(o, t, i, n, r), o = o.nextSibling;
          else
            for (; o;) Ao(o, t, i, n, r), o = o.nextSibling;
          t.push("</", u, ">")
        } else t.push("/>");
        return;
      case Hs:
      case qs:
        for (o = e.firstChild; o;) Ao(o, t, i, n, r), o = o.nextSibling;
        return;
      case Rs:
        return t.push(" ", e.name, '="', e.value.replace(/[&"]/g, so), '"');
      case Ms:
        return t.push(e.data.replace(/[<&]/g, so).replace(/]]>/g, "]]&gt;"));
      case Ns:
        return t.push("<![CDATA[", e.data, "]]>");
      case js:
        return t.push("\x3c!--", e.data, "--\x3e");
      case Vs:
        var f = e.publicId,
          m = e.systemId;
        if (t.push("<!DOCTYPE ", e.name), f) t.push(" PUBLIC ", f), m && "." != m && t.push(" ", m), t.push(">");
        else if (m && "." != m) t.push(" SYSTEM ", m, ">");
        else {
          var g = e.internalSubset;
          g && t.push(" [", g, "]"), t.push(">")
        }
        return;
      case Fs:
        return t.push("<?", e.target, " ", e.data, "?>");
      case Us:
        return t.push("&", e.nodeName, ";");
      default:
        t.push("??", e.nodeName)
    }
  }

  function Po(e, t, i) {
    e[t] = i
  }
  Qs.prototype = Error.prototype, As(zs, Qs), $s.prototype = {
    length: 0,
    item: function (e) {
      return this[e] || null
    },
    toString: function (e, t) {
      for (var i = [], n = 0; n < this.length; n++) Ao(this[n], i, e, t);
      return i.join("")
    }
  }, Js.prototype.item = function (e) {
    return Zs(this), this[e]
  }, Ps(Js, $s), eo.prototype = {
    length: 0,
    item: $s.prototype.item,
    getNamedItem: function (e) {
      for (var t = this.length; t--;) {
        var i = this[t];
        if (i.nodeName == e) return i
      }
    },
    setNamedItem: function (e) {
      var t = e.ownerElement;
      if (t && t != this._ownerElement) throw new Qs(Ys);
      var i = this.getNamedItem(e.nodeName);
      return io(this._ownerElement, this, e, i), i
    },
    setNamedItemNS: function (e) {
      var t, i = e.ownerElement;
      if (i && i != this._ownerElement) throw new Qs(Ys);
      return t = this.getNamedItemNS(e.namespaceURI, e.localName), io(this._ownerElement, this, e, t), t
    },
    removeNamedItem: function (e) {
      var t = this.getNamedItem(e);
      return no(this._ownerElement, this, t), t
    },
    removeNamedItemNS: function (e, t) {
      var i = this.getNamedItemNS(e, t);
      return no(this._ownerElement, this, i), i
    },
    getNamedItemNS: function (e, t) {
      for (var i = this.length; i--;) {
        var n = this[i];
        if (n.localName == t && n.namespaceURI == e) return n
      }
      return null
    }
  }, ro.prototype = {
    hasFeature: function (e, t) {
      var i = this._features[e.toLowerCase()];
      return !(!i || t && !(t in i))
    },
    createDocument: function (e, t, i) {
      var n = new uo;
      if (n.implementation = this, n.childNodes = new $s, (n.doctype = i) && n.appendChild(i), t) {
        var r = n.createElementNS(e, t);
        n.appendChild(r)
      }
      return n
    },
    createDocumentType: function (e, t, i) {
      var n = new bo;
      return n.name = e, n.nodeName = e, n.publicId = t, n.systemId = i, n
    }
  }, ao.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    insertBefore: function (e, t) {
      return po(this, e, t)
    },
    replaceChild: function (e, t) {
      this.insertBefore(e, t), t && this.removeChild(t)
    },
    removeChild: function (e) {
      return ho(this, e)
    },
    appendChild: function (e) {
      return this.insertBefore(e, null)
    },
    hasChildNodes: function () {
      return null != this.firstChild
    },
    cloneNode: function (e) {
      return function e(t, i, n) {
        var r = new i.constructor;
        for (var a in i) {
          var s = i[a];
          "object" != typeof s && s != r[a] && (r[a] = s)
        }
        i.childNodes && (r.childNodes = new $s);
        r.ownerDocument = t;
        switch (r.nodeType) {
          case Ds:
            var o = i.attributes,
              u = r.attributes = new eo,
              l = o.length;
            u._ownerElement = r;
            for (var c = 0; c < l; c++) r.setAttributeNode(e(t, o.item(c), !0));
            break;
          case Rs:
            n = !0
        }
        if (n)
          for (var d = i.firstChild; d;) r.appendChild(e(t, d, n)), d = d.nextSibling;
        return r
      }(this.ownerDocument || this, this, e)
    },
    normalize: function () {
      for (var e = this.firstChild; e;) {
        var t = e.nextSibling;
        t && t.nodeType == Ms && e.nodeType == Ms ? (this.removeChild(t), e.appendData(t.data)) : (e.normalize(), e = t)
      }
    },
    isSupported: function (e, t) {
      return this.ownerDocument.implementation.hasFeature(e, t)
    },
    hasAttributes: function () {
      return 0 < this.attributes.length
    },
    lookupPrefix: function (e) {
      for (var t = this; t;) {
        var i = t._nsMap;
        if (i)
          for (var n in i)
            if (i[n] == e) return n;
        t = t.nodeType == Rs ? t.ownerDocument : t.parentNode
      }
      return null
    },
    lookupNamespaceURI: function (e) {
      for (var t = this; t;) {
        var i = t._nsMap;
        if (i && e in i) return i[e];
        t = t.nodeType == Rs ? t.ownerDocument : t.parentNode
      }
      return null
    },
    isDefaultNamespace: function (e) {
      return null == this.lookupPrefix(e)
    }
  }, As(Os, ao), As(Os, ao.prototype), uo.prototype = {
    nodeName: "#document",
    nodeType: Hs,
    doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function (e, t) {
      if (e.nodeType != qs) return null == this.documentElement && e.nodeType == Ds && (this.documentElement = e), po(this, e, t), e.ownerDocument = this, e;
      for (var i = e.firstChild; i;) {
        var n = i.nextSibling;
        this.insertBefore(i, t), i = n
      }
      return e
    },
    removeChild: function (e) {
      return this.documentElement == e && (this.documentElement = null), ho(this, e)
    },
    importNode: function (e, t) {
      return function e(t, i, n) {
        var r;
        switch (i.nodeType) {
          case Ds:
            (r = i.cloneNode(!1)).ownerDocument = t;
          case qs:
            break;
          case Rs:
            n = !0
        }
        r = r || i.cloneNode(!1);
        r.ownerDocument = t;
        r.parentNode = null;
        if (n)
          for (var a = i.firstChild; a;) r.appendChild(e(t, a, n)), a = a.nextSibling;
        return r
      }(this, e, t)
    },
    getElementById: function (t) {
      var i = null;
      return oo(this.documentElement, function (e) {
        if (e.nodeType == Ds && e.getAttribute("id") == t) return i = e, !0
      }), i
    },
    getElementsByClassName: function (e) {
      var n = new RegExp("(^|\\s)" + e + "(\\s|$)");
      return new Js(this, function (t) {
        var i = [];
        return oo(t.documentElement, function (e) {
          e !== t && e.nodeType == Ds && n.test(e.getAttribute("class")) && i.push(e)
        }), i
      })
    },
    createElement: function (e) {
      var t = new fo;
      return t.ownerDocument = this, t.nodeName = e, t.tagName = e, t.childNodes = new $s, (t.attributes = new eo)._ownerElement = t
    },
    createDocumentFragment: function () {
      var e = new ko;
      return e.ownerDocument = this, e.childNodes = new $s, e
    },
    createTextNode: function (e) {
      var t = new vo;
      return t.ownerDocument = this, t.appendData(e), t
    },
    createComment: function (e) {
      var t = new yo;
      return t.ownerDocument = this, t.appendData(e), t
    },
    createCDATASection: function (e) {
      var t = new _o;
      return t.ownerDocument = this, t.appendData(e), t
    },
    createProcessingInstruction: function (e, t) {
      var i = new wo;
      return i.ownerDocument = this, i.tagName = i.target = e, i.nodeValue = i.data = t, i
    },
    createAttribute: function (e) {
      var t = new mo;
      return t.ownerDocument = this, t.name = e, t.nodeName = e, t.localName = e, t.specified = !0, t
    },
    createEntityReference: function (e) {
      var t = new Eo;
      return t.ownerDocument = this, t.nodeName = e, t
    },
    createElementNS: function (e, t) {
      var i = new fo,
        n = t.split(":"),
        r = i.attributes = new eo;
      return i.childNodes = new $s, i.ownerDocument = this, i.nodeName = t, i.tagName = t, i.namespaceURI = e, 2 == n.length ? (i.prefix = n[0], i.localName = n[1]) : i.localName = t, r._ownerElement = i
    },
    createAttributeNS: function (e, t) {
      var i = new mo,
        n = t.split(":");
      return i.ownerDocument = this, i.nodeName = t, i.name = t, i.namespaceURI = e, i.specified = !0, 2 == n.length ? (i.prefix = n[0], i.localName = n[1]) : i.localName = t, i
    }
  }, Ps(uo, ao), uo.prototype.getElementsByTagName = (fo.prototype = {
    nodeType: Ds,
    hasAttribute: function (e) {
      return null != this.getAttributeNode(e)
    },
    getAttribute: function (e) {
      var t = this.getAttributeNode(e);
      return t && t.value || ""
    },
    getAttributeNode: function (e) {
      return this.attributes.getNamedItem(e)
    },
    setAttribute: function (e, t) {
      var i = this.ownerDocument.createAttribute(e);
      i.value = i.nodeValue = "" + t, this.setAttributeNode(i)
    },
    removeAttribute: function (e) {
      var t = this.getAttributeNode(e);
      t && this.removeAttributeNode(t)
    },
    appendChild: function (e) {
      return e.nodeType === qs ? this.insertBefore(e, null) : function (e, t) {
        var i = t.parentNode;
        if (i) {
          var n = e.lastChild;
          i.removeChild(t);
          n = e.lastChild
        }
        return n = e.lastChild, t.parentNode = e, t.previousSibling = n, t.nextSibling = null, n ? n.nextSibling = t : e.firstChild = t, e.lastChild = t, co(e.ownerDocument, e, t), t
      }(this, e)
    },
    setAttributeNode: function (e) {
      return this.attributes.setNamedItem(e)
    },
    setAttributeNodeNS: function (e) {
      return this.attributes.setNamedItemNS(e)
    },
    removeAttributeNode: function (e) {
      return this.attributes.removeNamedItem(e.nodeName)
    },
    removeAttributeNS: function (e, t) {
      var i = this.getAttributeNodeNS(e, t);
      i && this.removeAttributeNode(i)
    },
    hasAttributeNS: function (e, t) {
      return null != this.getAttributeNodeNS(e, t)
    },
    getAttributeNS: function (e, t) {
      var i = this.getAttributeNodeNS(e, t);
      return i && i.value || ""
    },
    setAttributeNS: function (e, t, i) {
      var n = this.ownerDocument.createAttributeNS(e, t);
      n.value = n.nodeValue = "" + i, this.setAttributeNode(n)
    },
    getAttributeNodeNS: function (e, t) {
      return this.attributes.getNamedItemNS(e, t)
    },
    getElementsByTagName: function (n) {
      return new Js(this, function (t) {
        var i = [];
        return oo(t, function (e) {
          e === t || e.nodeType != Ds || "*" !== n && e.tagName != n || i.push(e)
        }), i
      })
    },
    getElementsByTagNameNS: function (n, r) {
      return new Js(this, function (t) {
        var i = [];
        return oo(t, function (e) {
          e === t || e.nodeType !== Ds || "*" !== n && e.namespaceURI !== n || "*" !== r && e.localName != r || i.push(e)
        }), i
      })
    }
  }).getElementsByTagName, uo.prototype.getElementsByTagNameNS = fo.prototype.getElementsByTagNameNS, Ps(fo, ao), mo.prototype.nodeType = Rs, Ps(mo, ao), go.prototype = {
    data: "",
    substringData: function (e, t) {
      return this.data.substring(e, e + t)
    },
    appendData: function (e) {
      e = this.data + e, this.nodeValue = this.data = e, this.length = e.length
    },
    insertData: function (e, t) {
      this.replaceData(e, 0, t)
    },
    appendChild: function (e) {
      throw new Error(Gs[Xs])
    },
    deleteData: function (e, t) {
      this.replaceData(e, t, "")
    },
    replaceData: function (e, t, i) {
      i = this.data.substring(0, e) + i + this.data.substring(e + t), this.nodeValue = this.data = i, this.length = i.length
    }
  }, Ps(go, ao), vo.prototype = {
    nodeName: "#text",
    nodeType: Ms,
    splitText: function (e) {
      var t = this.data,
        i = t.substring(e);
      t = t.substring(0, e), this.data = this.nodeValue = t, this.length = t.length;
      var n = this.ownerDocument.createTextNode(i);
      return this.parentNode && this.parentNode.insertBefore(n, this.nextSibling), n
    }
  }, Ps(vo, go), yo.prototype = {
    nodeName: "#comment",
    nodeType: js
  }, Ps(yo, go), _o.prototype = {
    nodeName: "#cdata-section",
    nodeType: Ns
  }, Ps(_o, go), bo.prototype.nodeType = Vs, Ps(bo, ao), To.prototype.nodeType = Ws, Ps(To, ao), So.prototype.nodeType = Bs, Ps(So, ao), Eo.prototype.nodeType = Us, Ps(Eo, ao), ko.prototype.nodeName = "#document-fragment", ko.prototype.nodeType = qs, Ps(ko, ao), wo.prototype.nodeType = Fs, Ps(wo, ao), Co.prototype.serializeToString = function (e, t, i) {
    return Io.call(e, t, i)
  }, ao.prototype.toString = Io;
  try {
    if (Object.defineProperty) {
      Object.defineProperty(Js.prototype, "length", {
        get: function () {
          return Zs(this), this.$$length
        }
      }), Object.defineProperty(ao.prototype, "textContent", {
        get: function () {
          return function e(t) {
            switch (t.nodeType) {
              case Ds:
              case qs:
                var i = [];
                for (t = t.firstChild; t;) 7 !== t.nodeType && 8 !== t.nodeType && i.push(e(t)), t = t.nextSibling;
                return i.join("");
              default:
                return t.nodeValue
            }
          }(this)
        },
        set: function (e) {
          switch (this.nodeType) {
            case Ds:
            case qs:
              for (; this.firstChild;) this.removeChild(this.firstChild);
              (e || String(e)) && this.appendChild(this.ownerDocument.createTextNode(e));
              break;
            default:
              this.data = e, this.value = e, this.nodeValue = e
          }
        }
      }), Po = function (e, t, i) {
        e["$$" + t] = i
      }
    }
  } catch (e) {}

  function Lo(e) {
    return !!e && "object" == typeof e
  }

  function Oo() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
    return t.reduce(function (t, i) {
      return "object" != typeof i || Object.keys(i).forEach(function (e) {
        Array.isArray(t[e]) && Array.isArray(i[e]) ? t[e] = t[e].concat(i[e]) : Lo(t[e]) && Lo(i[e]) ? t[e] = Oo(t[e], i[e]) : t[e] = i[e]
      }), t
    }, {})
  }

  function Do(e) {
    return e.reduce(function (e, t) {
      return e.concat(t)
    }, [])
  }

  function Ro(e) {
    if (!e.length) return [];
    for (var t = [], i = 0; i < e.length; i++) t.push(e[i]);
    return t
  }

  function Mo(e) {
    var t = e.baseUrl,
      i = void 0 === t ? "" : t,
      n = e.source,
      r = void 0 === n ? "" : n,
      a = e.range,
      s = void 0 === a ? "" : a,
      o = e.indexRange,
      u = void 0 === o ? "" : o,
      l = {
        uri: r,
        resolvedUri: Ea(i || "", r)
      };
    if (s || u) {
      var c = (s || u).split("-"),
        d = parseInt(c[0], 10),
        h = parseInt(c[1], 10);
      l.byterange = {
        length: h - d + 1,
        offset: d
      }
    }
    return l
  }

  function No(e) {
    return e && "number" != typeof e && (e = parseInt(e, 10)), isNaN(e) ? null : e
  }

  function Uo(e) {
    var t = e.type,
      i = void 0 === t ? "static" : t,
      n = e.duration,
      r = e.timescale,
      a = void 0 === r ? 1 : r,
      s = e.sourceDuration,
      o = Ou[i](e),
      u = function (e, t) {
        for (var i = [], n = e; n < t; n++) i.push(n);
        return i
      }(o.start, o.end).map(function (o) {
        return function (e, t) {
          var i = o.duration,
            n = o.timescale,
            r = void 0 === n ? 1 : n,
            a = o.periodIndex,
            s = o.startNumber;
          return {
            number: (void 0 === s ? 1 : s) + e,
            duration: i / r,
            timeline: a,
            time: t * i
          }
        }
      }(e));
    if ("static" === i) {
      var l = u.length - 1;
      u[l].duration = s - n / a * l
    }
    return u
  }

  function Bo(e) {
    var t = e.baseUrl,
      i = e.initialization,
      n = void 0 === i ? {} : i,
      r = e.sourceDuration,
      a = e.indexRange,
      s = void 0 === a ? "" : a,
      o = e.duration;
    if (!t) throw new Error(Au);
    var u = Mo({
        baseUrl: t,
        source: n.sourceURL,
        range: n.range
      }),
      l = Mo({
        baseUrl: t,
        source: t,
        indexRange: s
      });
    if (l.map = u, o) {
      var c = Uo(e);
      c.length && (l.duration = c[0].duration, l.timeline = c[0].timeline)
    } else r && (l.duration = r, l.timeline = 0);
    return l.number = 0, [l]
  }

  function Fo(e, t, i) {
    for (var n = e.sidx.map ? e.sidx.map : null, r = e.sidx.duration, a = e.timeline || 0, s = e.sidx.byterange, o = s.offset + s.length, u = t.timescale, l = t.references.filter(function (e) {
        return 1 !== e.referenceType
      }), c = [], d = o + t.firstOffset, h = 0; h < l.length; h++) {
      var p = t.references[h],
        f = p.referencedSize,
        m = p.subsegmentDuration,
        g = Bo({
          baseUrl: i,
          timescale: u,
          timeline: a,
          periodIndex: a,
          duration: m,
          sourceDuration: r,
          indexRange: d + "-" + (d + f - 1)
        })[0];
      n && (g.map = n), c.push(g), d += f
    }
    return e.segments = c, e
  }

  function jo(e) {
    return e && e.uri + "-" + function (e) {
      var t = e.offset + e.length - 1;
      return e.offset + "-" + t
    }(e.byterange)
  }

  function Ho(e) {
    return function (t) {
      return Object.keys(t).map(function (e) {
        return t[e]
      })
    }(e.reduce(function (e, t) {
      var i, n = t.attributes.id + (t.attributes.lang || "");
      e[n] ? (t.segments[0] && (t.segments[0].discontinuity = !0), (i = e[n].segments).push.apply(i, t.segments), t.attributes.contentProtection && (e[n].attributes.contentProtection = t.attributes.contentProtection)) : e[n] = t;
      return e
    }, {})).map(function (e) {
      return e.discontinuityStarts = function (e, n) {
        return e.reduce(function (e, t, i) {
          return t[n] && e.push(i), e
        }, [])
      }(e.segments, "discontinuity"), e
    })
  }

  function Vo(e, t) {
    var i = jo(e.sidx),
      n = i && t[i] && t[i].sidx;
    return n && Fo(e, n, e.sidx.resolvedUri), e
  }

  function qo(e) {
    var t, i = e.attributes,
      n = e.segments,
      r = e.sidx,
      a = {
        attributes: (t = {
          NAME: i.id,
          AUDIO: "audio",
          SUBTITLES: "subs",
          RESOLUTION: {
            width: i.width,
            height: i.height
          },
          CODECS: i.codecs,
          BANDWIDTH: i.bandwidth
        }, t["PROGRAM-ID"] = 1, t),
        uri: "",
        endList: "static" === (i.type || "static"),
        timeline: i.periodIndex,
        resolvedUri: "",
        targetDuration: i.duration,
        segments: n,
        mediaSequence: n.length ? n[0].number : 1
      };
    return i.contentProtection && (a.contentProtection = i.contentProtection), r && (a.sidx = r), a
  }

  function Wo(e) {
    var t = e.attributes;
    return "video/mp4" === t.mimeType || "video/webm" === t.mimeType || "video" === t.contentType
  }

  function zo(e) {
    var t = e.attributes;
    return "audio/mp4" === t.mimeType || "audio/webm" === t.mimeType || "audio" === t.contentType
  }

  function Go(e) {
    var t = e.attributes;
    return "text/vtt" === t.mimeType || "text" === t.contentType
  }

  function Xo(e, t, i) {
    var n;
    if (void 0 === i && (i = {}), !e.length) return {};
    var r = e[0].attributes,
      a = r.sourceDuration,
      s = r.type,
      o = void 0 === s ? "static" : s,
      u = r.suggestedPresentationDelay,
      l = r.minimumUpdatePeriod,
      c = Ho(e.filter(Wo)).map(qo),
      d = Ho(e.filter(zo)),
      h = e.filter(Go),
      p = {
        allowCache: !0,
        discontinuityStarts: [],
        segments: [],
        endList: !0,
        mediaGroups: (n = {
          AUDIO: {},
          VIDEO: {}
        }, n["CLOSED-CAPTIONS"] = {}, n.SUBTITLES = {}, n),
        uri: "",
        duration: a,
        playlists: function (e, t) {
          if (void 0 === t && (t = {}), !Object.keys(t).length) return e;
          for (var i in e) e[i] = Vo(e[i], t);
          return e
        }(c, i)
      };
    0 <= l && (p.minimumUpdatePeriod = 1e3 * l), t && (p.locations = t), "dynamic" === o && (p.suggestedPresentationDelay = u);
    var f = 0 === p.playlists.length;
    return d.length && (p.mediaGroups.AUDIO.audio = function (e, o, u) {
      var l;
      void 0 === o && (o = {}), void 0 === u && (u = !1);
      var t = e.reduce(function (e, t) {
        var i = t.attributes.role && t.attributes.role.value || "",
          n = t.attributes.lang || "",
          r = t.attributes.label || "main";
        if (n && !t.attributes.label) {
          var a = i ? " (" + i + ")" : "";
          r = t.attributes.lang + a
        }
        e[r] || (e[r] = {
          language: n,
          autoselect: !0,
          default: "main" === i,
          playlists: [],
          uri: ""
        });
        var s = Vo(function (e, t) {
          var i, n = e.attributes,
            r = e.segments,
            a = e.sidx,
            s = {
              attributes: (i = {
                NAME: n.id,
                BANDWIDTH: n.bandwidth,
                CODECS: n.codecs
              }, i["PROGRAM-ID"] = 1, i),
              uri: "",
              endList: "static" === (n.type || "static"),
              timeline: n.periodIndex,
              resolvedUri: "",
              targetDuration: n.duration,
              segments: r,
              mediaSequence: r.length ? r[0].number : 1
            };
          return n.contentProtection && (s.contentProtection = n.contentProtection), a && (s.sidx = a), t && (s.attributes.AUDIO = "audio", s.attributes.SUBTITLES = "subs"), s
        }(t, u), o);
        return e[r].playlists.push(s), "undefined" == typeof l && "main" === i && ((l = t).default = !0), e
      }, {});
      l || (t[Object.keys(t)[0]].default = !0);
      return t
    }(d, i, f)), h.length && (p.mediaGroups.SUBTITLES.subs = function (e, n) {
      return void 0 === n && (n = {}), e.reduce(function (e, t) {
        var i = t.attributes.lang || "text";
        return e[i] || (e[i] = {
          language: i,
          default: !1,
          autoselect: !1,
          playlists: [],
          uri: ""
        }), e[i].playlists.push(Vo(function (e) {
          var t, i = e.attributes,
            n = e.segments;
          "undefined" == typeof n && (n = [{
            uri: i.baseUrl,
            timeline: i.periodIndex,
            resolvedUri: i.baseUrl || "",
            duration: i.sourceDuration,
            number: 0
          }], i.duration = i.sourceDuration);
          var r = ((t = {
            NAME: i.id,
            BANDWIDTH: i.bandwidth
          })["PROGRAM-ID"] = 1, t);
          return i.codecs && (r.CODECS = i.codecs), {
            attributes: r,
            uri: "",
            endList: "static" === (i.type || "static"),
            timeline: i.periodIndex,
            resolvedUri: i.baseUrl || "",
            targetDuration: i.duration,
            segments: n,
            mediaSequence: n.length ? n[0].number : 1
          }
        }(t), n)), e
      }, {})
    }(h, i)), p
  }

  function Ko(e, t) {
    for (var i, n, r, a, s, o, u, l, c, d, h, p, f = e.type, m = void 0 === f ? "static" : f, g = e.minimumUpdatePeriod, v = void 0 === g ? 0 : g, y = e.media, _ = void 0 === y ? "" : y, b = e.sourceDuration, T = e.timescale, S = void 0 === T ? 1 : T, E = e.startNumber, k = void 0 === E ? 1 : E, w = e.periodIndex, C = [], I = -1, x = 0; x < t.length; x++) {
      var A = t[x],
        P = A.d,
        L = A.r || 0,
        O = A.t || 0;
      I < 0 && (I = O), O && I < O && (I = O);
      var D = void 0;
      if (L < 0) {
        var R = x + 1;
        D = R === t.length ? "dynamic" === m && 0 < v && 0 < _.indexOf("$Number$") ? (n = I, r = P, void 0, a = (i = e).NOW, s = i.clientOffset, o = i.availabilityStartTime, u = i.timescale, l = void 0 === u ? 1 : u, c = i.start, d = void 0 === c ? 0 : c, h = i.minimumUpdatePeriod, p = (a + s) / 1e3 + (void 0 === h ? 0 : h) - (o + d), Math.ceil((p * l - n) / r)) : (b * S - I) / P : (t[R].t - I) / P
      } else D = L + 1;
      for (var M = k + C.length + D, N = k + C.length; N < M;) C.push({
        number: N,
        duration: P / S,
        time: I,
        timeline: w
      }), I += P, N++
    }
    return C
  }

  function Yo(e, t) {
    return e.replace(Du, function (a) {
      return function (e, t, i, n) {
        if ("$$" === e) return "$";
        if ("undefined" == typeof a[t]) return e;
        var r = "" + a[t];
        return "RepresentationID" === t ? r : (n = i ? parseInt(n, 10) : 1) <= r.length ? r : new Array(n - r.length + 1).join("0") + r
      }
    }(t))
  }

  function Qo(n, e) {
    var r = {
        RepresentationID: n.id,
        Bandwidth: n.bandwidth || 0
      },
      t = n.initialization,
      i = void 0 === t ? {
        sourceURL: "",
        range: ""
      } : t,
      a = Mo({
        baseUrl: n.baseUrl,
        source: Yo(i.sourceURL, r),
        range: i.range
      });
    return function (e, t) {
      return e.duration || t ? e.duration ? Uo(e) : Ko(e, t) : [{
        number: e.startNumber || 1,
        duration: e.sourceDuration,
        time: 0,
        timeline: e.periodIndex
      }]
    }(n, e).map(function (e) {
      r.Number = e.number, r.Time = e.time;
      var t = Yo(n.media || "", r),
        i = {
          uri: t,
          timeline: e.timeline,
          duration: e.duration,
          resolvedUri: Ea(n.baseUrl || "", t),
          map: a,
          number: e.number
        };
      return n.presentationTimeOffset && (i.presentationTimeOffset = n.presentationTimeOffset), i
    })
  }

  function $o(t, e) {
    var i = t.duration,
      n = t.segmentUrls,
      r = void 0 === n ? [] : n;
    if (!i && !e || i && e) throw new Error(Pu);
    var a, s = r.map(function (e) {
      return function (e, t) {
        var i = e.baseUrl,
          n = e.initialization,
          r = void 0 === n ? {} : n,
          a = Mo({
            baseUrl: i,
            source: r.sourceURL,
            range: r.range
          }),
          s = Mo({
            baseUrl: i,
            source: t.media,
            range: t.mediaRange
          });
        return s.map = a, s
      }(t, e)
    });
    return i && (a = Uo(t)), e && (a = Ko(t, e)), a.map(function (e, t) {
      if (s[t]) {
        var i = s[t];
        return i.timeline = e.timeline, i.duration = e.duration, i.number = e.number, i
      }
    }).filter(function (e) {
      return e
    })
  }

  function Jo(e) {
    var t, i, n = e.attributes,
      r = e.segmentInfo;
    r.template ? (i = Qo, t = Oo(n, r.template), r.template.presentationTimeOffset && (t.presentationTimeOffset = r.template.presentationTimeOffset / r.template.timescale)) : r.base ? (i = Bo, t = Oo(n, r.base)) : r.list && (i = $o, t = Oo(n, r.list));
    var a = {
      attributes: n
    };
    if (!i) return a;
    var s = i(t, r.timeline);
    if (t.duration) {
      var o = t,
        u = o.duration,
        l = o.timescale,
        c = void 0 === l ? 1 : l;
      t.duration = u / c
    } else s.length ? t.duration = s.reduce(function (e, t) {
      return Math.max(e, Math.ceil(t.duration))
    }, 0) : t.duration = 0;
    return a.attributes = t, a.segments = s, r.base && t.indexRange && (a.sidx = s[0], a.segments = []), a
  }

  function Zo(e, t) {
    return Ro(e.childNodes).filter(function (e) {
      return e.tagName === t
    })
  }

  function eu(e) {
    return e.textContent.trim()
  }

  function tu(e) {
    var t = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/.exec(e);
    if (!t) return 0;
    var i = t.slice(1),
      n = i[0],
      r = i[1],
      a = i[2],
      s = i[3],
      o = i[4],
      u = i[5];
    return 31536e3 * parseFloat(n || 0) + 2592e3 * parseFloat(r || 0) + 86400 * parseFloat(a || 0) + 3600 * parseFloat(s || 0) + 60 * parseFloat(o || 0) + parseFloat(u || 0)
  }

  function iu(e) {
    return e && e.attributes ? Ro(e.attributes).reduce(function (e, t) {
      var i = Ru[t.name] || Ru.DEFAULT;
      return e[t.name] = i(t.value), e
    }, {}) : {}
  }

  function nu(e, i) {
    return i.length ? Do(e.map(function (t) {
      return i.map(function (e) {
        return Ea(t, eu(e))
      })
    })) : e
  }

  function ru(e) {
    var t = Zo(e, "SegmentTemplate")[0],
      i = Zo(e, "SegmentList")[0],
      n = i && Zo(i, "SegmentURL").map(function (e) {
        return Oo({
          tag: "SegmentURL"
        }, iu(e))
      }),
      r = Zo(e, "SegmentBase")[0],
      a = i || t,
      s = a && Zo(a, "SegmentTimeline")[0],
      o = i || r || t,
      u = o && Zo(o, "Initialization")[0],
      l = t && iu(t);
    l && u ? l.initialization = u && iu(u) : l && l.initialization && (l.initialization = {
      sourceURL: l.initialization
    });
    var c = {
      template: l,
      timeline: s && Zo(s, "S").map(function (e) {
        return iu(e)
      }),
      list: i && Oo(iu(i), {
        segmentUrls: n,
        initialization: iu(u)
      }),
      base: r && Oo(iu(r), {
        initialization: iu(u)
      })
    };
    return Object.keys(c).forEach(function (e) {
      c[e] || delete c[e]
    }), c
  }

  function au(h, p, f) {
    return function (e) {
      var t = iu(e),
        i = nu(p, Zo(e, "BaseURL")),
        n = Zo(e, "Role")[0],
        r = {
          role: iu(n)
        },
        a = Oo(h, t, r),
        s = Zo(e, "Label")[0];
      if (s && s.childNodes.length) {
        var o = s.childNodes[0].nodeValue.trim();
        a = Oo(a, {
          label: o
        })
      }
      var u = function (e) {
        return e.reduce(function (e, t) {
          var i = iu(t),
            n = Mu[i.schemeIdUri];
          if (n) {
            e[n] = {
              attributes: i
            };
            var r = Zo(t, "cenc:pssh")[0];
            if (r) {
              var a = eu(r),
                s = a && Na(a);
              e[n].pssh = s
            }
          }
          return e
        }, {})
      }(Zo(e, "ContentProtection"));
      Object.keys(u).length && (a = Oo(a, {
        contentProtection: u
      }));
      var l = ru(e),
        c = Zo(e, "Representation"),
        d = Oo(f, l);
      return Do(c.map(function (a, s, o) {
        return function (e) {
          var t = Zo(e, "BaseURL"),
            i = nu(s, t),
            n = Oo(a, iu(e)),
            r = ru(e);
          return i.map(function (e) {
            return {
              segmentInfo: Oo(o, r),
              attributes: Oo(n, {
                baseUrl: e
              })
            }
          })
        }
      }(a, i, d)))
    }
  }

  function su(e, t) {
    void 0 === t && (t = {});
    var i = t,
      n = i.manifestUri,
      r = void 0 === n ? "" : n,
      a = i.NOW,
      s = void 0 === a ? Date.now() : a,
      o = i.clientOffset,
      u = void 0 === o ? 0 : o,
      l = Zo(e, "Period");
    if (!l.length) throw new Error(Cu);
    var c = Zo(e, "Location"),
      d = iu(e),
      h = nu([r], Zo(e, "BaseURL"));
    return d.sourceDuration = d.mediaPresentationDuration || 0, d.NOW = s, d.clientOffset = u, c.length && (d.locations = c.map(eu)), {
      locations: d.locations,
      representationInfo: Do(l.map(function (l, c) {
        return function (e, t) {
          var i = nu(c, Zo(e, "BaseURL")),
            n = iu(e),
            r = parseInt(n.id, 10),
            a = rs.isNaN(r) ? t : r,
            s = Oo(l, {
              periodIndex: a
            }),
            o = Zo(e, "AdaptationSet"),
            u = ru(e);
          return Do(o.map(au(s, i, u)))
        }
      }(d, h)))
    }
  }

  function ou(e) {
    if ("" === e) throw new Error(Iu);
    var t, i, n = new wu;
    try {
      i = (t = n.parseFromString(e, "application/xml")) && "MPD" === t.documentElement.tagName ? t.documentElement : null
    } catch (e) {}
    if (!i || i && 0 < i.getElementsByTagName("parsererror").length) throw new Error(xu);
    return i
  }

  function uu(e, t) {
    void 0 === t && (t = {});
    var i = su(ou(e), t),
      n = function (e) {
        return e.map(Jo)
      }(i.representationInfo);
    return Xo(n, i.locations, t.sidxMapping)
  }

  function lu(e) {
    return function (e) {
      var t = Zo(e, "UTCTiming")[0];
      if (!t) return null;
      var i = iu(t);
      switch (i.schemeIdUri) {
        case "urn:mpeg:dash:utc:http-head:2014":
        case "urn:mpeg:dash:utc:http-head:2012":
          i.method = "HEAD";
          break;
        case "urn:mpeg:dash:utc:http-xsdate:2014":
        case "urn:mpeg:dash:utc:http-iso:2014":
        case "urn:mpeg:dash:utc:http-xsdate:2012":
        case "urn:mpeg:dash:utc:http-iso:2012":
          i.method = "GET";
          break;
        case "urn:mpeg:dash:utc:direct:2014":
        case "urn:mpeg:dash:utc:direct:2012":
          i.method = "DIRECT", i.value = Date.parse(i.value);
          break;
        case "urn:mpeg:dash:utc:http-ntp:2014":
        case "urn:mpeg:dash:utc:ntp:2014":
        case "urn:mpeg:dash:utc:sntp:2014":
        default:
          throw new Error(Lu)
      }
      return i
    }(ou(e))
  }

  function cu(e) {
    return e instanceof Uint8Array ? e : (Array.isArray(e) || function (e) {
      return ArrayBuffer.isView(e)
    }(e) || e instanceof ArrayBuffer || (e = "number" != typeof e || "number" == typeof e && e != e ? 0 : [e]), new Uint8Array(e && e.buffer || e, e && e.byteOffset || 0, e && e.byteLength || 0))
  }

  function du(e, t) {
    var i = (void 0 === t ? {} : t).le,
      n = void 0 !== i && i;
    ("bigint" != typeof e && "number" != typeof e || "number" == typeof e && e != e) && (e = 0);
    for (var r = function (e) {
        return Math.ceil(function (e) {
          return e.toString(2).length
        }(e) / 8)
      }(e = Bu(e)), a = new Uint8Array(new ArrayBuffer(r)), s = 0; s < r; s++) {
      var o = n ? s : Math.abs(s + 1 - a.length);
      a[o] = Number(e / Fu[s] & Bu(255)), e < 0 && (a[o] = Math.abs(~a[o]), a[o] -= 0 === s ? 1 : 2)
    }
    return a
  }

  function hu(e, t) {
    if ("string" != typeof e && e && "function" == typeof e.toString && (e = e.toString()), "string" != typeof e) return new Uint8Array;
    t || (e = unescape(encodeURIComponent(e)));
    for (var i = new Uint8Array(e.length), n = 0; n < e.length; n++) i[n] = e.charCodeAt(n);
    return i
  }

  function pu(i, e, t) {
    var n = void 0 === t ? {} : t,
      r = n.offset,
      a = void 0 === r ? 0 : r,
      s = n.mask,
      o = void 0 === s ? [] : s;
    i = cu(i);
    var u = (e = cu(e)).every ? e.every : Array.prototype.every;
    return e.length && i.length - a >= e.length && u.call(e, function (e, t) {
      return e === (o[t] ? o[t] & i[a + t] : i[a + t])
    })
  }

  function fu(e, t) {
    return void 0 === t && (t = 0), (e = cu(e)).length - t < 10 || !pu(e, ju, {
      offset: t
    }) ? t : fu(e, t += function (e, t) {
      void 0 === t && (t = 0);
      var i = (e = cu(e))[t + 5],
        n = e[t + 6] << 21 | e[t + 7] << 14 | e[t + 8] << 7 | e[t + 9];
      return (16 & i) >> 4 ? 20 + n : 10 + n
    }(e, t))
  }

  function mu(e) {
    return "string" == typeof e ? hu(e) : e
  }

  function gu(e, t, i) {
    void 0 === i && (i = !1), t = function (e) {
      return Array.isArray(e) ? e.map(function (e) {
        return mu(e)
      }) : [mu(e)]
    }(t), e = cu(e);
    var n = [];
    if (!t.length) return n;
    for (var r = 0; r < e.length;) {
      var a = (e[r] << 24 | e[r + 1] << 16 | e[r + 2] << 8 | e[r + 3]) >>> 0,
        s = e.subarray(r + 4, r + 8);
      if (0 == a) break;
      var o = r + a;
      if (o > e.length) {
        if (i) break;
        o = e.length
      }
      var u = e.subarray(r + 8, o);
      pu(s, t[0]) && (1 === t.length ? n.push(u) : n.push.apply(n, gu(u, t.slice(1), i))), r = o
    }
    return n
  }

  function vu(e, t, i, n) {
    void 0 === i && (i = !0), void 0 === n && (n = !1);
    var r = function (e) {
        for (var t = 1, i = 0; i < Vu.length && !(e & Vu[i]); i++) t++;
        return t
      }(e[t]),
      a = e.subarray(t, t + r);
    return i && ((a = Array.prototype.slice.call(e, t, t + r))[0] ^= Vu[r - 1]), {
      length: r,
      value: function (r, e) {
        var t = void 0 === e ? {} : e,
          i = t.signed,
          n = void 0 !== i && i,
          a = t.le,
          s = void 0 !== a && a;
        r = cu(r);
        var o = s ? "reduce" : "reduceRight",
          u = (r[o] ? r[o] : Array.prototype[o]).call(r, function (e, t, i) {
            var n = s ? i : Math.abs(i + 1 - r.length);
            return e + Bu(t) * Fu[n]
          }, Bu(0));
        if (n) {
          var l = Fu[r.length] / Bu(2) - Bu(1);
          l < (u = Bu(u)) && (u -= l, u -= l, u -= Bu(2))
        }
        return Number(u)
      }(a, {
        signed: n
      }),
      bytes: a
    }
  }

  function yu(e) {
    return "string" == typeof e ? e.match(/.{1,2}/g).map(function (e) {
      return yu(e)
    }) : "number" == typeof e ? du(e) : e
  }

  function _u(e, t, i) {
    if (i >= t.length) return t.length;
    var n = vu(t, i, !1);
    if (pu(e.bytes, n.bytes)) return i;
    var r = vu(t, i + n.length);
    return _u(e, t, i + r.length + r.value + n.length)
  }

  function bu(e, t) {
    t = function (e) {
      return Array.isArray(e) ? e.map(function (e) {
        return yu(e)
      }) : [yu(e)]
    }(t), e = cu(e);
    var i = [];
    if (!t.length) return i;
    for (var n = 0; n < e.length;) {
      var r = vu(e, n, !1),
        a = vu(e, n + r.length),
        s = n + r.length + a.length;
      127 === a.value && (a.value = _u(r, e, s), a.value !== e.length && (a.value -= s));
      var o = s + a.value > e.length ? e.length : s + a.value,
        u = e.subarray(s, o);
      pu(t[0], r.bytes) && (1 === t.length ? i.push(u) : i = i.concat(bu(u, t.slice(1)))), n += r.length + a.length + u.length
    }
    return i
  }

  function Tu(e) {
    for (var t = [], i = 1; i < e.length - 2;) pu(e.subarray(i, i + 3), zu) && (t.push(i + 2), i++), i++;
    if (0 === t.length) return e;
    var n = e.length - t.length,
      r = new Uint8Array(n),
      a = 0;
    for (i = 0; i < n; a++, i++) a === t[0] && (a++, t.shift()), r[i] = e[a];
    return r
  }

  function Su(e, t, i, n) {
    void 0 === n && (n = 1 / 0), e = cu(e), i = [].concat(i);
    for (var r, a = 0, s = 0; a < e.length && (s < n || r);) {
      var o = void 0;
      if (pu(e.subarray(a), qu) ? o = 4 : pu(e.subarray(a), Wu) && (o = 3), o) {
        if (s++, r) return Tu(e.subarray(r, a));
        var u = void 0;
        "h264" === t ? u = 31 & e[a + o] : "h265" === t && (u = e[a + o] >> 1 & 63), -1 !== i.indexOf(u) && (r = a + o), a += o + ("h264" === t ? 1 : 2)
      } else a++
    }
    return e.subarray(0, 0)
  }
  var Eu = {
      Node: ao,
      DOMException: Qs,
      DOMImplementation: ro,
      XMLSerializer: Co
    },
    ku = i(function (e, t) {
      function i(e) {
        this.options = e || {
          locator: {}
        }
      }

      function c() {
        this.cdata = !1
      }

      function d(e, t) {
        t.lineNumber = e.lineNumber, t.columnNumber = e.columnNumber
      }

      function h(e) {
        if (e) return "\n@" + (e.systemId || "") + "#[line:" + e.lineNumber + ",col:" + e.columnNumber + "]"
      }

      function r(e, t, i) {
        return "string" == typeof e ? e.substr(t, i) : e.length >= t + i || t ? new java.lang.String(e, t, i) + "" : e
      }

      function p(e, t) {
        e.currentElement ? e.currentElement.appendChild(t) : e.doc.appendChild(t)
      }
      i.prototype.parseFromString = function (e, t) {
        var i = this.options,
          n = new f,
          r = i.domBuilder || new c,
          a = i.errorHandler,
          s = i.locator,
          o = i.xmlns || {},
          u = /\/x?html?$/.test(t),
          l = u ? as.entityMap : {
            lt: "<",
            gt: ">",
            amp: "&",
            quot: '"',
            apos: "'"
          };
        return s && r.setDocumentLocator(s), n.errorHandler = function (n, e, r) {
          if (!n) {
            if (e instanceof c) return e;
            n = e
          }
          var a = {},
            s = n instanceof Function;

          function t(t) {
            var i = n[t];
            !i && s && (i = 2 == n.length ? function (e) {
              n(t, e)
            } : n), a[t] = i && function (e) {
              i("[xmldom " + t + "]\t" + e + h(r))
            } || function () {}
          }
          return r = r || {}, t("warning"), t("error"), t("fatalError"), a
        }(a, r, s), n.domBuilder = i.domBuilder || r, u && (o[""] = "http://www.w3.org/1999/xhtml"), o.xml = o.xml || "http://www.w3.org/XML/1998/namespace", e && "string" == typeof e ? n.parse(e, o, l) : n.errorHandler.error("invalid doc source"), r.doc
      }, c.prototype = {
        startDocument: function () {
          this.doc = (new a).createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId)
        },
        startElement: function (e, t, i, n) {
          var r = this.doc,
            a = r.createElementNS(e, i || t),
            s = n.length;
          p(this, a), this.currentElement = a, this.locator && d(this.locator, a);
          for (var o = 0; o < s; o++) {
            e = n.getURI(o);
            var u = n.getValue(o),
              l = (i = n.getQName(o), r.createAttributeNS(e, i));
            this.locator && d(n.getLocator(o), l), l.value = l.nodeValue = u, a.setAttributeNode(l)
          }
        },
        endElement: function (e, t, i) {
          var n = this.currentElement;
          n.tagName;
          this.currentElement = n.parentNode
        },
        startPrefixMapping: function (e, t) {},
        endPrefixMapping: function (e) {},
        processingInstruction: function (e, t) {
          var i = this.doc.createProcessingInstruction(e, t);
          this.locator && d(this.locator, i), p(this, i)
        },
        ignorableWhitespace: function (e, t, i) {},
        characters: function (e, t, i) {
          if (e = r.apply(this, arguments)) {
            if (this.cdata) var n = this.doc.createCDATASection(e);
            else n = this.doc.createTextNode(e);
            this.currentElement ? this.currentElement.appendChild(n) : /^\s*$/.test(e) && this.doc.appendChild(n), this.locator && d(this.locator, n)
          }
        },
        skippedEntity: function (e) {},
        endDocument: function () {
          this.doc.normalize()
        },
        setDocumentLocator: function (e) {
          (this.locator = e) && (e.lineNumber = 0)
        },
        comment: function (e, t, i) {
          e = r.apply(this, arguments);
          var n = this.doc.createComment(e);
          this.locator && d(this.locator, n), p(this, n)
        },
        startCDATA: function () {
          this.cdata = !0
        },
        endCDATA: function () {
          this.cdata = !1
        },
        startDTD: function (e, t, i) {
          var n = this.doc.implementation;
          if (n && n.createDocumentType) {
            var r = n.createDocumentType(e, t, i);
            this.locator && d(this.locator, r), p(this, r)
          }
        },
        warning: function (e) {},
        error: function (e) {},
        fatalError: function (e) {
          throw new n(e, this.locator)
        }
      }, "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function (e) {
        c.prototype[e] = function () {
          return null
        }
      });
      var f = xs.XMLReader,
        n = xs.ParseError,
        a = t.DOMImplementation = Eu.DOMImplementation;
      t.XMLSerializer = Eu.XMLSerializer, t.DOMParser = i, t.__DOMHandler = c
    }),
    wu = (ku.DOMImplementation, ku.XMLSerializer, ku.DOMParser),
    Cu = (ku.__DOMHandler, "INVALID_NUMBER_OF_PERIOD"),
    Iu = "DASH_EMPTY_MANIFEST",
    xu = "DASH_INVALID_XML",
    Au = "NO_BASE_URL",
    Pu = "SEGMENT_TIME_UNSPECIFIED",
    Lu = "UNSUPPORTED_UTC_TIMING_SCHEME",
    Ou = {
      static: function (e) {
        var t = e.duration,
          i = e.timescale,
          n = void 0 === i ? 1 : i,
          r = e.sourceDuration,
          a = No(e.endNumber);
        return {
          start: 0,
          end: "number" == typeof a ? a : Math.ceil(r / (t / n))
        }
      },
      dynamic: function (e) {
        var t = e.NOW,
          i = e.clientOffset,
          n = e.availabilityStartTime,
          r = e.timescale,
          a = void 0 === r ? 1 : r,
          s = e.duration,
          o = e.start,
          u = void 0 === o ? 0 : o,
          l = e.minimumUpdatePeriod,
          c = void 0 === l ? 0 : l,
          d = e.timeShiftBufferDepth,
          h = void 0 === d ? 1 / 0 : d,
          p = No(e.endNumber),
          f = (t + i) / 1e3,
          m = n + u,
          g = f + c - m,
          v = Math.ceil(g * a / s),
          y = Math.floor((f - m - h) * a / s),
          _ = Math.floor((f - m) * a / s);
        return {
          start: Math.max(0, y),
          end: "number" == typeof p ? p : Math.min(v, _)
        }
      }
    },
    Du = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g,
    Ru = {
      mediaPresentationDuration: function (e) {
        return tu(e)
      },
      availabilityStartTime: function (e) {
        return function (e) {
          return /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(e) && (e += "Z"), Date.parse(e)
        }(e) / 1e3
      },
      minimumUpdatePeriod: function (e) {
        return tu(e)
      },
      suggestedPresentationDelay: function (e) {
        return tu(e)
      },
      type: function (e) {
        return e
      },
      timeShiftBufferDepth: function (e) {
        return tu(e)
      },
      start: function (e) {
        return tu(e)
      },
      width: function (e) {
        return parseInt(e, 10)
      },
      height: function (e) {
        return parseInt(e, 10)
      },
      bandwidth: function (e) {
        return parseInt(e, 10)
      },
      startNumber: function (e) {
        return parseInt(e, 10)
      },
      timescale: function (e) {
        return parseInt(e, 10)
      },
      presentationTimeOffset: function (e) {
        return parseInt(e, 10)
      },
      duration: function (e) {
        var t = parseInt(e, 10);
        return isNaN(t) ? tu(e) : t
      },
      d: function (e) {
        return parseInt(e, 10)
      },
      t: function (e) {
        return parseInt(e, 10)
      },
      r: function (e) {
        return parseInt(e, 10)
      },
      DEFAULT: function (e) {
        return e
      }
    },
    Mu = {
      "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
      "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
      "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
      "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime"
    },
    Nu = Math.pow(2, 32),
    Uu = function (e) {
      var t = new DataView(e.buffer, e.byteOffset, e.byteLength),
        i = {
          version: e[0],
          flags: new Uint8Array(e.subarray(1, 4)),
          references: [],
          referenceId: t.getUint32(4),
          timescale: t.getUint32(8)
        },
        n = 12;
      0 === i.version ? (i.earliestPresentationTime = t.getUint32(n), i.firstOffset = t.getUint32(n + 4), n += 8) : (i.earliestPresentationTime = t.getUint32(n) * Nu + t.getUint32(n + 4), i.firstOffset = t.getUint32(n + 8) * Nu + t.getUint32(n + 12), n += 16), n += 2;
      var r = t.getUint16(n);
      for (n += 2; 0 < r; n += 12, r--) i.references.push({
        referenceType: (128 & e[n]) >>> 7,
        referencedSize: 2147483647 & t.getUint32(n),
        subsegmentDuration: t.getUint32(n + 4),
        startsWithSap: !!(128 & e[n + 8]),
        sapType: (112 & e[n + 8]) >>> 4,
        sapDeltaTime: 268435455 & t.getUint32(n + 8)
      });
      return i
    },
    Bu = Aa.BigInt || Number,
    Fu = [Bu("0x1"), Bu("0x100"), Bu("0x10000"), Bu("0x1000000"), Bu("0x100000000"), Bu("0x10000000000"), Bu("0x1000000000000"), Bu("0x100000000000000"), Bu("0x10000000000000000")],
    ju = cu([73, 68, 51]),
    Hu = {
      EBML: cu([26, 69, 223, 163]),
      DocType: cu([66, 130]),
      Segment: cu([24, 83, 128, 103]),
      SegmentInfo: cu([21, 73, 169, 102]),
      Tracks: cu([22, 84, 174, 107]),
      Track: cu([174]),
      TrackNumber: cu([215]),
      DefaultDuration: cu([35, 227, 131]),
      TrackEntry: cu([174]),
      TrackType: cu([131]),
      FlagDefault: cu([136]),
      CodecID: cu([134]),
      CodecPrivate: cu([99, 162]),
      VideoTrack: cu([224]),
      AudioTrack: cu([225]),
      Cluster: cu([31, 67, 182, 117]),
      Timestamp: cu([231]),
      TimestampScale: cu([42, 215, 177]),
      BlockGroup: cu([160]),
      BlockDuration: cu([155]),
      Block: cu([161]),
      SimpleBlock: cu([163])
    },
    Vu = [128, 64, 32, 16, 8, 4, 2, 1],
    qu = cu([0, 0, 0, 1]),
    Wu = cu([0, 0, 1]),
    zu = cu([0, 0, 3]),
    Gu = {
      webm: cu([119, 101, 98, 109]),
      matroska: cu([109, 97, 116, 114, 111, 115, 107, 97]),
      flac: cu([102, 76, 97, 67]),
      ogg: cu([79, 103, 103, 83]),
      ac3: cu([11, 119]),
      riff: cu([82, 73, 70, 70]),
      avi: cu([65, 86, 73]),
      wav: cu([87, 65, 86, 69]),
      "3gp": cu([102, 116, 121, 112, 51, 103]),
      mp4: cu([102, 116, 121, 112]),
      fmp4: cu([115, 116, 121, 112]),
      mov: cu([102, 116, 121, 112, 113, 116])
    },
    Xu = {
      aac: function (e) {
        var t = fu(e);
        return pu(e, [255, 16], {
          offset: t,
          mask: [255, 22]
        })
      },
      mp3: function (e) {
        var t = fu(e);
        return pu(e, [255, 2], {
          offset: t,
          mask: [255, 6]
        })
      },
      webm: function (e) {
        var t = bu(e, [Hu.EBML, Hu.DocType])[0];
        return pu(t, Gu.webm)
      },
      mkv: function (e) {
        var t = bu(e, [Hu.EBML, Hu.DocType])[0];
        return pu(t, Gu.matroska)
      },
      mp4: function (e) {
        return !Xu["3gp"](e) && !Xu.mov(e) && (pu(e, Gu.mp4, {
          offset: 4
        }) || pu(e, Gu.fmp4, {
          offset: 4
        }))
      },
      mov: function (e) {
        return pu(e, Gu.mov, {
          offset: 4
        })
      },
      "3gp": function (e) {
        return pu(e, Gu["3gp"], {
          offset: 4
        })
      },
      ac3: function (e) {
        var t = fu(e);
        return pu(e, Gu.ac3, {
          offset: t
        })
      },
      ts: function (e) {
        if (e.length < 189 && 1 <= e.length) return 71 === e[0];
        for (var t = 0; t + 188 < e.length && t < 188;) {
          if (71 === e[t] && 71 === e[t + 188]) return !0;
          t += 1
        }
        return !1
      },
      flac: function (e) {
        var t = fu(e);
        return pu(e, Gu.flac, {
          offset: t
        })
      },
      ogg: function (e) {
        return pu(e, Gu.ogg)
      },
      avi: function (e) {
        return pu(e, Gu.riff) && pu(e, Gu.avi, {
          offset: 8
        })
      },
      wav: function (e) {
        return pu(e, Gu.riff) && pu(e, Gu.wav, {
          offset: 8
        })
      },
      h264: function (e) {
        return function (e, t, i) {
          return Su(e, "h264", t, i)
        }(e, 7, 3).length
      },
      h265: function (e) {
        return function (e, t, i) {
          return Su(e, "h265", t, i)
        }(e, [32, 33], 3).length
      }
    },
    Ku = Object.keys(Xu).filter(function (e) {
      return "ts" !== e && "h264" !== e && "h265" !== e
    }).concat(["ts", "h264", "h265"]);
  Ku.forEach(function (e) {
    var t = Xu[e];
    Xu[e] = function (e) {
      return t(cu(e))
    }
  });

  function Yu(e) {
    e = cu(e);
    for (var t = 0; t < Ku.length; t++) {
      var i = Ku[t];
      if (Ju[i](e)) return i
    }
    return ""
  }

  function Qu(e) {
    return 0 < gu(e, ["moof"]).length
  }

  function $u() {
    this.init = function () {
      var a = {};
      this.on = function (e, t) {
        a[e] || (a[e] = []), a[e] = a[e].concat(t)
      }, this.off = function (e, t) {
        var i;
        return !!a[e] && (i = a[e].indexOf(t), a[e] = a[e].slice(), a[e].splice(i, 1), -1 < i)
      }, this.trigger = function (e) {
        var t, i, n, r;
        if (t = a[e])
          if (2 === arguments.length)
            for (n = t.length, i = 0; i < n; ++i) t[i].call(this, arguments[1]);
          else {
            for (r = [], i = arguments.length, i = 1; i < arguments.length; ++i) r.push(arguments[i]);
            for (n = t.length, i = 0; i < n; ++i) t[i].apply(this, r)
          }
      }, this.dispose = function () {
        a = {}
      }
    }
  }
  var Ju = Xu,
    Zu = 27,
    el = 15,
    tl = 21;
  $u.prototype.pipe = function (t) {
    return this.on("data", function (e) {
      t.push(e)
    }), this.on("done", function (e) {
      t.flush(e)
    }), this.on("partialdone", function (e) {
      t.partialFlush(e)
    }), this.on("endedtimeline", function (e) {
      t.endTimeline(e)
    }), this.on("reset", function (e) {
      t.reset(e)
    }), t
  }, $u.prototype.push = function (e) {
    this.trigger("data", e)
  }, $u.prototype.flush = function (e) {
    this.trigger("done", e)
  }, $u.prototype.partialFlush = function (e) {
    this.trigger("partialdone", e)
  }, $u.prototype.endTimeline = function (e) {
    this.trigger("endedtimeline", e)
  }, $u.prototype.reset = function (e) {
    this.trigger("reset", e)
  };

  function il(e, t) {
    var i = 1;
    for (t < e && (i = -1); 4294967296 < Math.abs(t - e);) e += 8589934592 * i;
    return e
  }
  new $u;

  function nl(e) {
    var t = 31 & e[1];
    return t <<= 8, t |= e[2]
  }

  function rl(e) {
    return !!(64 & e[1])
  }

  function al(e) {
    var t = 0;
    return 1 < (48 & e[3]) >>> 4 && (t += e[4] + 1), t
  }

  function sl(e) {
    switch (e) {
      case 5:
        return "slice_layer_without_partitioning_rbsp_idr";
      case 6:
        return "sei_rbsp";
      case 7:
        return "seq_parameter_set_rbsp";
      case 8:
        return "pic_parameter_set_rbsp";
      case 9:
        return "access_unit_delimiter_rbsp";
      default:
        return null
    }
  }

  function ol(e, t) {
    var i = e[t + 6] << 21 | e[t + 7] << 14 | e[t + 8] << 7 | e[t + 9];
    return i = 0 <= i ? i : 0, (16 & e[t + 5]) >> 4 ? i + 20 : i + 10
  }

  function ul(e) {
    return e[0] << 21 | e[1] << 14 | e[2] << 7 | e[3]
  }
  var ll, cl, dl, hl, pl = {
      parseType: function (e, t) {
        var i = nl(e);
        return 0 === i ? "pat" : i === t ? "pmt" : t ? "pes" : null
      },
      parsePat: function (e) {
        var t = rl(e),
          i = 4 + al(e);
        return t && (i += e[i] + 1), (31 & e[i + 10]) << 8 | e[i + 11]
      },
      parsePmt: function (e) {
        var t = {},
          i = rl(e),
          n = 4 + al(e);
        if (i && (n += e[n] + 1), 1 & e[n + 5]) {
          var r;
          r = 3 + ((15 & e[n + 1]) << 8 | e[n + 2]) - 4;
          for (var a = 12 + ((15 & e[n + 10]) << 8 | e[n + 11]); a < r;) {
            var s = n + a;
            t[(31 & e[s + 1]) << 8 | e[s + 2]] = e[s], a += 5 + ((15 & e[s + 3]) << 8 | e[s + 4])
          }
          return t
        }
      },
      parsePayloadUnitStartIndicator: rl,
      parsePesType: function (e, t) {
        switch (t[nl(e)]) {
          case Zu:
            return "video";
          case el:
            return "audio";
          case tl:
            return "timed-metadata";
          default:
            return null
        }
      },
      parsePesTime: function (e) {
        if (!rl(e)) return null;
        var t = 4 + al(e);
        if (t >= e.byteLength) return null;
        var i, n = null;
        return 192 & (i = e[t + 7]) && ((n = {}).pts = (14 & e[t + 9]) << 27 | (255 & e[t + 10]) << 20 | (254 & e[t + 11]) << 12 | (255 & e[t + 12]) << 5 | (254 & e[t + 13]) >>> 3, n.pts *= 4, n.pts += (6 & e[t + 13]) >>> 1, n.dts = n.pts, 64 & i && (n.dts = (14 & e[t + 14]) << 27 | (255 & e[t + 15]) << 20 | (254 & e[t + 16]) << 12 | (255 & e[t + 17]) << 5 | (254 & e[t + 18]) >>> 3, n.dts *= 4, n.dts += (6 & e[t + 18]) >>> 1)), n
      },
      videoPacketContainsKeyFrame: function (e) {
        for (var t = 4 + al(e), i = e.subarray(t), n = 0, r = 0, a = !1; r < i.byteLength - 3; r++)
          if (1 === i[r + 2]) {
            n = r + 5;
            break
          } for (; n < i.byteLength;) switch (i[n]) {
          case 0:
            if (0 !== i[n - 1]) {
              n += 2;
              break
            }
            if (0 !== i[n - 2]) {
              n++;
              break
            }
            for (r + 3 !== n - 2 && "slice_layer_without_partitioning_rbsp_idr" === sl(31 & i[r + 3]) && (a = !0); 1 !== i[++n] && n < i.length;);
            r = n - 2, n += 3;
            break;
          case 1:
            if (0 !== i[n - 1] || 0 !== i[n - 2]) {
              n += 3;
              break
            }
            "slice_layer_without_partitioning_rbsp_idr" === sl(31 & i[r + 3]) && (a = !0), r = n - 2, n += 3;
            break;
          default:
            n += 3
        }
        return i = i.subarray(r), n -= r, r = 0, i && 3 < i.byteLength && "slice_layer_without_partitioning_rbsp_idr" === sl(31 & i[r + 3]) && (a = !0), a
      }
    },
    fl = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350],
    ml = {
      isLikelyAacData: function (e) {
        var t = function e(t, i) {
          return t.length - i < 10 || t[i] !== "I".charCodeAt(0) || t[i + 1] !== "D".charCodeAt(0) || t[i + 2] !== "3".charCodeAt(0) ? i : e(t, i += ol(t, i))
        }(e, 0);
        return e.length >= t + 2 && 255 == (255 & e[t]) && 240 == (240 & e[t + 1]) && 16 == (22 & e[t + 1])
      },
      parseId3TagSize: ol,
      parseAdtsSize: function (e, t) {
        var i = (224 & e[t + 5]) >> 5,
          n = e[t + 4] << 3;
        return 6144 & e[t + 3] | n | i
      },
      parseType: function (e, t) {
        return e[t] === "I".charCodeAt(0) && e[t + 1] === "D".charCodeAt(0) && e[t + 2] === "3".charCodeAt(0) ? "timed-metadata" : !0 & e[t] && 240 == (240 & e[t + 1]) ? "audio" : null
      },
      parseSampleRate: function (e) {
        for (var t = 0; t + 5 < e.length;) {
          if (255 === e[t] && 240 == (246 & e[t + 1])) return fl[(60 & e[t + 2]) >>> 2];
          t++
        }
        return null
      },
      parseAacTimestamp: function (e) {
        var t, i, n;
        t = 10, 64 & e[5] && (t += 4, t += ul(e.subarray(10, 14)));
        do {
          if ((i = ul(e.subarray(t + 4, t + 8))) < 1) return null;
          if ("PRIV" === String.fromCharCode(e[t], e[t + 1], e[t + 2], e[t + 3])) {
            n = e.subarray(t + 10, t + i + 10);
            for (var r = 0; r < n.byteLength; r++)
              if (0 === n[r]) {
                if ("com.apple.streaming.transportStreamTimestamp" !== unescape(function (e, t, i) {
                    var n, r = "";
                    for (n = t; n < i; n++) r += "%" + ("00" + e[n].toString(16)).slice(-2);
                    return r
                  }(n, 0, r))) break;
                var a = n.subarray(r + 1),
                  s = (1 & a[3]) << 30 | a[4] << 22 | a[5] << 14 | a[6] << 6 | a[7] >>> 2;
                return s *= 4, s += 3 & a[7]
              }
          }
          t += 10, t += i
        } while (t < e.byteLength);
        return null
      }
    },
    gl = 9e4,
    vl = (ll = function (e) {
      return 9e4 * e
    }, cl = function (e, t) {
      return e * t
    }, dl = function (e) {
      return e / 9e4
    }, hl = function (e, t) {
      return e / t
    }, gl),
    yl = il,
    _l = {};
  _l.ts = pl, _l.aac = ml;

  function bl(e, t, i) {
    for (var n, r, a, s, o = 0, u = Il, l = !1; u <= e.byteLength;)
      if (71 !== e[o] || 71 !== e[u] && u !== e.byteLength) o++, u++;
      else {
        switch (n = e.subarray(o, u), _l.ts.parseType(n, t.pid)) {
          case "pes":
            r = _l.ts.parsePesType(n, t.table), a = _l.ts.parsePayloadUnitStartIndicator(n), "audio" === r && a && (s = _l.ts.parsePesTime(n)) && (s.type = "audio", i.audio.push(s), l = !0)
        }
        if (l) break;
        o += Il, u += Il
      } for (o = (u = e.byteLength) - Il, l = !1; 0 <= o;)
      if (71 !== e[o] || 71 !== e[u] && u !== e.byteLength) o--, u--;
      else {
        switch (n = e.subarray(o, u), _l.ts.parseType(n, t.pid)) {
          case "pes":
            r = _l.ts.parsePesType(n, t.table), a = _l.ts.parsePayloadUnitStartIndicator(n), "audio" === r && a && (s = _l.ts.parsePesTime(n)) && (s.type = "audio", i.audio.push(s), l = !0)
        }
        if (l) break;
        o -= Il, u -= Il
      }
  }

  function Tl(e, t, i) {
    for (var n, r, a, s, o, u, l, c = 0, d = Il, h = !1, p = {
        data: [],
        size: 0
      }; d < e.byteLength;)
      if (71 !== e[c] || 71 !== e[d]) c++, d++;
      else {
        switch (n = e.subarray(c, d), _l.ts.parseType(n, t.pid)) {
          case "pes":
            if (r = _l.ts.parsePesType(n, t.table), a = _l.ts.parsePayloadUnitStartIndicator(n), "video" === r && (a && !h && (s = _l.ts.parsePesTime(n)) && (s.type = "video", i.video.push(s), h = !0), !i.firstKeyFrame)) {
              if (a && 0 !== p.size) {
                for (o = new Uint8Array(p.size), u = 0; p.data.length;) l = p.data.shift(), o.set(l, u), u += l.byteLength;
                if (_l.ts.videoPacketContainsKeyFrame(o)) {
                  var f = _l.ts.parsePesTime(o);
                  f && (i.firstKeyFrame = f, i.firstKeyFrame.type = "video")
                }
                p.size = 0
              }
              p.data.push(n), p.size += n.byteLength
            }
        }
        if (h && i.firstKeyFrame) break;
        c += Il, d += Il
      } for (c = (d = e.byteLength) - Il, h = !1; 0 <= c;)
      if (71 !== e[c] || 71 !== e[d]) c--, d--;
      else {
        switch (n = e.subarray(c, d), _l.ts.parseType(n, t.pid)) {
          case "pes":
            r = _l.ts.parsePesType(n, t.table), a = _l.ts.parsePayloadUnitStartIndicator(n), "video" === r && a && (s = _l.ts.parsePesTime(n)) && (s.type = "video", i.video.push(s), h = !0)
        }
        if (h) break;
        c -= Il, d -= Il
      }
  }

  function Sl(e) {
    var t = {
        pid: null,
        table: null
      },
      i = {};
    for (var n in function (e, t) {
        for (var i, n = 0, r = Il; r < e.byteLength;)
          if (71 !== e[n] || 71 !== e[r]) n++, r++;
          else {
            switch (i = e.subarray(n, r), _l.ts.parseType(i, t.pid)) {
              case "pat":
                t.pid || (t.pid = _l.ts.parsePat(i));
                break;
              case "pmt":
                t.table || (t.table = _l.ts.parsePmt(i))
            }
            if (t.pid && t.table) return;
            n += Il, r += Il
          }
      }(e, t), t.table) {
      if (t.table.hasOwnProperty(n)) switch (t.table[n]) {
        case Zu:
          i.video = [], Tl(e, t, i), 0 === i.video.length && delete i.video;
          break;
        case el:
          i.audio = [], bl(e, t, i), 0 === i.audio.length && delete i.audio
      }
    }
    return i
  }
  var El, kl, wl, Cl = gl,
    Il = 188,
    xl = function (e, t) {
      var i;
      return (i = _l.aac.isLikelyAacData(e) ? function (e) {
        for (var t, i = !1, n = 0, r = null, a = null, s = 0, o = 0; 3 <= e.length - o;) {
          switch (_l.aac.parseType(e, o)) {
            case "timed-metadata":
              if (e.length - o < 10) {
                i = !0;
                break
              }
              if ((s = _l.aac.parseId3TagSize(e, o)) > e.length) {
                i = !0;
                break
              }
              null === a && (t = e.subarray(o, o + s), a = _l.aac.parseAacTimestamp(t)), o += s;
              break;
            case "audio":
              if (e.length - o < 7) {
                i = !0;
                break
              }
              if ((s = _l.aac.parseAdtsSize(e, o)) > e.length) {
                i = !0;
                break
              }
              null === r && (t = e.subarray(o, o + s), r = _l.aac.parseSampleRate(t)), n++, o += s;
              break;
            default:
              o++
          }
          if (i) return null
        }
        if (null === r || null === a) return null;
        var u = Cl / r;
        return {
          audio: [{
            type: "audio",
            dts: a,
            pts: a
          }, {
            type: "audio",
            dts: a + 1024 * n * u,
            pts: a + 1024 * n * u
          }]
        }
      }(e) : Sl(e)) && (i.audio || i.video) ? (function (e, t) {
        if (e.audio && e.audio.length) {
          var i = t;
          "undefined" != typeof i && !isNaN(i) || (i = e.audio[0].dts), e.audio.forEach(function (e) {
            e.dts = yl(e.dts, i), e.pts = yl(e.pts, i), e.dtsTime = e.dts / Cl, e.ptsTime = e.pts / Cl
          })
        }
        if (e.video && e.video.length) {
          var n = t;
          if ("undefined" != typeof n && !isNaN(n) || (n = e.video[0].dts), e.video.forEach(function (e) {
              e.dts = yl(e.dts, n), e.pts = yl(e.pts, n), e.dtsTime = e.dts / Cl, e.ptsTime = e.pts / Cl
            }), e.firstKeyFrame) {
            var r = e.firstKeyFrame;
            r.dts = yl(r.dts, n), r.pts = yl(r.pts, n), r.dtsTime = r.dts / Cl, r.ptsTime = r.pts / Cl
          }
        }
      }(i, t), i) : null
    },
    Al = function (e) {
      return e >>> 0
    },
    Pl = function (e) {
      var t = "";
      return t += String.fromCharCode(e[0]), t += String.fromCharCode(e[1]), t += String.fromCharCode(e[2]), t += String.fromCharCode(e[3])
    },
    Ll = Al,
    Ol = function e(t, i) {
      var n, r, a, s, o, u = [];
      if (!i.length) return null;
      for (n = 0; n < t.byteLength;) r = Ll(t[n] << 24 | t[n + 1] << 16 | t[n + 2] << 8 | t[n + 3]), a = Pl(t.subarray(n + 4, n + 8)), s = 1 < r ? n + r : t.byteLength, a === i[0] && (1 === i.length ? u.push(t.subarray(n + 8, s)) : (o = e(t.subarray(n + 8, s), i.slice(1))).length && (u = u.concat(o))), n = s;
      return u
    },
    Dl = function (e) {
      var t, i = new DataView(e.buffer, e.byteOffset, e.byteLength),
        n = {
          version: e[0],
          flags: new Uint8Array(e.subarray(1, 4)),
          trackId: i.getUint32(4)
        },
        r = 1 & n.flags[2],
        a = 2 & n.flags[2],
        s = 8 & n.flags[2],
        o = 16 & n.flags[2],
        u = 32 & n.flags[2],
        l = 65536 & n.flags[0],
        c = 131072 & n.flags[0];
      return t = 8, r && (t += 4, n.baseDataOffset = i.getUint32(12), t += 4), a && (n.sampleDescriptionIndex = i.getUint32(t), t += 4), s && (n.defaultSampleDuration = i.getUint32(t), t += 4), o && (n.defaultSampleSize = i.getUint32(t), t += 4), u && (n.defaultSampleFlags = i.getUint32(t)), l && (n.durationIsEmpty = !0), !r && c && (n.baseDataOffsetIsMoof = !0), n
    },
    Rl = function (e) {
      return {
        isLeading: (12 & e[0]) >>> 2,
        dependsOn: 3 & e[0],
        isDependedOn: (192 & e[1]) >>> 6,
        hasRedundancy: (48 & e[1]) >>> 4,
        paddingValue: (14 & e[1]) >>> 1,
        isNonSyncSample: 1 & e[1],
        degradationPriority: e[2] << 8 | e[3]
      }
    },
    Ml = function (e) {
      var t, i = {
          version: e[0],
          flags: new Uint8Array(e.subarray(1, 4)),
          samples: []
        },
        n = new DataView(e.buffer, e.byteOffset, e.byteLength),
        r = 1 & i.flags[2],
        a = 4 & i.flags[2],
        s = 1 & i.flags[1],
        o = 2 & i.flags[1],
        u = 4 & i.flags[1],
        l = 8 & i.flags[1],
        c = n.getUint32(4),
        d = 8;
      for (r && (i.dataOffset = n.getInt32(d), d += 4), a && c && (t = {
          flags: Rl(e.subarray(d, d + 4))
        }, d += 4, s && (t.duration = n.getUint32(d), d += 4), o && (t.size = n.getUint32(d), d += 4), l && (1 === i.version ? t.compositionTimeOffset = n.getInt32(d) : t.compositionTimeOffset = n.getUint32(d), d += 4), i.samples.push(t), c--); c--;) t = {}, s && (t.duration = n.getUint32(d), d += 4), o && (t.size = n.getUint32(d), d += 4), u && (t.flags = Rl(e.subarray(d, d + 4)), d += 4), l && (1 === i.version ? t.compositionTimeOffset = n.getInt32(d) : t.compositionTimeOffset = n.getUint32(d), d += 4), i.samples.push(t);
      return i
    },
    Nl = Al,
    Ul = function (e) {
      var t = {
        version: e[0],
        flags: new Uint8Array(e.subarray(1, 4)),
        baseMediaDecodeTime: Nl(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7])
      };
      return 1 === t.version && (t.baseMediaDecodeTime *= Math.pow(2, 32), t.baseMediaDecodeTime += Nl(e[8] << 24 | e[9] << 16 | e[10] << 8 | e[11])), t
    },
    Bl = Al,
    Fl = function (e) {
      return ("00" + e.toString(16)).slice(-2)
    };
  El = function (a, e) {
    var t, i, n;
    return t = Ol(e, ["moof", "traf"]), i = [].concat.apply([], t.map(function (r) {
      return Ol(r, ["tfhd"]).map(function (e) {
        var t, i, n;
        return t = Bl(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7]), i = a[t] || 9e4, (n = "number" != typeof (n = Ol(r, ["tfdt"]).map(function (e) {
          var t, i;
          return t = e[0], i = Bl(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7]), 1 === t && (i *= Math.pow(2, 32), i += Bl(e[8] << 24 | e[9] << 16 | e[10] << 8 | e[11])), i
        })[0]) || isNaN(n) ? 1 / 0 : n) / i
      })
    })), n = Math.min.apply(null, i), isFinite(n) ? n : 0
  }, kl = function (e) {
    var t = Ol(e, ["moov", "trak"]),
      h = [];
    return t.forEach(function (e) {
      var t, i, n = {},
        r = Ol(e, ["tkhd"])[0];
      r && (i = (t = new DataView(r.buffer, r.byteOffset, r.byteLength)).getUint8(0), n.id = 0 === i ? t.getUint32(12) : t.getUint32(20));
      var a = Ol(e, ["mdia", "hdlr"])[0];
      if (a) {
        var s = Pl(a.subarray(8, 12));
        n.type = "vide" === s ? "video" : "soun" === s ? "audio" : s
      }
      var o = Ol(e, ["mdia", "minf", "stbl", "stsd"])[0];
      if (o) {
        var u = o.subarray(8);
        n.codec = Pl(u.subarray(4, 8));
        var l, c = Ol(u, [n.codec])[0];
        c && (/^[a-z]vc[1-9]$/i.test(n.codec) ? (l = c.subarray(78), "avcC" === Pl(l.subarray(4, 8)) && 11 < l.length ? (n.codec += ".", n.codec += Fl(l[9]), n.codec += Fl(l[10]), n.codec += Fl(l[11])) : n.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(n.codec) ? (l = c.subarray(28), "esds" === Pl(l.subarray(4, 8)) && 20 < l.length && 0 !== l[19] ? (n.codec += "." + Fl(l[19]), n.codec += "." + Fl(l[20] >>> 2 & 63).replace(/^0/, "")) : n.codec = "mp4a.40.2") : n.codec = n.codec.toLowerCase())
      }
      var d = Ol(e, ["mdia", "mdhd"])[0];
      d && (n.timescale = wl(d)), h.push(n)
    }), h
  };

  function jl(e, t, i) {
    return e && i && i.responseURL && t !== i.responseURL ? i.responseURL : t
  }

  function Hl(e) {
    return ya.log.debug ? ya.log.debug.bind(ya, "VHS:", e + " >") : function () {}
  }

  function Vl(e, t) {
    return e + "-" + t
  }

  function ql(e) {
    var t = e.onwarn,
      i = e.oninfo,
      n = e.manifestString,
      r = e.customTagParsers,
      a = void 0 === r ? [] : r,
      s = e.customTagMappers,
      o = void 0 === s ? [] : s,
      u = e.experimentalLLHLS,
      l = new $a;
    t && l.on("warn", t), i && l.on("info", i), a.forEach(function (e) {
      return l.addParser(e)
    }), o.forEach(function (e) {
      return l.addTagMapper(e)
    }), l.push(n), l.end();
    var c = l.manifest;
    if (u || (["preloadSegment", "skip", "serverControl", "renditionReports", "partInf", "partTargetDuration"].forEach(function (e) {
        c.hasOwnProperty(e) && delete c[e]
      }), c.segments && c.segments.forEach(function (t) {
        ["parts", "preloadHints"].forEach(function (e) {
          t.hasOwnProperty(e) && delete t[e]
        })
      })), !c.targetDuration) {
      var d = 10;
      c.segments && c.segments.length && (d = c.segments.reduce(function (e, t) {
        return Math.max(e, t.duration)
      }, 0)), t && t("manifest has no targetDuration defaulting to " + d), c.targetDuration = d
    }
    return c
  }

  function Wl(r, a) {
    ["AUDIO", "SUBTITLES"].forEach(function (e) {
      for (var t in r.mediaGroups[e])
        for (var i in r.mediaGroups[e][t]) {
          var n = r.mediaGroups[e][t][i];
          a(n, e, t, i)
        }
    })
  }

  function zl(e) {
    var t = e.playlist,
      i = e.uri,
      n = e.id;
    t.id = n, i && (t.uri = i), t.attributes = t.attributes || {}
  }

  function Gl(s, e) {
    s.uri = e;
    for (var t = 0; t < s.playlists.length; t++)
      if (!s.playlists[t].uri) {
        var i = "placeholder-uri-" + t;
        s.playlists[t].uri = i
      } Wl(s, function (e, t, i, n) {
        if (e.playlists && e.playlists.length && !e.playlists[0].uri) {
          var r = "placeholder-uri-" + t + "-" + i + "-" + n,
            a = Vl(0, r);
          e.playlists[0].uri = r, e.playlists[0].id = a, s.playlists[a] = e.playlists[0], s.playlists[r] = e.playlists[0]
        }
      }),
      function (e) {
        for (var t = e.playlists.length; t--;) {
          var i = e.playlists[t];
          zl({
            playlist: i,
            id: Vl(t, i.uri)
          }), i.resolvedUri = md(e.uri, i.uri), e.playlists[i.id] = i, (e.playlists[i.uri] = i).attributes.BANDWIDTH || gd.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.")
        }
      }(s),
      function (t) {
        Wl(t, function (e) {
          e.uri && (e.resolvedUri = md(t.uri, e.uri))
        })
      }(s)
  }

  function Xl(e, t) {
    if (!e) return t;
    var i = vd(e, t);
    if (e.parts && !t.parts) delete i.parts;
    else if (e.parts && t.parts)
      for (var n = 0; n < t.parts.length; n++) e.parts && e.parts[n] && (i.parts[n] = vd(e.parts[n], t.parts[n]));
    return i
  }

  function Kl(e, t) {
    !e.resolvedUri && e.uri && (e.resolvedUri = md(t, e.uri)), e.key && !e.key.resolvedUri && (e.key.resolvedUri = md(t, e.key.uri)), e.map && !e.map.resolvedUri && (e.map.resolvedUri = md(t, e.map.uri)), e.parts && e.parts.length && e.parts.forEach(function (e) {
      e.resolvedUri || (e.resolvedUri = md(t, e.uri))
    }), e.preloadHints && e.preloadHints.length && e.preloadHints.forEach(function (e) {
      e.resolvedUri || (e.resolvedUri = md(t, e.uri))
    })
  }

  function Yl(e) {
    var t = e.segments || [];
    return e.preloadSegment && e.preloadSegment.parts && t.push(e.preloadSegment), t
  }

  function Ql(e, t) {
    return e === t || e.segments && t.segments && e.segments.length === t.segments.length && e.endList === t.endList && e.mediaSequence === t.mediaSequence
  }

  function $l(e, t, i) {
    void 0 === i && (i = Ql);
    var n = vd(e, {}),
      r = n.playlists[t.id];
    if (!r) return null;
    if (i(r, t)) return null;
    var a = vd(r, t);
    t.segments = Yl(t), r.segments && (a.segments = function (e, t, i) {
      var n = e.slice(),
        r = t.slice();
      i = i || 0;
      for (var a = Math.min(e.length, t.length + i), s = i; s < a; s++) {
        var o = s - i;
        r[o] = Xl(n[s], r[o])
      }
      return r
    }(r.segments, t.segments, t.mediaSequence - r.mediaSequence)), a.segments.forEach(function (e) {
      Kl(e, a.resolvedUri)
    });
    for (var s = 0; s < n.playlists.length; s++) n.playlists[s].id === t.id && (n.playlists[s] = a);
    return n.playlists[t.id] = a, n.playlists[t.uri] = a, n
  }

  function Jl(e, t) {
    var i = e.segments[e.segments.length - 1],
      n = i && i.parts && i.parts[i.parts.length - 1],
      r = n && n.duration || i && i.duration;
    return t && r ? 1e3 * r : 500 * (e.partTargetDuration || e.targetDuration || 10)
  }

  function Zl(e, t) {
    var i, n = [];
    if (e && e.length)
      for (i = 0; i < e.length; i++) t(e.start(i), e.end(i)) && n.push([e.start(i), e.end(i)]);
    return ya.createTimeRanges(n)
  }

  function ec(e, i) {
    return Zl(e, function (e, t) {
      return e - .1 <= i && i <= t + .1
    })
  }

  function tc(e, t) {
    return Zl(e, function (e) {
      return t <= e - _d
    })
  }

  function ic(e) {
    var t = [];
    if (!e || !e.length) return "";
    for (var i = 0; i < e.length; i++) t.push(e.start(i) + " => " + e.end(i));
    return t.join(", ")
  }

  function nc(e) {
    for (var t = [], i = 0; i < e.length; i++) t.push({
      start: e.start(i),
      end: e.end(i)
    });
    return t
  }

  function rc(e, t) {
    if (t.endList) return 0;
    if (e && e.suggestedPresentationDelay) return e.suggestedPresentationDelay;
    var i = t.segments && t.segments.length && t.segments[t.segments.length - 1],
      n = i && i.parts && i.parts.length;
    return n && t.serverControl && t.serverControl.partHoldBack ? t.serverControl.partHoldBack : n && t.partTargetDuration ? 3 * t.partTargetDuration : t.serverControl && t.serverControl.holdBack ? t.serverControl.holdBack : t.targetDuration ? 3 * t.targetDuration : 0
  }

  function ac(e, t, i) {
    if ("undefined" == typeof t && (t = e.mediaSequence + e.segments.length), t < e.mediaSequence) return 0;
    var n = function (e, t) {
      var i = 0,
        n = t - e.mediaSequence,
        r = e.segments[n];
      if (r) {
        if ("undefined" != typeof r.start) return {
          result: r.start,
          precise: !0
        };
        if ("undefined" != typeof r.end) return {
          result: r.end - r.duration,
          precise: !0
        }
      }
      for (; n--;) {
        if ("undefined" != typeof (r = e.segments[n]).end) return {
          result: i + r.end,
          precise: !0
        };
        if (i += r.duration, "undefined" != typeof r.start) return {
          result: i + r.start,
          precise: !0
        }
      }
      return {
        result: i,
        precise: !1
      }
    }(e, t);
    if (n.precise) return n.result;
    var r = function (e, t) {
      for (var i, n = 0, r = t - e.mediaSequence; r < e.segments.length; r++) {
        if ("undefined" != typeof (i = e.segments[r]).start) return {
          result: i.start - n,
          precise: !0
        };
        if (n += i.duration, "undefined" != typeof i.end) return {
          result: i.end - n,
          precise: !0
        }
      }
      return {
        result: -1,
        precise: !1
      }
    }(e, t);
    return r.precise ? r.result : n.result + i
  }

  function sc(e, t, i) {
    if (!e) return 0;
    if ("number" != typeof i && (i = 0), "undefined" == typeof t) {
      if (e.totalDuration) return e.totalDuration;
      if (!e.endList) return Ia.Infinity
    }
    return ac(e, t, i)
  }

  function oc(e, t, i) {
    var n = 0;
    if (i < t) {
      var r = [i, t];
      t = r[0], i = r[1]
    }
    if (t < 0) {
      for (var a = t; a < Math.min(0, i); a++) n += e.targetDuration;
      t = 0
    }
    for (var s = t; s < i; s++) n += e.segments[s].duration;
    return n
  }

  function uc(e, t, i, n) {
    if (!e || !e.segments) return null;
    if (e.endList) return sc(e);
    if (null === t) return null;
    t = t || 0;
    var r = ac(e, e.mediaSequence + e.segments.length, t);
    return i && (r -= n = "number" == typeof n ? n : rc(null, e)), Math.max(0, r)
  }

  function lc(e) {
    return e.excludeUntil && e.excludeUntil > Date.now()
  }

  function cc(e) {
    return e.excludeUntil && e.excludeUntil === 1 / 0
  }

  function dc(e) {
    var t = lc(e);
    return !e.disabled && !t
  }

  function hc(e, t) {
    return t.attributes && t.attributes[e]
  }

  function pc(e, t) {
    if (1 === e.playlists.length) return !0;
    var i = t.attributes.BANDWIDTH || Number.MAX_VALUE;
    return 0 === e.playlists.filter(function (e) {
      return !!dc(e) && (e.attributes.BANDWIDTH || 0) < i
    }).length
  }

  function fc(e, t) {
    return !(!e && !t || !e && t || e && !t) && (e === t || (!(!e.id || !t.id || e.id !== t.id) || (!(!e.resolvedUri || !t.resolvedUri || e.resolvedUri !== t.resolvedUri) || !(!e.uri || !t.uri || e.uri !== t.uri))))
  }

  function mc(e, t) {
    var i = e && e.mediaGroups && e.mediaGroups.AUDIO || {},
      n = !1;
    for (var r in i) {
      for (var a in i[r])
        if (n = t(i[r][a])) break;
      if (n) break
    }
    return !!n
  }

  function gc(n) {
    if (!n || !n.playlists || !n.playlists.length) return mc(n, function (e) {
      return e.playlists && e.playlists.length || e.uri
    });
    for (var e = function (e) {
        var t = n.playlists[e],
          i = t.attributes && t.attributes.CODECS;
        return i && i.split(",").every(function (e) {
          return qa(e)
        }) ? "continue" : mc(n, function (e) {
          return fc(t, e)
        }) ? "continue" : {
          v: !1
        }
      }, t = 0; t < n.playlists.length; t++) {
      var i = e(t);
      if ("continue" !== i && "object" == typeof i) return i.v
    }
    return !0
  }

  function vc(e, t, i, n) {
    var r = "arraybuffer" === e.responseType ? e.response : e.responseText;
    !t && r && (e.responseTime = Date.now(), e.roundTripTime = e.responseTime - e.requestTime, e.bytesReceived = r.byteLength || r.length, e.bandwidth || (e.bandwidth = Math.floor(e.bytesReceived / e.roundTripTime * 8 * 1e3))), i.headers && (e.responseHeaders = i.headers), t && "ETIMEDOUT" === t.code && (e.timedout = !0), t || e.aborted || 200 === i.statusCode || 206 === i.statusCode || 0 === i.statusCode || (t = new Error("XHR Failed with a response of: " + (e && (r || e.responseText)))), n(t, e)
  }

  function yc() {
    function s(e, i) {
      e = Ed({
        timeout: 45e3
      }, e);
      var t = s.beforeRequest || ya.Vhs.xhr.beforeRequest;
      if (t && "function" == typeof t) {
        var n = t(e);
        n && (e = n)
      }
      var r = (!0 === ya.Vhs.xhr.original ? Sd : ya.Vhs.xhr)(e, function (e, t) {
          return vc(r, e, t, i)
        }),
        a = r.abort;
      return r.abort = function () {
        return r.aborted = !0, a.apply(r, arguments)
      }, r.uri = e.uri, r.requestTime = Date.now(), r
    }
    return s.original = !0, s
  }

  function _c(e) {
    var t = {};
    return e.byterange && (t.Range = function (e) {
      var t = e.offset + e.length - 1;
      return "bytes=" + e.offset + "-" + t
    }(e.byterange)), t
  }

  function bc(e, t) {
    var i = e.toString(16);
    return "00".substring(0, 2 - i.length) + i + (t % 2 ? " " : "")
  }

  function Tc(e) {
    return 32 <= e && e < 126 ? String.fromCharCode(e) : "."
  }

  function Sc(i) {
    var n = {};
    return Object.keys(i).forEach(function (e) {
      var t = i[e];
      ArrayBuffer.isView(t) ? n[e] = {
        bytes: t.buffer,
        byteOffset: t.byteOffset,
        byteLength: t.byteLength
      } : n[e] = t
    }), n
  }

  function Ec(e) {
    var t = e.byterange || {
      length: 1 / 0,
      offset: 0
    };
    return [t.length, t.offset, e.resolvedUri].join(",")
  }

  function kc(e) {
    return e.resolvedUri
  }

  function wc(e) {
    for (var t = Array.prototype.slice.call(e), i = "", n = 0; n < t.length / 16; n++) i += t.slice(16 * n, 16 * n + 16).map(bc).join("") + " " + t.slice(16 * n, 16 * n + 16).map(Tc).join("") + "\n";
    return i
  }

  function Cc(e) {
    var t = e.playlist,
      i = e.time,
      n = void 0 === i ? void 0 : i,
      r = e.callback;
    if (!r) throw new Error("getProgramTime: callback must be provided");
    if (!t || void 0 === n) return r({
      message: "getProgramTime: playlist and time must be provided"
    });
    var a = function (e, t) {
      if (!t || !t.segments || 0 === t.segments.length) return null;
      for (var i, n = 0, r = 0; r < t.segments.length && !(e <= (n = (i = t.segments[r]).videoTimingInfo ? i.videoTimingInfo.transmuxedPresentationEnd : n + i.duration)); r++);
      var a = t.segments[t.segments.length - 1];
      if (a.videoTimingInfo && a.videoTimingInfo.transmuxedPresentationEnd < e) return null;
      if (n < e) {
        if (e > n + .25 * a.duration) return null;
        i = a
      }
      return {
        segment: i,
        estimatedStart: i.videoTimingInfo ? i.videoTimingInfo.transmuxedPresentationStart : n - i.duration,
        type: i.videoTimingInfo ? "accurate" : "estimate"
      }
    }(n, t);
    if (!a) return r({
      message: "valid programTime was not found"
    });
    if ("estimate" === a.type) return r({
      message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
      seekTime: a.estimatedStart
    });
    var s = {
        mediaSeconds: n
      },
      o = function (e, t) {
        if (!t.dateTimeObject) return null;
        var i = t.videoTimingInfo.transmuxerPrependedSeconds,
          n = e - (t.videoTimingInfo.transmuxedPresentationStart + i);
        return new Date(t.dateTimeObject.getTime() + 1e3 * n)
      }(n, a.segment);
    return o && (s.programDateTime = o.toISOString()), r(null, s)
  }

  function Ic(e) {
    var t = e.programTime,
      i = e.playlist,
      n = e.retryCount,
      r = void 0 === n ? 2 : n,
      a = e.seekTo,
      s = e.pauseAfterSeek,
      o = void 0 === s || s,
      u = e.tech,
      l = e.callback;
    if (!l) throw new Error("seekToProgramTime: callback must be provided");
    if ("undefined" == typeof t || !i || !a) return l({
      message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
    if (!i.endList && !u.hasStarted_) return l({
      message: "player must be playing a live stream to start buffering"
    });
    if (! function (e) {
        if (!e.segments || 0 === e.segments.length) return !1;
        for (var t = 0; t < e.segments.length; t++) {
          if (!e.segments[t].dateTimeObject) return !1
        }
        return !0
      }(i)) return l({
      message: "programDateTime tags must be provided in the manifest " + i.resolvedUri
    });
    var c = function (e, t) {
      var i;
      try {
        i = new Date(e)
      } catch (e) {
        return null
      }
      if (!t || !t.segments || 0 === t.segments.length) return null;
      var n = t.segments[0];
      if (i < n.dateTimeObject) return null;
      for (var r = 0; r < t.segments.length - 1; r++) {
        if (n = t.segments[r], i < t.segments[r + 1].dateTimeObject) break
      }
      var a = t.segments[t.segments.length - 1],
        s = a.dateTimeObject,
        o = a.videoTimingInfo ? function (e) {
          return e.transmuxedPresentationEnd - e.transmuxedPresentationStart - e.transmuxerPrependedSeconds
        }(a.videoTimingInfo) : a.duration + .25 * a.duration;
      return new Date(s.getTime() + 1e3 * o) < i ? null : (s < i && (n = a), {
        segment: n,
        estimatedStart: n.videoTimingInfo ? n.videoTimingInfo.transmuxedPresentationStart : Td.duration(t, t.mediaSequence + t.segments.indexOf(n)),
        type: n.videoTimingInfo ? "accurate" : "estimate"
      })
    }(t, i);
    if (!c) return l({
      message: t + " was not found in the stream"
    });
    var d = c.segment,
      h = function (e, t) {
        var i, n;
        try {
          i = new Date(e), n = new Date(t)
        } catch (e) {}
        var r = i.getTime();
        return (n.getTime() - r) / 1e3
      }(d.dateTimeObject, t);
    if ("estimate" === c.type) return 0 === r ? l({
      message: t + " is not buffered yet. Try again"
    }) : (a(c.estimatedStart + h), void u.one("seeked", function () {
      Ic({
        programTime: t,
        playlist: i,
        retryCount: r - 1,
        seekTo: a,
        pauseAfterSeek: o,
        tech: u,
        callback: l
      })
    }));
    var p = d.start + h;
    u.one("seeked", function () {
      return l(null, u.currentTime())
    }), o && u.pause(), a(p)
  }

  function xc(e, t) {
    if (4 === e.readyState) return t()
  }

  function Ac(e, t, r) {
    function a(e, t, i, n) {
      return t.abort(), u = !0, r(e, t, i, n)
    }

    function i(e, t) {
      if (!u) {
        if (e) return a(e, t, "", o);
        var i = t.responseText.substring(o && o.byteLength || 0, t.responseText.length);
        if (o = function () {
            for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
            if ((t = t.filter(function (e) {
                return e && (e.byteLength || e.length) && "string" != typeof e
              })).length <= 1) return cu(t[0]);
            var n = t.reduce(function (e, t, i) {
                return e + (t.byteLength || t.length)
              }, 0),
              r = new Uint8Array(n),
              a = 0;
            return t.forEach(function (e) {
              e = cu(e), r.set(e, a), a += e.byteLength
            }), r
          }(o, hu(i, !0)), s = s || fu(o), o.length < 10 || s && o.length < s + 2) return xc(t, function () {
          return a(e, t, "", o)
        });
        var n = Yu(o);
        return "ts" === n && o.length < 188 ? xc(t, function () {
          return a(e, t, "", o)
        }) : !n && o.length < 376 ? xc(t, function () {
          return a(e, t, "", o)
        }) : a(null, t, n, o)
      }
    }
    var s, o = [],
      u = !1,
      n = t({
        uri: e,
        beforeSend: function (t) {
          t.overrideMimeType("text/plain; charset=x-user-defined"), t.addEventListener("progress", function (e) {
            return e.total, e.loaded, vc(t, null, {
              statusCode: t.status
            }, i)
          })
        }
      }, function (e, t) {
        return vc(n, e, t, i)
      });
    return n
  }

  function Pc(e, t) {
    if (!Ql(e, t)) return !1;
    if (e.sidx && t.sidx && (e.sidx.offset !== t.sidx.offset || e.sidx.length !== t.sidx.length)) return !1;
    if (!e.sidx && t.sidx || e.sidx && !t.sidx) return !1;
    if (e.segments && !t.segments || !e.segments && t.segments) return !1;
    if (!e.segments && !t.segments) return !0;
    for (var i = 0; i < e.segments.length; i++) {
      var n = e.segments[i],
        r = t.segments[i];
      if (n.uri !== r.uri) return !1;
      if (n.byterange || r.byterange) {
        var a = n.byterange,
          s = r.byterange;
        if (a && !s || !a && s) return !1;
        if (a.offset !== s.offset || a.length !== s.length) return !1
      }
    }
    return !0
  }

  function Lc(e, t) {
    var i, n, r = {};
    for (var a in e) {
      var s = e[a].sidx;
      if (s) {
        var o = jo(s);
        if (!t[o]) break;
        var u = t[o].sidxInfo;
        i = u, n = s, (Boolean(!i.map && !n.map) || Boolean(i.map && n.map && i.map.byterange.offset === n.map.byterange.offset && i.map.byterange.length === n.map.byterange.length)) && i.uri === n.uri && i.byterange.offset === n.byterange.offset && i.byterange.length === n.byterange.length && (r[o] = t[o])
      }
    }
    return r
  }

  function Oc(e) {
    for (var t = new Uint8Array(new ArrayBuffer(e.length)), i = 0; i < e.length; i++) t[i] = e.charCodeAt(i);
    return t.buffer
  }

  function Dc(e) {
    return e.on = e.addEventListener, e.off = e.removeEventListener, e
  }

  function Rc(n) {
    return function () {
      var e = function (t) {
          try {
            return URL.createObjectURL(new Blob([t], {
              type: "application/javascript"
            }))
          } catch (e) {
            var i = new BlobBuilder;
            return i.append(t), URL.createObjectURL(i.getBlob())
          }
        }(n),
        t = Dc(new Worker(e));
      t.objURL = e;
      var i = t.terminate;
      return t.on = t.addEventListener, t.off = t.removeEventListener, t.terminate = function () {
        return URL.revokeObjectURL(e), i.call(this)
      }, t
    }
  }

  function Mc(e) {
    return "var browserWorkerPolyFill = " + Dc.toString() + ";\nbrowserWorkerPolyFill(self);\n" + e
  }

  function Nc(e) {
    return e.toString().replace(/^function.+?{/, "").slice(0, -1)
  }

  function Uc(t) {
    var i = t.transmuxer,
      e = t.bytes,
      n = t.audioAppendStart,
      r = t.gopsToAlignWith,
      a = t.isPartial,
      s = t.remux,
      o = t.onData,
      u = t.onTrackInfo,
      l = t.onAudioTimingInfo,
      c = t.onVideoTimingInfo,
      d = t.onVideoSegmentTimingInfo,
      h = t.onAudioSegmentTimingInfo,
      p = t.onId3,
      f = t.onCaptions,
      m = t.onDone,
      g = t.onEndedTimeline,
      v = t.isEndOfTimeline,
      y = {
        isPartial: a,
        buffer: []
      },
      _ = v;
    if (i.onmessage = function (e) {
        i.currentTransmux === t && ("data" === e.data.action && function (e, t, i) {
          var n = e.data.segment,
            r = n.type,
            a = n.initSegment,
            s = n.captions,
            o = n.captionStreams,
            u = n.metadata,
            l = n.videoFrameDtsTime,
            c = n.videoFramePtsTime;
          t.buffer.push({
            captions: s,
            captionStreams: o,
            metadata: u
          });
          var d = e.data.segment.boxes || {
              data: e.data.segment.data
            },
            h = {
              type: r,
              data: new Uint8Array(d.data, d.data.byteOffset, d.data.byteLength),
              initSegment: new Uint8Array(a.data, a.byteOffset, a.byteLength)
            };
          "undefined" != typeof l && (h.videoFrameDtsTime = l), "undefined" != typeof c && (h.videoFramePtsTime = c), i(h)
        }(e, y, o), "trackinfo" === e.data.action && u(e.data.trackInfo), "gopInfo" === e.data.action && function (e, t) {
          t.gopInfo = e.data.gopInfo
        }(e, y), "audioTimingInfo" === e.data.action && l(e.data.audioTimingInfo), "videoTimingInfo" === e.data.action && c(e.data.videoTimingInfo), "videoSegmentTimingInfo" === e.data.action && d(e.data.videoSegmentTimingInfo), "audioSegmentTimingInfo" === e.data.action && h(e.data.audioSegmentTimingInfo), "id3Frame" === e.data.action && p([e.data.id3Frame], e.data.id3Frame.dispatchType), "caption" === e.data.action && f(e.data.caption), "endedtimeline" === e.data.action && (_ = !1, g()), "transmuxed" === e.data.type && (_ || (i.onmessage = null, function (e) {
          var t = e.transmuxedData,
            i = e.callback;
          t.buffer = [], i(t)
        }({
          transmuxedData: y,
          callback: m
        }), Ad(i))))
      }, n && i.postMessage({
        action: "setAudioAppendStart",
        appendStart: n
      }), Array.isArray(r) && i.postMessage({
        action: "alignGopsWith",
        gopsToAlignWith: r
      }), "undefined" != typeof s && i.postMessage({
        action: "setRemux",
        remux: s
      }), e.byteLength) {
      var b = e instanceof ArrayBuffer ? e : e.buffer,
        T = e instanceof ArrayBuffer ? 0 : e.byteOffset;
      i.postMessage({
        action: "push",
        data: b,
        byteOffset: T,
        byteLength: e.byteLength
      }, [b])
    }
    i.postMessage({
      action: a ? "partialFlush" : "flush"
    }), v && i.postMessage({
      action: "endTimeline"
    })
  }

  function Bc(e, t) {
    e.postMessage({
      action: t
    }), Ad(e)
  }

  function Fc(e, t) {
    if (!t.currentTransmux) return t.currentTransmux = e, void Bc(t, e);
    t.transmuxQueue.push(Bc.bind(null, t, e))
  }

  function jc(e) {
    if (!e.transmuxer.currentTransmux) return e.transmuxer.currentTransmux = e, void Uc(e);
    e.transmuxer.transmuxQueue.push(e)
  }

  function Hc(e) {
    e.forEach(function (e) {
      e.abort()
    })
  }

  function Vc(e, t) {
    return t.timedout ? {
      status: t.status,
      message: "HLS request timed-out at URL: " + t.uri,
      code: Dd,
      xhr: t
    } : t.aborted ? {
      status: t.status,
      message: "HLS request aborted at URL: " + t.uri,
      code: Rd,
      xhr: t
    } : e ? {
      status: t.status,
      message: "HLS request errored at URL: " + t.uri,
      code: Od,
      xhr: t
    } : null
  }

  function qc(e) {
    var i = e.segment,
      t = e.bytes,
      n = e.isPartial,
      r = e.trackInfoFn,
      a = e.timingInfoFn,
      s = e.videoSegmentTimingInfoFn,
      o = e.audioSegmentTimingInfoFn,
      u = e.id3Fn,
      l = e.captionsFn,
      c = e.isEndOfTimeline,
      d = e.endedTimelineFn,
      h = e.dataFn,
      p = e.doneFn,
      f = i.map && i.map.tracks || {},
      m = Boolean(f.audio && f.video),
      g = a.bind(null, i, "audio", "start"),
      v = a.bind(null, i, "audio", "end"),
      y = a.bind(null, i, "video", "start"),
      _ = a.bind(null, i, "video", "end");
    if (!n && !i.lastReachedChar) {
      var b = function (e, t) {
        var i = "number" != typeof t || isNaN(t) ? void 0 : t * vl,
          n = xl(e, i);
        if (!n) return null;
        var r = {
          hasVideo: n.video && 2 === n.video.length || !1,
          hasAudio: n.audio && 2 === n.audio.length || !1
        };
        return r.hasVideo && (r.videoStart = n.video[0].ptsTime), r.hasAudio && (r.audioStart = n.audio[0].ptsTime), r
      }(t, i.baseStartTime);
      b && (r(i, {
        hasAudio: b.hasAudio,
        hasVideo: b.hasVideo,
        isMuxed: m
      }), r = null, b.hasAudio && !m && g(b.audioStart), b.hasVideo && y(b.videoStart), y = g = null)
    }
    jc({
      bytes: t,
      transmuxer: i.transmuxer,
      audioAppendStart: i.audioAppendStart,
      gopsToAlignWith: i.gopsToAlignWith,
      isPartial: n,
      remux: m,
      onData: function (e) {
        e.type = "combined" === e.type ? "video" : e.type, h(i, e)
      },
      onTrackInfo: function (e) {
        r && (m && (e.isMuxed = !0), r(i, e))
      },
      onAudioTimingInfo: function (e) {
        g && "undefined" != typeof e.start && (g(e.start), g = null), v && "undefined" != typeof e.end && v(e.end)
      },
      onVideoTimingInfo: function (e) {
        y && "undefined" != typeof e.start && (y(e.start), y = null), _ && "undefined" != typeof e.end && _(e.end)
      },
      onVideoSegmentTimingInfo: function (e) {
        s(e)
      },
      onAudioSegmentTimingInfo: function (e) {
        o(e)
      },
      onId3: function (e, t) {
        u(i, e, t)
      },
      onCaptions: function (e) {
        l(i, [e])
      },
      isEndOfTimeline: c && !n,
      onEndedTimeline: function () {
        d()
      },
      onDone: function (e) {
        p && !n && (e.type = "combined" === e.type ? "video" : e.type, p(null, i, e))
      }
    })
  }

  function Wc(e) {
    var n = e.segment,
      r = e.bytes,
      t = e.isPartial,
      i = e.trackInfoFn,
      a = e.timingInfoFn,
      s = e.videoSegmentTimingInfoFn,
      o = e.audioSegmentTimingInfoFn,
      u = e.id3Fn,
      l = e.captionsFn,
      c = e.isEndOfTimeline,
      d = e.endedTimelineFn,
      h = e.dataFn,
      p = e.doneFn,
      f = new Uint8Array(r);
    if (Qu(f)) {
      n.isFmp4 = !0;
      var m = n.map.tracks,
        g = {
          isFmp4: !0,
          hasVideo: !!m.video,
          hasAudio: !!m.audio
        };
      m.audio && m.audio.codec && "enca" !== m.audio.codec && (g.audioCodec = m.audio.codec), m.video && m.video.codec && "encv" !== m.video.codec && (g.videoCodec = m.video.codec), m.video && m.audio && (g.isMuxed = !0), i(n, g);
      var v = pd(n.map.timescales, f);
      g.hasAudio && !g.isMuxed && a(n, "audio", "start", v), g.hasVideo && a(n, "video", "start", v);
      var y = function (e) {
        h(n, {
          data: r,
          type: g.hasAudio && !g.isMuxed ? "audio" : "video"
        }), e && e.length && l(n, e), p(null, n, {})
      };
      if (!m.video || !r.byteLength || !n.transmuxer) return void y();
      var _ = r instanceof ArrayBuffer ? r : r.buffer,
        b = r instanceof ArrayBuffer ? 0 : r.byteOffset;
      return n.transmuxer.addEventListener("message", function e(t) {
        if ("mp4Captions" === t.data.action) {
          n.transmuxer.removeEventListener("message", e);
          var i = t.data.data;
          n.bytes = r = new Uint8Array(i, i.byteOffset || 0, i.byteLength), y(t.data.captions)
        }
      }), void n.transmuxer.postMessage({
        action: "pushMp4Captions",
        timescales: n.map.timescales,
        trackIds: [m.video.id],
        data: _,
        byteOffset: b,
        byteLength: r.byteLength
      }, [_])
    }
    if (n.transmuxer) {
      if ("undefined" == typeof n.container && (n.container = Yu(f)), "ts" !== n.container && "aac" !== n.container) return i(n, {
        hasAudio: !1,
        hasVideo: !1
      }), void p(null, n, {});
      qc({
        segment: n,
        bytes: r,
        isPartial: t,
        trackInfoFn: i,
        timingInfoFn: a,
        videoSegmentTimingInfoFn: s,
        audioSegmentTimingInfoFn: o,
        id3Fn: u,
        captionsFn: l,
        isEndOfTimeline: c,
        endedTimelineFn: d,
        dataFn: h,
        doneFn: p
      })
    } else p(null, n, {})
  }

  function zc(e) {
    var i = e.activeXhrs,
      n = e.decryptionWorker,
      r = e.trackInfoFn,
      a = e.timingInfoFn,
      s = e.videoSegmentTimingInfoFn,
      o = e.audioSegmentTimingInfoFn,
      u = e.id3Fn,
      l = e.captionsFn,
      c = e.isEndOfTimeline,
      d = e.endedTimelineFn,
      h = e.dataFn,
      p = e.doneFn,
      f = 0,
      m = !1;
    return function (e, t) {
      if (!m) {
        if (e) return m = !0, Hc(i), p(e, t);
        if ((f += 1) === i.length) {
          if (t.endOfAllRequests = Date.now(), t.encryptedBytes) return function (e) {
            var t, n = e.decryptionWorker,
              r = e.segment,
              a = e.trackInfoFn,
              s = e.timingInfoFn,
              o = e.videoSegmentTimingInfoFn,
              u = e.audioSegmentTimingInfoFn,
              l = e.id3Fn,
              c = e.captionsFn,
              d = e.isEndOfTimeline,
              h = e.endedTimelineFn,
              p = e.dataFn,
              f = e.doneFn;
            n.addEventListener("message", function e(t) {
              if (t.data.source === r.requestId) {
                n.removeEventListener("message", e);
                var i = t.data.decrypted;
                r.bytes = new Uint8Array(i.bytes, i.byteOffset, i.byteLength), Wc({
                  segment: r,
                  bytes: r.bytes,
                  isPartial: !1,
                  trackInfoFn: a,
                  timingInfoFn: s,
                  videoSegmentTimingInfoFn: o,
                  audioSegmentTimingInfoFn: u,
                  id3Fn: l,
                  captionsFn: c,
                  isEndOfTimeline: d,
                  endedTimelineFn: h,
                  dataFn: p,
                  doneFn: f
                })
              }
            }), t = r.key.bytes.slice ? r.key.bytes.slice() : new Uint32Array(Array.prototype.slice.call(r.key.bytes)), n.postMessage(Sc({
              source: r.requestId,
              encrypted: r.encryptedBytes,
              key: t,
              iv: r.key.iv
            }), [r.encryptedBytes.buffer, t.buffer])
          }({
            decryptionWorker: n,
            segment: t,
            trackInfoFn: r,
            timingInfoFn: a,
            videoSegmentTimingInfoFn: s,
            audioSegmentTimingInfoFn: o,
            id3Fn: u,
            captionsFn: l,
            isEndOfTimeline: c,
            endedTimelineFn: d,
            dataFn: h,
            doneFn: p
          });
          Wc({
            segment: t,
            bytes: t.bytes,
            isPartial: !1,
            trackInfoFn: r,
            timingInfoFn: a,
            videoSegmentTimingInfoFn: s,
            audioSegmentTimingInfoFn: o,
            id3Fn: u,
            captionsFn: l,
            isEndOfTimeline: c,
            endedTimelineFn: d,
            dataFn: h,
            doneFn: p
          })
        }
      }
    }
  }

  function Gc(e) {
    var n = e.segment,
      r = e.progressFn,
      a = e.trackInfoFn,
      s = e.timingInfoFn,
      o = e.videoSegmentTimingInfoFn,
      u = e.audioSegmentTimingInfoFn,
      l = e.id3Fn,
      c = e.captionsFn,
      d = e.isEndOfTimeline,
      h = e.endedTimelineFn,
      p = e.dataFn,
      f = e.handlePartialData;
    return function (e) {
      var t = e.target;
      if (!t.aborted) {
        if (f && !n.key && t.responseText && 8 <= t.responseText.length) {
          var i = Oc(t.responseText.substring(n.lastReachedChar || 0));
          !n.lastReachedChar && Qu(new Uint8Array(i)) || (n.lastReachedChar = t.responseText.length, Wc({
            segment: n,
            bytes: i,
            isPartial: !0,
            trackInfoFn: a,
            timingInfoFn: s,
            videoSegmentTimingInfoFn: o,
            audioSegmentTimingInfoFn: u,
            id3Fn: l,
            captionsFn: c,
            isEndOfTimeline: d,
            endedTimelineFn: h,
            dataFn: p
          }))
        }
        return n.stats = ya.mergeOptions(n.stats, function (e) {
          var t = e.target,
            i = {
              bandwidth: 1 / 0,
              bytesReceived: 0,
              roundTripTime: Date.now() - t.requestTime || 0
            };
          return i.bytesReceived = e.loaded, i.bandwidth = Math.floor(i.bytesReceived / i.roundTripTime * 8 * 1e3), i
        }(e)), !n.stats.firstBytesReceivedAt && n.stats.bytesReceived && (n.stats.firstBytesReceivedAt = Date.now()), r(e, n)
      }
    }
  }

  function Xc(e) {
    var t = e.xhr,
      i = e.xhrOptions,
      n = e.decryptionWorker,
      r = e.segment,
      a = e.abortFn,
      s = e.progressFn,
      o = e.trackInfoFn,
      u = e.timingInfoFn,
      l = e.videoSegmentTimingInfoFn,
      c = e.audioSegmentTimingInfoFn,
      d = e.id3Fn,
      h = e.captionsFn,
      p = e.isEndOfTimeline,
      f = e.endedTimelineFn,
      m = e.dataFn,
      g = e.doneFn,
      v = e.handlePartialData,
      y = [],
      _ = zc({
        activeXhrs: y,
        decryptionWorker: n,
        trackInfoFn: o,
        timingInfoFn: u,
        videoSegmentTimingInfoFn: l,
        audioSegmentTimingInfoFn: c,
        id3Fn: d,
        captionsFn: h,
        isEndOfTimeline: p,
        endedTimelineFn: f,
        dataFn: m,
        doneFn: g
      });
    if (r.key && !r.key.bytes) {
      var b = t(ya.mergeOptions(i, {
        uri: r.key.resolvedUri,
        responseType: "arraybuffer"
      }), function (a, s) {
        return function (e, t) {
          var i = t.response,
            n = Vc(e, t);
          if (n) return s(n, a);
          if (16 !== i.byteLength) return s({
            status: t.status,
            message: "Invalid HLS key at URL: " + t.uri,
            code: Od,
            xhr: t
          }, a);
          var r = new DataView(i);
          return a.key.bytes = new Uint32Array([r.getUint32(0), r.getUint32(4), r.getUint32(8), r.getUint32(12)]), s(null, a)
        }
      }(r, _));
      y.push(b)
    }
    if (r.map && !r.map.bytes) {
      var T = t(ya.mergeOptions(i, {
        uri: r.map.resolvedUri,
        responseType: "arraybuffer",
        headers: _c(r.map)
      }), function (e) {
        var a = e.segment,
          s = e.finishProcessingFn;
        return function (e, t) {
          var i = t.response,
            n = Vc(e, t);
          if (n) return s(n, a);
          if (0 === i.byteLength) return s({
            status: t.status,
            message: "Empty HLS segment content at URL: " + t.uri,
            code: Od,
            xhr: t
          }, a);
          a.map.bytes = new Uint8Array(t.response);
          var r = Yu(a.map.bytes);
          return "mp4" !== r ? s({
            status: t.status,
            message: "Found unsupported " + (r || "unknown") + " container for initialization segment at URL: " + t.uri,
            code: Od,
            internal: !0,
            xhr: t
          }, a) : (fd(a.map.bytes).forEach(function (e) {
            a.map.tracks = a.map.tracks || {}, a.map.tracks[e.type] || "number" == typeof (a.map.tracks[e.type] = e).id && e.timescale && (a.map.timescales = a.map.timescales || {}, a.map.timescales[e.id] = e.timescale)
          }), s(null, a))
        }
      }({
        segment: r,
        finishProcessingFn: _
      }));
      y.push(T)
    }
    var S = ya.mergeOptions(i, {
      uri: r.part && r.part.resolvedUri || r.resolvedUri,
      responseType: "arraybuffer",
      headers: _c(r)
    });
    v && (S.responseType = "text", S.beforeSend = function (e) {
      e.overrideMimeType("text/plain; charset=x-user-defined")
    });
    var E = t(S, function (e) {
      var a = e.segment,
        s = e.finishProcessingFn,
        o = e.responseType;
      return function (e, t) {
        var i = t.response,
          n = Vc(e, t);
        if (n) return s(n, a);
        var r = "arraybuffer" !== o && t.responseText ? Oc(t.responseText.substring(a.lastReachedChar || 0)) : t.response;
        return 0 === i.byteLength ? s({
          status: t.status,
          message: "Empty HLS segment content at URL: " + t.uri,
          code: Od,
          xhr: t
        }, a) : (a.stats = function (e) {
          return {
            bandwidth: e.bandwidth,
            bytesReceived: e.bytesReceived || 0,
            roundTripTime: e.roundTripTime || 0
          }
        }(t), a.key ? a.encryptedBytes = new Uint8Array(r) : a.bytes = new Uint8Array(r), s(null, a))
      }
    }({
      segment: r,
      finishProcessingFn: _,
      responseType: S.responseType
    }));
    E.addEventListener("progress", Gc({
      segment: r,
      progressFn: s,
      trackInfoFn: o,
      timingInfoFn: u,
      videoSegmentTimingInfoFn: l,
      audioSegmentTimingInfoFn: c,
      id3Fn: d,
      captionsFn: h,
      isEndOfTimeline: p,
      endedTimelineFn: f,
      dataFn: m,
      handlePartialData: v
    })), y.push(E);
    var k = {};
    return y.forEach(function (e) {
        e.addEventListener("loadend", function (e) {
          var t = e.loadendState,
            i = e.abortFn;
          return function (e) {
            e.target.aborted && i && !t.calledAbortFn && (i(), t.calledAbortFn = !0)
          }
        }({
          loadendState: k,
          abortFn: a
        }))
      }),
      function () {
        return Hc(y)
      }
  }

  function Kc(e, t) {
    var i = t.attributes || {};
    return e && e.mediaGroups && e.mediaGroups.AUDIO && i.AUDIO && e.mediaGroups.AUDIO[i.AUDIO]
  }

  function Yc(e) {
    var r = {};
    return e.forEach(function (e) {
      var t = e.mediaType,
        i = e.type,
        n = e.details;
      r[t] = r[t] || [], r[t].push(Ha("" + i + n))
    }), Object.keys(r).forEach(function (e) {
      if (1 < r[e].length) return Md("multiple " + e + " codecs found as attributes: " + r[e].join(", ") + ". Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs."), void(r[e] = null);
      r[e] = r[e][0]
    }), r
  }

  function Qc(e) {
    var t = 0;
    return e.audio && t++, e.video && t++, t
  }

  function $c(e, t) {
    var i = t.attributes || {},
      n = Yc(function (e) {
        var t = e.attributes || {};
        if (t.CODECS) return Va(t.CODECS)
      }(t) || []);
    if (Kc(e, t) && !n.audio && ! function (e, t) {
        if (!Kc(e, t)) return !0;
        var i = t.attributes || {},
          n = e.mediaGroups.AUDIO[i.AUDIO];
        for (var r in n)
          if (!n[r].uri && !n[r].playlists) return !0;
        return !1
      }(e, t)) {
      var r = Yc(function (e, t) {
        if (!e.mediaGroups.AUDIO || !t) return null;
        var i = e.mediaGroups.AUDIO[t];
        if (!i) return null;
        for (var n in i) {
          var r = i[n];
          if (r.default && r.playlists) return Va(r.playlists[0].attributes.CODECS)
        }
        return null
      }(e, i.AUDIO) || []);
      r.audio && (n.audio = r.audio)
    }
    return n
  }

  function Jc(e) {
    if (e && e.playlist) {
      var t = e.playlist;
      return JSON.stringify({
        id: t.id,
        bandwidth: e.bandwidth,
        width: e.width,
        height: e.height,
        codecs: t.attributes && t.attributes.CODECS || ""
      })
    }
  }

  function Zc(e, t) {
    if (!e) return "";
    var i = Ia.getComputedStyle(e);
    return i ? i[t] : ""
  }

  function ed(e, n) {
    var r = e.slice();
    e.sort(function (e, t) {
      var i = n(e, t);
      return 0 === i ? r.indexOf(e) - r.indexOf(t) : i
    })
  }

  function td(e, t) {
    var i, n;
    return e.attributes.BANDWIDTH && (i = e.attributes.BANDWIDTH), i = i || Ia.Number.MAX_VALUE, t.attributes.BANDWIDTH && (n = t.attributes.BANDWIDTH), i - (n = n || Ia.Number.MAX_VALUE)
  }

  function id(e, t, i, n, r, a) {
    if (e) {
      var s = {
          bandwidth: t,
          width: i,
          height: n,
          limitRenditionByPlayerDimensions: r
        },
        o = e.playlists;
      Td.isAudioOnly(e) && (o = a.getAudioTrackPlaylists_(), s.audioOnly = !0);
      var u = o.map(function (e) {
        var t = e.attributes && e.attributes.RESOLUTION && e.attributes.RESOLUTION.width,
          i = e.attributes && e.attributes.RESOLUTION && e.attributes.RESOLUTION.height;
        return {
          bandwidth: e.attributes && e.attributes.BANDWIDTH || Ia.Number.MAX_VALUE,
          width: t,
          height: i,
          playlist: e
        }
      });
      ed(u, function (e, t) {
        return e.bandwidth - t.bandwidth
      });
      var l = (u = u.filter(function (e) {
        return !Td.isIncompatible(e.playlist)
      })).filter(function (e) {
        return Td.isEnabled(e.playlist)
      });
      l.length || (l = u.filter(function (e) {
        return !Td.isDisabled(e.playlist)
      }));
      var c = l.filter(function (e) {
          return e.bandwidth * Id.BANDWIDTH_VARIANCE < t
        }),
        d = c[c.length - 1],
        h = c.filter(function (e) {
          return e.bandwidth === d.bandwidth
        })[0];
      if (!1 === r) {
        var p = h || l[0] || u[0];
        if (p && p.playlist) {
          var f = "sortedPlaylistReps";
          return h && (f = "bandwidthBestRep"), l[0] && (f = "enabledPlaylistReps"), Nd("choosing " + Jc(p) + " using " + f + " with options", s), p.playlist
        }
        return Nd("could not choose a playlist with options", s), null
      }
      var m = c.filter(function (e) {
        return e.width && e.height
      });
      ed(m, function (e, t) {
        return e.width - t.width
      });
      var g = m.filter(function (e) {
        return e.width === i && e.height === n
      });
      d = g[g.length - 1];
      var v, y, _, b = g.filter(function (e) {
        return e.bandwidth === d.bandwidth
      })[0];
      b || (y = (v = m.filter(function (e) {
        return e.width > i || e.height > n
      })).filter(function (e) {
        return e.width === v[0].width && e.height === v[0].height
      }), d = y[y.length - 1], _ = y.filter(function (e) {
        return e.bandwidth === d.bandwidth
      })[0]);
      var T = _ || b || h || l[0] || u[0];
      if (T && T.playlist) {
        var S = "sortedPlaylistReps";
        return _ ? S = "resolutionPlusOneRep" : b ? S = "resolutionBestRep" : h ? S = "bandwidthBestRep" : l[0] && (S = "enabledPlaylistReps"), Nd("choosing " + Jc(T) + " using " + S + " with options", s), T.playlist
      }
      return Nd("could not choose a playlist with options", s), null
    }
  }

  function nd() {
    var e = this.useDevicePixelRatio && Ia.devicePixelRatio || 1;
    return id(this.playlists.master, this.systemBandwidth, parseInt(Zc(this.tech_.el(), "width"), 10) * e, parseInt(Zc(this.tech_.el(), "height"), 10) * e, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_)
  }

  function rd(e) {
    var t = e.inbandTextTracks,
      i = e.metadataArray,
      n = e.timestampOffset,
      r = e.videoDuration;
    if (i) {
      var a = Ia.WebKitDataCue || Ia.VTTCue,
        s = t.metadataTrack_;
      if (s && (i.forEach(function (e) {
          var i = e.cueTime + n;
          !("number" != typeof i || Ia.isNaN(i) || i < 0) && i < 1 / 0 && e.frames.forEach(function (e) {
            var t = new a(i, i, e.value || e.url || e.data || "");
            t.frame = e, t.value = e,
              function (e) {
                Object.defineProperties(e.frame, {
                  id: {
                    get: function () {
                      return ya.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), e.value.key
                    }
                  },
                  value: {
                    get: function () {
                      return ya.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), e.value.data
                    }
                  },
                  privateData: {
                    get: function () {
                      return ya.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), e.value.data
                    }
                  }
                })
              }(t), s.addCue(t)
          })
        }), s.cues && s.cues.length)) {
        for (var o = s.cues, u = [], l = 0; l < o.length; l++) o[l] && u.push(o[l]);
        var c = u.reduce(function (e, t) {
            var i = e[t.startTime] || [];
            return i.push(t), e[t.startTime] = i, e
          }, {}),
          d = Object.keys(c).sort(function (e, t) {
            return Number(e) - Number(t)
          });
        d.forEach(function (e, t) {
          var i = c[e],
            n = Number(d[t + 1]) || r;
          i.forEach(function (e) {
            e.endTime = n
          })
        })
      }
    }
  }

  function ad(e, t, i) {
    var n, r;
    if (i && i.cues)
      for (n = i.cues.length; n--;)(r = i.cues[n]).startTime >= e && r.endTime <= t && i.removeCue(r)
  }

  function sd(e) {
    return "number" == typeof e && isFinite(e)
  }

  function od(e) {
    var t = e.segment,
      i = t.start,
      n = t.end,
      r = t.parts,
      a = e.playlist,
      s = a.mediaSequence,
      o = a.id,
      u = a.segments,
      l = void 0 === u ? [] : u,
      c = e.mediaIndex,
      d = e.partIndex,
      h = e.timeline;
    return [(e.segment.uri ? "segment" : "pre-segment") + " [" + c + "/" + (l.length - 1) + "]", d ? "part [" + d + "/" + (r.length - 1) + "]" : "", "mediaSequenceNumber [" + s + "/" + (s + l.length - 1) + "]", "playlist [" + o + "]", "start/end [" + i + " => " + n + "]", "timeline [" + h + "]"].join(" ")
  }

  function ud(e) {
    return e + "TimingInfo"
  }

  function ld(e) {
    var t = e.segmentTimeline,
      i = e.currentTimeline,
      n = e.startOfSegment,
      r = e.buffered;
    return e.overrideCheck || t !== i ? t < i ? n : r.length ? r.end(r.length - 1) : n : null
  }

  function cd(e) {
    var t = e.timelineChangeController,
      i = e.currentTimeline,
      n = e.segmentTimeline,
      r = e.loaderType,
      a = e.audioDisabled;
    if (i === n) return !1;
    if ("audio" === r) {
      var s = t.lastTimelineChange({
        type: "main"
      });
      return !s || s.to !== n
    }
    if ("main" === r && a) {
      var o = t.pendingTimelineChange({
        type: "audio"
      });
      return !o || o.to !== n
    }
    return !1
  }

  function dd(e) {
    var t = e.segmentDuration,
      i = e.maxDuration;
    return !!t && Math.round(t) > i + _d
  }

  function hd(e, t) {
    if ("hls" !== t) return null;
    var i = function (e, t) {
      var i = e && "number" == typeof e.start && "number" == typeof e.end ? e.end - e.start : 0,
        n = t && "number" == typeof t.start && "number" == typeof t.end ? t.end - t.start : 0;
      return Math.max(i, n)
    }(e.audioTimingInfo, e.videoTimingInfo);
    if (!i) return null;
    var n = e.playlist.targetDuration,
      r = dd({
        segmentDuration: i,
        maxDuration: 2 * n
      }),
      a = dd({
        segmentDuration: i,
        maxDuration: n
      }),
      s = "Segment with index " + e.mediaIndex + " from playlist " + e.playlist.id + " has a duration of " + i + " when the reported duration is " + e.duration + " and the target duration is " + n + ". For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1";
    return r || a ? {
      severity: r ? "warn" : "info",
      message: s
    } : null
  }
  var pd = El,
    fd = kl,
    md = (wl = function (e) {
      var t = 0 === e[0] ? 12 : 20;
      return Bl(e[t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t])
    }, Ea),
    gd = ya.log,
    vd = ya.mergeOptions,
    yd = function (c) {
      function e(e, t, i) {
        var n;
        if (void 0 === i && (i = {}), n = c.call(this) || this, !e) throw new Error("A non-empty playlist URL or object is required");
        n.logger_ = Hl("PlaylistLoader");
        var r = i,
          a = r.withCredentials,
          s = void 0 !== a && a,
          o = r.handleManifestRedirects,
          u = void 0 !== o && o;
        n.src = e, n.vhs_ = t, n.withCredentials = s, n.handleManifestRedirects = u;
        var l = t.options_;
        return n.customTagParsers = l && l.customTagParsers || [], n.customTagMappers = l && l.customTagMappers || [], n.experimentalLLHLS = l && l.experimentalLLHLS || !1, n.state = "HAVE_NOTHING", n.on("mediaupdatetimeout", function () {
          "HAVE_METADATA" === n.state && (n.state = "HAVE_CURRENT_METADATA", n.request = n.vhs_.xhr({
            uri: md(n.master.uri, n.media().uri),
            withCredentials: n.withCredentials
          }, function (e, t) {
            if (n.request) return e ? n.playlistRequestError(n.request, n.media(), "HAVE_METADATA") : void n.haveMetadata({
              playlistString: n.request.responseText,
              url: n.media().uri,
              id: n.media().id
            })
          }))
        }), n
      }
      ka(e, c);
      var t = e.prototype;
      return t.playlistRequestError = function (e, t, i) {
        var n = t.uri,
          r = t.id;
        this.request = null, i && (this.state = i), this.error = {
          playlist: this.master.playlists[r],
          status: e.status,
          message: "HLS playlist request error at URL: " + n + ".",
          responseText: e.responseText,
          code: 500 <= e.status ? 4 : 2
        }, this.trigger("error")
      }, t.haveMetadata = function (e) {
        var i = this,
          t = e.playlistString,
          n = e.playlistObject,
          r = e.url,
          a = e.id;
        this.request = null, this.state = "HAVE_METADATA";
        var s = n || ql({
          onwarn: function (e) {
            var t = e.message;
            return i.logger_("m3u8-parser warn for " + a + ": " + t)
          },
          oninfo: function (e) {
            var t = e.message;
            return i.logger_("m3u8-parser info for " + a + ": " + t)
          },
          manifestString: t,
          customTagParsers: this.customTagParsers,
          customTagMappers: this.customTagMappers,
          experimentalLLHLS: this.experimentalLLHLS
        });
        s.lastRequest = Date.now(), zl({
          playlist: s,
          uri: r,
          id: a
        });
        var o = $l(this.master, s);
        this.targetDuration = s.partTargetDuration || s.targetDuration, o ? (this.master = o, this.media_ = this.master.playlists[a]) : this.trigger("playlistunchanged"), this.media().endList || (Ia.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = Ia.setTimeout(function () {
          i.trigger("mediaupdatetimeout")
        }, Jl(this.media(), !!o))), this.trigger("loadedplaylist")
      }, t.dispose = function () {
        this.trigger("dispose"), this.stopRequest(), Ia.clearTimeout(this.mediaUpdateTimeout), Ia.clearTimeout(this.finalRenditionTimeout), this.off()
      }, t.stopRequest = function () {
        if (this.request) {
          var e = this.request;
          this.request = null, e.onreadystatechange = null, e.abort()
        }
      }, t.media = function (i, e) {
        var n = this;
        if (!i) return this.media_;
        if ("HAVE_NOTHING" === this.state) throw new Error("Cannot switch media playlist from " + this.state);
        if ("string" == typeof i) {
          if (!this.master.playlists[i]) throw new Error("Unknown playlist URI: " + i);
          i = this.master.playlists[i]
        }
        if (Ia.clearTimeout(this.finalRenditionTimeout), e) {
          var t = (i.partTargetDuration || i.targetDuration) / 2 * 1e3 || 5e3;
          this.finalRenditionTimeout = Ia.setTimeout(this.media.bind(this, i, !1), t)
        } else {
          var r = this.state,
            a = !this.media_ || i.id !== this.media_.id;
          if (this.master.playlists[i.id].endList || i.endList && i.segments.length) return this.request && (this.request.onreadystatechange = null, this.request.abort(), this.request = null), this.state = "HAVE_METADATA", this.media_ = i, void(a && (this.trigger("mediachanging"), "HAVE_MASTER" === r ? this.trigger("loadedmetadata") : this.trigger("mediachange")));
          if (a) {
            if (this.state = "SWITCHING_MEDIA", this.request) {
              if (i.resolvedUri === this.request.url) return;
              this.request.onreadystatechange = null, this.request.abort(), this.request = null
            }
            this.media_ && this.trigger("mediachanging"), this.request = this.vhs_.xhr({
              uri: i.resolvedUri,
              withCredentials: this.withCredentials
            }, function (e, t) {
              if (n.request) {
                if (i.lastRequest = Date.now(), i.resolvedUri = jl(n.handleManifestRedirects, i.resolvedUri, t), e) return n.playlistRequestError(n.request, i, r);
                n.haveMetadata({
                  playlistString: t.responseText,
                  url: i.uri,
                  id: i.id
                }), "HAVE_MASTER" === r ? n.trigger("loadedmetadata") : n.trigger("mediachange")
              }
            })
          }
        }
      }, t.pause = function () {
        this.stopRequest(), Ia.clearTimeout(this.mediaUpdateTimeout), "HAVE_NOTHING" === this.state && (this.started = !1), "SWITCHING_MEDIA" === this.state ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MASTER" : "HAVE_CURRENT_METADATA" === this.state && (this.state = "HAVE_METADATA")
      }, t.load = function (e) {
        var t = this;
        Ia.clearTimeout(this.mediaUpdateTimeout);
        var i = this.media();
        if (e) {
          var n = i ? (i.partTargetDuration || i.targetDuration) / 2 * 1e3 : 5e3;
          this.mediaUpdateTimeout = Ia.setTimeout(function () {
            return t.load()
          }, n)
        } else this.started ? i && !i.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist") : this.start()
      }, t.start = function () {
        var n = this;
        if (this.started = !0, "object" == typeof this.src) return this.src.uri || (this.src.uri = Ia.location.href), this.src.resolvedUri = this.src.uri, void setTimeout(function () {
          n.setupInitialPlaylist(n.src)
        }, 0);
        this.request = this.vhs_.xhr({
          uri: this.src,
          withCredentials: this.withCredentials
        }, function (e, t) {
          if (n.request) {
            if (n.request = null, e) return n.error = {
              status: t.status,
              message: "HLS playlist request error at URL: " + n.src + ".",
              responseText: t.responseText,
              code: 2
            }, "HAVE_NOTHING" === n.state && (n.started = !1), n.trigger("error");
            n.src = jl(n.handleManifestRedirects, n.src, t);
            var i = ql({
              manifestString: t.responseText,
              customTagParsers: n.customTagParsers,
              customTagMappers: n.customTagMappers,
              experimentalLLHLS: n.experimentalLLHLS
            });
            n.setupInitialPlaylist(i)
          }
        })
      }, t.srcUri = function () {
        return "string" == typeof this.src ? this.src : this.src.uri
      }, t.setupInitialPlaylist = function (e) {
        if (this.state = "HAVE_MASTER", e.playlists) return this.master = e, Gl(this.master, this.srcUri()), e.playlists.forEach(function (t) {
          t.segments = Yl(t), t.segments.forEach(function (e) {
            Kl(e, t.resolvedUri)
          })
        }), this.trigger("loadedplaylist"), void(this.request || this.media(this.master.playlists[0]));
        var t = this.srcUri() || Ia.location.href;
        this.master = function (e, t) {
          var i = Vl(0, t),
            n = {
              mediaGroups: {
                AUDIO: {},
                VIDEO: {},
                "CLOSED-CAPTIONS": {},
                SUBTITLES: {}
              },
              uri: Ia.location.href,
              resolvedUri: Ia.location.href,
              playlists: [{
                uri: t,
                id: i,
                resolvedUri: t,
                attributes: {}
              }]
            };
          return n.playlists[i] = n.playlists[0], n.playlists[t] = n.playlists[0], n
        }(0, t), this.haveMetadata({
          playlistObject: e,
          url: t,
          id: this.master.playlists[0].id
        }), this.trigger("loadedmetadata")
      }, e
    }(ya.EventTarget),
    _d = 1 / 30,
    bd = ya.createTimeRange,
    Td = {
      liveEdgeDelay: rc,
      duration: sc,
      seekable: function (e, t, i) {
        var n = t || 0,
          r = uc(e, t, !0, i);
        return null === r ? bd() : bd(n, r)
      },
      getMediaInfoForTime: function (e, t, i, n) {
        var r = function (e) {
            return (e.segments || []).reduce(function (i, e, n) {
              return e.parts ? e.parts.forEach(function (e, t) {
                i.push({
                  duration: e.duration,
                  segmentIndex: n,
                  partIndex: t
                })
              }) : i.push({
                duration: e.duration,
                segmentIndex: n,
                partIndex: null
              }), i
            }, [])
          }(e),
          a = t - n;
        if (a < 0) {
          if (0 < i)
            for (var s = i - 1; 0 <= s; s--) {
              var o = r[s];
              if (0 < (a += o.duration + _d)) return {
                mediaIndex: o.segmentIndex,
                startTime: n - oc(e, i, o.segmentIndex),
                partIndex: o.partIndex
              }
            }
          return {
            mediaIndex: r[0] && r[0].segmentIndex || 0,
            partIndex: r[0] && r[0].partIndex || null,
            startTime: t
          }
        }
        if (i < 0) {
          for (var u = i; u < 0; u++)
            if ((a -= e.targetDuration) < 0) return {
              mediaIndex: r[0].segmentIndex,
              startTime: t
            };
          i = 0
        }
        for (var l = i; l < r.length; l++) {
          var c = r[l];
          if ((a -= c.duration + _d) < 0) return {
            mediaIndex: c.segmentIndex,
            startTime: n + oc(e, i, c.segmentIndex),
            partIndex: c.partIndex
          }
        }
        return {
          mediaIndex: r[r.length - 1].segmentIndex,
          partIndex: r[r.length - 1].partIndex,
          startTime: t
        }
      },
      isEnabled: dc,
      isDisabled: function (e) {
        return e.disabled
      },
      isBlacklisted: lc,
      isIncompatible: cc,
      playlistEnd: uc,
      isAes: function (e) {
        for (var t = 0; t < e.segments.length; t++)
          if (e.segments[t].key) return !0;
        return !1
      },
      hasAttribute: hc,
      estimateSegmentRequestTime: function (e, t, i, n) {
        return void 0 === n && (n = 0), hc("BANDWIDTH", i) ? (e * i.attributes.BANDWIDTH - 8 * n) / t : NaN
      },
      isLowestEnabledRendition: pc,
      isAudioOnly: gc,
      playlistMatch: fc
    },
    Sd = ya.xhr,
    Ed = ya.mergeOptions,
    kd = Object.freeze({
      __proto__: null,
      createTransferableMessage: Sc,
      initSegmentId: Ec,
      segmentKeyId: kc,
      hexDump: wc,
      tagDump: function (e) {
        var t = e.bytes;
        return wc(t)
      },
      textRanges: function (e) {
        var t, i, n, r = "";
        for (t = 0; t < e.length; t++) r += (n = t, (i = e).start(n) + "-" + i.end(n) + " ");
        return r
      }
    }),
    wd = ya.mergeOptions,
    Cd = function (c) {
      function e(e, t, i, n) {
        var r;
        void 0 === i && (i = {}), (r = c.call(this) || this).masterPlaylistLoader_ = n || Ta(r), n || (r.isMaster_ = !0);
        var a = i,
          s = a.withCredentials,
          o = void 0 !== s && s,
          u = a.handleManifestRedirects,
          l = void 0 !== u && u;
        if (r.vhs_ = t, r.withCredentials = o, r.handleManifestRedirects = l, !e) throw new Error("A non-empty playlist URL or object is required");
        return r.on("minimumUpdatePeriod", function () {
          r.refreshXml_()
        }), r.on("mediaupdatetimeout", function () {
          r.refreshMedia_(r.media().id)
        }), r.state = "HAVE_NOTHING", r.loadedPlaylists_ = {}, r.logger_ = Hl("DashPlaylistLoader"), r.isMaster_ ? (r.masterPlaylistLoader_.srcUrl = e, r.masterPlaylistLoader_.sidxMapping_ = {}) : r.childPlaylist_ = e, r
      }
      ka(e, c);
      var t = e.prototype;
      return t.requestErrored_ = function (e, t, i) {
        return !this.request || (this.request = null, e ? (this.error = "object" != typeof e || e instanceof Error ? {
          status: t.status,
          message: "DASH request error at URL: " + t.uri,
          response: t.response,
          code: 2
        } : e, i && (this.state = i), this.trigger("error"), !0) : void 0)
      }, t.addSidxSegments_ = function (o, r, a) {
        var u = this,
          s = o.sidx && jo(o.sidx);
        if (o.sidx && s && !this.masterPlaylistLoader_.sidxMapping_[s]) {
          var l = jl(this.handleManifestRedirects, o.sidx.resolvedUri),
            c = function (e, t) {
              if (!u.requestErrored_(e, t, r)) {
                var i, n = u.masterPlaylistLoader_.sidxMapping_;
                try {
                  i = Uu(cu(t.response).subarray(8))
                } catch (e) {
                  return void u.requestErrored_(e, t, r)
                }
                return n[s] = {
                  sidxInfo: o.sidx,
                  sidx: i
                }, Fo(o, i, o.sidx.resolvedUri), a(!0)
              }
            };
          this.request = Ac(l, this.vhs_.xhr, function (e, t, i, n) {
            if (e) return c(e, t);
            if (!i || "mp4" !== i) return c({
              status: t.status,
              message: "Unsupported " + (i || "unknown") + " container type for sidx segment at URL: " + l,
              response: "",
              playlist: o,
              internal: !0,
              blacklistDuration: 1 / 0,
              code: 2
            }, t);
            var r = o.sidx.byterange,
              a = r.offset,
              s = r.length;
            if (n.length >= s + a) return c(e, {
              response: n.subarray(a, a + s),
              status: t.status,
              uri: t.uri
            });
            u.request = u.vhs_.xhr({
              uri: l,
              responseType: "arraybuffer",
              headers: _c({
                byterange: o.sidx.byterange
              })
            }, c)
          })
        } else this.mediaRequest_ = Ia.setTimeout(function () {
          return a(!1)
        }, 0)
      }, t.dispose = function () {
        this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, Ia.clearTimeout(this.minimumUpdatePeriodTimeout_), Ia.clearTimeout(this.mediaRequest_), Ia.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.masterPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.masterPlaylistLoader_.createMupOnMedia_), this.masterPlaylistLoader_.createMupOnMedia_ = null), this.off()
      }, t.hasPendingRequest = function () {
        return this.request || this.mediaRequest_
      }, t.stopRequest = function () {
        if (this.request) {
          var e = this.request;
          this.request = null, e.onreadystatechange = null, e.abort()
        }
      }, t.media = function (t) {
        var i = this;
        if (!t) return this.media_;
        if ("HAVE_NOTHING" === this.state) throw new Error("Cannot switch media playlist from " + this.state);
        var n = this.state;
        if ("string" == typeof t) {
          if (!this.masterPlaylistLoader_.master.playlists[t]) throw new Error("Unknown playlist URI: " + t);
          t = this.masterPlaylistLoader_.master.playlists[t]
        }
        var e = !this.media_ || t.id !== this.media_.id;
        if (e && this.loadedPlaylists_[t.id] && this.loadedPlaylists_[t.id].endList) return this.state = "HAVE_METADATA", this.media_ = t, void(e && (this.trigger("mediachanging"), this.trigger("mediachange")));
        e && (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(t, n, function (e) {
          i.haveMetadata({
            startingState: n,
            playlist: t
          })
        }))
      }, t.haveMetadata = function (e) {
        var t = e.startingState,
          i = e.playlist;
        this.state = "HAVE_METADATA", this.loadedPlaylists_[i.id] = i, this.mediaRequest_ = null, this.refreshMedia_(i.id), "HAVE_MASTER" === t ? this.trigger("loadedmetadata") : this.trigger("mediachange")
      }, t.pause = function () {
        this.masterPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.masterPlaylistLoader_.createMupOnMedia_), this.masterPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), Ia.clearTimeout(this.mediaUpdateTimeout), Ia.clearTimeout(this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_), this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_ = null, this.mediaUpdateTimeout = null, "HAVE_NOTHING" === this.state && (this.started = !1)
      }, t.load = function (e) {
        var t = this;
        Ia.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
        var i = this.media();
        if (e) {
          var n = i ? i.targetDuration / 2 * 1e3 : 5e3;
          this.mediaUpdateTimeout = Ia.setTimeout(function () {
            return t.load()
          }, n)
        } else this.started ? i && !i.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist") : this.start()
      }, t.start = function () {
        var i = this;
        this.started = !0, this.isMaster_ ? this.requestMaster_(function (e, t) {
          i.haveMaster_(), i.hasPendingRequest() || i.media_ || i.media(i.masterPlaylistLoader_.master.playlists[0])
        }) : this.mediaRequest_ = Ia.setTimeout(function () {
          return i.haveMaster_()
        }, 0)
      }, t.requestMaster_ = function (n) {
        var r = this;
        this.request = this.vhs_.xhr({
          uri: this.masterPlaylistLoader_.srcUrl,
          withCredentials: this.withCredentials
        }, function (e, t) {
          if (!r.requestErrored_(e, t)) {
            var i = t.responseText !== r.masterPlaylistLoader_.masterXml_;
            return r.masterPlaylistLoader_.masterXml_ = t.responseText, t.responseHeaders && t.responseHeaders.date ? r.masterLoaded_ = Date.parse(t.responseHeaders.date) : r.masterLoaded_ = Date.now(), r.masterPlaylistLoader_.srcUrl = jl(r.handleManifestRedirects, r.masterPlaylistLoader_.srcUrl, t), i ? (r.handleMaster_(), void r.syncClientServerClock_(function () {
              return n(t, i)
            })) : n(t, i)
          }
          "HAVE_NOTHING" === r.state && (r.started = !1)
        })
      }, t.syncClientServerClock_ = function (n) {
        var r = this,
          a = lu(this.masterPlaylistLoader_.masterXml_);
        return null === a ? (this.masterPlaylistLoader_.clientOffset_ = this.masterLoaded_ - Date.now(), n()) : "DIRECT" === a.method ? (this.masterPlaylistLoader_.clientOffset_ = a.value - Date.now(), n()) : void(this.request = this.vhs_.xhr({
          uri: md(this.masterPlaylistLoader_.srcUrl, a.value),
          method: a.method,
          withCredentials: this.withCredentials
        }, function (e, t) {
          if (r.request) {
            if (e) return r.masterPlaylistLoader_.clientOffset_ = r.masterLoaded_ - Date.now(), n();
            var i;
            i = "HEAD" === a.method ? t.responseHeaders && t.responseHeaders.date ? Date.parse(t.responseHeaders.date) : r.masterLoaded_ : Date.parse(t.responseText), r.masterPlaylistLoader_.clientOffset_ = i - Date.now(), n()
          }
        }))
      }, t.haveMaster_ = function () {
        this.state = "HAVE_MASTER", this.isMaster_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_)
      }, t.handleMaster_ = function () {
        this.mediaRequest_ = null;
        var e = function (e) {
            var t = e.masterXml,
              i = e.srcUrl,
              n = e.clientOffset,
              r = e.sidxMapping,
              a = uu(t, {
                manifestUri: i,
                clientOffset: n,
                sidxMapping: r
              });
            return Gl(a, i), a
          }({
            masterXml: this.masterPlaylistLoader_.masterXml_,
            srcUrl: this.masterPlaylistLoader_.srcUrl,
            clientOffset: this.masterPlaylistLoader_.clientOffset_,
            sidxMapping: this.masterPlaylistLoader_.sidxMapping_
          }),
          t = this.masterPlaylistLoader_.master;
        t && (e = function (e, t, i) {
          for (var s = !0, o = wd(e, {
              duration: t.duration,
              minimumUpdatePeriod: t.minimumUpdatePeriod
            }), n = 0; n < t.playlists.length; n++) {
            var r = t.playlists[n];
            if (r.sidx) {
              var a = jo(r.sidx);
              i && i[a] && Fo(r, i[a].sidx, r.sidx.resolvedUri)
            }
            var u = $l(o, r, Pc);
            u && (o = u, s = !1)
          }
          return Wl(t, function (e, t, i, n) {
            if (e.playlists && e.playlists.length) {
              var r = e.playlists[0].id,
                a = $l(o, e.playlists[0], Pc);
              a && ((o = a).mediaGroups[t][i][n].playlists[0] = o.playlists[r], s = !1)
            }
          }), t.minimumUpdatePeriod !== e.minimumUpdatePeriod && (s = !1), s ? null : o
        }(t, e, this.masterPlaylistLoader_.sidxMapping_)), this.masterPlaylistLoader_.master = e || t;
        var i = this.masterPlaylistLoader_.master.locations && this.masterPlaylistLoader_.master.locations[0];
        return i && i !== this.masterPlaylistLoader_.srcUrl && (this.masterPlaylistLoader_.srcUrl = i), (!t || e && e.minimumUpdatePeriod !== t.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), Boolean(e)
      }, t.updateMinimumUpdatePeriodTimeout_ = function () {
        var e = this.masterPlaylistLoader_;
        e.createMupOnMedia_ && (e.off("loadedmetadata", e.createMupOnMedia_), e.createMupOnMedia_ = null), e.minimumUpdatePeriodTimeout_ && (Ia.clearTimeout(e.minimumUpdatePeriodTimeout_), e.minimumUpdatePeriodTimeout_ = null);
        var t = e.master && e.master.minimumUpdatePeriod;
        0 === t && (e.media() ? t = 1e3 * e.media().targetDuration : (e.createMupOnMedia_ = e.updateMinimumUpdatePeriodTimeout_, e.one("loadedmetadata", e.createMupOnMedia_))), "number" != typeof t || t <= 0 ? t < 0 && this.logger_("found invalid minimumUpdatePeriod of " + t + ", not setting a timeout") : this.createMUPTimeout_(t)
      }, t.createMUPTimeout_ = function (e) {
        var t = this.masterPlaylistLoader_;
        t.minimumUpdatePeriodTimeout_ = Ia.setTimeout(function () {
          t.minimumUpdatePeriodTimeout_ = null, t.trigger("minimumUpdatePeriod"), t.createMUPTimeout_(e)
        }, e)
      }, t.refreshXml_ = function () {
        var i = this;
        this.requestMaster_(function (e, t) {
          t && (i.media_ && (i.media_ = i.masterPlaylistLoader_.master.playlists[i.media_.id]), i.masterPlaylistLoader_.sidxMapping_ = function (e, a) {
            var s = Lc(e.playlists, a);
            return Wl(e, function (e, t, i, n) {
              if (e.playlists && e.playlists.length) {
                var r = e.playlists;
                s = wd(s, Lc(r, a))
              }
            }), s
          }(i.masterPlaylistLoader_.master, i.masterPlaylistLoader_.sidxMapping_), i.addSidxSegments_(i.media(), i.state, function (e) {
            i.refreshMedia_(i.media().id)
          }))
        })
      }, t.refreshMedia_ = function (e) {
        var t = this;
        if (!e) throw new Error("refreshMedia_ must take a media id");
        this.media_ && this.isMaster_ && this.handleMaster_();
        var i = this.masterPlaylistLoader_.master.playlists,
          n = !this.media_ || this.media_ !== i[e];
        if (n ? this.media_ = i[e] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
          ! function e() {
            t.media().endList || (t.mediaUpdateTimeout = Ia.setTimeout(function () {
              t.trigger("mediaupdatetimeout"), e()
            }, Jl(t.media(), Boolean(n))))
          }()
        }
        this.trigger("loadedplaylist")
      }, e
    }(ya.EventTarget),
    Id = {
      GOAL_BUFFER_LENGTH: 30,
      MAX_GOAL_BUFFER_LENGTH: 60,
      BACK_BUFFER_LENGTH: 30,
      GOAL_BUFFER_LENGTH_RATE: 1,
      INITIAL_BANDWIDTH: 4194304,
      BANDWIDTH_VARIANCE: 1.2,
      BUFFER_LOW_WATER_LINE: 0,
      MAX_BUFFER_LOW_WATER_LINE: 30,
      EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
      BUFFER_LOW_WATER_LINE_RATE: 1,
      BUFFER_HIGH_WATER_LINE: 30
    },
    xd = Rc(Mc(Nc(function () {
      function e() {
        this.init = function () {
          var a = {};
          this.on = function (e, t) {
            a[e] || (a[e] = []), a[e] = a[e].concat(t)
          }, this.off = function (e, t) {
            var i;
            return !!a[e] && (i = a[e].indexOf(t), a[e] = a[e].slice(), a[e].splice(i, 1), -1 < i)
          }, this.trigger = function (e) {
            var t, i, n, r;
            if (t = a[e])
              if (2 === arguments.length)
                for (n = t.length, i = 0; i < n; ++i) t[i].call(this, arguments[1]);
              else {
                for (r = [], i = arguments.length, i = 1; i < arguments.length; ++i) r.push(arguments[i]);
                for (n = t.length, i = 0; i < n; ++i) t[i].apply(this, r)
              }
          }, this.dispose = function () {
            a = {}
          }
        }
      }
      e.prototype.pipe = function (t) {
        return this.on("data", function (e) {
          t.push(e)
        }), this.on("done", function (e) {
          t.flush(e)
        }), this.on("partialdone", function (e) {
          t.partialFlush(e)
        }), this.on("endedtimeline", function (e) {
          t.endTimeline(e)
        }), this.on("reset", function (e) {
          t.reset(e)
        }), t
      }, e.prototype.push = function (e) {
        this.trigger("data", e)
      }, e.prototype.flush = function (e) {
        this.trigger("done", e)
      }, e.prototype.partialFlush = function (e) {
        this.trigger("partialdone", e)
      }, e.prototype.endTimeline = function (e) {
        this.trigger("endedtimeline", e)
      }, e.prototype.reset = function (e) {
        this.trigger("reset", e)
      };
      var l, t, i, r, a, n, s, o, u, c, d, h, p, f, m, g, v, y, _, b, T, S, E, k, w, C, I, x, A, P, L, O, D, R, M, N, U, B, F, j, H = e,
        V = Math.pow(2, 32) - 1;
      ! function () {
        var e;
        if (S = {
            avc1: [],
            avcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            smhd: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            styp: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: []
          }, "undefined" != typeof Uint8Array) {
          for (e in S) S.hasOwnProperty(e) && (S[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
          E = new Uint8Array(["i".charCodeAt(0), "s".charCodeAt(0), "o".charCodeAt(0), "m".charCodeAt(0)]), w = new Uint8Array(["a".charCodeAt(0), "v".charCodeAt(0), "c".charCodeAt(0), "1".charCodeAt(0)]), k = new Uint8Array([0, 0, 0, 1]), C = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 118, 105, 100, 101, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 86, 105, 100, 101, 111, 72, 97, 110, 100, 108, 101, 114, 0]), I = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 115, 111, 117, 110, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 83, 111, 117, 110, 100, 72, 97, 110, 100, 108, 101, 114, 0]), x = {
            video: C,
            audio: I
          }, L = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 12, 117, 114, 108, 32, 0, 0, 0, 1]), P = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]), O = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0]), D = O, R = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), M = O, A = new Uint8Array([0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0])
        }
      }(), l = function (e) {
        var t, i, n = [],
          r = 0;
        for (t = 1; t < arguments.length; t++) n.push(arguments[t]);
        for (t = n.length; t--;) r += n[t].byteLength;
        for (i = new Uint8Array(r + 8), new DataView(i.buffer, i.byteOffset, i.byteLength).setUint32(0, i.byteLength), i.set(e, 4), t = 0, r = 8; t < n.length; t++) i.set(n[t], r), r += n[t].byteLength;
        return i
      }, t = function () {
        return l(S.dinf, l(S.dref, L))
      }, i = function (e) {
        return l(S.esds, new Uint8Array([0, 0, 0, 0, 3, 25, 0, 0, 0, 4, 17, 64, 21, 0, 6, 0, 0, 0, 218, 192, 0, 0, 218, 192, 5, 2, e.audioobjecttype << 3 | e.samplingfrequencyindex >>> 1, e.samplingfrequencyindex << 7 | e.channelcount << 3, 6, 1, 2]))
      }, m = function (e) {
        return l(S.hdlr, x[e])
      }, f = function (e) {
        var t = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 3, 0, 1, 95, 144, e.duration >>> 24 & 255, e.duration >>> 16 & 255, e.duration >>> 8 & 255, 255 & e.duration, 85, 196, 0, 0]);
        return e.samplerate && (t[12] = e.samplerate >>> 24 & 255, t[13] = e.samplerate >>> 16 & 255, t[14] = e.samplerate >>> 8 & 255, t[15] = 255 & e.samplerate), l(S.mdhd, t)
      }, p = function (e) {
        return l(S.mdia, f(e), m(e.type), n(e))
      }, a = function (e) {
        return l(S.mfhd, new Uint8Array([0, 0, 0, 0, (4278190080 & e) >> 24, (16711680 & e) >> 16, (65280 & e) >> 8, 255 & e]))
      }, n = function (e) {
        return l(S.minf, "video" === e.type ? l(S.vmhd, A) : l(S.smhd, P), t(), v(e))
      }, s = function (e, t) {
        for (var i = [], n = t.length; n--;) i[n] = _(t[n]);
        return l.apply(null, [S.moof, a(e)].concat(i))
      }, o = function (e) {
        for (var t = e.length, i = []; t--;) i[t] = d(e[t]);
        return l.apply(null, [S.moov, c(4294967295)].concat(i).concat(u(e)))
      }, u = function (e) {
        for (var t = e.length, i = []; t--;) i[t] = b(e[t]);
        return l.apply(null, [S.mvex].concat(i))
      }, c = function (e) {
        var t = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 2, 0, 1, 95, 144, (4278190080 & e) >> 24, (16711680 & e) >> 16, (65280 & e) >> 8, 255 & e, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 255, 255, 255]);
        return l(S.mvhd, t)
      }, g = function (e) {
        var t, i, n = e.samples || [],
          r = new Uint8Array(4 + n.length);
        for (i = 0; i < n.length; i++) t = n[i].flags, r[i + 4] = t.dependsOn << 4 | t.isDependedOn << 2 | t.hasRedundancy;
        return l(S.sdtp, r)
      }, v = function (e) {
        return l(S.stbl, y(e), l(S.stts, M), l(S.stsc, D), l(S.stsz, R), l(S.stco, O))
      }, y = function (e) {
        return l(S.stsd, new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1]), "video" === e.type ? N(e) : U(e))
      }, N = function (e) {
        var t, i, n = e.sps || [],
          r = e.pps || [],
          a = [],
          s = [];
        for (t = 0; t < n.length; t++) a.push((65280 & n[t].byteLength) >>> 8), a.push(255 & n[t].byteLength), a = a.concat(Array.prototype.slice.call(n[t]));
        for (t = 0; t < r.length; t++) s.push((65280 & r[t].byteLength) >>> 8), s.push(255 & r[t].byteLength), s = s.concat(Array.prototype.slice.call(r[t]));
        if (i = [S.avc1, new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, (65280 & e.width) >> 8, 255 & e.width, (65280 & e.height) >> 8, 255 & e.height, 0, 72, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 1, 19, 118, 105, 100, 101, 111, 106, 115, 45, 99, 111, 110, 116, 114, 105, 98, 45, 104, 108, 115, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 17, 17]), l(S.avcC, new Uint8Array([1, e.profileIdc, e.profileCompatibility, e.levelIdc, 255].concat([n.length], a, [r.length], s))), l(S.btrt, new Uint8Array([0, 28, 156, 128, 0, 45, 198, 192, 0, 45, 198, 192]))], e.sarRatio) {
          var o = e.sarRatio[0],
            u = e.sarRatio[1];
          i.push(l(S.pasp, new Uint8Array([(4278190080 & o) >> 24, (16711680 & o) >> 16, (65280 & o) >> 8, 255 & o, (4278190080 & u) >> 24, (16711680 & u) >> 16, (65280 & u) >> 8, 255 & u])))
        }
        return l.apply(null, i)
      }, U = function (e) {
        return l(S.mp4a, new Uint8Array([0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, (65280 & e.channelcount) >> 8, 255 & e.channelcount, (65280 & e.samplesize) >> 8, 255 & e.samplesize, 0, 0, 0, 0, (65280 & e.samplerate) >> 8, 255 & e.samplerate, 0, 0]), i(e))
      }, h = function (e) {
        var t = new Uint8Array([0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, (4278190080 & e.id) >> 24, (16711680 & e.id) >> 16, (65280 & e.id) >> 8, 255 & e.id, 0, 0, 0, 0, (4278190080 & e.duration) >> 24, (16711680 & e.duration) >> 16, (65280 & e.duration) >> 8, 255 & e.duration, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, (65280 & e.width) >> 8, 255 & e.width, 0, 0, (65280 & e.height) >> 8, 255 & e.height, 0, 0]);
        return l(S.tkhd, t)
      }, _ = function (e) {
        var t, i, n, r, a, s;
        return t = l(S.tfhd, new Uint8Array([0, 0, 0, 58, (4278190080 & e.id) >> 24, (16711680 & e.id) >> 16, (65280 & e.id) >> 8, 255 & e.id, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])), a = Math.floor(e.baseMediaDecodeTime / (1 + V)), s = Math.floor(e.baseMediaDecodeTime % (1 + V)), i = l(S.tfdt, new Uint8Array([1, 0, 0, 0, a >>> 24 & 255, a >>> 16 & 255, a >>> 8 & 255, 255 & a, s >>> 24 & 255, s >>> 16 & 255, s >>> 8 & 255, 255 & s])), 92, "audio" === e.type ? (n = T(e, 92), l(S.traf, t, i, n)) : (r = g(e), n = T(e, r.length + 92), l(S.traf, t, i, n, r))
      }, d = function (e) {
        return e.duration = e.duration || 4294967295, l(S.trak, h(e), p(e))
      }, b = function (e) {
        var t = new Uint8Array([0, 0, 0, 0, (4278190080 & e.id) >> 24, (16711680 & e.id) >> 16, (65280 & e.id) >> 8, 255 & e.id, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1]);
        return "video" !== e.type && (t[t.length - 1] = 0), l(S.trex, t)
      }, j = function (e, t) {
        var i = 0,
          n = 0,
          r = 0,
          a = 0;
        return e.length && (void 0 !== e[0].duration && (i = 1), void 0 !== e[0].size && (n = 2), void 0 !== e[0].flags && (r = 4), void 0 !== e[0].compositionTimeOffset && (a = 8)), [0, 0, i | n | r | a, 1, (4278190080 & e.length) >>> 24, (16711680 & e.length) >>> 16, (65280 & e.length) >>> 8, 255 & e.length, (4278190080 & t) >>> 24, (16711680 & t) >>> 16, (65280 & t) >>> 8, 255 & t]
      }, F = function (e, t) {
        var i, n, r, a, s, o;
        for (t += 20 + 16 * (a = e.samples || []).length, r = j(a, t), (n = new Uint8Array(r.length + 16 * a.length)).set(r), i = r.length, o = 0; o < a.length; o++) s = a[o], n[i++] = (4278190080 & s.duration) >>> 24, n[i++] = (16711680 & s.duration) >>> 16, n[i++] = (65280 & s.duration) >>> 8, n[i++] = 255 & s.duration, n[i++] = (4278190080 & s.size) >>> 24, n[i++] = (16711680 & s.size) >>> 16, n[i++] = (65280 & s.size) >>> 8, n[i++] = 255 & s.size, n[i++] = s.flags.isLeading << 2 | s.flags.dependsOn, n[i++] = s.flags.isDependedOn << 6 | s.flags.hasRedundancy << 4 | s.flags.paddingValue << 1 | s.flags.isNonSyncSample, n[i++] = 61440 & s.flags.degradationPriority, n[i++] = 15 & s.flags.degradationPriority, n[i++] = (4278190080 & s.compositionTimeOffset) >>> 24, n[i++] = (16711680 & s.compositionTimeOffset) >>> 16, n[i++] = (65280 & s.compositionTimeOffset) >>> 8, n[i++] = 255 & s.compositionTimeOffset;
        return l(S.trun, n)
      }, B = function (e, t) {
        var i, n, r, a, s, o;
        for (t += 20 + 8 * (a = e.samples || []).length, r = j(a, t), (i = new Uint8Array(r.length + 8 * a.length)).set(r), n = r.length, o = 0; o < a.length; o++) s = a[o], i[n++] = (4278190080 & s.duration) >>> 24, i[n++] = (16711680 & s.duration) >>> 16, i[n++] = (65280 & s.duration) >>> 8, i[n++] = 255 & s.duration, i[n++] = (4278190080 & s.size) >>> 24, i[n++] = (16711680 & s.size) >>> 16, i[n++] = (65280 & s.size) >>> 8, i[n++] = 255 & s.size;
        return l(S.trun, i)
      }, T = function (e, t) {
        return "audio" === e.type ? B(e, t) : F(e, t)
      };
      r = function () {
        return l(S.ftyp, E, k, E, w)
      };

      function q(e, t) {
        var i = {
          size: 0,
          flags: {
            isLeading: 0,
            dependsOn: 1,
            isDependedOn: 0,
            hasRedundancy: 0,
            degradationPriority: 0,
            isNonSyncSample: 1
          }
        };
        return i.dataOffset = t, i.compositionTimeOffset = e.pts - e.dts, i.duration = e.duration, i.size = 4 * e.length, i.size += e.byteLength, e.keyFrame && (i.flags.dependsOn = 2, i.flags.isNonSyncSample = 0), i
      }

      function W(e) {
        for (var t = []; e--;) t.push(0);
        return t
      }

      function z() {
        if (!X) {
          var e = {
            96e3: [ue, [227, 64], W(154), [56]],
            88200: [ue, [231], W(170), [56]],
            64e3: [ue, [248, 192], W(240), [56]],
            48e3: [ue, [255, 192], W(268), [55, 148, 128], W(54), [112]],
            44100: [ue, [255, 192], W(268), [55, 163, 128], W(84), [112]],
            32e3: [ue, [255, 192], W(268), [55, 234], W(226), [112]],
            24e3: [ue, [255, 192], W(268), [55, 255, 128], W(268), [111, 112], W(126), [224]],
            16e3: [ue, [255, 192], W(268), [55, 255, 128], W(268), [111, 255], W(269), [223, 108], W(195), [1, 192]],
            12e3: [le, W(268), [3, 127, 248], W(268), [6, 255, 240], W(268), [13, 255, 224], W(268), [27, 253, 128], W(259), [56]],
            11025: [le, W(268), [3, 127, 248], W(268), [6, 255, 240], W(268), [13, 255, 224], W(268), [27, 255, 192], W(268), [55, 175, 128], W(108), [112]],
            8e3: [le, W(268), [3, 121, 16], W(47), [7]]
          };
          X = function (i) {
            return Object.keys(i).reduce(function (e, t) {
              return e[t] = new Uint8Array(i[t].reduce(function (e, t) {
                return e.concat(t)
              }, [])), e
            }, {})
          }(e)
        }
        return X
      }

      function G(e) {
        e = e || {}, G.prototype.init.call(this), this.parse708captions_ = "boolean" != typeof e.parse708captions || e.parse708captions, this.captionPackets_ = [], this.ccStreams_ = [new Be(0, 0), new Be(0, 1), new Be(1, 0), new Be(1, 1)], this.parse708captions_ && (this.cc708Stream_ = new De), this.reset(), this.ccStreams_.forEach(function (e) {
          e.on("data", this.trigger.bind(this, "data")), e.on("partialdone", this.trigger.bind(this, "partialdone")), e.on("done", this.trigger.bind(this, "done"))
        }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")))
      }
      var X, K, Y, Q, $, J = function (e) {
          return l(S.mdat, e)
        },
        Z = s,
        ee = function (e) {
          var t, i = r(),
            n = o(e);
          return (t = new Uint8Array(i.byteLength + n.byteLength)).set(i), t.set(n, i.byteLength), t
        },
        te = function (e) {
          var t, i, n = [],
            r = [];
          for (r.byteLength = 0, r.nalCount = 0, r.duration = 0, t = n.byteLength = 0; t < e.length; t++) "access_unit_delimiter_rbsp" === (i = e[t]).nalUnitType ? (n.length && (n.duration = i.dts - n.dts, r.byteLength += n.byteLength, r.nalCount += n.length, r.duration += n.duration, r.push(n)), (n = [i]).byteLength = i.data.byteLength, n.pts = i.pts, n.dts = i.dts) : ("slice_layer_without_partitioning_rbsp_idr" === i.nalUnitType && (n.keyFrame = !0), n.duration = i.dts - n.dts, n.byteLength += i.data.byteLength, n.push(i));
          return r.length && (!n.duration || n.duration <= 0) && (n.duration = r[r.length - 1].duration), r.byteLength += n.byteLength, r.nalCount += n.length, r.duration += n.duration, r.push(n), r
        },
        ie = function (e) {
          var t, i, n = [],
            r = [];
          for (n.byteLength = 0, n.nalCount = 0, n.duration = 0, n.pts = e[0].pts, n.dts = e[0].dts, r.byteLength = 0, r.nalCount = 0, r.duration = 0, r.pts = e[0].pts, r.dts = e[0].dts, t = 0; t < e.length; t++)(i = e[t]).keyFrame ? (n.length && (r.push(n), r.byteLength += n.byteLength, r.nalCount += n.nalCount, r.duration += n.duration), (n = [i]).nalCount = i.length, n.byteLength = i.byteLength, n.pts = i.pts, n.dts = i.dts, n.duration = i.duration) : (n.duration += i.duration, n.nalCount += i.length, n.byteLength += i.byteLength, n.push(i));
          return r.length && n.duration <= 0 && (n.duration = r[r.length - 1].duration), r.byteLength += n.byteLength, r.nalCount += n.nalCount, r.duration += n.duration, r.push(n), r
        },
        ne = function (e) {
          var t;
          return !e[0][0].keyFrame && 1 < e.length && (t = e.shift(), e.byteLength -= t.byteLength, e.nalCount -= t.nalCount, e[0][0].dts = t.dts, e[0][0].pts = t.pts, e[0][0].duration += t.duration), e
        },
        re = function (e, t) {
          var i, n, r, a, s, o = t || 0,
            u = [];
          for (i = 0; i < e.length; i++)
            for (a = e[i], n = 0; n < a.length; n++) s = a[n], o += (r = q(s, o)).size, u.push(r);
          return u
        },
        ae = function (e) {
          var t, i, n, r, a, s, o = 0,
            u = e.byteLength,
            l = e.nalCount,
            c = new Uint8Array(u + 4 * l),
            d = new DataView(c.buffer);
          for (t = 0; t < e.length; t++)
            for (r = e[t], i = 0; i < r.length; i++)
              for (a = r[i], n = 0; n < a.length; n++) s = a[n], d.setUint32(o, s.data.byteLength), o += 4, c.set(s.data, o), o += s.data.byteLength;
          return c
        },
        se = function (e, t) {
          var i, n = [];
          return i = q(e, t || 0), n.push(i), n
        },
        oe = function (e) {
          var t, i, n = 0,
            r = e.byteLength,
            a = e.length,
            s = new Uint8Array(r + 4 * a),
            o = new DataView(s.buffer);
          for (t = 0; t < e.length; t++) i = e[t], o.setUint32(n, i.data.byteLength), n += 4, s.set(i.data, n), n += i.data.byteLength;
          return s
        },
        ue = [33, 16, 5, 32, 164, 27],
        le = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252],
        ce = 9e4,
        de = K = function (e) {
          return 9e4 * e
        },
        he = (Y = function (e, t) {
          return e * t
        }, Q = function (e) {
          return e / 9e4
        }),
        pe = ($ = function (e, t) {
          return e / t
        }, function (e, t) {
          return K($(e, t))
        }),
        fe = function (e, t) {
          return Y(Q(e), t)
        },
        me = function (e, t, i) {
          return Q(i ? e : e - t)
        },
        ge = function (e, t, i, n) {
          var r, a, s, o, u, l = 0,
            c = 0,
            d = 0;
          if (t.length && (r = pe(e.baseMediaDecodeTime, e.samplerate), a = Math.ceil(ce / (e.samplerate / 1024)), i && n && (l = r - Math.max(i, n), d = (c = Math.floor(l / a)) * a), !(c < 1 || ce / 2 < d))) {
            for (s = (s = z()[e.samplerate]) || t[0].data, o = 0; o < c; o++) u = t[0], t.splice(0, 0, {
              data: s,
              dts: u.dts - a,
              pts: u.pts - a
            });
            return e.baseMediaDecodeTime -= Math.floor(fe(d, e.samplerate)), d
          }
        },
        ve = function (e, t, i) {
          return t.minSegmentDts >= i ? e : (t.minSegmentDts = 1 / 0, e.filter(function (e) {
            return e.dts >= i && (t.minSegmentDts = Math.min(t.minSegmentDts, e.dts), t.minSegmentPts = t.minSegmentDts, !0)
          }))
        },
        ye = function (e) {
          var t, i, n = [];
          for (t = 0; t < e.length; t++) i = e[t], n.push({
            size: i.data.byteLength,
            duration: 1024
          });
          return n
        },
        _e = function (e) {
          var t, i, n = 0,
            r = new Uint8Array(function (e) {
              var t, i = 0;
              for (t = 0; t < e.length; t++) i += e[t].data.byteLength;
              return i
            }(e));
          for (t = 0; t < e.length; t++) i = e[t], r.set(i.data, n), n += i.data.byteLength;
          return r
        },
        be = ce,
        Te = function (e) {
          delete e.minSegmentDts, delete e.maxSegmentDts, delete e.minSegmentPts, delete e.maxSegmentPts
        },
        Se = function (e, t) {
          var i, n = e.minSegmentDts;
          return t || (n -= e.timelineStartInfo.dts), i = e.timelineStartInfo.baseMediaDecodeTime, i += n, i = Math.max(0, i), "audio" === e.type && (i *= e.samplerate / be, i = Math.floor(i)), i
        },
        Ee = function (e, t) {
          "number" == typeof t.pts && (void 0 === e.timelineStartInfo.pts && (e.timelineStartInfo.pts = t.pts), void 0 === e.minSegmentPts ? e.minSegmentPts = t.pts : e.minSegmentPts = Math.min(e.minSegmentPts, t.pts), void 0 === e.maxSegmentPts ? e.maxSegmentPts = t.pts : e.maxSegmentPts = Math.max(e.maxSegmentPts, t.pts)), "number" == typeof t.dts && (void 0 === e.timelineStartInfo.dts && (e.timelineStartInfo.dts = t.dts), void 0 === e.minSegmentDts ? e.minSegmentDts = t.dts : e.minSegmentDts = Math.min(e.minSegmentDts, t.dts), void 0 === e.maxSegmentDts ? e.maxSegmentDts = t.dts : e.maxSegmentDts = Math.max(e.maxSegmentDts, t.dts))
        },
        ke = function (e) {
          for (var t = 0, i = {
              payloadType: -1,
              payloadSize: 0
            }, n = 0, r = 0; t < e.byteLength && 128 !== e[t];) {
            for (; 255 === e[t];) n += 255, t++;
            for (n += e[t++]; 255 === e[t];) r += 255, t++;
            if (r += e[t++], !i.payload && 4 === n) {
              if ("GA94" === String.fromCharCode(e[t + 3], e[t + 4], e[t + 5], e[t + 6])) {
                i.payloadType = n, i.payloadSize = r, i.payload = e.subarray(t, t + r);
                break
              }
              i.payload = void 0
            }
            t += r, r = n = 0
          }
          return i
        },
        we = function (e) {
          return 181 !== e.payload[0] ? null : 49 != (e.payload[1] << 8 | e.payload[2]) ? null : "GA94" !== String.fromCharCode(e.payload[3], e.payload[4], e.payload[5], e.payload[6]) ? null : 3 !== e.payload[7] ? null : e.payload.subarray(8, e.payload.length - 1)
        },
        Ce = function (e, t) {
          var i, n, r, a, s = [];
          if (!(64 & t[0])) return s;
          for (n = 31 & t[0], i = 0; i < n; i++) a = {
            type: 3 & t[2 + (r = 3 * i)],
            pts: e
          }, 4 & t[2 + r] && (a.ccData = t[3 + r] << 8 | t[4 + r], s.push(a));
          return s
        },
        Ie = function (e) {
          for (var t, i, n = e.byteLength, r = [], a = 1; a < n - 2;) 0 === e[a] && 0 === e[a + 1] && 3 === e[a + 2] ? (r.push(a + 2), a += 2) : a++;
          if (0 === r.length) return e;
          t = n - r.length, i = new Uint8Array(t);
          var s = 0;
          for (a = 0; a < t; s++, a++) s === r[0] && (s++, r.shift()), i[a] = e[s];
          return i
        },
        xe = 4;
      (G.prototype = new H).push = function (e) {
        var t, i, n;
        if ("sei_rbsp" === e.nalUnitType && (t = ke(e.escapedRBSP)).payload && t.payloadType === xe && (i = we(t)))
          if (e.dts < this.latestDts_) this.ignoreNextEqualDts_ = !0;
          else {
            if (e.dts === this.latestDts_ && this.ignoreNextEqualDts_) return this.numSameDts_--, void(this.numSameDts_ || (this.ignoreNextEqualDts_ = !1));
            n = Ce(e.pts, i), this.captionPackets_ = this.captionPackets_.concat(n), this.latestDts_ !== e.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = e.dts
          }
      }, G.prototype.flushCCStreams = function (t) {
        this.ccStreams_.forEach(function (e) {
          return "flush" === t ? e.flush() : e.partialFlush()
        }, this)
      }, G.prototype.flushStream = function (e) {
        this.captionPackets_.length && (this.captionPackets_.forEach(function (e, t) {
          e.presortIndex = t
        }), this.captionPackets_.sort(function (e, t) {
          return e.pts === t.pts ? e.presortIndex - t.presortIndex : e.pts - t.pts
        }), this.captionPackets_.forEach(function (e) {
          e.type < 2 ? this.dispatchCea608Packet(e) : this.dispatchCea708Packet(e)
        }, this), this.captionPackets_.length = 0), this.flushCCStreams(e)
      }, G.prototype.flush = function () {
        return this.flushStream("flush")
      }, G.prototype.partialFlush = function () {
        return this.flushStream("partialFlush")
      }, G.prototype.reset = function () {
        this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function (e) {
          e.reset()
        })
      }, G.prototype.dispatchCea608Packet = function (e) {
        this.setsTextOrXDSActive(e) ? this.activeCea608Channel_[e.type] = null : this.setsChannel1Active(e) ? this.activeCea608Channel_[e.type] = 0 : this.setsChannel2Active(e) && (this.activeCea608Channel_[e.type] = 1), null !== this.activeCea608Channel_[e.type] && this.ccStreams_[(e.type << 1) + this.activeCea608Channel_[e.type]].push(e)
      }, G.prototype.setsChannel1Active = function (e) {
        return 4096 == (30720 & e.ccData)
      }, G.prototype.setsChannel2Active = function (e) {
        return 6144 == (30720 & e.ccData)
      }, G.prototype.setsTextOrXDSActive = function (e) {
        return 256 == (28928 & e.ccData) || 4138 == (30974 & e.ccData) || 6186 == (30974 & e.ccData)
      }, G.prototype.dispatchCea708Packet = function (e) {
        this.parse708captions_ && this.cc708Stream_.push(e)
      };

      function Ae(e) {
        return 32 <= e && e <= 127 || 160 <= e && e <= 255
      }

      function Pe(e) {
        this.windowNum = e, this.reset()
      }
      var Le = {
        127: 9834,
        4128: 32,
        4129: 160,
        4133: 8230,
        4138: 352,
        4140: 338,
        4144: 9608,
        4145: 8216,
        4146: 8217,
        4147: 8220,
        4148: 8221,
        4149: 8226,
        4153: 8482,
        4154: 353,
        4156: 339,
        4157: 8480,
        4159: 376,
        4214: 8539,
        4215: 8540,
        4216: 8541,
        4217: 8542,
        4218: 9168,
        4219: 9124,
        4220: 9123,
        4221: 9135,
        4222: 9126,
        4223: 9121,
        4256: 12600
      };
      Pe.prototype.reset = function () {
        this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0
      }, Pe.prototype.getText = function () {
        return this.rows.join("\n")
      }, Pe.prototype.clearText = function () {
        this.rows = [""], this.rowIdx = 0
      }, Pe.prototype.newLine = function (e) {
        for (this.rows.length >= this.virtualRowCount && "function" == typeof this.beforeRowOverflow && this.beforeRowOverflow(e), 0 < this.rows.length && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount;) this.rows.shift(), this.rowIdx--
      }, Pe.prototype.isEmpty = function () {
        return 0 === this.rows.length || 1 === this.rows.length && "" === this.rows[0]
      }, Pe.prototype.addText = function (e) {
        this.rows[this.rowIdx] += e
      }, Pe.prototype.backspace = function () {
        if (!this.isEmpty()) {
          var e = this.rows[this.rowIdx];
          this.rows[this.rowIdx] = e.substr(0, e.length - 1)
        }
      };

      function Oe(e) {
        this.serviceNum = e, this.text = "", this.currentWindow = new Pe(-1), this.windows = []
      }
      Oe.prototype.init = function (e, t) {
        this.startPts = e;
        for (var i = 0; i < 8; i++) this.windows[i] = new Pe(i), "function" == typeof t && (this.windows[i].beforeRowOverflow = t)
      }, Oe.prototype.setCurrentWindow = function (e) {
        this.currentWindow = this.windows[e]
      };
      var De = function e() {
        e.prototype.init.call(this);
        var t = this;
        this.current708Packet = null, this.services = {}, this.push = function (e) {
          3 === e.type ? t.new708Packet() : null === t.current708Packet && t.new708Packet(), t.add708Bytes(e)
        }
      };
      De.prototype = new H, De.prototype.new708Packet = function () {
        null !== this.current708Packet && this.push708Packet(), this.current708Packet = {
          data: [],
          ptsVals: []
        }
      }, De.prototype.add708Bytes = function (e) {
        var t = e.ccData,
          i = t >>> 8,
          n = 255 & t;
        this.current708Packet.ptsVals.push(e.pts), this.current708Packet.data.push(i), this.current708Packet.data.push(n)
      }, De.prototype.push708Packet = function () {
        var e = this.current708Packet,
          t = e.data,
          i = null,
          n = null,
          r = 0,
          a = t[r++];
        for (e.seq = a >> 6, e.sizeCode = 63 & a; r < t.length; r++) n = 31 & (a = t[r++]), 7 === (i = a >> 5) && 0 < n && (i = a = t[r++]), this.pushServiceBlock(i, r, n), 0 < n && (r += n - 1)
      }, De.prototype.pushServiceBlock = function (e, t, i) {
        var n, r = t,
          a = this.current708Packet.data,
          s = this.services[e];
        for (s = s || this.initService(e, r); r < t + i && r < a.length; r++) n = a[r], Ae(n) ? r = this.handleText(r, s) : 16 === n ? r = this.extendedCommands(r, s) : 128 <= n && n <= 135 ? r = this.setCurrentWindow(r, s) : 152 <= n && n <= 159 ? r = this.defineWindow(r, s) : 136 === n ? r = this.clearWindows(r, s) : 140 === n ? r = this.deleteWindows(r, s) : 137 === n ? r = this.displayWindows(r, s) : 138 === n ? r = this.hideWindows(r, s) : 139 === n ? r = this.toggleWindows(r, s) : 151 === n ? r = this.setWindowAttributes(r, s) : 144 === n ? r = this.setPenAttributes(r, s) : 145 === n ? r = this.setPenColor(r, s) : 146 === n ? r = this.setPenLocation(r, s) : 143 === n ? s = this.reset(r, s) : 8 === n ? s.currentWindow.backspace() : 12 === n ? s.currentWindow.clearText() : 13 === n ? s.currentWindow.pendingNewLine = !0 : 14 === n ? s.currentWindow.clearText() : 141 === n && r++
      }, De.prototype.extendedCommands = function (e, t) {
        var i = this.current708Packet.data[++e];
        return Ae(i) && (e = this.handleText(e, t, !0)), e
      }, De.prototype.getPts = function (e) {
        return this.current708Packet.ptsVals[Math.floor(e / 2)]
      }, De.prototype.initService = function (t, e) {
        var i = this;
        return this.services[t] = new Oe(t), this.services[t].init(this.getPts(e), function (e) {
          i.flushDisplayed(e, i.services[t])
        }), this.services[t]
      }, De.prototype.handleText = function (e, t, i) {
        var n = function (e) {
            var t = Le[e] || e;
            return 4096 & e && e === t ? "" : String.fromCharCode(t)
          }((i ? 4096 : 0) | this.current708Packet.data[e]),
          r = t.currentWindow;
        return r.pendingNewLine && !r.isEmpty() && r.newLine(this.getPts(e)), r.pendingNewLine = !1, r.addText(n), e
      }, De.prototype.setCurrentWindow = function (e, t) {
        var i = 7 & this.current708Packet.data[e];
        return t.setCurrentWindow(i), e
      }, De.prototype.defineWindow = function (e, t) {
        var i = this.current708Packet.data,
          n = i[e],
          r = 7 & n;
        t.setCurrentWindow(r);
        var a = t.currentWindow;
        return n = i[++e], a.visible = (32 & n) >> 5, a.rowLock = (16 & n) >> 4, a.columnLock = (8 & n) >> 3, a.priority = 7 & n, n = i[++e], a.relativePositioning = (128 & n) >> 7, a.anchorVertical = 127 & n, n = i[++e], a.anchorHorizontal = n, n = i[++e], a.anchorPoint = (240 & n) >> 4, a.rowCount = 15 & n, n = i[++e], a.columnCount = 63 & n, n = i[++e], a.windowStyle = (56 & n) >> 3, a.penStyle = 7 & n, a.virtualRowCount = a.rowCount + 1, e
      }, De.prototype.setWindowAttributes = function (e, t) {
        var i = this.current708Packet.data,
          n = i[e],
          r = t.currentWindow.winAttr;
        return n = i[++e], r.fillOpacity = (192 & n) >> 6, r.fillRed = (48 & n) >> 4, r.fillGreen = (12 & n) >> 2, r.fillBlue = 3 & n, n = i[++e], r.borderType = (192 & n) >> 6, r.borderRed = (48 & n) >> 4, r.borderGreen = (12 & n) >> 2, r.borderBlue = 3 & n, n = i[++e], r.borderType += (128 & n) >> 5, r.wordWrap = (64 & n) >> 6, r.printDirection = (48 & n) >> 4, r.scrollDirection = (12 & n) >> 2, r.justify = 3 & n, n = i[++e], r.effectSpeed = (240 & n) >> 4, r.effectDirection = (12 & n) >> 2, r.displayEffect = 3 & n, e
      }, De.prototype.flushDisplayed = function (e, t) {
        for (var i = [], n = 0; n < 8; n++) t.windows[n].visible && !t.windows[n].isEmpty() && i.push(t.windows[n].getText());
        t.endPts = e, t.text = i.join("\n\n"), this.pushCaption(t), t.startPts = e
      }, De.prototype.pushCaption = function (e) {
        "" !== e.text && (this.trigger("data", {
          startPts: e.startPts,
          endPts: e.endPts,
          text: e.text,
          stream: "cc708_" + e.serviceNum
        }), e.text = "", e.startPts = e.endPts)
      }, De.prototype.displayWindows = function (e, t) {
        var i = this.current708Packet.data[++e],
          n = this.getPts(e);
        this.flushDisplayed(n, t);
        for (var r = 0; r < 8; r++) i & 1 << r && (t.windows[r].visible = 1);
        return e
      }, De.prototype.hideWindows = function (e, t) {
        var i = this.current708Packet.data[++e],
          n = this.getPts(e);
        this.flushDisplayed(n, t);
        for (var r = 0; r < 8; r++) i & 1 << r && (t.windows[r].visible = 0);
        return e
      }, De.prototype.toggleWindows = function (e, t) {
        var i = this.current708Packet.data[++e],
          n = this.getPts(e);
        this.flushDisplayed(n, t);
        for (var r = 0; r < 8; r++) i & 1 << r && (t.windows[r].visible ^= 1);
        return e
      }, De.prototype.clearWindows = function (e, t) {
        var i = this.current708Packet.data[++e],
          n = this.getPts(e);
        this.flushDisplayed(n, t);
        for (var r = 0; r < 8; r++) i & 1 << r && t.windows[r].clearText();
        return e
      }, De.prototype.deleteWindows = function (e, t) {
        var i = this.current708Packet.data[++e],
          n = this.getPts(e);
        this.flushDisplayed(n, t);
        for (var r = 0; r < 8; r++) i & 1 << r && t.windows[r].reset();
        return e
      }, De.prototype.setPenAttributes = function (e, t) {
        var i = this.current708Packet.data,
          n = i[e],
          r = t.currentWindow.penAttr;
        return n = i[++e], r.textTag = (240 & n) >> 4, r.offset = (12 & n) >> 2, r.penSize = 3 & n, n = i[++e], r.italics = (128 & n) >> 7, r.underline = (64 & n) >> 6, r.edgeType = (56 & n) >> 3, r.fontStyle = 7 & n, e
      }, De.prototype.setPenColor = function (e, t) {
        var i = this.current708Packet.data,
          n = i[e],
          r = t.currentWindow.penColor;
        return n = i[++e], r.fgOpacity = (192 & n) >> 6, r.fgRed = (48 & n) >> 4, r.fgGreen = (12 & n) >> 2, r.fgBlue = 3 & n, n = i[++e], r.bgOpacity = (192 & n) >> 6, r.bgRed = (48 & n) >> 4, r.bgGreen = (12 & n) >> 2, r.bgBlue = 3 & n, n = i[++e], r.edgeRed = (48 & n) >> 4, r.edgeGreen = (12 & n) >> 2, r.edgeBlue = 3 & n, e
      }, De.prototype.setPenLocation = function (e, t) {
        var i = this.current708Packet.data,
          n = i[e],
          r = t.currentWindow.penLoc;
        return t.currentWindow.pendingNewLine = !0, n = i[++e], r.row = 15 & n, n = i[++e], r.column = 63 & n, e
      }, De.prototype.reset = function (e, t) {
        var i = this.getPts(e);
        return this.flushDisplayed(i, t), this.initService(t.serviceNum, e)
      };

      function Re(e) {
        return null === e ? "" : (e = Ne[e] || e, String.fromCharCode(e))
      }

      function Me() {
        for (var e = [], t = 15; t--;) e.push("");
        return e
      }
      var Ne = {
          42: 225,
          92: 233,
          94: 237,
          95: 243,
          96: 250,
          123: 231,
          124: 247,
          125: 209,
          126: 241,
          127: 9608,
          304: 174,
          305: 176,
          306: 189,
          307: 191,
          308: 8482,
          309: 162,
          310: 163,
          311: 9834,
          312: 224,
          313: 160,
          314: 232,
          315: 226,
          316: 234,
          317: 238,
          318: 244,
          319: 251,
          544: 193,
          545: 201,
          546: 211,
          547: 218,
          548: 220,
          549: 252,
          550: 8216,
          551: 161,
          552: 42,
          553: 39,
          554: 8212,
          555: 169,
          556: 8480,
          557: 8226,
          558: 8220,
          559: 8221,
          560: 192,
          561: 194,
          562: 199,
          563: 200,
          564: 202,
          565: 203,
          566: 235,
          567: 206,
          568: 207,
          569: 239,
          570: 212,
          571: 217,
          572: 249,
          573: 219,
          574: 171,
          575: 187,
          800: 195,
          801: 227,
          802: 205,
          803: 204,
          804: 236,
          805: 210,
          806: 242,
          807: 213,
          808: 245,
          809: 123,
          810: 125,
          811: 92,
          812: 94,
          813: 95,
          814: 124,
          815: 126,
          816: 196,
          817: 228,
          818: 214,
          819: 246,
          820: 223,
          821: 165,
          822: 164,
          823: 9474,
          824: 197,
          825: 229,
          826: 216,
          827: 248,
          828: 9484,
          829: 9488,
          830: 9492,
          831: 9496
        },
        Ue = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152],
        Be = function e(t, i) {
          e.prototype.init.call(this), this.field_ = t || 0, this.dataChannel_ = i || 0, this.name_ = "CC" + (1 + (this.field_ << 1 | this.dataChannel_)), this.setConstants(), this.reset(), this.push = function (e) {
            var t, i, n, r, a;
            if ((t = 32639 & e.ccData) !== this.lastControlCode_) {
              if (4096 == (61440 & t) ? this.lastControlCode_ = t : t !== this.PADDING_ && (this.lastControlCode_ = null), n = t >>> 8, r = 255 & t, t !== this.PADDING_)
                if (t === this.RESUME_CAPTION_LOADING_) this.mode_ = "popOn";
                else if (t === this.END_OF_CAPTION_) this.mode_ = "popOn", this.clearFormatting(e.pts), this.flushDisplayed(e.pts), i = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = i, this.startPts_ = e.pts;
              else if (t === this.ROLL_UP_2_ROWS_) this.rollUpRows_ = 2, this.setRollUp(e.pts);
              else if (t === this.ROLL_UP_3_ROWS_) this.rollUpRows_ = 3, this.setRollUp(e.pts);
              else if (t === this.ROLL_UP_4_ROWS_) this.rollUpRows_ = 4, this.setRollUp(e.pts);
              else if (t === this.CARRIAGE_RETURN_) this.clearFormatting(e.pts), this.flushDisplayed(e.pts), this.shiftRowsUp_(), this.startPts_ = e.pts;
              else if (t === this.BACKSPACE_) "popOn" === this.mode_ ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
              else if (t === this.ERASE_DISPLAYED_MEMORY_) this.flushDisplayed(e.pts), this.displayed_ = Me();
              else if (t === this.ERASE_NON_DISPLAYED_MEMORY_) this.nonDisplayed_ = Me();
              else if (t === this.RESUME_DIRECT_CAPTIONING_) "paintOn" !== this.mode_ && (this.flushDisplayed(e.pts), this.displayed_ = Me()), this.mode_ = "paintOn", this.startPts_ = e.pts;
              else if (this.isSpecialCharacter(n, r)) a = Re((n = (3 & n) << 8) | r), this[this.mode_](e.pts, a), this.column_++;
              else if (this.isExtCharacter(n, r)) "popOn" === this.mode_ ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1), a = Re((n = (3 & n) << 8) | r), this[this.mode_](e.pts, a), this.column_++;
              else if (this.isMidRowCode(n, r)) this.clearFormatting(e.pts), this[this.mode_](e.pts, " "), this.column_++, 14 == (14 & r) && this.addFormatting(e.pts, ["i"]), 1 == (1 & r) && this.addFormatting(e.pts, ["u"]);
              else if (this.isOffsetControlCode(n, r)) this.column_ += 3 & r;
              else if (this.isPAC(n, r)) {
                var s = Ue.indexOf(7968 & t);
                "rollUp" === this.mode_ && (s - this.rollUpRows_ + 1 < 0 && (s = this.rollUpRows_ - 1), this.setRollUp(e.pts, s)), s !== this.row_ && (this.clearFormatting(e.pts), this.row_ = s), 1 & r && -1 === this.formatting_.indexOf("u") && this.addFormatting(e.pts, ["u"]), 16 == (16 & t) && (this.column_ = 4 * ((14 & t) >> 1)), this.isColorPAC(r) && 14 == (14 & r) && this.addFormatting(e.pts, ["i"])
              } else this.isNormalChar(n) && (0 === r && (r = null), a = Re(n), a += Re(r), this[this.mode_](e.pts, a), this.column_ += a.length)
            } else this.lastControlCode_ = null
          }
        };
      Be.prototype = new H, Be.prototype.flushDisplayed = function (e) {
        var t = this.displayed_.map(function (e) {
          try {
            return e.trim()
          } catch (e) {
            return ""
          }
        }).join("\n").replace(/^\n+|\n+$/g, "");
        t.length && this.trigger("data", {
          startPts: this.startPts_,
          endPts: e,
          text: t,
          stream: this.name_
        })
      }, Be.prototype.reset = function () {
        this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = Me(), this.nonDisplayed_ = Me(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = 14, this.rollUpRows_ = 2, this.formatting_ = []
      }, Be.prototype.setConstants = function () {
        0 === this.dataChannel_ ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : 1 === this.dataChannel_ && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = 32 | this.CONTROL_, this.END_OF_CAPTION_ = 47 | this.CONTROL_, this.ROLL_UP_2_ROWS_ = 37 | this.CONTROL_, this.ROLL_UP_3_ROWS_ = 38 | this.CONTROL_, this.ROLL_UP_4_ROWS_ = 39 | this.CONTROL_, this.CARRIAGE_RETURN_ = 45 | this.CONTROL_, this.RESUME_DIRECT_CAPTIONING_ = 41 | this.CONTROL_, this.BACKSPACE_ = 33 | this.CONTROL_, this.ERASE_DISPLAYED_MEMORY_ = 44 | this.CONTROL_, this.ERASE_NON_DISPLAYED_MEMORY_ = 46 | this.CONTROL_
      }, Be.prototype.isSpecialCharacter = function (e, t) {
        return e === this.EXT_ && 48 <= t && t <= 63
      }, Be.prototype.isExtCharacter = function (e, t) {
        return (e === this.EXT_ + 1 || e === this.EXT_ + 2) && 32 <= t && t <= 63
      }, Be.prototype.isMidRowCode = function (e, t) {
        return e === this.EXT_ && 32 <= t && t <= 47
      }, Be.prototype.isOffsetControlCode = function (e, t) {
        return e === this.OFFSET_ && 33 <= t && t <= 35
      }, Be.prototype.isPAC = function (e, t) {
        return e >= this.BASE_ && e < this.BASE_ + 8 && 64 <= t && t <= 127
      }, Be.prototype.isColorPAC = function (e) {
        return 64 <= e && e <= 79 || 96 <= e && e <= 127
      }, Be.prototype.isNormalChar = function (e) {
        return 32 <= e && e <= 127
      }, Be.prototype.setRollUp = function (e, t) {
        if ("rollUp" !== this.mode_ && (this.row_ = 14, this.mode_ = "rollUp", this.flushDisplayed(e), this.nonDisplayed_ = Me(), this.displayed_ = Me()), void 0 !== t && t !== this.row_)
          for (var i = 0; i < this.rollUpRows_; i++) this.displayed_[t - i] = this.displayed_[this.row_ - i], this.displayed_[this.row_ - i] = "";
        void 0 === t && (t = this.row_), this.topRow_ = t - this.rollUpRows_ + 1
      }, Be.prototype.addFormatting = function (e, t) {
        this.formatting_ = this.formatting_.concat(t);
        var i = t.reduce(function (e, t) {
          return e + "<" + t + ">"
        }, "");
        this[this.mode_](e, i)
      }, Be.prototype.clearFormatting = function (e) {
        if (this.formatting_.length) {
          var t = this.formatting_.reverse().reduce(function (e, t) {
            return e + "</" + t + ">"
          }, "");
          this.formatting_ = [], this[this.mode_](e, t)
        }
      }, Be.prototype.popOn = function (e, t) {
        var i = this.nonDisplayed_[this.row_];
        i += t, this.nonDisplayed_[this.row_] = i
      }, Be.prototype.rollUp = function (e, t) {
        var i = this.displayed_[this.row_];
        i += t, this.displayed_[this.row_] = i
      }, Be.prototype.shiftRowsUp_ = function () {
        var e;
        for (e = 0; e < this.topRow_; e++) this.displayed_[e] = "";
        for (e = this.row_ + 1; e < 15; e++) this.displayed_[e] = "";
        for (e = this.topRow_; e < this.row_; e++) this.displayed_[e] = this.displayed_[e + 1];
        this.displayed_[this.row_] = ""
      }, Be.prototype.paintOn = function (e, t) {
        var i = this.displayed_[this.row_];
        i += t, this.displayed_[this.row_] = i
      };

      function Fe(e, t) {
        var i = 1;
        for (t < e && (i = -1); 4294967296 < Math.abs(t - e);) e += 8589934592 * i;
        return e
      }

      function je(e) {
        var t, i;
        je.prototype.init.call(this), this.type_ = e || "shared", this.push = function (e) {
          "shared" !== this.type_ && e.type !== this.type_ || (void 0 === i && (i = e.dts), e.dts = Fe(e.dts, i), e.pts = Fe(e.pts, i), t = e.dts, this.trigger("data", e))
        }, this.flush = function () {
          i = t, this.trigger("done")
        }, this.endTimeline = function () {
          this.flush(), this.trigger("endedtimeline")
        }, this.discontinuity = function () {
          t = i = void 0
        }, this.reset = function () {
          this.discontinuity(), this.trigger("reset")
        }
      }
      var He = {
          CaptionStream: G,
          Cea608Stream: Be,
          Cea708Stream: De
        },
        Ve = {
          H264_STREAM_TYPE: 27,
          ADTS_STREAM_TYPE: 15,
          METADATA_STREAM_TYPE: 21
        };
      je.prototype = new H;

      function qe(e, t, i) {
        var n, r = "";
        for (n = t; n < i; n++) r += "%" + ("00" + e[n].toString(16)).slice(-2);
        return r
      }

      function We(e, t, i) {
        return decodeURIComponent(qe(e, t, i))
      }

      function ze(e) {
        return e[0] << 21 | e[1] << 14 | e[2] << 7 | e[3]
      }
      var Ge, Xe = je,
        Ke = {
          TXXX: function (e) {
            var t;
            if (3 === e.data[0]) {
              for (t = 1; t < e.data.length; t++)
                if (0 === e.data[t]) {
                  e.description = We(e.data, 1, t), e.value = We(e.data, t + 1, e.data.length).replace(/\0*$/, "");
                  break
                } e.data = e.value
            }
          },
          WXXX: function (e) {
            var t;
            if (3 === e.data[0])
              for (t = 1; t < e.data.length; t++)
                if (0 === e.data[t]) {
                  e.description = We(e.data, 1, t), e.url = We(e.data, t + 1, e.data.length);
                  break
                }
          },
          PRIV: function (e) {
            var t, i;
            for (t = 0; t < e.data.length; t++)
              if (0 === e.data[t]) {
                e.owner = (i = e.data, unescape(qe(i, 0, t)));
                break
              } e.privateData = e.data.subarray(t + 1), e.data = e.privateData
          }
        };
      (Ge = function (e) {
        var t, u = {
            debug: !(!e || !e.debug),
            descriptor: e && e.descriptor
          },
          l = 0,
          c = [],
          d = 0;
        if (Ge.prototype.init.call(this), this.dispatchType = Ve.METADATA_STREAM_TYPE.toString(16), u.descriptor)
          for (t = 0; t < u.descriptor.length; t++) this.dispatchType += ("00" + u.descriptor[t].toString(16)).slice(-2);
        this.push = function (e) {
          var t, i, n, r, a;
          if ("timed-metadata" === e.type)
            if (e.dataAlignmentIndicator && (d = 0, c.length = 0), 0 === c.length && (e.data.length < 10 || e.data[0] !== "I".charCodeAt(0) || e.data[1] !== "D".charCodeAt(0) || e.data[2] !== "3".charCodeAt(0))) u.debug;
            else if (c.push(e), d += e.data.byteLength, 1 === c.length && (l = ze(e.data.subarray(6, 10)), l += 10), !(d < l)) {
            for (t = {
                data: new Uint8Array(l),
                frames: [],
                pts: c[0].pts,
                dts: c[0].dts
              }, a = 0; a < l;) t.data.set(c[0].data.subarray(0, l - a), a), a += c[0].data.byteLength, d -= c[0].data.byteLength, c.shift();
            i = 10, 64 & t.data[5] && (i += 4, i += ze(t.data.subarray(10, 14)), l -= ze(t.data.subarray(16, 20)));
            do {
              if ((n = ze(t.data.subarray(i + 4, i + 8))) < 1) return;
              if ((r = {
                  id: String.fromCharCode(t.data[i], t.data[i + 1], t.data[i + 2], t.data[i + 3]),
                  data: t.data.subarray(i + 10, i + n + 10)
                }).key = r.id, Ke[r.id] && (Ke[r.id](r), "com.apple.streaming.transportStreamTimestamp" === r.owner)) {
                var s = r.data,
                  o = (1 & s[3]) << 30 | s[4] << 22 | s[5] << 14 | s[6] << 6 | s[7] >>> 2;
                o *= 4, o += 3 & s[7], r.timeStamp = o, void 0 === t.pts && void 0 === t.dts && (t.pts = r.timeStamp, t.dts = r.timeStamp), this.trigger("timestamp", r)
              }
              t.frames.push(r), i += 10, i += n
            } while (i < l);
            this.trigger("data", t)
          }
        }
      }).prototype = new H;
      var Ye, Qe, $e, Je = Ge,
        Ze = Xe;
      (Ye = function () {
        var r = new Uint8Array(188),
          a = 0;
        Ye.prototype.init.call(this), this.push = function (e) {
          var t, i = 0,
            n = 188;
          for (a ? ((t = new Uint8Array(e.byteLength + a)).set(r.subarray(0, a)), t.set(e, a), a = 0) : t = e; n < t.byteLength;) 71 !== t[i] || 71 !== t[n] ? (i++, n++) : (this.trigger("data", t.subarray(i, n)), i += 188, n += 188);
          i < t.byteLength && (r.set(t.subarray(i), 0), a = t.byteLength - i)
        }, this.flush = function () {
          188 === a && 71 === r[0] && (this.trigger("data", r), a = 0), this.trigger("done")
        }, this.endTimeline = function () {
          this.flush(), this.trigger("endedtimeline")
        }, this.reset = function () {
          a = 0, this.trigger("reset")
        }
      }).prototype = new H, (Qe = function () {
        var n, r, a, s;
        Qe.prototype.init.call(this), (s = this).packetsWaitingForPmt = [], this.programMapTable = void 0, n = function (e, t) {
          var i = 0;
          t.payloadUnitStartIndicator && (i += e[i] + 1), "pat" === t.type ? r(e.subarray(i), t) : a(e.subarray(i), t)
        }, r = function (e, t) {
          t.section_number = e[7], t.last_section_number = e[8], s.pmtPid = (31 & e[10]) << 8 | e[11], t.pmtPid = s.pmtPid
        }, a = function (e, t) {
          var i, n;
          if (1 & e[5]) {
            for (s.programMapTable = {
                video: null,
                audio: null,
                "timed-metadata": {}
              }, i = 3 + ((15 & e[1]) << 8 | e[2]) - 4, n = 12 + ((15 & e[10]) << 8 | e[11]); n < i;) {
              var r = e[n],
                a = (31 & e[n + 1]) << 8 | e[n + 2];
              r === Ve.H264_STREAM_TYPE && null === s.programMapTable.video ? s.programMapTable.video = a : r === Ve.ADTS_STREAM_TYPE && null === s.programMapTable.audio ? s.programMapTable.audio = a : r === Ve.METADATA_STREAM_TYPE && (s.programMapTable["timed-metadata"][a] = r), n += 5 + ((15 & e[n + 3]) << 8 | e[n + 4])
            }
            t.programMapTable = s.programMapTable
          }
        }, this.push = function (e) {
          var t = {},
            i = 4;
          if (t.payloadUnitStartIndicator = !!(64 & e[1]), t.pid = 31 & e[1], t.pid <<= 8, t.pid |= e[2], 1 < (48 & e[3]) >>> 4 && (i += e[i] + 1), 0 === t.pid) t.type = "pat", n(e.subarray(i), t), this.trigger("data", t);
          else if (t.pid === this.pmtPid)
            for (t.type = "pmt", n(e.subarray(i), t), this.trigger("data", t); this.packetsWaitingForPmt.length;) this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
          else void 0 === this.programMapTable ? this.packetsWaitingForPmt.push([e, i, t]) : this.processPes_(e, i, t)
        }, this.processPes_ = function (e, t, i) {
          i.pid === this.programMapTable.video ? i.streamType = Ve.H264_STREAM_TYPE : i.pid === this.programMapTable.audio ? i.streamType = Ve.ADTS_STREAM_TYPE : i.streamType = this.programMapTable["timed-metadata"][i.pid], i.type = "pes", i.data = e.subarray(t), this.trigger("data", i)
        }
      }).prototype = new H, Qe.STREAM_TYPES = {
        h264: 27,
        adts: 15
      }, ($e = function () {
        function n(e, t, i) {
          var n, r, a = new Uint8Array(e.size),
            s = {
              type: t
            },
            o = 0,
            u = 0;
          if (e.data.length && !(e.size < 9)) {
            for (s.trackId = e.data[0].pid, o = 0; o < e.data.length; o++) r = e.data[o], a.set(r.data, u), u += r.data.byteLength;
            ! function (e, t) {
              var i, n = e[0] << 16 | e[1] << 8 | e[2];
              t.data = new Uint8Array, 1 == n && (t.packetLength = 6 + (e[4] << 8 | e[5]), t.dataAlignmentIndicator = 0 != (4 & e[6]), 192 & (i = e[7]) && (t.pts = (14 & e[9]) << 27 | (255 & e[10]) << 20 | (254 & e[11]) << 12 | (255 & e[12]) << 5 | (254 & e[13]) >>> 3, t.pts *= 4, t.pts += (6 & e[13]) >>> 1, t.dts = t.pts, 64 & i && (t.dts = (14 & e[14]) << 27 | (255 & e[15]) << 20 | (254 & e[16]) << 12 | (255 & e[17]) << 5 | (254 & e[18]) >>> 3, t.dts *= 4, t.dts += (6 & e[18]) >>> 1)), t.data = e.subarray(9 + e[8]))
            }(a, s), n = "video" === t || s.packetLength <= e.size, (i || n) && (e.size = 0, e.data.length = 0), n && l.trigger("data", s)
          }
        }
        var t, l = this,
          r = {
            data: [],
            size: 0
          },
          a = {
            data: [],
            size: 0
          },
          s = {
            data: [],
            size: 0
          };
        $e.prototype.init.call(this), this.push = function (i) {
          ({
            pat: function () {},
            pes: function () {
              var e, t;
              switch (i.streamType) {
                case Ve.H264_STREAM_TYPE:
                  e = r, t = "video";
                  break;
                case Ve.ADTS_STREAM_TYPE:
                  e = a, t = "audio";
                  break;
                case Ve.METADATA_STREAM_TYPE:
                  e = s, t = "timed-metadata";
                  break;
                default:
                  return
              }
              i.payloadUnitStartIndicator && n(e, t, !0), e.data.push(i), e.size += i.data.byteLength
            },
            pmt: function () {
              var e = {
                type: "metadata",
                tracks: []
              };
              null !== (t = i.programMapTable).video && e.tracks.push({
                timelineStartInfo: {
                  baseMediaDecodeTime: 0
                },
                id: +t.video,
                codec: "avc",
                type: "video"
              }), null !== t.audio && e.tracks.push({
                timelineStartInfo: {
                  baseMediaDecodeTime: 0
                },
                id: +t.audio,
                codec: "adts",
                type: "audio"
              }), l.trigger("data", e)
            }
          })[i.type]()
        }, this.reset = function () {
          r.size = 0, r.data.length = 0, a.size = 0, a.data.length = 0, this.trigger("reset")
        }, this.flushStreams_ = function () {
          n(r, "video"), n(a, "audio"), n(s, "timed-metadata")
        }, this.flush = function () {
          this.flushStreams_(), this.trigger("done")
        }
      }).prototype = new H;
      var et = {
        PAT_PID: 0,
        MP2T_PACKET_LENGTH: 188,
        TransportPacketStream: Ye,
        TransportParseStream: Qe,
        ElementaryStream: $e,
        TimestampRolloverStream: Ze,
        CaptionStream: He.CaptionStream,
        Cea608Stream: He.Cea608Stream,
        Cea708Stream: He.Cea708Stream,
        MetadataStream: Je
      };
      for (var tt in Ve) Ve.hasOwnProperty(tt) && (et[tt] = Ve[tt]);
      var it, nt = et,
        rt = ce,
        at = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
      (it = function (u) {
        var l, c = 0;
        it.prototype.init.call(this), this.push = function (e) {
          var t, i, n, r, a, s, o = 0;
          if (u || (c = 0), "audio" === e.type)
            for (l ? (r = l, (l = new Uint8Array(r.byteLength + e.data.byteLength)).set(r), l.set(e.data, r.byteLength)) : l = e.data; o + 5 < l.length;)
              if (255 === l[o] && 240 == (246 & l[o + 1])) {
                if (i = 2 * (1 & ~l[o + 1]), t = (3 & l[o + 3]) << 11 | l[o + 4] << 3 | (224 & l[o + 5]) >> 5, s = (a = 1024 * (1 + (3 & l[o + 6]))) * rt / at[(60 & l[o + 2]) >>> 2], n = o + t, l.byteLength < n) return;
                if (this.trigger("data", {
                    pts: e.pts + c * s,
                    dts: e.dts + c * s,
                    sampleCount: a,
                    audioobjecttype: 1 + (l[o + 2] >>> 6 & 3),
                    channelcount: (1 & l[o + 2]) << 2 | (192 & l[o + 3]) >>> 6,
                    samplerate: at[(60 & l[o + 2]) >>> 2],
                    samplingfrequencyindex: (60 & l[o + 2]) >>> 2,
                    samplesize: 16,
                    data: l.subarray(o + 7 + i, n)
                  }), c++, l.byteLength === n) return void(l = void 0);
                l = l.subarray(n)
              } else o++
        }, this.flush = function () {
          c = 0, this.trigger("done")
        }, this.reset = function () {
          l = void 0, this.trigger("reset")
        }, this.endTimeline = function () {
          l = void 0, this.trigger("endedtimeline")
        }
      }).prototype = new H;
      var st, ot, ut, lt = it,
        ct = function (n) {
          var r = n.byteLength,
            a = 0,
            s = 0;
          this.length = function () {
            return 8 * r
          }, this.bitsAvailable = function () {
            return 8 * r + s
          }, this.loadWord = function () {
            var e = n.byteLength - r,
              t = new Uint8Array(4),
              i = Math.min(4, r);
            if (0 === i) throw new Error("no bytes available");
            t.set(n.subarray(e, e + i)), a = new DataView(t.buffer).getUint32(0), s = 8 * i, r -= i
          }, this.skipBits = function (e) {
            var t;
            e < s || (e -= s, e -= 8 * (t = Math.floor(e / 8)), r -= t, this.loadWord()), a <<= e, s -= e
          }, this.readBits = function (e) {
            var t = Math.min(s, e),
              i = a >>> 32 - t;
            return 0 < (s -= t) ? a <<= t : 0 < r && this.loadWord(), 0 < (t = e - t) ? i << t | this.readBits(t) : i
          }, this.skipLeadingZeros = function () {
            var e;
            for (e = 0; e < s; ++e)
              if (0 != (a & 2147483648 >>> e)) return a <<= e, s -= e, e;
            return this.loadWord(), e + this.skipLeadingZeros()
          }, this.skipUnsignedExpGolomb = function () {
            this.skipBits(1 + this.skipLeadingZeros())
          }, this.skipExpGolomb = function () {
            this.skipBits(1 + this.skipLeadingZeros())
          }, this.readUnsignedExpGolomb = function () {
            var e = this.skipLeadingZeros();
            return this.readBits(e + 1) - 1
          }, this.readExpGolomb = function () {
            var e = this.readUnsignedExpGolomb();
            return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1)
          }, this.readBoolean = function () {
            return 1 === this.readBits(1)
          }, this.readUnsignedByte = function () {
            return this.readBits(8)
          }, this.loadWord()
        };
      (ot = function () {
        var n, r, a = 0;
        ot.prototype.init.call(this), this.push = function (e) {
          for (var t, i = (r = r ? ((t = new Uint8Array(r.byteLength + e.data.byteLength)).set(r), t.set(e.data, r.byteLength), t) : e.data).byteLength; a < i - 3; a++)
            if (1 === r[a + 2]) {
              n = a + 5;
              break
            } for (; n < i;) switch (r[n]) {
            case 0:
              if (0 !== r[n - 1]) {
                n += 2;
                break
              }
              if (0 !== r[n - 2]) {
                n++;
                break
              }
              for (a + 3 !== n - 2 && this.trigger("data", r.subarray(a + 3, n - 2)); 1 !== r[++n] && n < i;);
              a = n - 2, n += 3;
              break;
            case 1:
              if (0 !== r[n - 1] || 0 !== r[n - 2]) {
                n += 3;
                break
              }
              this.trigger("data", r.subarray(a + 3, n - 2)), a = n - 2, n += 3;
              break;
            default:
              n += 3
          }
          r = r.subarray(a), n -= a, a = 0
        }, this.reset = function () {
          r = null, a = 0, this.trigger("reset")
        }, this.flush = function () {
          r && 3 < r.byteLength && this.trigger("data", r.subarray(a + 3)), r = null, a = 0, this.trigger("done")
        }, this.endTimeline = function () {
          this.flush(), this.trigger("endedtimeline")
        }
      }).prototype = new H, ut = {
        100: !0,
        110: !0,
        122: !0,
        244: !0,
        44: !0,
        83: !0,
        86: !0,
        118: !0,
        128: !0,
        138: !0,
        139: !0,
        134: !0
      }, (st = function () {
        var i, n, r, a, s, o, _, t = new ot;
        st.prototype.init.call(this), (i = this).push = function (e) {
          "video" === e.type && (n = e.trackId, r = e.pts, a = e.dts, t.push(e))
        }, t.on("data", function (e) {
          var t = {
            trackId: n,
            pts: r,
            dts: a,
            data: e
          };
          switch (31 & e[0]) {
            case 5:
              t.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
              break;
            case 6:
              t.nalUnitType = "sei_rbsp", t.escapedRBSP = s(e.subarray(1));
              break;
            case 7:
              t.nalUnitType = "seq_parameter_set_rbsp", t.escapedRBSP = s(e.subarray(1)), t.config = o(t.escapedRBSP);
              break;
            case 8:
              t.nalUnitType = "pic_parameter_set_rbsp";
              break;
            case 9:
              t.nalUnitType = "access_unit_delimiter_rbsp"
          }
          i.trigger("data", t)
        }), t.on("done", function () {
          i.trigger("done")
        }), t.on("partialdone", function () {
          i.trigger("partialdone")
        }), t.on("reset", function () {
          i.trigger("reset")
        }), t.on("endedtimeline", function () {
          i.trigger("endedtimeline")
        }), this.flush = function () {
          t.flush()
        }, this.partialFlush = function () {
          t.partialFlush()
        }, this.reset = function () {
          t.reset()
        }, this.endTimeline = function () {
          t.endTimeline()
        }, _ = function (e, t) {
          var i, n = 8,
            r = 8;
          for (i = 0; i < e; i++) 0 !== r && (r = (n + t.readExpGolomb() + 256) % 256), n = 0 === r ? n : r
        }, s = function (e) {
          for (var t, i, n = e.byteLength, r = [], a = 1; a < n - 2;) 0 === e[a] && 0 === e[a + 1] && 3 === e[a + 2] ? (r.push(a + 2), a += 2) : a++;
          if (0 === r.length) return e;
          t = n - r.length, i = new Uint8Array(t);
          var s = 0;
          for (a = 0; a < t; s++, a++) s === r[0] && (s++, r.shift()), i[a] = e[s];
          return i
        }, o = function (e) {
          var t, i, n, r, a, s, o, u, l, c, d, h, p, f = 0,
            m = 0,
            g = 0,
            v = 0,
            y = 1;
          if (i = (t = new ct(e)).readUnsignedByte(), r = t.readUnsignedByte(), n = t.readUnsignedByte(), t.skipUnsignedExpGolomb(), ut[i] && (3 === (a = t.readUnsignedExpGolomb()) && t.skipBits(1), t.skipUnsignedExpGolomb(), t.skipUnsignedExpGolomb(), t.skipBits(1), t.readBoolean()))
            for (d = 3 !== a ? 8 : 12, p = 0; p < d; p++) t.readBoolean() && _(p < 6 ? 16 : 64, t);
          if (t.skipUnsignedExpGolomb(), 0 === (s = t.readUnsignedExpGolomb())) t.readUnsignedExpGolomb();
          else if (1 === s)
            for (t.skipBits(1), t.skipExpGolomb(), t.skipExpGolomb(), o = t.readUnsignedExpGolomb(), p = 0; p < o; p++) t.skipExpGolomb();
          if (t.skipUnsignedExpGolomb(), t.skipBits(1), u = t.readUnsignedExpGolomb(), l = t.readUnsignedExpGolomb(), 0 === (c = t.readBits(1)) && t.skipBits(1), t.skipBits(1), t.readBoolean() && (f = t.readUnsignedExpGolomb(), m = t.readUnsignedExpGolomb(), g = t.readUnsignedExpGolomb(), v = t.readUnsignedExpGolomb()), t.readBoolean() && t.readBoolean()) {
            switch (t.readUnsignedByte()) {
              case 1:
                h = [1, 1];
                break;
              case 2:
                h = [12, 11];
                break;
              case 3:
                h = [10, 11];
                break;
              case 4:
                h = [16, 11];
                break;
              case 5:
                h = [40, 33];
                break;
              case 6:
                h = [24, 11];
                break;
              case 7:
                h = [20, 11];
                break;
              case 8:
                h = [32, 11];
                break;
              case 9:
                h = [80, 33];
                break;
              case 10:
                h = [18, 11];
                break;
              case 11:
                h = [15, 11];
                break;
              case 12:
                h = [64, 33];
                break;
              case 13:
                h = [160, 99];
                break;
              case 14:
                h = [4, 3];
                break;
              case 15:
                h = [3, 2];
                break;
              case 16:
                h = [2, 1];
                break;
              case 255:
                h = [t.readUnsignedByte() << 8 | t.readUnsignedByte(), t.readUnsignedByte() << 8 | t.readUnsignedByte()]
            }
            h && (y = h[0] / h[1])
          }
          return {
            profileIdc: i,
            levelIdc: n,
            profileCompatibility: r,
            width: Math.ceil((16 * (u + 1) - 2 * f - 2 * m) * y),
            height: (2 - c) * (l + 1) * 16 - 2 * g - 2 * v,
            sarRatio: h
          }
        }
      }).prototype = new H;

      function dt(e, t) {
        var i = e[t + 6] << 21 | e[t + 7] << 14 | e[t + 8] << 7 | e[t + 9];
        return i = 0 <= i ? i : 0, (16 & e[t + 5]) >> 4 ? i + 20 : i + 10
      }
      var ht, pt = {
          H264Stream: st,
          NalByteStream: ot
        },
        ft = function (e) {
          var t = function e(t, i) {
            return t.length - i < 10 || t[i] !== "I".charCodeAt(0) || t[i + 1] !== "D".charCodeAt(0) || t[i + 2] !== "3".charCodeAt(0) ? i : e(t, i += dt(t, i))
          }(e, 0);
          return e.length >= t + 2 && 255 == (255 & e[t]) && 240 == (240 & e[t + 1]) && 16 == (22 & e[t + 1])
        },
        mt = dt,
        gt = function (e, t) {
          var i = (224 & e[t + 5]) >> 5,
            n = e[t + 4] << 3;
          return 6144 & e[t + 3] | n | i
        };
      (ht = function () {
        var o = new Uint8Array,
          u = 0;
        ht.prototype.init.call(this), this.setTimestamp = function (e) {
          u = e
        }, this.push = function (e) {
          var t, i, n, r, a = 0,
            s = 0;
          for (o.length ? (r = o.length, (o = new Uint8Array(e.byteLength + r)).set(o.subarray(0, r)), o.set(e, r)) : o = e; 3 <= o.length - s;)
            if (o[s] !== "I".charCodeAt(0) || o[s + 1] !== "D".charCodeAt(0) || o[s + 2] !== "3".charCodeAt(0))
              if (255 != (255 & o[s]) || 240 != (240 & o[s + 1])) s++;
              else {
                if (o.length - s < 7) break;
                if (s + (a = gt(o, s)) > o.length) break;
                n = {
                  type: "audio",
                  data: o.subarray(s, s + a),
                  pts: u,
                  dts: u
                }, this.trigger("data", n), s += a
              }
          else {
            if (o.length - s < 10) break;
            if (s + (a = mt(o, s)) > o.length) break;
            i = {
              type: "timed-metadata",
              data: o.subarray(s, s + a)
            }, this.trigger("data", i), s += a
          }
          t = o.length - s, o = 0 < t ? o.subarray(s) : new Uint8Array
        }, this.reset = function () {
          o = new Uint8Array, this.trigger("reset")
        }, this.endTimeline = function () {
          o = new Uint8Array, this.trigger("endedtimeline")
        }
      }).prototype = new H;

      function vt(e, t) {
        var i;
        if (e.length !== t.length) return !1;
        for (i = 0; i < e.length; i++)
          if (e[i] !== t[i]) return !1;
        return !0
      }

      function yt(e, t, i, n, r, a) {
        return {
          start: {
            dts: e,
            pts: e + (i - t)
          },
          end: {
            dts: e + (n - t),
            pts: e + (r - i)
          },
          prependedContentDuration: a,
          baseMediaDecodeTime: e
        }
      }
      var _t, bt, Tt, St, Et = ht,
        kt = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"],
        wt = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"],
        Ct = pt.H264Stream,
        It = ft,
        xt = ce;
      (bt = function (o, u) {
        var l = [],
          c = 0,
          d = 0,
          h = 0,
          p = 1 / 0;
        u = u || {}, bt.prototype.init.call(this), this.push = function (t) {
          Ee(o, t), o && kt.forEach(function (e) {
            o[e] = t[e]
          }), l.push(t)
        }, this.setEarliestDts = function (e) {
          d = e
        }, this.setVideoBaseMediaDecodeTime = function (e) {
          p = e
        }, this.setAudioAppendStart = function (e) {
          h = e
        }, this.flush = function () {
          var e, t, i, n, r, a, s;
          0 !== l.length && (e = ve(l, o, d), o.baseMediaDecodeTime = Se(o, u.keepOriginalTimestamps), s = ge(o, e, h, p), o.samples = ye(e), i = J(_e(e)), l = [], t = Z(c, [o]), n = new Uint8Array(t.byteLength + i.byteLength), c++, n.set(t), n.set(i, t.byteLength), Te(o), r = Math.ceil(1024 * xt / o.samplerate), e.length && (a = e.length * r, this.trigger("segmentTimingInfo", yt(pe(o.baseMediaDecodeTime, o.samplerate), e[0].dts, e[0].pts, e[0].dts + a, e[0].pts + a, s || 0)), this.trigger("timingInfo", {
            start: e[0].pts,
            end: e[0].pts + a
          })), this.trigger("data", {
            track: o,
            boxes: n
          })), this.trigger("done", "AudioSegmentStream")
        }, this.reset = function () {
          Te(o), l = [], this.trigger("reset")
        }
      }).prototype = new H, (_t = function (c, d) {
        var t, i, h = 0,
          p = [],
          f = [];
        d = d || {}, _t.prototype.init.call(this), delete c.minPTS, this.gopCache_ = [], this.push = function (e) {
          Ee(c, e), "seq_parameter_set_rbsp" !== e.nalUnitType || t || (t = e.config, c.sps = [e.data], wt.forEach(function (e) {
            c[e] = t[e]
          }, this)), "pic_parameter_set_rbsp" !== e.nalUnitType || i || (i = e.data, c.pps = [e.data]), p.push(e)
        }, this.flush = function () {
          for (var e, t, i, n, r, a, s, o, u = 0; p.length && "access_unit_delimiter_rbsp" !== p[0].nalUnitType;) p.shift();
          if (0 === p.length) return this.resetStream_(), void this.trigger("done", "VideoSegmentStream");
          if (e = te(p), (i = ie(e))[0][0].keyFrame || ((t = this.getGopForFusion_(p[0], c)) ? (u = t.duration, i.unshift(t), i.byteLength += t.byteLength, i.nalCount += t.nalCount, i.pts = t.pts, i.dts = t.dts, i.duration += t.duration) : i = ne(i)), f.length) {
            var l;
            if (!(l = d.alignGopsAtEnd ? this.alignGopsAtEnd_(i) : this.alignGopsAtStart_(i))) return this.gopCache_.unshift({
              gop: i.pop(),
              pps: c.pps,
              sps: c.sps
            }), this.gopCache_.length = Math.min(6, this.gopCache_.length), p = [], this.resetStream_(), void this.trigger("done", "VideoSegmentStream");
            Te(c), i = l
          }
          Ee(c, i), c.samples = re(i), r = J(ae(i)), c.baseMediaDecodeTime = Se(c, d.keepOriginalTimestamps), this.trigger("processedGopsInfo", i.map(function (e) {
            return {
              pts: e.pts,
              dts: e.dts,
              byteLength: e.byteLength
            }
          })), s = i[0], o = i[i.length - 1], this.trigger("segmentTimingInfo", yt(c.baseMediaDecodeTime, s.dts, s.pts, o.dts + o.duration, o.pts + o.duration, u)), this.trigger("timingInfo", {
            start: i[0].pts,
            end: i[i.length - 1].pts + i[i.length - 1].duration
          }), this.gopCache_.unshift({
            gop: i.pop(),
            pps: c.pps,
            sps: c.sps
          }), this.gopCache_.length = Math.min(6, this.gopCache_.length), p = [], this.trigger("baseMediaDecodeTime", c.baseMediaDecodeTime), this.trigger("timelineStartInfo", c.timelineStartInfo), n = Z(h, [c]), a = new Uint8Array(n.byteLength + r.byteLength), h++, a.set(n), a.set(r, n.byteLength), this.trigger("data", {
            track: c,
            boxes: a
          }), this.resetStream_(), this.trigger("done", "VideoSegmentStream")
        }, this.reset = function () {
          this.resetStream_(), p = [], this.gopCache_.length = 0, f.length = 0, this.trigger("reset")
        }, this.resetStream_ = function () {
          Te(c), i = t = void 0
        }, this.getGopForFusion_ = function (e) {
          var t, i, n, r, a, s = 1 / 0;
          for (a = 0; a < this.gopCache_.length; a++) n = (r = this.gopCache_[a]).gop, c.pps && vt(c.pps[0], r.pps[0]) && c.sps && vt(c.sps[0], r.sps[0]) && (n.dts < c.timelineStartInfo.dts || -1e4 <= (t = e.dts - n.dts - n.duration) && t <= 45e3 && (!i || t < s) && (i = r, s = t));
          return i ? i.gop : null
        }, this.alignGopsAtStart_ = function (e) {
          var t, i, n, r, a, s, o, u;
          for (a = e.byteLength, s = e.nalCount, o = e.duration, t = i = 0; t < f.length && i < e.length && (n = f[t], r = e[i], n.pts !== r.pts);) r.pts > n.pts ? t++ : (i++, a -= r.byteLength, s -= r.nalCount, o -= r.duration);
          return 0 === i ? e : i === e.length ? null : ((u = e.slice(i)).byteLength = a, u.duration = o, u.nalCount = s, u.pts = u[0].pts, u.dts = u[0].dts, u)
        }, this.alignGopsAtEnd_ = function (e) {
          var t, i, n, r, a, s, o;
          for (t = f.length - 1, i = e.length - 1, a = null, s = !1; 0 <= t && 0 <= i;) {
            if (n = f[t], r = e[i], n.pts === r.pts) {
              s = !0;
              break
            }
            n.pts > r.pts ? t-- : (t === f.length - 1 && (a = i), i--)
          }
          if (!s && null === a) return null;
          if (0 === (o = s ? i : a)) return e;
          var u = e.slice(o),
            l = u.reduce(function (e, t) {
              return e.byteLength += t.byteLength, e.duration += t.duration, e.nalCount += t.nalCount, e
            }, {
              byteLength: 0,
              duration: 0,
              nalCount: 0
            });
          return u.byteLength = l.byteLength, u.duration = l.duration, u.nalCount = l.nalCount, u.pts = u[0].pts, u.dts = u[0].dts, u
        }, this.alignGopsWith = function (e) {
          f = e
        }
      }).prototype = new H, (St = function (e, t) {
        this.numberOfTracks = 0, this.metadataStream = t, "undefined" != typeof (e = e || {}).remux ? this.remuxTracks = !!e.remux : this.remuxTracks = !0, "boolean" == typeof e.keepOriginalTimestamps ? this.keepOriginalTimestamps = e.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, St.prototype.init.call(this), this.push = function (e) {
          return e.text ? this.pendingCaptions.push(e) : e.frames ? this.pendingMetadata.push(e) : (this.pendingTracks.push(e.track), this.pendingBytes += e.boxes.byteLength, "video" === e.track.type && (this.videoTrack = e.track, this.pendingBoxes.push(e.boxes)), void("audio" === e.track.type && (this.audioTrack = e.track, this.pendingBoxes.unshift(e.boxes))))
        }
      }).prototype = new H, St.prototype.flush = function (e) {
        var t, i, n, r, a = 0,
          s = {
            captions: [],
            captionStreams: {},
            metadata: [],
            info: {}
          },
          o = 0;
        if (this.pendingTracks.length < this.numberOfTracks) {
          if ("VideoSegmentStream" !== e && "AudioSegmentStream" !== e) return;
          if (this.remuxTracks) return;
          if (0 === this.pendingTracks.length) return this.emittedTracks++, void(this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0))
        }
        if (this.videoTrack ? (o = this.videoTrack.timelineStartInfo.pts, wt.forEach(function (e) {
            s.info[e] = this.videoTrack[e]
          }, this)) : this.audioTrack && (o = this.audioTrack.timelineStartInfo.pts, kt.forEach(function (e) {
            s.info[e] = this.audioTrack[e]
          }, this)), this.videoTrack || this.audioTrack) {
          for (1 === this.pendingTracks.length ? s.type = this.pendingTracks[0].type : s.type = "combined", this.emittedTracks += this.pendingTracks.length, n = ee(this.pendingTracks), s.initSegment = new Uint8Array(n.byteLength), s.initSegment.set(n), s.data = new Uint8Array(this.pendingBytes), r = 0; r < this.pendingBoxes.length; r++) s.data.set(this.pendingBoxes[r], a), a += this.pendingBoxes[r].byteLength;
          for (r = 0; r < this.pendingCaptions.length; r++)(t = this.pendingCaptions[r]).startTime = me(t.startPts, o, this.keepOriginalTimestamps), t.endTime = me(t.endPts, o, this.keepOriginalTimestamps), s.captionStreams[t.stream] = !0, s.captions.push(t);
          for (r = 0; r < this.pendingMetadata.length; r++)(i = this.pendingMetadata[r]).cueTime = me(i.pts, o, this.keepOriginalTimestamps), s.metadata.push(i);
          for (s.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", s), r = 0; r < s.captions.length; r++) t = s.captions[r], this.trigger("caption", t);
          for (r = 0; r < s.metadata.length; r++) i = s.metadata[r], this.trigger("id3Frame", i)
        }
        this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0)
      }, St.prototype.setRemux = function (e) {
        this.remuxTracks = e
      }, (Tt = function (n) {
        var r, a, s = this,
          i = !0;
        Tt.prototype.init.call(this), n = n || {}, this.baseMediaDecodeTime = n.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function () {
          var t = {};
          (this.transmuxPipeline_ = t).type = "aac", t.metadataStream = new nt.MetadataStream, t.aacStream = new Et, t.audioTimestampRolloverStream = new nt.TimestampRolloverStream("audio"), t.timedMetadataTimestampRolloverStream = new nt.TimestampRolloverStream("timed-metadata"), t.adtsStream = new lt, t.coalesceStream = new St(n, t.metadataStream), t.headOfPipeline = t.aacStream, t.aacStream.pipe(t.audioTimestampRolloverStream).pipe(t.adtsStream), t.aacStream.pipe(t.timedMetadataTimestampRolloverStream).pipe(t.metadataStream).pipe(t.coalesceStream), t.metadataStream.on("timestamp", function (e) {
            t.aacStream.setTimestamp(e.timeStamp)
          }), t.aacStream.on("data", function (e) {
            "timed-metadata" !== e.type && "audio" !== e.type || t.audioSegmentStream || (a = a || {
              timelineStartInfo: {
                baseMediaDecodeTime: s.baseMediaDecodeTime
              },
              codec: "adts",
              type: "audio"
            }, t.coalesceStream.numberOfTracks++, t.audioSegmentStream = new bt(a, n), t.audioSegmentStream.on("timingInfo", s.trigger.bind(s, "audioTimingInfo")), t.adtsStream.pipe(t.audioSegmentStream).pipe(t.coalesceStream), s.trigger("trackinfo", {
              hasAudio: !!a,
              hasVideo: !!r
            }))
          }), t.coalesceStream.on("data", this.trigger.bind(this, "data")), t.coalesceStream.on("done", this.trigger.bind(this, "done"))
        }, this.setupTsPipeline = function () {
          var i = {};
          (this.transmuxPipeline_ = i).type = "ts", i.metadataStream = new nt.MetadataStream, i.packetStream = new nt.TransportPacketStream, i.parseStream = new nt.TransportParseStream, i.elementaryStream = new nt.ElementaryStream, i.timestampRolloverStream = new nt.TimestampRolloverStream, i.adtsStream = new lt, i.h264Stream = new Ct, i.captionStream = new nt.CaptionStream(n), i.coalesceStream = new St(n, i.metadataStream), i.headOfPipeline = i.packetStream, i.packetStream.pipe(i.parseStream).pipe(i.elementaryStream).pipe(i.timestampRolloverStream), i.timestampRolloverStream.pipe(i.h264Stream), i.timestampRolloverStream.pipe(i.adtsStream), i.timestampRolloverStream.pipe(i.metadataStream).pipe(i.coalesceStream), i.h264Stream.pipe(i.captionStream).pipe(i.coalesceStream), i.elementaryStream.on("data", function (e) {
            var t;
            if ("metadata" === e.type) {
              for (t = e.tracks.length; t--;) r || "video" !== e.tracks[t].type ? a || "audio" !== e.tracks[t].type || ((a = e.tracks[t]).timelineStartInfo.baseMediaDecodeTime = s.baseMediaDecodeTime) : (r = e.tracks[t]).timelineStartInfo.baseMediaDecodeTime = s.baseMediaDecodeTime;
              r && !i.videoSegmentStream && (i.coalesceStream.numberOfTracks++, i.videoSegmentStream = new _t(r, n), i.videoSegmentStream.on("timelineStartInfo", function (e) {
                a && !n.keepOriginalTimestamps && (a.timelineStartInfo = e, i.audioSegmentStream.setEarliestDts(e.dts - s.baseMediaDecodeTime))
              }), i.videoSegmentStream.on("processedGopsInfo", s.trigger.bind(s, "gopInfo")), i.videoSegmentStream.on("segmentTimingInfo", s.trigger.bind(s, "videoSegmentTimingInfo")), i.videoSegmentStream.on("baseMediaDecodeTime", function (e) {
                a && i.audioSegmentStream.setVideoBaseMediaDecodeTime(e)
              }), i.videoSegmentStream.on("timingInfo", s.trigger.bind(s, "videoTimingInfo")), i.h264Stream.pipe(i.videoSegmentStream).pipe(i.coalesceStream)), a && !i.audioSegmentStream && (i.coalesceStream.numberOfTracks++, i.audioSegmentStream = new bt(a, n), i.audioSegmentStream.on("timingInfo", s.trigger.bind(s, "audioTimingInfo")), i.audioSegmentStream.on("segmentTimingInfo", s.trigger.bind(s, "audioSegmentTimingInfo")), i.adtsStream.pipe(i.audioSegmentStream).pipe(i.coalesceStream)), s.trigger("trackinfo", {
                hasAudio: !!a,
                hasVideo: !!r
              })
            }
          }), i.coalesceStream.on("data", this.trigger.bind(this, "data")), i.coalesceStream.on("id3Frame", function (e) {
            e.dispatchType = i.metadataStream.dispatchType, s.trigger("id3Frame", e)
          }), i.coalesceStream.on("caption", this.trigger.bind(this, "caption")), i.coalesceStream.on("done", this.trigger.bind(this, "done"))
        }, this.setBaseMediaDecodeTime = function (e) {
          var t = this.transmuxPipeline_;
          n.keepOriginalTimestamps || (this.baseMediaDecodeTime = e), a && (a.timelineStartInfo.dts = void 0, a.timelineStartInfo.pts = void 0, Te(a), t.audioTimestampRolloverStream && t.audioTimestampRolloverStream.discontinuity()), r && (t.videoSegmentStream && (t.videoSegmentStream.gopCache_ = []), r.timelineStartInfo.dts = void 0, r.timelineStartInfo.pts = void 0, Te(r), t.captionStream.reset()), t.timestampRolloverStream && t.timestampRolloverStream.discontinuity()
        }, this.setAudioAppendStart = function (e) {
          a && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(e)
        }, this.setRemux = function (e) {
          var t = this.transmuxPipeline_;
          n.remux = e, t && t.coalesceStream && t.coalesceStream.setRemux(e)
        }, this.alignGopsWith = function (e) {
          r && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(e)
        }, this.push = function (e) {
          if (i) {
            var t = It(e);
            t && "aac" !== this.transmuxPipeline_.type ? this.setupAacPipeline() : t || "ts" === this.transmuxPipeline_.type || this.setupTsPipeline(), i = !1
          }
          this.transmuxPipeline_.headOfPipeline.push(e)
        }, this.flush = function () {
          i = !0, this.transmuxPipeline_.headOfPipeline.flush()
        }, this.endTimeline = function () {
          this.transmuxPipeline_.headOfPipeline.endTimeline()
        }, this.reset = function () {
          this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset()
        }, this.resetCaptions = function () {
          this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset()
        }
      }).prototype = new H;

      function At(a, s) {
        var o = [],
          u = 0,
          l = 0,
          c = 0,
          d = 1 / 0,
          h = null,
          p = null;
        s = s || {}, At.prototype.init.call(this), this.push = function (t) {
          Ee(a, t), a && kt.forEach(function (e) {
            a[e] = t[e]
          }), o.push(t)
        }, this.setEarliestDts = function (e) {
          l = e
        }, this.setVideoBaseMediaDecodeTime = function (e) {
          d = e
        }, this.setAudioAppendStart = function (e) {
          c = e
        }, this.processFrames_ = function () {
          var e, t, i, n, r;
          0 !== o.length && 0 !== (e = ve(o, a, l)).length && (a.baseMediaDecodeTime = Se(a, s.keepOriginalTimestamps), ge(a, e, c, d), a.samples = ye(e), i = J(_e(e)), o = [], t = Z(u, [a]), u++, a.initSegment = ee([a]), (n = new Uint8Array(t.byteLength + i.byteLength)).set(t), n.set(i, t.byteLength), Te(a), null === h && (p = h = e[0].pts), p += e.length * (1024 * Ot / a.samplerate), r = {
            start: h
          }, this.trigger("timingInfo", r), this.trigger("data", {
            track: a,
            boxes: n
          }))
        }, this.flush = function () {
          this.processFrames_(), this.trigger("timingInfo", {
            start: h,
            end: p
          }), this.resetTiming_(), this.trigger("done", "AudioSegmentStream")
        }, this.partialFlush = function () {
          this.processFrames_(), this.trigger("partialdone", "AudioSegmentStream")
        }, this.endTimeline = function () {
          this.flush(), this.trigger("endedtimeline", "AudioSegmentStream")
        }, this.resetTiming_ = function () {
          Te(a), p = h = null
        }, this.reset = function () {
          this.resetTiming_(), o = [], this.trigger("reset")
        }
      }
      var Pt = {
          Transmuxer: Tt,
          VideoSegmentStream: _t,
          AudioSegmentStream: bt,
          AUDIO_PROPERTIES: kt,
          VIDEO_PROPERTIES: wt,
          generateSegmentTimingInfo: yt
        },
        Lt = {
          Adts: lt,
          h264: pt
        },
        Ot = ce;
      At.prototype = new H;

      function Dt(o, u) {
        var t, i, l, c = 0,
          d = [],
          h = [],
          p = null,
          f = null,
          m = !0;
        u = u || {}, Dt.prototype.init.call(this), this.push = function (e) {
          Ee(o, e), "undefined" == typeof o.timelineStartInfo.dts && (o.timelineStartInfo.dts = e.dts), "seq_parameter_set_rbsp" !== e.nalUnitType || t || (t = e.config, o.sps = [e.data], wt.forEach(function (e) {
            o[e] = t[e]
          }, this)), "pic_parameter_set_rbsp" !== e.nalUnitType || i || (i = e.data, o.pps = [e.data]), d.push(e)
        }, this.processNals_ = function (e) {
          var t;
          for (d = h.concat(d); d.length && "access_unit_delimiter_rbsp" !== d[0].nalUnitType;) d.shift();
          if (0 !== d.length) {
            var i = te(d);
            if (i.length)
              if (h = i[i.length - 1], e && (i.pop(), i.duration -= h.duration, i.nalCount -= h.length, i.byteLength -= h.byteLength), i.length) {
                if (this.trigger("timelineStartInfo", o.timelineStartInfo), m) {
                  if (!(l = ie(i))[0][0].keyFrame) {
                    if (!(l = ne(l))[0][0].keyFrame) return d = [].concat.apply([], i).concat(h), void(h = []);
                    (i = [].concat.apply([], l)).duration = l.duration
                  }
                  m = !1
                }
                for (null === p && (p = i[0].pts, f = p), f += i.duration, this.trigger("timingInfo", {
                    start: p,
                    end: f
                  }), t = 0; t < i.length; t++) {
                  var n = i[t];
                  o.samples = se(n);
                  var r = J(oe(n));
                  Te(o), Ee(o, n), o.baseMediaDecodeTime = Se(o, u.keepOriginalTimestamps);
                  var a = Z(c, [o]);
                  c++, o.initSegment = ee([o]);
                  var s = new Uint8Array(a.byteLength + r.byteLength);
                  s.set(a), s.set(r, a.byteLength), this.trigger("data", {
                    track: o,
                    boxes: s,
                    sequence: c,
                    videoFrameDts: n.dts,
                    videoFramePts: n.pts
                  })
                }
                d = []
              } else d = []
          }
        }, this.resetTimingAndConfig_ = function () {
          i = t = void 0, f = p = null
        }, this.partialFlush = function () {
          this.processNals_(!0), this.trigger("partialdone", "VideoSegmentStream")
        }, this.flush = function () {
          this.processNals_(!1), this.resetTimingAndConfig_(), this.trigger("done", "VideoSegmentStream")
        }, this.endTimeline = function () {
          this.flush(), this.trigger("endedtimeline", "VideoSegmentStream")
        }, this.reset = function () {
          this.resetTimingAndConfig_(), h = [], d = [], m = !0, this.trigger("reset")
        }
      }
      var Rt = At;
      Dt.prototype = new H;

      function Mt(e) {
        return e.prototype = new H, e.prototype.init.call(e), e
      }

      function Nt(t, i) {
        t.on("data", i.trigger.bind(i, "data")), t.on("done", i.trigger.bind(i, "done")), t.on("partialdone", i.trigger.bind(i, "partialdone")), t.on("endedtimeline", i.trigger.bind(i, "endedtimeline")), t.on("audioTimingInfo", i.trigger.bind(i, "audioTimingInfo")), t.on("videoTimingInfo", i.trigger.bind(i, "videoTimingInfo")), t.on("trackinfo", i.trigger.bind(i, "trackinfo")), t.on("id3Frame", function (e) {
          e.dispatchType = t.metadataStream.dispatchType, e.cueTime = he(e.pts), i.trigger("id3Frame", e)
        }), t.on("caption", function (e) {
          i.trigger("caption", e)
        })
      }

      function Ut(i) {
        var n = null,
          r = !0;
        i = i || {}, Ut.prototype.init.call(this), i.baseMediaDecodeTime = i.baseMediaDecodeTime || 0, this.push = function (e) {
          if (r) {
            var t = Ft(e);
            !t || n && "aac" === n.type ? t || n && "ts" === n.type || (n = function (i) {
              var n = {
                type: "ts",
                tracks: {
                  audio: null,
                  video: null
                },
                packet: new nt.TransportPacketStream,
                parse: new nt.TransportParseStream,
                elementary: new nt.ElementaryStream,
                timestampRollover: new nt.TimestampRolloverStream,
                adts: new Lt.Adts,
                h264: new Lt.h264.H264Stream,
                captionStream: new nt.CaptionStream(i),
                metadataStream: new nt.MetadataStream
              };
              return n.headOfPipeline = n.packet, n.packet.pipe(n.parse).pipe(n.elementary).pipe(n.timestampRollover), n.timestampRollover.pipe(n.h264), n.h264.pipe(n.captionStream), n.timestampRollover.pipe(n.metadataStream), n.timestampRollover.pipe(n.adts), n.elementary.on("data", function (e) {
                if ("metadata" === e.type) {
                  for (var t = 0; t < e.tracks.length; t++) n.tracks[e.tracks[t].type] || (n.tracks[e.tracks[t].type] = e.tracks[t], n.tracks[e.tracks[t].type].timelineStartInfo.baseMediaDecodeTime = i.baseMediaDecodeTime);
                  n.tracks.video && !n.videoSegmentStream && (n.videoSegmentStream = new Bt(n.tracks.video, i), n.videoSegmentStream.on("timelineStartInfo", function (e) {
                    n.tracks.audio && !i.keepOriginalTimestamps && n.audioSegmentStream.setEarliestDts(e.dts - i.baseMediaDecodeTime)
                  }), n.videoSegmentStream.on("timingInfo", n.trigger.bind(n, "videoTimingInfo")), n.videoSegmentStream.on("data", function (e) {
                    n.trigger("data", {
                      type: "video",
                      data: e
                    })
                  }), n.videoSegmentStream.on("done", n.trigger.bind(n, "done")), n.videoSegmentStream.on("partialdone", n.trigger.bind(n, "partialdone")), n.videoSegmentStream.on("endedtimeline", n.trigger.bind(n, "endedtimeline")), n.h264.pipe(n.videoSegmentStream)), n.tracks.audio && !n.audioSegmentStream && (n.audioSegmentStream = new Rt(n.tracks.audio, i), n.audioSegmentStream.on("data", function (e) {
                    n.trigger("data", {
                      type: "audio",
                      data: e
                    })
                  }), n.audioSegmentStream.on("done", n.trigger.bind(n, "done")), n.audioSegmentStream.on("partialdone", n.trigger.bind(n, "partialdone")), n.audioSegmentStream.on("endedtimeline", n.trigger.bind(n, "endedtimeline")), n.audioSegmentStream.on("timingInfo", n.trigger.bind(n, "audioTimingInfo")), n.adts.pipe(n.audioSegmentStream)), n.trigger("trackinfo", {
                    hasAudio: !!n.tracks.audio,
                    hasVideo: !!n.tracks.video
                  })
                }
              }), n.captionStream.on("data", function (e) {
                var t;
                t = n.tracks.video && n.tracks.video.timelineStartInfo.pts || 0, e.startTime = me(e.startPts, t, i.keepOriginalTimestamps), e.endTime = me(e.endPts, t, i.keepOriginalTimestamps), n.trigger("caption", e)
              }), (n = Mt(n)).metadataStream.on("data", n.trigger.bind(n, "id3Frame")), n
            }(i), Nt(n, this)) : (n = function (t) {
              var i = {
                type: "aac",
                tracks: {
                  audio: null
                },
                metadataStream: new nt.MetadataStream,
                aacStream: new Et,
                audioRollover: new nt.TimestampRolloverStream("audio"),
                timedMetadataRollover: new nt.TimestampRolloverStream("timed-metadata"),
                adtsStream: new lt(!0)
              };
              return i.headOfPipeline = i.aacStream, i.aacStream.pipe(i.audioRollover).pipe(i.adtsStream), i.aacStream.pipe(i.timedMetadataRollover).pipe(i.metadataStream), i.metadataStream.on("timestamp", function (e) {
                i.aacStream.setTimestamp(e.timeStamp)
              }), i.aacStream.on("data", function (e) {
                "timed-metadata" !== e.type && "audio" !== e.type || i.audioSegmentStream || (i.tracks.audio = i.tracks.audio || {
                  timelineStartInfo: {
                    baseMediaDecodeTime: t.baseMediaDecodeTime
                  },
                  codec: "adts",
                  type: "audio"
                }, i.audioSegmentStream = new Rt(i.tracks.audio, t), i.audioSegmentStream.on("data", function (e) {
                  i.trigger("data", {
                    type: "audio",
                    data: e
                  })
                }), i.audioSegmentStream.on("partialdone", i.trigger.bind(i, "partialdone")), i.audioSegmentStream.on("done", i.trigger.bind(i, "done")), i.audioSegmentStream.on("endedtimeline", i.trigger.bind(i, "endedtimeline")), i.audioSegmentStream.on("timingInfo", i.trigger.bind(i, "audioTimingInfo")), i.adtsStream.pipe(i.audioSegmentStream), i.trigger("trackinfo", {
                  hasAudio: !!i.tracks.audio,
                  hasVideo: !!i.tracks.video
                }))
              }), (i = Mt(i)).metadataStream.on("data", i.trigger.bind(i, "id3Frame")), i
            }(i), Nt(n, this)), r = !1
          }
          n.headOfPipeline.push(e)
        }, this.flush = function () {
          n && (r = !0, n.headOfPipeline.flush())
        }, this.partialFlush = function () {
          n && n.headOfPipeline.partialFlush()
        }, this.endTimeline = function () {
          n && n.headOfPipeline.endTimeline()
        }, this.reset = function () {
          n && n.headOfPipeline.reset()
        }, this.setBaseMediaDecodeTime = function (e) {
          i.keepOriginalTimestamps || (i.baseMediaDecodeTime = e), n && (n.tracks.audio && (n.tracks.audio.timelineStartInfo.dts = void 0, n.tracks.audio.timelineStartInfo.pts = void 0, Te(n.tracks.audio), n.audioRollover && n.audioRollover.discontinuity()), n.tracks.video && (n.videoSegmentStream && (n.videoSegmentStream.gopCache_ = []), n.tracks.video.timelineStartInfo.dts = void 0, n.tracks.video.timelineStartInfo.pts = void 0, Te(n.tracks.video)), n.timestampRollover && n.timestampRollover.discontinuity())
        }, this.setRemux = function (e) {
          i.remux = e, n && n.coalesceStream && n.coalesceStream.setRemux(e)
        }, this.setAudioAppendStart = function (e) {
          n && n.tracks.audio && n.audioSegmentStream && n.audioSegmentStream.setAudioAppendStart(e)
        }, this.alignGopsWith = function (e) {}
      }
      var Bt = Dt,
        Ft = ft;
      Ut.prototype = new H;

      function jt(e, t) {
        for (var i = e, n = 0; n < t.length; n++) {
          var r = t[n];
          if (i < r.size) return r;
          i -= r.size
        }
        return null
      }

      function Ht(e, c) {
        var n = Xt(e, ["moof", "traf"]),
          t = Xt(e, ["mdat"]),
          d = {},
          r = [];
        return t.forEach(function (e, t) {
          var i = n[t];
          r.push({
            mdat: e,
            traf: i
          })
        }), r.forEach(function (e) {
          var t, i = e.mdat,
            n = e.traf,
            r = Xt(n, ["tfhd"]),
            a = Jt(r[0]),
            s = a.trackId,
            o = Xt(n, ["tfdt"]),
            u = 0 < o.length ? Yt(o[0]).baseMediaDecodeTime : 0,
            l = Xt(n, ["trun"]);
          c === s && 0 < l.length && (t = function (e, t, i) {
            var n, r, a, s, o = new DataView(e.buffer, e.byteOffset, e.byteLength),
              u = [];
            for (r = 0; r + 4 < e.length; r += a)
              if (a = o.getUint32(r), r += 4, !(a <= 0)) switch (31 & e[r]) {
                case 6:
                  var l = e.subarray(r + 1, r + 1 + a),
                    c = jt(r, t);
                  if (n = {
                      nalUnitType: "sei_rbsp",
                      size: a,
                      data: l,
                      escapedRBSP: Zt(l),
                      trackId: i
                    }, c) n.pts = c.pts, n.dts = c.dts, s = c;
                  else {
                    if (!s) break;
                    n.pts = s.pts, n.dts = s.dts
                  }
                  u.push(n)
              }
            return u
          }(i, function (e, t, i) {
            var n = t,
              r = i.defaultSampleDuration || 0,
              a = i.defaultSampleSize || 0,
              s = i.trackId,
              o = [];
            return e.forEach(function (e) {
              var t = $t(e).samples;
              t.forEach(function (e) {
                void 0 === e.duration && (e.duration = r), void 0 === e.size && (e.size = a), e.trackId = s, e.dts = n, void 0 === e.compositionTimeOffset && (e.compositionTimeOffset = 0), e.pts = n + e.compositionTimeOffset, n += e.duration
              }), o = o.concat(t)
            }), o
          }(l, u, a), s), d[s] || (d[s] = []), d[s] = d[s].concat(t))
        }), d
      }

      function Vt(e) {
        return "AudioSegmentStream" === e ? "audio" : "VideoSegmentStream" === e ? "video" : ""
      }
      var qt = Ut,
        Wt = function (e) {
          return e >>> 0
        },
        zt = function (e) {
          var t = "";
          return t += String.fromCharCode(e[0]), t += String.fromCharCode(e[1]), t += String.fromCharCode(e[2]), t += String.fromCharCode(e[3])
        },
        Gt = Wt,
        Xt = function e(t, i) {
          var n, r, a, s, o, u = [];
          if (!i.length) return null;
          for (n = 0; n < t.byteLength;) r = Gt(t[n] << 24 | t[n + 1] << 16 | t[n + 2] << 8 | t[n + 3]), a = zt(t.subarray(n + 4, n + 8)), s = 1 < r ? n + r : t.byteLength, a === i[0] && (1 === i.length ? u.push(t.subarray(n + 8, s)) : (o = e(t.subarray(n + 8, s), i.slice(1))).length && (u = u.concat(o))), n = s;
          return u
        },
        Kt = Wt,
        Yt = function (e) {
          var t = {
            version: e[0],
            flags: new Uint8Array(e.subarray(1, 4)),
            baseMediaDecodeTime: Kt(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7])
          };
          return 1 === t.version && (t.baseMediaDecodeTime *= Math.pow(2, 32), t.baseMediaDecodeTime += Kt(e[8] << 24 | e[9] << 16 | e[10] << 8 | e[11])), t
        },
        Qt = function (e) {
          return {
            isLeading: (12 & e[0]) >>> 2,
            dependsOn: 3 & e[0],
            isDependedOn: (192 & e[1]) >>> 6,
            hasRedundancy: (48 & e[1]) >>> 4,
            paddingValue: (14 & e[1]) >>> 1,
            isNonSyncSample: 1 & e[1],
            degradationPriority: e[2] << 8 | e[3]
          }
        },
        $t = function (e) {
          var t, i = {
              version: e[0],
              flags: new Uint8Array(e.subarray(1, 4)),
              samples: []
            },
            n = new DataView(e.buffer, e.byteOffset, e.byteLength),
            r = 1 & i.flags[2],
            a = 4 & i.flags[2],
            s = 1 & i.flags[1],
            o = 2 & i.flags[1],
            u = 4 & i.flags[1],
            l = 8 & i.flags[1],
            c = n.getUint32(4),
            d = 8;
          for (r && (i.dataOffset = n.getInt32(d), d += 4), a && c && (t = {
              flags: Qt(e.subarray(d, d + 4))
            }, d += 4, s && (t.duration = n.getUint32(d), d += 4), o && (t.size = n.getUint32(d), d += 4), l && (1 === i.version ? t.compositionTimeOffset = n.getInt32(d) : t.compositionTimeOffset = n.getUint32(d), d += 4), i.samples.push(t), c--); c--;) t = {}, s && (t.duration = n.getUint32(d), d += 4), o && (t.size = n.getUint32(d), d += 4), u && (t.flags = Qt(e.subarray(d, d + 4)), d += 4), l && (1 === i.version ? t.compositionTimeOffset = n.getInt32(d) : t.compositionTimeOffset = n.getUint32(d), d += 4), i.samples.push(t);
          return i
        },
        Jt = function (e) {
          var t, i = new DataView(e.buffer, e.byteOffset, e.byteLength),
            n = {
              version: e[0],
              flags: new Uint8Array(e.subarray(1, 4)),
              trackId: i.getUint32(4)
            },
            r = 1 & n.flags[2],
            a = 2 & n.flags[2],
            s = 8 & n.flags[2],
            o = 16 & n.flags[2],
            u = 32 & n.flags[2],
            l = 65536 & n.flags[0],
            c = 131072 & n.flags[0];
          return t = 8, r && (t += 4, n.baseDataOffset = i.getUint32(12), t += 4), a && (n.sampleDescriptionIndex = i.getUint32(t), t += 4), s && (n.defaultSampleDuration = i.getUint32(t), t += 4), o && (n.defaultSampleSize = i.getUint32(t), t += 4), u && (n.defaultSampleFlags = i.getUint32(t)), l && (n.durationIsEmpty = !0), !r && c && (n.baseDataOffsetIsMoof = !0), n
        },
        Zt = Ie,
        ei = He.CaptionStream,
        ti = function () {
          var t, a, s, o, u, i, n = !1;
          this.isInitialized = function () {
            return n
          }, this.init = function (e) {
            t = new ei, n = !0, i = !!e && e.isPartial, t.on("data", function (e) {
              e.startTime = e.startPts / o, e.endTime = e.endPts / o, u.captions.push(e), u.captionStreams[e.stream] = !0
            })
          }, this.isNewInit = function (e, t) {
            return !(e && 0 === e.length || t && "object" == typeof t && 0 === Object.keys(t).length) && (s !== e[0] || o !== t[s])
          }, this.parse = function (e, t, i) {
            var n;
            if (!this.isInitialized()) return null;
            if (!t || !i) return null;
            if (this.isNewInit(t, i)) s = t[0], o = i[s];
            else if (null === s || !o) return a.push(e), null;
            for (; 0 < a.length;) {
              var r = a.shift();
              this.parse(r, t, i)
            }
            return null !== (n = function (e, t, i) {
              return null === t ? null : {
                seiNals: Ht(e, t)[t],
                timescale: i
              }
            }(e, s, o)) && n.seiNals ? (this.pushNals(n.seiNals), this.flushStream(), u) : null
          }, this.pushNals = function (e) {
            if (!this.isInitialized() || !e || 0 === e.length) return null;
            e.forEach(function (e) {
              t.push(e)
            })
          }, this.flushStream = function () {
            if (!this.isInitialized()) return null;
            i ? t.partialFlush() : t.flush()
          }, this.clearParsedCaptions = function () {
            u.captions = [], u.captionStreams = {}
          }, this.resetCaptionStream = function () {
            if (!this.isInitialized()) return null;
            t.reset()
          }, this.clearAllCaptions = function () {
            this.clearParsedCaptions(), this.resetCaptionStream()
          }, this.reset = function () {
            a = [], o = s = null, u ? this.clearParsedCaptions() : u = {
              captions: [],
              captionStreams: {}
            }, this.resetCaptionStream()
          }, this.reset()
        },
        ii = function () {
          function e(e, t) {
            this.options = t || {}, this.self = e, this.init()
          }
          var t = e.prototype;
          return t.init = function () {
            this.transmuxer && this.transmuxer.dispose(), this.transmuxer = this.options.handlePartialData ? new qt(this.options) : new Pt.Transmuxer(this.options), this.options.handlePartialData ? function (n, e) {
              e.on("data", function (e) {
                var t = {
                    data: e.data.track.initSegment.buffer,
                    byteOffset: e.data.track.initSegment.byteOffset,
                    byteLength: e.data.track.initSegment.byteLength
                  },
                  i = {
                    boxes: {
                      data: e.data.boxes.buffer,
                      byteOffset: e.data.boxes.byteOffset,
                      byteLength: e.data.boxes.byteLength
                    },
                    initSegment: t,
                    type: e.type,
                    sequence: e.data.sequence
                  };
                "undefined" != typeof e.data.videoFrameDts && (i.videoFrameDtsTime = he(e.data.videoFrameDts)), "undefined" != typeof e.data.videoFramePts && (i.videoFramePtsTime = he(e.data.videoFramePts)), n.postMessage({
                  action: "data",
                  segment: i
                }, [i.boxes.data, i.initSegment.data])
              }), e.on("id3Frame", function (e) {
                n.postMessage({
                  action: "id3Frame",
                  id3Frame: e
                })
              }), e.on("caption", function (e) {
                n.postMessage({
                  action: "caption",
                  caption: e
                })
              }), e.on("done", function (e) {
                n.postMessage({
                  action: "done",
                  type: Vt(e)
                })
              }), e.on("partialdone", function (e) {
                n.postMessage({
                  action: "partialdone",
                  type: Vt(e)
                })
              }), e.on("endedsegment", function (e) {
                n.postMessage({
                  action: "endedSegment",
                  type: Vt(e)
                })
              }), e.on("trackinfo", function (e) {
                n.postMessage({
                  action: "trackinfo",
                  trackInfo: e
                })
              }), e.on("audioTimingInfo", function (e) {
                if (null !== e.start) {
                  var t = {
                    start: he(e.start)
                  };
                  e.end && (t.end = he(e.end)), n.postMessage({
                    action: "audioTimingInfo",
                    audioTimingInfo: t
                  })
                } else n.postMessage({
                  action: "audioTimingInfo",
                  audioTimingInfo: e
                })
              }), e.on("videoTimingInfo", function (e) {
                var t = {
                  start: he(e.start)
                };
                e.end && (t.end = he(e.end)), n.postMessage({
                  action: "videoTimingInfo",
                  videoTimingInfo: t
                })
              })
            }(this.self, this.transmuxer) : function (n, e) {
              e.on("data", function (e) {
                var t = e.initSegment;
                e.initSegment = {
                  data: t.buffer,
                  byteOffset: t.byteOffset,
                  byteLength: t.byteLength
                };
                var i = e.data;
                e.data = i.buffer, n.postMessage({
                  action: "data",
                  segment: e,
                  byteOffset: i.byteOffset,
                  byteLength: i.byteLength
                }, [e.data])
              }), e.on("done", function (e) {
                n.postMessage({
                  action: "done"
                })
              }), e.on("gopInfo", function (e) {
                n.postMessage({
                  action: "gopInfo",
                  gopInfo: e
                })
              }), e.on("videoSegmentTimingInfo", function (e) {
                var t = {
                  start: {
                    decode: he(e.start.dts),
                    presentation: he(e.start.pts)
                  },
                  end: {
                    decode: he(e.end.dts),
                    presentation: he(e.end.pts)
                  },
                  baseMediaDecodeTime: he(e.baseMediaDecodeTime)
                };
                e.prependedContentDuration && (t.prependedContentDuration = he(e.prependedContentDuration)), n.postMessage({
                  action: "videoSegmentTimingInfo",
                  videoSegmentTimingInfo: t
                })
              }), e.on("audioSegmentTimingInfo", function (e) {
                var t = {
                  start: {
                    decode: he(e.start.dts),
                    presentation: he(e.start.pts)
                  },
                  end: {
                    decode: he(e.end.dts),
                    presentation: he(e.end.pts)
                  },
                  baseMediaDecodeTime: he(e.baseMediaDecodeTime)
                };
                e.prependedContentDuration && (t.prependedContentDuration = he(e.prependedContentDuration)), n.postMessage({
                  action: "audioSegmentTimingInfo",
                  audioSegmentTimingInfo: t
                })
              }), e.on("id3Frame", function (e) {
                n.postMessage({
                  action: "id3Frame",
                  id3Frame: e
                })
              }), e.on("caption", function (e) {
                n.postMessage({
                  action: "caption",
                  caption: e
                })
              }), e.on("trackinfo", function (e) {
                n.postMessage({
                  action: "trackinfo",
                  trackInfo: e
                })
              }), e.on("audioTimingInfo", function (e) {
                n.postMessage({
                  action: "audioTimingInfo",
                  audioTimingInfo: {
                    start: he(e.start),
                    end: he(e.end)
                  }
                })
              }), e.on("videoTimingInfo", function (e) {
                n.postMessage({
                  action: "videoTimingInfo",
                  videoTimingInfo: {
                    start: he(e.start),
                    end: he(e.end)
                  }
                })
              })
            }(this.self, this.transmuxer)
          }, t.pushMp4Captions = function (e) {
            this.captionParser || (this.captionParser = new ti, this.captionParser.init());
            var t = new Uint8Array(e.data, e.byteOffset, e.byteLength),
              i = this.captionParser.parse(t, e.trackIds, e.timescales);
            this.self.postMessage({
              action: "mp4Captions",
              captions: i && i.captions || [],
              data: t.buffer
            }, [t.buffer])
          }, t.clearAllMp4Captions = function () {
            this.captionParser && this.captionParser.clearAllCaptions()
          }, t.clearParsedMp4Captions = function () {
            this.captionParser && this.captionParser.clearParsedCaptions()
          }, t.push = function (e) {
            var t = new Uint8Array(e.data, e.byteOffset, e.byteLength);
            this.transmuxer.push(t)
          }, t.reset = function () {
            this.transmuxer.reset()
          }, t.setTimestampOffset = function (e) {
            var t = e.timestampOffset || 0;
            this.transmuxer.setBaseMediaDecodeTime(Math.round(de(t)))
          }, t.setAudioAppendStart = function (e) {
            this.transmuxer.setAudioAppendStart(Math.ceil(de(e.appendStart)))
          }, t.setRemux = function (e) {
            this.transmuxer.setRemux(e.remux)
          }, t.flush = function (e) {
            this.transmuxer.flush(), self.postMessage({
              action: "done",
              type: "transmuxed"
            })
          }, t.partialFlush = function (e) {
            this.transmuxer.partialFlush(), self.postMessage({
              action: "partialdone",
              type: "transmuxed"
            })
          }, t.endTimeline = function () {
            this.transmuxer.endTimeline(), self.postMessage({
              action: "endedtimeline",
              type: "transmuxed"
            })
          }, t.alignGopsWith = function (e) {
            this.transmuxer.alignGopsWith(e.gopsToAlignWith.slice())
          }, e
        }();
      self.onmessage = function (e) {
        "init" === e.data.action && e.data.options ? this.messageHandlers = new ii(self, e.data.options) : (this.messageHandlers || (this.messageHandlers = new ii(self)), e.data && e.data.action && "init" !== e.data.action && this.messageHandlers[e.data.action] && this.messageHandlers[e.data.action](e.data))
      }
    }))),
    Ad = function (e) {
      e.currentTransmux = null, e.transmuxQueue.length && (e.currentTransmux = e.transmuxQueue.shift(), "function" == typeof e.currentTransmux ? e.currentTransmux() : Uc(e.currentTransmux))
    },
    Pd = function (e) {
      Fc("reset", e)
    },
    Ld = function (e) {
      var t = new xd;
      t.currentTransmux = null, t.transmuxQueue = [];
      var i = t.terminate;
      return t.terminate = function () {
        return t.currentTransmux = null, t.transmuxQueue.length = 0, i.call(t)
      }, t.postMessage({
        action: "init",
        options: e
      }), t
    },
    Od = 2,
    Dd = -101,
    Rd = -102,
    Md = Hl("CodecUtils"),
    Nd = Hl("PlaylistSelector"),
    Ud = function (n) {
      function e(e, t) {
        var i;
        if (i = n.call(this) || this, !e) throw new TypeError("Initialization settings are required");
        if ("function" != typeof e.currentTime) throw new TypeError("No currentTime getter specified");
        if (!e.mediaSource) throw new TypeError("No MediaSource specified");
        return i.bandwidth = e.bandwidth, i.throughput = {
          rate: 0,
          count: 0
        }, i.roundTrip = NaN, i.resetStats_(), i.mediaIndex = null, i.partIndex = null, i.hasPlayed_ = e.hasPlayed, i.currentTime_ = e.currentTime, i.seekable_ = e.seekable, i.seeking_ = e.seeking, i.duration_ = e.duration, i.mediaSource_ = e.mediaSource, i.vhs_ = e.vhs, i.loaderType_ = e.loaderType, i.currentMediaInfo_ = void 0, i.startingMediaInfo_ = void 0, i.segmentMetadataTrack_ = e.segmentMetadataTrack, i.goalBufferLength_ = e.goalBufferLength, i.sourceType_ = e.sourceType, i.sourceUpdater_ = e.sourceUpdater, i.inbandTextTracks_ = e.inbandTextTracks, i.state_ = "INIT", i.handlePartialData_ = e.handlePartialData, i.timelineChangeController_ = e.timelineChangeController, i.shouldSaveSegmentTimingInfo_ = !0, i.parse708captions_ = e.parse708captions, i.checkBufferTimeout_ = null, i.error_ = void 0, i.currentTimeline_ = -1, i.pendingSegment_ = null, i.xhrOptions_ = null, i.pendingSegments_ = [], i.audioDisabled_ = !1, i.isPendingTimestampOffset_ = !1, i.gopBuffer_ = [], i.timeMapping_ = 0, i.safeAppend_ = 11 <= ya.browser.IE_VERSION, i.appendInitSegment_ = {
          audio: !0,
          video: !0
        }, i.playlistOfLastInitSegment_ = {
          audio: null,
          video: null
        }, i.callQueue_ = [], i.loadQueue_ = [], i.metadataQueue_ = {
          id3: [],
          caption: []
        }, i.waitingOnRemove_ = !1, i.quotaExceededErrorRetryTimeout_ = null, i.activeInitSegmentId_ = null, i.initSegments_ = {}, i.cacheEncryptionKeys_ = e.cacheEncryptionKeys, i.keyCache_ = {}, i.decrypter_ = e.decrypter, i.syncController_ = e.syncController, i.syncPoint_ = {
          segmentIndex: 0,
          time: 0
        }, i.transmuxer_ = i.createTransmuxer_(), i.triggerSyncInfoUpdate_ = function () {
          return i.trigger("syncinfoupdate")
        }, i.syncController_.on("syncinfoupdate", i.triggerSyncInfoUpdate_), i.mediaSource_.addEventListener("sourceopen", function () {
          i.isEndOfStream_() || (i.ended_ = !1)
        }), i.fetchAtBuffer_ = !1, i.logger_ = Hl("SegmentLoader[" + i.loaderType_ + "]"), Object.defineProperty(Ta(i), "state", {
          get: function () {
            return this.state_
          },
          set: function (e) {
            e !== this.state_ && (this.logger_(this.state_ + " -> " + e), this.state_ = e, this.trigger("statechange"))
          }
        }), i.sourceUpdater_.on("ready", function () {
          i.hasEnoughInfoToAppend_() && i.processCallQueue_()
        }), "main" === i.loaderType_ && i.timelineChangeController_.on("pendingtimelinechange", function () {
          i.hasEnoughInfoToAppend_() && i.processCallQueue_()
        }), "audio" === i.loaderType_ && i.timelineChangeController_.on("timelinechange", function () {
          i.hasEnoughInfoToLoad_() && i.processLoadQueue_(), i.hasEnoughInfoToAppend_() && i.processCallQueue_()
        }), i
      }
      ka(e, n);
      var t = e.prototype;
      return t.createTransmuxer_ = function () {
        return Ld({
          remux: !1,
          alignGopsAtEnd: this.safeAppend_,
          keepOriginalTimestamps: !0,
          handlePartialData: this.handlePartialData_,
          parse708captions: this.parse708captions_
        })
      }, t.resetStats_ = function () {
        this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0
      }, t.dispose = function () {
        this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && Ia.clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off()
      }, t.setAudio = function (e) {
        this.audioDisabled_ = !e, e ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_())
      }, t.abort = function () {
        "WAITING" === this.state ? (this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_()) : this.pendingSegment_ && (this.pendingSegment_ = null)
      }, t.abort_ = function () {
        this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, Ia.clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null
      }, t.checkForAbort_ = function (e) {
        return "APPENDING" !== this.state || this.pendingSegment_ ? !this.pendingSegment_ || this.pendingSegment_.requestId !== e : (this.state = "READY", !0)
      }, t.error = function (e) {
        return "undefined" != typeof e && (this.logger_("error occurred:", e), this.error_ = e), this.pendingSegment_ = null, this.error_
      }, t.endOfStream = function () {
        this.ended_ = !0, this.transmuxer_ && Pd(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended")
      }, t.buffered_ = function () {
        if (!this.sourceUpdater_ || !this.startingMediaInfo_) return ya.createTimeRanges();
        if ("main" === this.loaderType_) {
          var e = this.startingMediaInfo_,
            t = e.hasAudio,
            i = e.hasVideo,
            n = e.isMuxed;
          if (i && t && !this.audioDisabled_ && !n) return this.sourceUpdater_.buffered();
          if (i) return this.sourceUpdater_.videoBuffered()
        }
        return this.sourceUpdater_.audioBuffered()
      }, t.initSegmentForMap = function (e, t) {
        if (void 0 === t && (t = !1), !e) return null;
        var i = Ec(e),
          n = this.initSegments_[i];
        return t && !n && e.bytes && (this.initSegments_[i] = n = {
          resolvedUri: e.resolvedUri,
          byterange: e.byterange,
          bytes: e.bytes,
          tracks: e.tracks,
          timescales: e.timescales
        }), n || e
      }, t.segmentKey = function (e, t) {
        if (void 0 === t && (t = !1), !e) return null;
        var i = kc(e),
          n = this.keyCache_[i];
        this.cacheEncryptionKeys_ && t && !n && e.bytes && (this.keyCache_[i] = n = {
          resolvedUri: e.resolvedUri,
          bytes: e.bytes
        });
        var r = {
          resolvedUri: (n || e).resolvedUri
        };
        return n && (r.bytes = n.bytes), r
      }, t.couldBeginLoading_ = function () {
        return this.playlist_ && !this.paused()
      }, t.load = function () {
        if (this.monitorBuffer_(), this.playlist_) return "INIT" === this.state && this.couldBeginLoading_() ? this.init_() : void(!this.couldBeginLoading_() || "READY" !== this.state && "INIT" !== this.state || (this.state = "READY"))
      }, t.init_ = function () {
        return this.state = "READY", this.resetEverything(), this.monitorBuffer_()
      }, t.playlist = function (e, t) {
        if (void 0 === t && (t = {}), e) {
          var i = this.playlist_,
            n = this.pendingSegment_;
          this.playlist_ = e, this.xhrOptions_ = t, "INIT" === this.state && (e.syncInfo = {
            mediaSequence: e.mediaSequence,
            time: 0
          }, "main" === this.loaderType_ && this.syncController_.setDateTimeMappingForStart(e));
          var r = null;
          if (i && (i.id ? r = i.id : i.uri && (r = i.uri)), this.logger_("playlist update [" + r + " => " + (e.id || e.uri) + "]"), this.trigger("syncinfoupdate"), "INIT" === this.state && this.couldBeginLoading_()) return this.init_();
          if (!i || i.uri !== e.uri) return null === this.mediaIndex && !this.handlePartialData_ || this.resyncLoader(), this.currentMediaInfo_ = void 0, void this.trigger("playlistupdate");
          var a = e.mediaSequence - i.mediaSequence;
          if (this.logger_("live window shift [" + a + "]"), null !== this.mediaIndex)
            if (this.mediaIndex -= a, this.mediaIndex < 0) this.mediaIndex = null, this.partIndex = null;
            else {
              var s = this.playlist_.segments[this.mediaIndex];
              if (this.partIndex && (!s.parts || !s.parts.length || !s.parts[this.partIndex])) {
                var o = this.mediaIndex;
                this.logger_("currently processing part (index " + this.partIndex + ") no longer exists."), this.resetLoader(), this.mediaIndex = o
              }
            } n && (n.mediaIndex -= a, n.mediaIndex < 0 ? (n.mediaIndex = null, n.partIndex = null) : (0 <= n.mediaIndex && (n.segment = e.segments[n.mediaIndex]), 0 <= n.partIndex && n.segment.parts && (n.part = n.segment.parts[n.partIndex]))), this.syncController_.saveExpiredSegmentInfo(i, e)
        }
      }, t.pause = function () {
        this.checkBufferTimeout_ && (Ia.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = null)
      }, t.paused = function () {
        return null === this.checkBufferTimeout_
      }, t.resetEverything = function (e) {
        this.ended_ = !1, this.appendInitSegment_ = {
          audio: !0,
          video: !0
        }, this.resetLoader(), this.remove(0, 1 / 0, e), this.transmuxer_ && this.transmuxer_.postMessage({
          action: "clearAllMp4Captions"
        })
      }, t.resetLoader = function () {
        this.fetchAtBuffer_ = !1, this.resyncLoader()
      }, t.resyncLoader = function () {
        this.transmuxer_ && Pd(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({
          action: "clearParsedMp4Captions"
        })
      }, t.remove = function (e, t, i, n) {
        if (void 0 === i && (i = function () {}), void 0 === n && (n = !1), t === 1 / 0 && (t = this.duration_()), this.sourceUpdater_ && this.startingMediaInfo_) {
          var r = 1,
            a = function () {
              0 === --r && i()
            };
          for (var s in !n && this.audioDisabled_ || (r++, this.sourceUpdater_.removeAudio(e, t, a)), !n && "main" !== this.loaderType_ || (this.gopBuffer_ = function (e, t, i, n) {
              for (var r = Math.ceil((t - n) * vl), a = Math.ceil((i - n) * vl), s = e.slice(), o = e.length; o-- && !(e[o].pts <= a););
              if (-1 === o) return s;
              for (var u = o + 1; u-- && !(e[u].pts <= r););
              return u = Math.max(u, 0), s.splice(u, o - u + 1), s
            }(this.gopBuffer_, e, t, this.timeMapping_), r++, this.sourceUpdater_.removeVideo(e, t, a)), this.inbandTextTracks_) ad(e, t, this.inbandTextTracks_[s]);
          ad(e, t, this.segmentMetadataTrack_), a()
        } else this.logger_("skipping remove because no source updater or starting media info")
      }, t.monitorBuffer_ = function () {
        this.checkBufferTimeout_ && Ia.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = Ia.setTimeout(this.monitorBufferTick_.bind(this), 1)
      }, t.monitorBufferTick_ = function () {
        "READY" === this.state && this.fillBuffer_(), this.checkBufferTimeout_ && Ia.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = Ia.setTimeout(this.monitorBufferTick_.bind(this), 500)
      }, t.fillBuffer_ = function () {
        if (!this.sourceUpdater_.updating()) {
          this.syncPoint_ || (this.syncPoint_ = this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_()));
          var e = this.buffered_(),
            t = this.checkBuffer_(e, this.playlist_, this.mediaIndex, this.hasPlayed_(), this.currentTime_(), this.syncPoint_, this.partIndex);
          t && (t.timestampOffset = ld({
            segmentTimeline: t.timeline,
            currentTimeline: this.currentTimeline_,
            startOfSegment: t.startOfSegment,
            buffered: e,
            overrideCheck: this.isPendingTimestampOffset_
          }), this.isPendingTimestampOffset_ = !1, "number" == typeof t.timestampOffset && this.timelineChangeController_.pendingTimelineChange({
            type: this.loaderType_,
            from: this.currentTimeline_,
            to: t.timeline
          }), this.loadSegment_(t))
        }
      }, t.isEndOfStream_ = function (e, t, i) {
        if (void 0 === e && (e = this.mediaIndex), void 0 === t && (t = this.playlist_), void 0 === i && (i = this.partIndex), !t || !this.mediaSource_) return !1;
        var n = "number" == typeof e && t.segments[e],
          r = e + 1 === t.segments.length,
          a = !n || !n.parts || i + 1 === n.parts.length;
        return t.endList && "open" === this.mediaSource_.readyState && r && a
      }, t.checkBuffer_ = function (e, t, i, n, r, a, s) {
        var o = 0;
        e.length && (o = e.end(e.length - 1));
        var u = Math.max(0, o - r);
        if (!t.segments.length) return null;
        if (u >= this.goalBufferLength_()) return null;
        if (!n && 1 <= u) return null;
        var l, c = null,
          d = null,
          h = !1;
        if (null === a) d = this.getSyncSegmentCandidate_(t), h = !0;
        else if (null !== i) {
          var p = t.segments[i],
            f = "number" == typeof s ? s : -1;
          l = p.end ? p.end : o, p.parts && p.parts[f + 1] ? (d = i, c = f + 1) : d = i + 1
        } else {
          var m = Td.getMediaInfoForTime(t, this.fetchAtBuffer_ ? o : r, a.segmentIndex, a.time);
          d = m.mediaIndex, l = m.startTime, c = m.partIndex
        }
        "number" != typeof c && t.segments[d] && t.segments[d].parts && (c = 0);
        var g = this.generateSegmentInfo_(t, d, l, h, c);
        return !g || this.mediaSource_ && this.playlist_ && g.mediaIndex === this.playlist_.segments.length - 1 && "ended" === this.mediaSource_.readyState && !this.seeking_() ? void 0 : (this.logger_("checkBuffer_ returning " + g.uri, {
          segmentInfo: g,
          playlist: t,
          currentMediaIndex: i,
          currentPartIndex: s,
          nextPartIndex: c,
          nextMediaIndex: d,
          startOfSegment: l,
          isSyncRequest: h
        }), g)
      }, t.getSyncSegmentCandidate_ = function (e) {
        var t = this;
        if (-1 === this.currentTimeline_) return 0;
        var i = e.segments.map(function (e, t) {
          return {
            timeline: e.timeline,
            segmentIndex: t
          }
        }).filter(function (e) {
          return e.timeline === t.currentTimeline_
        });
        return i.length ? i[Math.min(i.length - 1, 1)].segmentIndex : Math.max(e.segments.length - 1, 0)
      }, t.generateSegmentInfo_ = function (e, t, i, n, r) {
        if (t < 0 || t >= e.segments.length) return null;
        var a = e.segments[t];
        if (a.parts && a.parts.length && r >= a.parts.length) return null;
        var s, o, u = a.parts && a.parts.length && a.parts[r],
          l = this.sourceUpdater_.audioBuffered(),
          c = this.sourceUpdater_.videoBuffered();
        return l.length && (s = l.end(l.length - 1) - this.sourceUpdater_.audioTimestampOffset()), c.length && (o = function (e, t, i) {
          if ("undefined" == typeof t || null === t || !e.length) return [];
          var n, r = Math.ceil((t - i + 3) * vl);
          for (n = 0; n < e.length && !(e[n].pts > r); n++);
          return e.slice(n)
        }(this.gopBuffer_, this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(), this.timeMapping_)), {
          requestId: "segment-loader-" + Math.random(),
          uri: u && u.resolvedUri || a.resolvedUri,
          mediaIndex: t,
          partIndex: u ? r : null,
          isSyncRequest: n,
          startOfSegment: i,
          playlist: e,
          bytes: null,
          encryptedBytes: null,
          timestampOffset: null,
          timeline: a.timeline,
          duration: a.duration,
          segment: a,
          part: u,
          byteLength: 0,
          transmuxer: this.transmuxer_,
          audioAppendStart: s,
          gopsToAlignWith: o
        }
      }, t.earlyAbortWhenNeeded_ = function (e) {
        if (!this.vhs_.tech_.paused() && this.xhrOptions_.timeout && this.playlist_.attributes.BANDWIDTH && !(Date.now() - (e.firstBytesReceivedAt || Date.now()) < 1e3)) {
          var t = this.currentTime_(),
            i = e.bandwidth,
            n = this.pendingSegment_.duration,
            r = Td.estimateSegmentRequestTime(n, i, this.playlist_, e.bytesReceived),
            a = function (e, t, i) {
              return void 0 === i && (i = 1), ((e.length ? e.end(e.length - 1) : 0) - t) / i
            }(this.buffered_(), t, this.vhs_.tech_.playbackRate()) - 1;
          if (!(r <= a)) {
            var s = function (e) {
              var t = e.master,
                i = e.currentTime,
                n = e.bandwidth,
                r = e.duration,
                a = e.segmentDuration,
                s = e.timeUntilRebuffer,
                o = e.currentTimeline,
                u = e.syncController,
                l = t.playlists.filter(function (e) {
                  return !Td.isIncompatible(e)
                }),
                c = l.filter(Td.isEnabled);
              c.length || (c = l.filter(function (e) {
                return !Td.isDisabled(e)
              }));
              var d = c.filter(Td.hasAttribute.bind(null, "BANDWIDTH")).map(function (e) {
                  var t = u.getSyncPoint(e, r, o, i) ? 1 : 2;
                  return {
                    playlist: e,
                    rebufferingImpact: Td.estimateSegmentRequestTime(a, n, e) * t - s
                  }
                }),
                h = d.filter(function (e) {
                  return e.rebufferingImpact <= 0
                });
              return ed(h, function (e, t) {
                return td(t.playlist, e.playlist)
              }), h.length ? h[0] : (ed(d, function (e, t) {
                return e.rebufferingImpact - t.rebufferingImpact
              }), d[0] || null)
            }({
              master: this.vhs_.playlists.master,
              currentTime: t,
              bandwidth: i,
              duration: this.duration_(),
              segmentDuration: n,
              timeUntilRebuffer: a,
              currentTimeline: this.currentTimeline_,
              syncController: this.syncController_
            });
            if (s) {
              var o = r - a - s.rebufferingImpact,
                u = .5;
              a <= _d && (u = 1), !s.playlist || s.playlist.uri === this.playlist_.uri || o < u || (this.bandwidth = s.playlist.attributes.BANDWIDTH * Id.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"))
            }
          }
        }
      }, t.handleAbort_ = function (e) {
        this.logger_("Aborting " + od(e)), this.mediaRequestsAborted += 1
      }, t.handleProgress_ = function (e, t) {
        this.earlyAbortWhenNeeded_(t.stats), this.checkForAbort_(t.requestId) || this.trigger("progress")
      }, t.handleTrackInfo_ = function (e, t) {
        this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId) || this.checkForIllegalMediaSwitch(t) || (t = t || {}, function (e, t) {
          if (!e && !t || !e && t || e && !t) return !1;
          if (e === t) return !0;
          var i = Object.keys(e).sort(),
            n = Object.keys(t).sort();
          if (i.length !== n.length) return !1;
          for (var r = 0; r < i.length; r++) {
            var a = i[r];
            if (a !== n[r]) return !1;
            if (e[a] !== t[a]) return !1
          }
          return !0
        }(this.currentMediaInfo_, t) || (this.appendInitSegment_ = {
          audio: !0,
          video: !0
        }, this.startingMediaInfo_ = t, this.currentMediaInfo_ = t, this.logger_("trackinfo update", t), this.trigger("trackinfo")), this.checkForAbort_(e.requestId) || (this.pendingSegment_.trackInfo = t, this.hasEnoughInfoToAppend_() && this.processCallQueue_()))
      }, t.handleTimingInfo_ = function (e, t, i, n) {
        if (this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId)) {
          var r = this.pendingSegment_,
            a = ud(t);
          r[a] = r[a] || {}, r[a][i] = n, this.logger_("timinginfo: " + t + " - " + i + " - " + n), this.hasEnoughInfoToAppend_() && this.processCallQueue_()
        }
      }, t.handleCaptions_ = function (e, t) {
        var s = this;
        if (this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId))
          if (0 !== t.length)
            if (this.pendingSegment_.hasAppendedData_) {
              var o = null === this.sourceUpdater_.videoTimestampOffset() ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(),
                u = {};
              t.forEach(function (e) {
                u[e.stream] = u[e.stream] || {
                  startTime: 1 / 0,
                  captions: [],
                  endTime: 0
                };
                var t = u[e.stream];
                t.startTime = Math.min(t.startTime, e.startTime + o), t.endTime = Math.max(t.endTime, e.endTime + o), t.captions.push(e)
              }), Object.keys(u).forEach(function (e) {
                var t = u[e],
                  i = t.startTime,
                  n = t.endTime,
                  r = t.captions,
                  a = s.inbandTextTracks_;
                s.logger_("adding cues from " + i + " -> " + n + " for " + e),
                  function (e, t, i) {
                    if (!e[i]) {
                      t.trigger({
                        type: "usage",
                        name: "vhs-608"
                      }), t.trigger({
                        type: "usage",
                        name: "hls-608"
                      });
                      var n = t.textTracks().getTrackById(i);
                      e[i] = n || t.addRemoteTextTrack({
                        kind: "captions",
                        id: i,
                        label: i
                      }, !1).track
                    }
                  }(a, s.vhs_.tech_, e), ad(i, n, a[e]),
                  function (e) {
                    var i = e.inbandTextTracks,
                      t = e.captionArray,
                      n = e.timestampOffset;
                    if (t) {
                      var r = Ia.WebKitDataCue || Ia.VTTCue;
                      t.forEach(function (e) {
                        var t = e.stream;
                        i[t].addCue(new r(e.startTime + n, e.endTime + n, e.text))
                      })
                    }
                  }({
                    captionArray: r,
                    inbandTextTracks: a,
                    timestampOffset: o
                  })
              }), this.transmuxer_ && this.transmuxer_.postMessage({
                action: "clearParsedMp4Captions"
              })
            } else this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, e, t));
        else this.logger_("SegmentLoader received no captions from a caption event")
      }, t.handleId3_ = function (e, t, i) {
        if (this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId))
          if (this.pendingSegment_.hasAppendedData_) {
            var n = null === this.sourceUpdater_.videoTimestampOffset() ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
            ! function (e, t, i) {
              e.metadataTrack_ || (e.metadataTrack_ = i.addRemoteTextTrack({
                kind: "metadata",
                label: "Timed Metadata"
              }, !1).track, e.metadataTrack_.inBandMetadataTrackDispatchType = t)
            }(this.inbandTextTracks_, i, this.vhs_.tech_), rd({
              inbandTextTracks: this.inbandTextTracks_,
              metadataArray: t,
              timestampOffset: n,
              videoDuration: this.duration_()
            })
          } else this.metadataQueue_.id3.push(this.handleId3_.bind(this, e, t, i))
      }, t.processMetadataQueue_ = function () {
        this.metadataQueue_.id3.forEach(function (e) {
          return e()
        }), this.metadataQueue_.caption.forEach(function (e) {
          return e()
        }), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = []
      }, t.processCallQueue_ = function () {
        var e = this.callQueue_;
        this.callQueue_ = [], e.forEach(function (e) {
          return e()
        })
      }, t.processLoadQueue_ = function () {
        var e = this.loadQueue_;
        this.loadQueue_ = [], e.forEach(function (e) {
          return e()
        })
      }, t.hasEnoughInfoToLoad_ = function () {
        if ("audio" !== this.loaderType_) return !0;
        var e = this.pendingSegment_;
        return !!e && (!this.currentMediaInfo_ || !cd({
          timelineChangeController: this.timelineChangeController_,
          currentTimeline: this.currentTimeline_,
          segmentTimeline: e.timeline,
          loaderType: this.loaderType_,
          audioDisabled: this.audioDisabled_
        }))
      }, t.hasEnoughInfoToAppend_ = function () {
        if (!this.sourceUpdater_.ready()) return !1;
        if (this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_) return !1;
        var e = this.pendingSegment_;
        if (!e || !e.trackInfo) return !1;
        if (!this.handlePartialData_) {
          var t = this.currentMediaInfo_,
            i = t.hasAudio,
            n = t.hasVideo,
            r = t.isMuxed;
          if (n && !e.videoTimingInfo) return !1;
          if (i && !this.audioDisabled_ && !r && !e.audioTimingInfo) return !1
        }
        return !cd({
          timelineChangeController: this.timelineChangeController_,
          currentTimeline: this.currentTimeline_,
          segmentTimeline: e.timeline,
          loaderType: this.loaderType_,
          audioDisabled: this.audioDisabled_
        })
      }, t.handleData_ = function (e, t) {
        if (this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId))
          if (!this.callQueue_.length && this.hasEnoughInfoToAppend_()) {
            var i = this.pendingSegment_;
            if (this.setTimeMapping_(i.timeline), this.updateMediaSecondsLoaded_(i.segment), "closed" !== this.mediaSource_.readyState) {
              if (e.map && (e.map = this.initSegmentForMap(e.map, !0), i.segment.map = e.map), e.key && this.segmentKey(e.key, !0), i.isFmp4 = e.isFmp4, i.timingInfo = i.timingInfo || {}, i.isFmp4) this.trigger("fmp4"), i.timingInfo.start = i[ud(t.type)].start;
              else {
                var n, r = "main" === this.loaderType_ && this.currentMediaInfo_.hasVideo;
                r && (n = this.handlePartialData_ ? t.videoFramePtsTime : i.videoTimingInfo.start), i.timingInfo.start = this.trueSegmentStart_({
                  currentStart: i.timingInfo.start,
                  playlist: i.playlist,
                  mediaIndex: i.mediaIndex,
                  currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
                  useVideoTimingInfo: r,
                  firstVideoFrameTimeForData: n,
                  videoTimingInfo: i.videoTimingInfo,
                  audioTimingInfo: i.audioTimingInfo
                })
              }
              this.updateAppendInitSegmentStatus(i, t.type), this.updateSourceBufferTimestampOffset_(i), i.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(i, t)
            }
          } else this.callQueue_.push(this.handleData_.bind(this, e, t))
      }, t.updateAppendInitSegmentStatus = function (e, t) {
        "main" !== this.loaderType_ || "number" != typeof e.timestampOffset || e.changedTimestampOffset || (this.appendInitSegment_ = {
          audio: !0,
          video: !0
        }), this.playlistOfLastInitSegment_[t] !== e.playlist && (this.appendInitSegment_[t] = !0)
      }, t.getInitSegmentAndUpdateState_ = function (e) {
        var t = e.type,
          i = e.initSegment,
          n = e.map,
          r = e.playlist;
        if (n) {
          var a = Ec(n);
          if (this.activeInitSegmentId_ === a) return null;
          i = this.initSegmentForMap(n, !0).bytes, this.activeInitSegmentId_ = a
        }
        return i && this.appendInitSegment_[t] ? (this.playlistOfLastInitSegment_[t] = r, this.appendInitSegment_[t] = !!n, this.activeInitSegmentId_ = null, i) : null
      }, t.handleQuotaExceededError_ = function (e, t) {
        var i = this,
          n = e.segmentInfo,
          r = e.type,
          a = e.bytes,
          s = this.sourceUpdater_.audioBuffered(),
          o = this.sourceUpdater_.videoBuffered();
        1 < s.length && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + nc(s).join(", ")), 1 < o.length && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + nc(o).join(", "));
        var u = s.length ? s.start(0) : 0,
          l = s.length ? s.end(s.length - 1) : 0,
          c = o.length ? o.start(0) : 0,
          d = o.length ? o.end(o.length - 1) : 0;
        if (l - u <= 1 && d - c <= 1) return this.logger_("On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. Appended byte length: " + a.byteLength + ", audio buffer: " + nc(s).join(", ") + ", video buffer: " + nc(o).join(", ") + ", "), this.error({
          message: "Quota exceeded error with append of a single segment of content",
          blacklistDuration: 1 / 0
        }), void this.trigger("error");
        this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
          segmentInfo: n,
          type: r,
          bytes: a
        }));
        var h = this.currentTime_() - 1;
        this.logger_("On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to " + h), this.remove(0, h, function () {
          i.logger_("On QUOTA_EXCEEDED_ERR, retrying append in 1s"), i.waitingOnRemove_ = !1, i.quotaExceededErrorRetryTimeout_ = Ia.setTimeout(function () {
            i.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), i.quotaExceededErrorRetryTimeout_ = null, i.processCallQueue_()
          }, 1e3)
        }, !0)
      }, t.handleAppendError_ = function (e, t) {
        var i = e.segmentInfo,
          n = e.type,
          r = e.bytes;
        t && (22 !== t.code ? (this.logger_("Received non QUOTA_EXCEEDED_ERR on append", t), this.error(n + " append of " + r.length + "b failed for segment #" + i.mediaIndex + " in playlist " + i.playlist.id), this.trigger("appenderror")) : this.handleQuotaExceededError_({
          segmentInfo: i,
          type: n,
          bytes: r
        }))
      }, t.appendToSourceBuffer_ = function (e) {
        var t = e.segmentInfo,
          i = e.type,
          n = e.initSegment,
          r = e.data,
          a = e.bytes;
        if (!a) {
          var s = [r],
            o = r.byteLength;
          n && (s.unshift(n), o += n.byteLength), a = function (e) {
            var t, i = 0;
            return e.bytes && (t = new Uint8Array(e.bytes), e.segments.forEach(function (e) {
              t.set(e, i), i += e.byteLength
            })), t
          }({
            bytes: o,
            segments: s
          })
        }
        this.sourceUpdater_.appendBuffer({
          segmentInfo: t,
          type: i,
          bytes: a
        }, this.handleAppendError_.bind(this, {
          segmentInfo: t,
          type: i,
          bytes: a
        }))
      }, t.handleSegmentTimingInfo_ = function (e, t, i) {
        if (this.pendingSegment_ && t === this.pendingSegment_.requestId) {
          var n = this.pendingSegment_.segment,
            r = e + "TimingInfo";
          n[r] || (n[r] = {}), n[r].transmuxerPrependedSeconds = i.prependedContentDuration || 0, n[r].transmuxedPresentationStart = i.start.presentation, n[r].transmuxedDecodeStart = i.start.decode, n[r].transmuxedPresentationEnd = i.end.presentation, n[r].transmuxedDecodeEnd = i.end.decode, n[r].baseMediaDecodeTime = i.baseMediaDecodeTime
        }
      }, t.appendData_ = function (e, t) {
        var i = t.type,
          n = t.data;
        if (n && n.byteLength && ("audio" !== i || !this.audioDisabled_)) {
          var r = this.getInitSegmentAndUpdateState_({
            type: i,
            initSegment: t.initSegment,
            playlist: e.playlist,
            map: e.isFmp4 ? e.segment.map : null
          });
          this.appendToSourceBuffer_({
            segmentInfo: e,
            type: i,
            initSegment: r,
            data: n
          })
        }
      }, t.loadSegment_ = function (i) {
        var n = this;
        this.state = "WAITING", this.pendingSegment_ = i, this.trimBackBuffer_(i), "number" == typeof i.timestampOffset && this.transmuxer_ && this.transmuxer_.postMessage({
          action: "clearAllMp4Captions"
        }), this.hasEnoughInfoToLoad_() ? this.updateTransmuxerAndRequestSegment_(i) : this.loadQueue_.push(function () {
          var e = n.buffered_();
          "number" == typeof i.timestampOffset && (i.timestampOffset = ld({
            segmentTimeline: i.timeline,
            currentTimeline: n.currentTimeline_,
            startOfSegment: i.startOfSegment,
            buffered: e,
            overrideCheck: !0
          })), delete i.audioAppendStart;
          var t = n.sourceUpdater_.audioBuffered();
          t.length && (i.audioAppendStart = t.end(t.length - 1) - n.sourceUpdater_.audioTimestampOffset()), n.updateTransmuxerAndRequestSegment_(i)
        })
      }, t.updateTransmuxerAndRequestSegment_ = function (e) {
        var t = this;
        this.shouldUpdateTransmuxerTimestampOffset_(e.timestampOffset) && (this.gopBuffer_.length = 0, e.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({
          action: "reset"
        }), this.transmuxer_.postMessage({
          action: "setTimestampOffset",
          timestampOffset: e.timestampOffset
        }));
        var i = this.createSimplifiedSegmentObj_(e),
          n = this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex),
          r = null !== this.mediaIndex,
          a = e.timeline !== this.currentTimeline_ && 0 < e.timeline,
          s = n || r && a;
        this.logger_("Requesting " + od(e)), e.abortRequests = Xc({
          xhr: this.vhs_.xhr,
          xhrOptions: this.xhrOptions_,
          decryptionWorker: this.decrypter_,
          segment: i,
          handlePartialData: this.handlePartialData_,
          abortFn: this.handleAbort_.bind(this, e),
          progressFn: this.handleProgress_.bind(this),
          trackInfoFn: this.handleTrackInfo_.bind(this),
          timingInfoFn: this.handleTimingInfo_.bind(this),
          videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", e.requestId),
          audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", e.requestId),
          captionsFn: this.handleCaptions_.bind(this),
          isEndOfTimeline: s,
          endedTimelineFn: function () {
            t.logger_("received endedtimeline callback")
          },
          id3Fn: this.handleId3_.bind(this),
          dataFn: this.handleData_.bind(this),
          doneFn: this.segmentRequestFinished_.bind(this)
        })
      }, t.trimBackBuffer_ = function (e) {
        var t = function (e, t, i) {
          var n = t - Id.BACK_BUFFER_LENGTH;
          e.length && (n = Math.max(n, e.start(0)));
          var r = t - i;
          return Math.min(r, n)
        }(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
        0 < t && this.remove(0, t)
      }, t.createSimplifiedSegmentObj_ = function (e) {
        var t = e.segment,
          i = e.part,
          n = {
            resolvedUri: i ? i.resolvedUri : t.resolvedUri,
            byterange: i ? i.byterange : t.byterange,
            requestId: e.requestId,
            transmuxer: e.transmuxer,
            audioAppendStart: e.audioAppendStart,
            gopsToAlignWith: e.gopsToAlignWith,
            part: e.part
          },
          r = e.playlist.segments[e.mediaIndex - 1];
        if (r && r.timeline === t.timeline && (r.videoTimingInfo ? n.baseStartTime = r.videoTimingInfo.transmuxedDecodeEnd : r.audioTimingInfo && (n.baseStartTime = r.audioTimingInfo.transmuxedDecodeEnd)), t.key) {
          var a = t.key.iv || new Uint32Array([0, 0, 0, e.mediaIndex + e.playlist.mediaSequence]);
          n.key = this.segmentKey(t.key), n.key.iv = a
        }
        return t.map && (n.map = this.initSegmentForMap(t.map)), n
      }, t.saveTransferStats_ = function (e) {
        this.mediaRequests += 1, e && (this.mediaBytesTransferred += e.bytesReceived, this.mediaTransferDuration += e.roundTripTime)
      }, t.saveBandwidthRelatedStats_ = function (e, t) {
        this.pendingSegment_.byteLength = t.bytesReceived, e < 1 / 60 ? this.logger_("Ignoring segment's bandwidth because its duration of " + e + " is less than the min to record " + 1 / 60) : (this.bandwidth = t.bandwidth, this.roundTrip = t.roundTripTime)
      }, t.handleTimeout_ = function () {
        this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate")
      }, t.segmentRequestFinished_ = function (e, t, i) {
        if (this.callQueue_.length) this.callQueue_.push(this.segmentRequestFinished_.bind(this, e, t, i));
        else if (this.saveTransferStats_(t.stats), this.pendingSegment_ && t.requestId === this.pendingSegment_.requestId) {
          if (e) {
            if (this.pendingSegment_ = null, this.state = "READY", e.code === Rd) return;
            return this.pause(), e.code === Dd ? void this.handleTimeout_() : (this.mediaRequestsErrored += 1, this.error(e), void this.trigger("error"))
          }
          var n = this.pendingSegment_;
          this.saveBandwidthRelatedStats_(n.duration, t.stats), n.endOfAllRequests = t.endOfAllRequests, i.gopInfo && (this.gopBuffer_ = function (e, t, i) {
            if (!t.length) return e;
            if (i) return t.slice();
            for (var n = t[0].pts, r = 0; r < e.length && !(e[r].pts >= n); r++);
            return e.slice(0, r).concat(t)
          }(this.gopBuffer_, i.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(n)
        }
      }, t.setTimeMapping_ = function (e) {
        var t = this.syncController_.mappingForTimeline(e);
        null !== t && (this.timeMapping_ = t)
      }, t.updateMediaSecondsLoaded_ = function (e) {
        "number" == typeof e.start && "number" == typeof e.end ? this.mediaSecondsLoaded += e.end - e.start : this.mediaSecondsLoaded += e.duration
      }, t.shouldUpdateTransmuxerTimestampOffset_ = function (e) {
        return null !== e && ("main" === this.loaderType_ && e !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && e !== this.sourceUpdater_.audioTimestampOffset())
      }, t.trueSegmentStart_ = function (e) {
        var t = e.currentStart,
          i = e.playlist,
          n = e.mediaIndex,
          r = e.firstVideoFrameTimeForData,
          a = e.currentVideoTimestampOffset,
          s = e.useVideoTimingInfo,
          o = e.videoTimingInfo,
          u = e.audioTimingInfo;
        if ("undefined" != typeof t) return t;
        if (!s) return u.start;
        var l = i.segments[n - 1];
        return 0 !== n && l && "undefined" != typeof l.start && l.end === r + a ? o.start : r
      }, t.waitForAppendsToComplete_ = function (e) {
        if (!this.currentMediaInfo_) return this.error({
          message: "No starting media returned, likely due to an unsupported media format.",
          blacklistDuration: 1 / 0
        }), void this.trigger("error");
        var t = this.currentMediaInfo_,
          i = t.hasAudio,
          n = t.hasVideo,
          r = t.isMuxed,
          a = "main" === this.loaderType_ && n,
          s = !this.audioDisabled_ && i && !r;
        if (e.waitingOnAppends = 0, !e.hasAppendedData_) return e.timingInfo || "number" != typeof e.timestampOffset || (this.isPendingTimestampOffset_ = !0), e.timingInfo = {
          start: 0
        }, e.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(e), this.processMetadataQueue_()), void this.checkAppendsDone_(e);
        a && e.waitingOnAppends++, s && e.waitingOnAppends++, a && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, e)), s && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, e))
      }, t.checkAppendsDone_ = function (e) {
        this.checkForAbort_(e.requestId) || (e.waitingOnAppends--, 0 === e.waitingOnAppends && this.handleAppendsDone_())
      }, t.checkForIllegalMediaSwitch = function (e) {
        var t = function (e, t, i) {
          return "main" === e && t && i ? i.hasAudio || i.hasVideo ? t.hasVideo && !i.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !t.hasVideo && i.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null : "Neither audio nor video found in segment." : null
        }(this.loaderType_, this.currentMediaInfo_, e);
        return !!t && (this.error({
          message: t,
          blacklistDuration: 1 / 0
        }), this.trigger("error"), !0)
      }, t.updateSourceBufferTimestampOffset_ = function (e) {
        if (null !== e.timestampOffset && "number" == typeof e.timingInfo.start && !e.changedTimestampOffset && "main" === this.loaderType_) {
          var t = !1;
          e.timestampOffset -= e.timingInfo.start, e.changedTimestampOffset = !0, e.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(e.timestampOffset), t = !0), e.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(e.timestampOffset), t = !0), t && this.trigger("timestampoffset")
        }
      }, t.updateTimingInfoEnd_ = function (e) {
        e.timingInfo = e.timingInfo || {};
        var t = "main" === this.loaderType_ && this.currentMediaInfo_.hasVideo && e.videoTimingInfo ? e.videoTimingInfo : e.audioTimingInfo;
        t && (e.timingInfo.end = "number" == typeof t.end ? t.end : t.start + e.duration)
      }, t.handleAppendsDone_ = function () {
        if (this.pendingSegment_ && this.trigger("appendsdone"), !this.pendingSegment_) return this.state = "READY", void(this.paused() || this.monitorBuffer_());
        var e = this.pendingSegment_;
        this.updateTimingInfoEnd_(e), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
          segmentInfo: e,
          shouldSaveTimelineMapping: "main" === this.loaderType_
        }), this.logger_("Appended " + od(e));
        var t = hd(e, this.sourceType_);
        if (t && ("warn" === t.severity ? ya.log.warn(t.message) : this.logger_(t.message)), this.recordThroughput_(e), this.pendingSegment_ = null, this.state = "READY", e.isSyncRequest) this.trigger("syncinfoupdate");
        else {
          this.addSegmentMetadataCue_(e), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== e.timeline && (this.timelineChangeController_.lastTimelineChange({
            type: this.loaderType_,
            from: this.currentTimeline_,
            to: e.timeline
          }), "main" !== this.loaderType_ || this.audioDisabled_ || this.timelineChangeController_.lastTimelineChange({
            type: "audio",
            from: this.currentTimeline_,
            to: e.timeline
          })), this.currentTimeline_ = e.timeline, this.trigger("syncinfoupdate");
          var i = e.segment;
          if (i.end && this.currentTime_() - i.end > 3 * e.playlist.targetDuration) this.resetEverything();
          else null !== this.mediaIndex && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = e.mediaIndex, this.partIndex = e.partIndex, this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex) && this.endOfStream(), this.trigger("appended"), this.paused() || this.monitorBuffer_()
        }
      }, t.recordThroughput_ = function (e) {
        if (e.duration < 1 / 60) this.logger_("Ignoring segment's throughput because its duration of " + e.duration + " is less than the min to record " + 1 / 60);
        else {
          var t = this.throughput.rate,
            i = Date.now() - e.endOfAllRequests + 1,
            n = Math.floor(e.byteLength / i * 8 * 1e3);
          this.throughput.rate += (n - t) / ++this.throughput.count
        }
      }, t.addSegmentMetadataCue_ = function (e) {
        if (this.segmentMetadataTrack_) {
          var t = e.segment,
            i = t.start,
            n = t.end;
          if (sd(i) && sd(n)) {
            ad(i, n, this.segmentMetadataTrack_);
            var r = Ia.WebKitDataCue || Ia.VTTCue,
              a = {
                custom: t.custom,
                dateTimeObject: t.dateTimeObject,
                dateTimeString: t.dateTimeString,
                bandwidth: e.playlist.attributes.BANDWIDTH,
                resolution: e.playlist.attributes.RESOLUTION,
                codecs: e.playlist.attributes.CODECS,
                byteLength: e.byteLength,
                uri: e.uri,
                timeline: e.timeline,
                playlist: e.playlist.id,
                start: i,
                end: n
              },
              s = new r(i, n, JSON.stringify(a));
            s.value = a, this.segmentMetadataTrack_.addCue(s)
          }
        }
      }, e
    }(ya.EventTarget);
  /*! @name @videojs/http-streaming @version 2.7.1 @license Apache-2.0 */
  function Bd() {}

  function Fd(e) {
    return "string" != typeof e ? e : e.replace(/./, function (e) {
      return e.toUpperCase()
    })
  }

  function jd(e, t) {
    var i = t[e + "Buffer"];
    return i && i.updating || t.queuePending[e]
  }

  function Hd(e, t) {
    if (0 !== t.queue.length) {
      var i = 0,
        n = t.queue[i];
      if ("mediaSource" !== n.type) {
        if ("mediaSource" !== e && t.ready() && "closed" !== t.mediaSource.readyState && !jd(e, t)) {
          if (n.type !== e) {
            if (null === (i = function (e, t) {
                for (var i = 0; i < t.length; i++) {
                  var n = t[i];
                  if ("mediaSource" === n.type) return null;
                  if (n.type === e) return i
                }
                return null
              }(e, t.queue))) return;
            n = t.queue[i]
          }
          return t.queue.splice(i, 1), (t.queuePending[e] = n).action(e, t), n.doneFn ? void 0 : (t.queuePending[e] = null, void Hd(e, t))
        }
      } else t.updating() || "closed" === t.mediaSource.readyState || (t.queue.shift(), n.action(t), n.doneFn && n.doneFn(), Hd("audio", t), Hd("video", t))
    }
  }

  function Vd(e, t) {
    var i = t[e + "Buffer"],
      n = Fd(e);
    i && (i.removeEventListener("updateend", t["on" + n + "UpdateEnd_"]), i.removeEventListener("error", t["on" + n + "Error_"]), t.codecs[e] = null, t[e + "Buffer"] = null)
  }

  function qd(e, t) {
    return e && t && -1 !== Array.prototype.indexOf.call(e.sourceBuffers, t)
  }

  function Wd(e) {
    var t = e.type,
      i = e.sourceUpdater,
      n = e.action,
      r = e.doneFn,
      a = e.name;
    i.queue.push({
      type: t,
      action: n,
      doneFn: r,
      name: a
    }), Hd(t, i)
  }

  function zd(i, n) {
    return function (e) {
      if (n.queuePending[i]) {
        var t = n.queuePending[i].doneFn;
        n.queuePending[i] = null, t && t(n[i + "Error_"])
      }
      Hd(i, n)
    }
  }

  function Gd(e) {
    return decodeURIComponent(escape(String.fromCharCode.apply(null, e)))
  }

  function Xd(e, t) {
    for (var i = e.cues, n = 0; n < i.length; n++) {
      var r = i[n];
      if (t >= r.adStartTime && t <= r.adEndTime) return r
    }
    return null
  }

  function Kd(e, t, i) {
    void 0 === i && (i = 0);
    var n = t.segments;
    return t.endList || 0 === i ? e : n.length - (e + 1)
  }

  function Yd(e, t) {
    e.abort(), e.pause(), t && t.activePlaylistLoader && (t.activePlaylistLoader.pause(), t.activePlaylistLoader = null)
  }

  function Qd(e, t) {
    (t.activePlaylistLoader = e).load()
  }

  function $d(t) {
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function (e) {
      Th[e](e, t)
    });
    var i = t.mediaTypes,
      e = t.masterPlaylistLoader,
      n = t.tech,
      r = t.vhs;
    ["AUDIO", "SUBTITLES"].forEach(function (e) {
      i[e].activeGroup = function (s, o) {
        return function (t) {
          var e = o.masterPlaylistLoader,
            i = o.mediaTypes[s].groups,
            n = e.media();
          if (!n) return null;
          var r = null;
          n.attributes[s] && (r = i[n.attributes[s]]);
          var a = Object.keys(i);
          return r || (i.main ? r = i.main : 1 === a.length && (r = i[a[0]])), "undefined" == typeof t ? r : null !== t && r && r.filter(function (e) {
            return e.id === t.id
          })[0] || null
        }
      }(e, t), i[e].activeTrack = Sh[e](e, t), i[e].onGroupChanged = function (u, l) {
        return function () {
          var e = l.segmentLoaders,
            t = e[u],
            i = e.main,
            n = l.mediaTypes[u],
            r = n.activeTrack(),
            a = n.getActiveGroup(),
            s = n.activePlaylistLoader,
            o = n.lastGroup_;
          a && o && a.id === o.id || (n.lastGroup_ = a, n.lastTrack_ = r, Yd(t, n), a && !a.isMasterPlaylist && (a.playlistLoader ? (t.resyncLoader(), Qd(a.playlistLoader, n)) : s && i.resetEverything()))
        }
      }(e, t), i[e].onGroupChanging = function (t, i) {
        return function () {
          var e = i.segmentLoaders[t];
          i.mediaTypes[t].lastGroup_ = null, e.abort(), e.pause()
        }
      }(e, t), i[e].onTrackChanged = function (d, h) {
        return function () {
          var e = h.masterPlaylistLoader,
            t = h.segmentLoaders,
            i = t[d],
            n = t.main,
            r = h.mediaTypes[d],
            a = r.activeTrack(),
            s = r.getActiveGroup(),
            o = r.activePlaylistLoader,
            u = r.lastTrack_;
          if ((!u || !a || u.id !== a.id) && (r.lastGroup_ = s, r.lastTrack_ = a, Yd(i, r), s)) {
            if (s.isMasterPlaylist) {
              if (!a || !u || a.id === u.id) return;
              var l = h.vhs.masterPlaylistController_,
                c = l.selectPlaylist();
              if (l.media() === c) return;
              return r.logger_("track change. Switching master audio from " + u.id + " to " + a.id), e.pause(), n.resetEverything(), void l.fastQualityChange_(c)
            }
            if ("AUDIO" === d) {
              if (!s.playlistLoader) return n.setAudio(!0), void n.resetEverything();
              i.setAudio(!0), n.setAudio(!1)
            }
            o !== s.playlistLoader && (i.track && i.track(a), i.resetEverything()), Qd(s.playlistLoader, r)
          }
        }
      }(e, t), i[e].getActiveGroup = function (t, e) {
        var i = e.mediaTypes;
        return function () {
          var e = i[t].activeTrack();
          return e ? i[t].activeGroup(e) : null
        }
      }(e, t)
    });
    var a = i.AUDIO.activeGroup();
    if (a) {
      var s = (a.filter(function (e) {
        return e.default
      })[0] || a[0]).id;
      i.AUDIO.tracks[s].enabled = !0, i.AUDIO.onGroupChanged(), i.AUDIO.onTrackChanged()
    }

    function o() {
      i.AUDIO.onTrackChanged(), n.trigger({
        type: "usage",
        name: "vhs-audio-change"
      }), n.trigger({
        type: "usage",
        name: "hls-audio-change"
      })
    }
    for (var u in e.on("mediachange", function () {
        ["AUDIO", "SUBTITLES"].forEach(function (e) {
          return i[e].onGroupChanged()
        })
      }), e.on("mediachanging", function () {
        ["AUDIO", "SUBTITLES"].forEach(function (e) {
          return i[e].onGroupChanging()
        })
      }), n.audioTracks().addEventListener("change", o), n.remoteTextTracks().addEventListener("change", i.SUBTITLES.onTrackChanged), r.on("dispose", function () {
        n.audioTracks().removeEventListener("change", o), n.remoteTextTracks().removeEventListener("change", i.SUBTITLES.onTrackChanged)
      }), n.clearTracks("audio"), i.AUDIO.tracks) n.audioTracks().addTrack(i.AUDIO.tracks[u])
  }

  function Jd(e, t, i) {
    var n = e.masterPlaylistController_,
      r = n[(e.options_.smoothQualityChange ? "smooth" : "fast") + "QualityChange_"].bind(n);
    if (t.attributes) {
      var a = t.attributes.RESOLUTION;
      this.width = a && a.width, this.height = a && a.height, this.bandwidth = t.attributes.BANDWIDTH
    }
    this.codecs = $c(n.master(), t), this.playlist = t, this.id = i, this.enabled = function (r, a, s) {
      return function (e) {
        var t = r.master.playlists[a],
          i = cc(t),
          n = dc(t);
        return "undefined" == typeof e ? n : (e ? delete t.disabled : t.disabled = !0, e === n || i || (s(), e ? r.trigger("renditionenabled") : r.trigger("renditiondisabled")), e)
      }
    }(e.playlists, t.id, r)
  }

  function Zd(e) {
    ! function t(i, e) {
      var n = 0,
        r = 0,
        a = ya.mergeOptions(Ih, e);
      i.ready(function () {
        i.trigger({
          type: "usage",
          name: "vhs-error-reload-initialized"
        }), i.trigger({
          type: "usage",
          name: "hls-error-reload-initialized"
        })
      });

      function s() {
        r && i.currentTime(r)
      }

      function o(e) {
        null != e && (r = i.duration() !== 1 / 0 && i.currentTime() || 0, i.one("loadedmetadata", s), i.src(e), i.trigger({
          type: "usage",
          name: "vhs-error-reload"
        }), i.trigger({
          type: "usage",
          name: "hls-error-reload"
        }), i.play())
      }

      function u() {
        return Date.now() - n < 1e3 * a.errorInterval ? (i.trigger({
          type: "usage",
          name: "vhs-error-reload-canceled"
        }), void i.trigger({
          type: "usage",
          name: "hls-error-reload-canceled"
        })) : a.getSource && "function" == typeof a.getSource ? (n = Date.now(), a.getSource.call(i, o)) : void ya.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!")
      }

      function l() {
        i.off("loadedmetadata", s), i.off("error", u), i.off("dispose", l)
      }
      i.on("error", u), i.on("dispose", l), i.reloadSourceOnError = function (e) {
        l(), t(i, e)
      }
    }(this, e)
  }
  var eh, th = ["video", "audio"],
    ih = function (n, r, a) {
      return function (t, i) {
        var e = i[t + "Buffer"];
        if (qd(i.mediaSource, e)) {
          i.logger_("Appending segment " + r.mediaIndex + "'s " + n.length + " bytes to " + t + "Buffer");
          try {
            e.appendBuffer(n)
          } catch (e) {
            i.logger_("Error with code " + e.code + " " + (22 === e.code ? "(QUOTA_EXCEEDED_ERR) " : "") + "when appending segment " + r.mediaIndex + " to " + t + "Buffer"), i.queuePending[t] = null, a(e)
          }
        }
      }
    },
    nh = function (n, r) {
      return function (t, i) {
        var e = i[t + "Buffer"];
        if (qd(i.mediaSource, e)) {
          i.logger_("Removing " + n + " to " + r + " from " + t + "Buffer");
          try {
            e.remove(n, r)
          } catch (e) {
            i.logger_("Remove " + n + " to " + r + " from " + t + "Buffer failed")
          }
        }
      }
    },
    rh = function (n) {
      return function (e, t) {
        var i = t[e + "Buffer"];
        qd(t.mediaSource, i) && (t.logger_("Setting " + e + "timestampOffset to " + n), i.timestampOffset = n)
      }
    },
    ah = function (i) {
      return function (e, t) {
        i()
      }
    },
    sh = function (t) {
      return function (e) {
        if ("open" === e.mediaSource.readyState) {
          e.logger_("Calling mediaSource endOfStream(" + (t || "") + ")");
          try {
            e.mediaSource.endOfStream(t)
          } catch (e) {
            ya.log.warn("Failed to call media source endOfStream", e)
          }
        }
      }
    },
    oh = function (t) {
      return function (e) {
        e.logger_("Setting mediaSource duration to " + t);
        try {
          e.mediaSource.duration = t
        } catch (e) {
          ya.log.warn("Failed to set media source duration", e)
        }
      }
    },
    uh = function () {
      return function (t, e) {
        if ("open" === e.mediaSource.readyState) {
          var i = e[t + "Buffer"];
          if (qd(e.mediaSource, i)) {
            e.logger_("calling abort on " + t + "Buffer");
            try {
              i.abort()
            } catch (e) {
              ya.log.warn("Failed to abort on " + t + "Buffer", e)
            }
          }
        }
      }
    },
    lh = function (r, a) {
      return function (e) {
        var t = Fd(r),
          i = Wa(a);
        e.logger_("Adding " + r + "Buffer with codec " + a + " to mediaSource");
        var n = e.mediaSource.addSourceBuffer(i);
        n.addEventListener("updateend", e["on" + t + "UpdateEnd_"]), n.addEventListener("error", e["on" + t + "Error_"]), e.codecs[r] = a, e[r + "Buffer"] = n
      }
    },
    ch = function (i) {
      return function (e) {
        var t = e[i + "Buffer"];
        if (Vd(i, e), qd(e.mediaSource, t)) {
          e.logger_("Removing " + i + "Buffer with codec " + e.codecs[i] + " from mediaSource");
          try {
            e.mediaSource.removeSourceBuffer(t)
          } catch (e) {
            ya.log.warn("Failed to removeSourceBuffer " + i + "Buffer", e)
          }
        }
      }
    },
    dh = function (r) {
      return function (e, t) {
        var i = t[e + "Buffer"],
          n = Wa(r);
        qd(t.mediaSource, i) && t.codecs[e] !== r && (t.logger_("changing " + e + "Buffer codec from " + t.codecs[e] + " to " + r), i.changeType(n), t.codecs[e] = r)
      }
    },
    hh = function (i) {
      function e(e) {
        var t;
        return (t = i.call(this) || this).mediaSource = e, t.sourceopenListener_ = function () {
          return Hd("mediaSource", Ta(t))
        }, t.mediaSource.addEventListener("sourceopen", t.sourceopenListener_), t.logger_ = Hl("SourceUpdater"), t.audioTimestampOffset_ = 0, t.videoTimestampOffset_ = 0, t.queue = [], t.queuePending = {
          audio: null,
          video: null
        }, t.delayedAudioAppendQueue_ = [], t.videoAppendQueued_ = !1, t.codecs = {}, t.onVideoUpdateEnd_ = zd("video", Ta(t)), t.onAudioUpdateEnd_ = zd("audio", Ta(t)), t.onVideoError_ = function (e) {
          t.videoError_ = e
        }, t.onAudioError_ = function (e) {
          t.audioError_ = e
        }, t.createdSourceBuffers_ = !1, t.initializedEme_ = !1, t.triggeredReady_ = !1, t
      }
      ka(e, i);
      var t = e.prototype;
      return t.initializedEme = function () {
        this.initializedEme_ = !0, this.triggerReady()
      }, t.hasCreatedSourceBuffers = function () {
        return this.createdSourceBuffers_
      }, t.hasInitializedAnyEme = function () {
        return this.initializedEme_
      }, t.ready = function () {
        return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme()
      }, t.createSourceBuffers = function (e) {
        this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(e), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady())
      }, t.triggerReady = function () {
        this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"))
      }, t.addSourceBuffer = function (e, t) {
        Wd({
          type: "mediaSource",
          sourceUpdater: this,
          action: lh(e, t),
          name: "addSourceBuffer"
        })
      }, t.abort = function (e) {
        Wd({
          type: e,
          sourceUpdater: this,
          action: uh(e),
          name: "abort"
        })
      }, t.removeSourceBuffer = function (e) {
        this.canRemoveSourceBuffer() ? Wd({
          type: "mediaSource",
          sourceUpdater: this,
          action: ch(e),
          name: "removeSourceBuffer"
        }) : ya.log.error("removeSourceBuffer is not supported!")
      }, t.canRemoveSourceBuffer = function () {
        return !ya.browser.IE_VERSION && !ya.browser.IS_FIREFOX && Ia.MediaSource && Ia.MediaSource.prototype && "function" == typeof Ia.MediaSource.prototype.removeSourceBuffer
      }, e.canChangeType = function () {
        return Ia.SourceBuffer && Ia.SourceBuffer.prototype && "function" == typeof Ia.SourceBuffer.prototype.changeType
      }, t.canChangeType = function () {
        return this.constructor.canChangeType()
      }, t.changeType = function (e, t) {
        this.canChangeType() ? Wd({
          type: e,
          sourceUpdater: this,
          action: dh(t),
          name: "changeType"
        }) : ya.log.error("changeType is not supported!")
      }, t.addOrChangeSourceBuffers = function (i) {
        var n = this;
        if (!i || "object" != typeof i || 0 === Object.keys(i).length) throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
        Object.keys(i).forEach(function (e) {
          var t = i[e];
          if (!n.hasCreatedSourceBuffers()) return n.addSourceBuffer(e, t);
          n.canChangeType() && n.changeType(e, t)
        })
      }, t.appendBuffer = function (e, t) {
        var i = this,
          n = e.segmentInfo,
          r = e.type,
          a = e.bytes;
        if (this.processedAppend_ = !0, "audio" === r && this.videoBuffer && !this.videoAppendQueued_) return this.delayedAudioAppendQueue_.push([e, t]), void this.logger_("delayed audio append of " + a.length + " until video append");
        if (Wd({
            type: r,
            sourceUpdater: this,
            action: ih(a, n || {
              mediaIndex: -1
            }, t),
            doneFn: t,
            name: "appendBuffer"
          }), "video" === r) {
          if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length) return;
          var s = this.delayedAudioAppendQueue_.slice();
          this.logger_("queuing delayed audio " + s.length + " appendBuffers"), this.delayedAudioAppendQueue_.length = 0, s.forEach(function (e) {
            i.appendBuffer.apply(i, e)
          })
        }
      }, t.audioBuffered = function () {
        return qd(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : ya.createTimeRange()
      }, t.videoBuffered = function () {
        return qd(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : ya.createTimeRange()
      }, t.buffered = function () {
        var e = qd(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null,
          t = qd(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
        return t && !e ? this.audioBuffered() : e && !t ? this.videoBuffered() : function (e, t) {
          var i = null,
            n = null,
            r = 0,
            a = [],
            s = [];
          if (!(e && e.length && t && t.length)) return ya.createTimeRange();
          for (var o = e.length; o--;) a.push({
            time: e.start(o),
            type: "start"
          }), a.push({
            time: e.end(o),
            type: "end"
          });
          for (o = t.length; o--;) a.push({
            time: t.start(o),
            type: "start"
          }), a.push({
            time: t.end(o),
            type: "end"
          });
          for (a.sort(function (e, t) {
              return e.time - t.time
            }), o = 0; o < a.length; o++) "start" === a[o].type ? 2 === ++r && (i = a[o].time) : "end" === a[o].type && 1 === --r && (n = a[o].time), null !== i && null !== n && (s.push([i, n]), n = i = null);
          return ya.createTimeRanges(s)
        }(this.audioBuffered(), this.videoBuffered())
      }, t.setDuration = function (e, t) {
        void 0 === t && (t = Bd), Wd({
          type: "mediaSource",
          sourceUpdater: this,
          action: oh(e),
          name: "duration",
          doneFn: t
        })
      }, t.endOfStream = function (e, t) {
        void 0 === e && (e = null), void 0 === t && (t = Bd), "string" != typeof e && (e = void 0), Wd({
          type: "mediaSource",
          sourceUpdater: this,
          action: sh(e),
          name: "endOfStream",
          doneFn: t
        })
      }, t.removeAudio = function (e, t, i) {
        void 0 === i && (i = Bd), this.audioBuffered().length && 0 !== this.audioBuffered().end(0) ? Wd({
          type: "audio",
          sourceUpdater: this,
          action: nh(e, t),
          doneFn: i,
          name: "remove"
        }) : i()
      }, t.removeVideo = function (e, t, i) {
        void 0 === i && (i = Bd), this.videoBuffered().length && 0 !== this.videoBuffered().end(0) ? Wd({
          type: "video",
          sourceUpdater: this,
          action: nh(e, t),
          doneFn: i,
          name: "remove"
        }) : i()
      }, t.updating = function () {
        return !(!jd("audio", this) && !jd("video", this))
      }, t.audioTimestampOffset = function (e) {
        return "undefined" != typeof e && this.audioBuffer && this.audioTimestampOffset_ !== e && (Wd({
          type: "audio",
          sourceUpdater: this,
          action: rh(e),
          name: "timestampOffset"
        }), this.audioTimestampOffset_ = e), this.audioTimestampOffset_
      }, t.videoTimestampOffset = function (e) {
        return "undefined" != typeof e && this.videoBuffer && this.videoTimestampOffset !== e && (Wd({
          type: "video",
          sourceUpdater: this,
          action: rh(e),
          name: "timestampOffset"
        }), this.videoTimestampOffset_ = e), this.videoTimestampOffset_
      }, t.audioQueueCallback = function (e) {
        this.audioBuffer && Wd({
          type: "audio",
          sourceUpdater: this,
          action: ah(e),
          name: "callback"
        })
      }, t.videoQueueCallback = function (e) {
        this.videoBuffer && Wd({
          type: "video",
          sourceUpdater: this,
          action: ah(e),
          name: "callback"
        })
      }, t.dispose = function () {
        var t = this;
        this.trigger("dispose"), th.forEach(function (e) {
          t.abort(e), t.canRemoveSourceBuffer() ? t.removeSourceBuffer(e) : t[e + "QueueCallback"](function () {
            return Vd(e, t)
          })
        }), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off()
      }, e
    }(ya.EventTarget),
    ph = new Uint8Array("\n\n".split("").map(function (e) {
      return e.charCodeAt(0)
    })),
    fh = function (n) {
      function e(e, t) {
        var i;
        return void 0 === t && (t = {}), (i = n.call(this, e, t) || this).handlePartialData_ = !1, i.mediaSource_ = null, i.subtitlesTrack_ = null, i.loaderType_ = "subtitle", i.featuresNativeTextTracks_ = e.featuresNativeTextTracks, i.shouldSaveSegmentTimingInfo_ = !1, i
      }
      ka(e, n);
      var t = e.prototype;
      return t.createTransmuxer_ = function () {
        return null
      }, t.buffered_ = function () {
        if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length) return ya.createTimeRanges();
        var e = this.subtitlesTrack_.cues,
          t = e[0].startTime,
          i = e[e.length - 1].startTime;
        return ya.createTimeRanges([
          [t, i]
        ])
      }, t.initSegmentForMap = function (e, t) {
        if (void 0 === t && (t = !1), !e) return null;
        var i = Ec(e),
          n = this.initSegments_[i];
        if (t && !n && e.bytes) {
          var r = ph.byteLength + e.bytes.byteLength,
            a = new Uint8Array(r);
          a.set(e.bytes), a.set(ph, e.bytes.byteLength), this.initSegments_[i] = n = {
            resolvedUri: e.resolvedUri,
            byterange: e.byterange,
            bytes: a
          }
        }
        return n || e
      }, t.couldBeginLoading_ = function () {
        return this.playlist_ && this.subtitlesTrack_ && !this.paused()
      }, t.init_ = function () {
        return this.state = "READY", this.resetEverything(), this.monitorBuffer_()
      }, t.track = function (e) {
        return "undefined" == typeof e || (this.subtitlesTrack_ = e, "INIT" === this.state && this.couldBeginLoading_() && this.init_()), this.subtitlesTrack_
      }, t.remove = function (e, t) {
        ad(e, t, this.subtitlesTrack_)
      }, t.fillBuffer_ = function () {
        var e = this;
        this.syncPoint_ || (this.syncPoint_ = this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_()));
        var t = this.checkBuffer_(this.buffered_(), this.playlist_, this.mediaIndex, this.hasPlayed_(), this.currentTime_(), this.syncPoint_);
        if (t = this.skipEmptySegments_(t)) {
          if (null === this.syncController_.timestampOffsetForTimeline(t.timeline)) {
            return this.syncController_.one("timestampoffset", function () {
              e.state = "READY", e.paused() || e.monitorBuffer_()
            }), void(this.state = "WAITING_ON_TIMELINE")
          }
          this.loadSegment_(t)
        }
      }, t.skipEmptySegments_ = function (e) {
        for (; e && e.segment.empty;) e = this.generateSegmentInfo_(e.playlist, e.mediaIndex + 1, e.startOfSegment + e.duration, e.isSyncRequest);
        return e
      }, t.stopForError = function (e) {
        this.error(e), this.state = "READY", this.pause(), this.trigger("error")
      }, t.segmentRequestFinished_ = function (e, t, i) {
        var n = this;
        if (this.subtitlesTrack_) {
          if (this.saveTransferStats_(t.stats), !this.pendingSegment_) return this.state = "READY", void(this.mediaRequestsAborted += 1);
          if (e) return e.code === Dd && this.handleTimeout_(), e.code === Rd ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, void this.stopForError(e);
          var r = this.pendingSegment_;
          this.saveBandwidthRelatedStats_(r.duration, t.stats), this.state = "APPENDING", this.trigger("appending");
          var a = r.segment;
          if (a.map && (a.map.bytes = t.map.bytes), r.bytes = t.bytes, "function" != typeof Ia.WebVTT && this.subtitlesTrack_ && this.subtitlesTrack_.tech_) {
            var s, o = function () {
              n.subtitlesTrack_.tech_.off("vttjsloaded", s), n.stopForError({
                message: "Error loading vtt.js"
              })
            };
            return s = function () {
              n.subtitlesTrack_.tech_.off("vttjserror", o), n.segmentRequestFinished_(e, t, i)
            }, this.state = "WAITING_ON_VTTJS", this.subtitlesTrack_.tech_.one("vttjsloaded", s), void this.subtitlesTrack_.tech_.one("vttjserror", o)
          }
          a.requested = !0;
          try {
            this.parseVTTCues_(r)
          } catch (e) {
            return void this.stopForError({
              message: e.message
            })
          }
          if (this.updateTimeMapping_(r, this.syncController_.timelines[r.timeline], this.playlist_), r.cues.length ? r.timingInfo = {
              start: r.cues[0].startTime,
              end: r.cues[r.cues.length - 1].endTime
            } : r.timingInfo = {
              start: r.startOfSegment,
              end: r.startOfSegment + r.duration
            }, r.isSyncRequest) return this.trigger("syncinfoupdate"), this.pendingSegment_ = null, void(this.state = "READY");
          r.byteLength = r.bytes.byteLength, this.mediaSecondsLoaded += a.duration, r.cues.forEach(function (e) {
              n.subtitlesTrack_.addCue(n.featuresNativeTextTracks_ ? new Ia.VTTCue(e.startTime, e.endTime, e.text) : e)
            }),
            function (t) {
              var e = t.cues;
              if (e)
                for (var i = 0; i < e.length; i++) {
                  for (var n = [], r = 0, a = 0; a < e.length; a++) e[i].startTime === e[a].startTime && e[i].endTime === e[a].endTime && e[i].text === e[a].text && 1 < ++r && n.push(e[a]);
                  n.length && n.forEach(function (e) {
                    return t.removeCue(e)
                  })
                }
            }(this.subtitlesTrack_), this.handleAppendsDone_()
        } else this.state = "READY"
      }, t.handleData_ = function () {}, t.updateTimingInfoEnd_ = function () {}, t.parseVTTCues_ = function (t) {
        var e, i = !1;
        "function" == typeof Ia.TextDecoder ? e = new Ia.TextDecoder("utf8") : (e = Ia.WebVTT.StringDecoder(), i = !0);
        var n = new Ia.WebVTT.Parser(Ia, Ia.vttjs, e);
        if (t.cues = [], t.timestampmap = {
            MPEGTS: 0,
            LOCAL: 0
          }, n.oncue = t.cues.push.bind(t.cues), n.ontimestampmap = function (e) {
            t.timestampmap = e
          }, n.onparsingerror = function (e) {
            ya.log.warn("Error encountered when parsing cues: " + e.message)
          }, t.segment.map) {
          var r = t.segment.map.bytes;
          i && (r = Gd(r)), n.parse(r)
        }
        var a = t.bytes;
        i && (a = Gd(a)), n.parse(a), n.flush()
      }, t.updateTimeMapping_ = function (e, t, i) {
        var n = e.segment;
        if (t)
          if (e.cues.length) {
            var r = e.timestampmap,
              a = r.MPEGTS / vl - r.LOCAL + t.mapping;
            if (e.cues.forEach(function (e) {
                e.startTime += a, e.endTime += a
              }), !i.syncInfo) {
              var s = e.cues[0].startTime,
                o = e.cues[e.cues.length - 1].startTime;
              i.syncInfo = {
                mediaSequence: i.mediaSequence + e.mediaIndex,
                time: Math.min(s, o - n.duration)
              }
            }
          } else n.empty = !0
      }, e
    }(Ud),
    mh = [{
      name: "VOD",
      run: function (e, t, i, n, r) {
        if (i === 1 / 0) return null;
        return {
          time: 0,
          segmentIndex: 0
        }
      }
    }, {
      name: "ProgramDateTime",
      run: function (e, t, i, n, r) {
        if (!Object.keys(e.timelineToDatetimeMappings).length) return null;
        var a = t.segments || [],
          s = null,
          o = null;
        r = r || 0;
        for (var u = 0; u < a.length; u++) {
          var l = Kd(u, t, r),
            c = a[l],
            d = e.timelineToDatetimeMappings[c.timeline];
          if (d && c.dateTimeObject) {
            var h = c.dateTimeObject.getTime() / 1e3 + d,
              p = Math.abs(r - h);
            if (null !== o && (0 === p || o < p)) break;
            o = p, s = {
              time: h,
              segmentIndex: l
            }
          }
        }
        return s
      }
    }, {
      name: "Segment",
      run: function (e, t, i, n, r) {
        var a = t.segments || [],
          s = null,
          o = null;
        r = r || 0;
        for (var u = 0; u < a.length; u++) {
          var l = Kd(u, t, r),
            c = a[l];
          if (c.timeline === n && "undefined" != typeof c.start) {
            var d = Math.abs(r - c.start);
            if (null !== o && o < d) break;
            (!s || null === o || d <= o) && (o = d, s = {
              time: c.start,
              segmentIndex: l
            })
          }
        }
        return s
      }
    }, {
      name: "Discontinuity",
      run: function (e, t, i, n, r) {
        var a = null;
        if (r = r || 0, t.discontinuityStarts && t.discontinuityStarts.length)
          for (var s = null, o = 0; o < t.discontinuityStarts.length; o++) {
            var u = t.discontinuityStarts[o],
              l = t.discontinuitySequence + o + 1,
              c = e.discontinuities[l];
            if (c) {
              var d = Math.abs(r - c.time);
              if (null !== s && s < d) break;
              (!a || null === s || d <= s) && (s = d, a = {
                time: c.time,
                segmentIndex: u
              })
            }
          }
        return a
      }
    }, {
      name: "Playlist",
      run: function (e, t, i, n, r) {
        return t.syncInfo ? {
          time: t.syncInfo.time,
          segmentIndex: t.syncInfo.mediaSequence - t.mediaSequence
        } : null
      }
    }],
    gh = function (i) {
      function e(e) {
        var t;
        return (t = i.call(this) || this).timelines = [], t.discontinuities = [], t.timelineToDatetimeMappings = {}, t.logger_ = Hl("SyncController"), t
      }
      ka(e, i);
      var t = e.prototype;
      return t.getSyncPoint = function (e, t, i, n) {
        var r = this.runStrategies_(e, t, i, n);
        return r.length ? this.selectSyncPoint_(r, {
          key: "time",
          value: n
        }) : null
      }, t.getExpiredTime = function (e, t) {
        if (!e || !e.segments) return null;
        var i = this.runStrategies_(e, t, e.discontinuitySequence, 0);
        if (!i.length) return null;
        var n = this.selectSyncPoint_(i, {
          key: "segmentIndex",
          value: 0
        });
        return 0 < n.segmentIndex && (n.time *= -1), Math.abs(n.time + oc(e, n.segmentIndex, 0))
      }, t.runStrategies_ = function (e, t, i, n) {
        for (var r = [], a = 0; a < mh.length; a++) {
          var s = mh[a],
            o = s.run(this, e, t, i, n);
          o && (o.strategy = s.name, r.push({
            strategy: s.name,
            syncPoint: o
          }))
        }
        return r
      }, t.selectSyncPoint_ = function (e, t) {
        for (var i = e[0].syncPoint, n = Math.abs(e[0].syncPoint[t.key] - t.value), r = e[0].strategy, a = 1; a < e.length; a++) {
          var s = Math.abs(e[a].syncPoint[t.key] - t.value);
          s < n && (n = s, i = e[a].syncPoint, r = e[a].strategy)
        }
        return this.logger_("syncPoint for [" + t.key + ": " + t.value + "] chosen with strategy [" + r + "]: [time:" + i.time + ", segmentIndex:" + i.segmentIndex + "]"), i
      }, t.saveExpiredSegmentInfo = function (e, t) {
        for (var i = t.mediaSequence - e.mediaSequence - 1; 0 <= i; i--) {
          var n = e.segments[i];
          if (n && "undefined" != typeof n.start) {
            t.syncInfo = {
              mediaSequence: e.mediaSequence + i,
              time: n.start
            }, this.logger_("playlist refresh sync: [time:" + t.syncInfo.time + ", mediaSequence: " + t.syncInfo.mediaSequence + "]"), this.trigger("syncinfoupdate");
            break
          }
        }
      }, t.setDateTimeMappingForStart = function (e) {
        if (this.timelineToDatetimeMappings = {}, e.segments && e.segments.length && e.segments[0].dateTimeObject) {
          var t = e.segments[0],
            i = t.dateTimeObject.getTime() / 1e3;
          this.timelineToDatetimeMappings[t.timeline] = -i
        }
      }, t.saveSegmentTimingInfo = function (e) {
        var t = e.segmentInfo,
          i = e.shouldSaveTimelineMapping,
          n = this.calculateSegmentTimeMapping_(t, t.timingInfo, i),
          r = t.segment;
        n && (this.saveDiscontinuitySyncInfo_(t), t.playlist.syncInfo || (t.playlist.syncInfo = {
          mediaSequence: t.playlist.mediaSequence + t.mediaIndex,
          time: r.start
        }));
        var a = r.dateTimeObject;
        r.discontinuity && i && a && (this.timelineToDatetimeMappings[r.timeline] = -a.getTime() / 1e3)
      }, t.timestampOffsetForTimeline = function (e) {
        return "undefined" == typeof this.timelines[e] ? null : this.timelines[e].time
      }, t.mappingForTimeline = function (e) {
        return "undefined" == typeof this.timelines[e] ? null : this.timelines[e].mapping
      }, t.calculateSegmentTimeMapping_ = function (e, t, i) {
        var n = e.segment,
          r = this.timelines[e.timeline];
        if ("number" == typeof e.timestampOffset) r = {
          time: e.startOfSegment,
          mapping: e.startOfSegment - t.start
        }, i && (this.timelines[e.timeline] = r, this.trigger("timestampoffset"), this.logger_("time mapping for timeline " + e.timeline + ": [time: " + r.time + "] [mapping: " + r.mapping + "]")), n.start = e.startOfSegment, n.end = t.end + r.mapping;
        else {
          if (!r) return !1;
          n.start = t.start + r.mapping, n.end = t.end + r.mapping
        }
        return !0
      }, t.saveDiscontinuitySyncInfo_ = function (e) {
        var t = e.playlist,
          i = e.segment;
        if (i.discontinuity) this.discontinuities[i.timeline] = {
          time: i.start,
          accuracy: 0
        };
        else if (t.discontinuityStarts && t.discontinuityStarts.length)
          for (var n = 0; n < t.discontinuityStarts.length; n++) {
            var r = t.discontinuityStarts[n],
              a = t.discontinuitySequence + n + 1,
              s = r - e.mediaIndex,
              o = Math.abs(s);
            if (!this.discontinuities[a] || this.discontinuities[a].accuracy > o) {
              var u = void 0;
              u = s < 0 ? i.start - oc(t, e.mediaIndex, r) : i.end + oc(t, e.mediaIndex + 1, r), this.discontinuities[a] = {
                time: u,
                accuracy: o
              }
            }
          }
      }, t.dispose = function () {
        this.trigger("dispose"), this.off()
      }, e
    }(ya.EventTarget),
    vh = function (t) {
      function e() {
        var e;
        return (e = t.call(this) || this).pendingTimelineChanges_ = {}, e.lastTimelineChanges_ = {}, e
      }
      ka(e, t);
      var i = e.prototype;
      return i.clearPendingTimelineChange = function (e) {
        this.pendingTimelineChanges_[e] = null, this.trigger("pendingtimelinechange")
      }, i.pendingTimelineChange = function (e) {
        var t = e.type,
          i = e.from,
          n = e.to;
        return "number" == typeof i && "number" == typeof n && (this.pendingTimelineChanges_[t] = {
          type: t,
          from: i,
          to: n
        }, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[t]
      }, i.lastTimelineChange = function (e) {
        var t = e.type,
          i = e.from,
          n = e.to;
        return "number" == typeof i && "number" == typeof n && (this.lastTimelineChanges_[t] = {
          type: t,
          from: i,
          to: n
        }, delete this.pendingTimelineChanges_[t], this.trigger("timelinechange")), this.lastTimelineChanges_[t]
      }, i.dispose = function () {
        this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off()
      }, e
    }(ya.EventTarget),
    yh = Rc(Mc(Nc(function () {
      function e(e, t, i) {
        return e(i = {
          path: t,
          exports: {},
          require: function (e, t) {
            return function () {
              throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs")
            }(null == t && i.path)
          }
        }, i.exports), i.exports
      }
      var t = e(function (e) {
          function n(e, t) {
            for (var i = 0; i < t.length; i++) {
              var n = t[i];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
            }
          }
          e.exports = function (e, t, i) {
            return t && n(e.prototype, t), i && n(e, i), e
          }, e.exports.default = e.exports, e.exports.__esModule = !0
        }),
        i = e(function (i) {
          function n(e, t) {
            return i.exports = n = Object.setPrototypeOf || function (e, t) {
              return e.__proto__ = t, e
            }, i.exports.default = i.exports, i.exports.__esModule = !0, n(e, t)
          }
          i.exports = n, i.exports.default = i.exports, i.exports.__esModule = !0
        }),
        n = e(function (e) {
          e.exports = function (e, t) {
            e.prototype = Object.create(t.prototype), e.prototype.constructor = e, i(e, t)
          }, e.exports.default = e.exports, e.exports.__esModule = !0
        }),
        r = function () {
          function e() {
            this.listeners = {}
          }
          var t = e.prototype;
          return t.on = function (e, t) {
            this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t)
          }, t.off = function (e, t) {
            if (!this.listeners[e]) return !1;
            var i = this.listeners[e].indexOf(t);
            return this.listeners[e] = this.listeners[e].slice(0), this.listeners[e].splice(i, 1), -1 < i
          }, t.trigger = function (e, t) {
            var i = this.listeners[e];
            if (i)
              if (2 === arguments.length)
                for (var n = i.length, r = 0; r < n; ++r) i[r].call(this, t);
              else
                for (var a = Array.prototype.slice.call(arguments, 1), s = i.length, o = 0; o < s; ++o) i[o].apply(this, a)
          }, t.dispose = function () {
            this.listeners = {}
          }, t.pipe = function (t) {
            this.on("data", function (e) {
              t.push(e)
            })
          }, e
        }();

      function g(e) {
        return e << 24 | (65280 & e) << 8 | (16711680 & e) >> 8 | e >>> 24
      }
      /*! @name aes-decrypter @version 3.1.2 @license Apache-2.0 */
      var c = null,
        v = function () {
          function e(e) {
            var t, i, n;
            c = c || function () {
              var e, t, i, n, r, a, s, o, u = [
                  [
                    [],
                    [],
                    [],
                    [],
                    []
                  ],
                  [
                    [],
                    [],
                    [],
                    [],
                    []
                  ]
                ],
                l = u[0],
                c = u[1],
                d = l[4],
                h = c[4],
                p = [],
                f = [];
              for (e = 0; e < 256; e++) f[(p[e] = e << 1 ^ 283 * (e >> 7)) ^ e] = e;
              for (t = i = 0; !d[t]; t ^= n || 1, i = f[i] || 1)
                for (a = (a = i ^ i << 1 ^ i << 2 ^ i << 3 ^ i << 4) >> 8 ^ 255 & a ^ 99, o = 16843009 * p[r = p[n = p[h[d[t] = a] = t]]] ^ 65537 * r ^ 257 * n ^ 16843008 * t, s = 257 * p[a] ^ 16843008 * a, e = 0; e < 4; e++) l[e][t] = s = s << 24 ^ s >>> 8, c[e][a] = o = o << 24 ^ o >>> 8;
              for (e = 0; e < 5; e++) l[e] = l[e].slice(0), c[e] = c[e].slice(0);
              return u
            }(), this._tables = [
              [c[0][0].slice(), c[0][1].slice(), c[0][2].slice(), c[0][3].slice(), c[0][4].slice()],
              [c[1][0].slice(), c[1][1].slice(), c[1][2].slice(), c[1][3].slice(), c[1][4].slice()]
            ];
            var r = this._tables[0][4],
              a = this._tables[1],
              s = e.length,
              o = 1;
            if (4 !== s && 6 !== s && 8 !== s) throw new Error("Invalid aes key size");
            var u = e.slice(0),
              l = [];
            for (this._key = [u, l], t = s; t < 4 * s + 28; t++) n = u[t - 1], (t % s == 0 || 8 === s && t % s == 4) && (n = r[n >>> 24] << 24 ^ r[n >> 16 & 255] << 16 ^ r[n >> 8 & 255] << 8 ^ r[255 & n], t % s == 0 && (n = n << 8 ^ n >>> 24 ^ o << 24, o = o << 1 ^ 283 * (o >> 7))), u[t] = u[t - s] ^ n;
            for (i = 0; t; i++, t--) n = u[3 & i ? t : t - 4], l[i] = t <= 4 || i < 4 ? n : a[0][r[n >>> 24]] ^ a[1][r[n >> 16 & 255]] ^ a[2][r[n >> 8 & 255]] ^ a[3][r[255 & n]]
          }
          return e.prototype.decrypt = function (e, t, i, n, r, a) {
            var s, o, u, l, c = this._key[1],
              d = e ^ c[0],
              h = n ^ c[1],
              p = i ^ c[2],
              f = t ^ c[3],
              m = c.length / 4 - 2,
              g = 4,
              v = this._tables[1],
              y = v[0],
              _ = v[1],
              b = v[2],
              T = v[3],
              S = v[4];
            for (l = 0; l < m; l++) s = y[d >>> 24] ^ _[h >> 16 & 255] ^ b[p >> 8 & 255] ^ T[255 & f] ^ c[g], o = y[h >>> 24] ^ _[p >> 16 & 255] ^ b[f >> 8 & 255] ^ T[255 & d] ^ c[g + 1], u = y[p >>> 24] ^ _[f >> 16 & 255] ^ b[d >> 8 & 255] ^ T[255 & h] ^ c[g + 2], f = y[f >>> 24] ^ _[d >> 16 & 255] ^ b[h >> 8 & 255] ^ T[255 & p] ^ c[g + 3], g += 4, d = s, h = o, p = u;
            for (l = 0; l < 4; l++) r[(3 & -l) + a] = S[d >>> 24] << 24 ^ S[h >> 16 & 255] << 16 ^ S[p >> 8 & 255] << 8 ^ S[255 & f] ^ c[g++], s = d, d = h, h = p, p = f, f = s
          }, e
        }(),
        l = function (t) {
          function e() {
            var e;
            return (e = t.call(this, r) || this).jobs = [], e.delay = 1, e.timeout_ = null, e
          }
          n(e, t);
          var i = e.prototype;
          return i.processJob_ = function () {
            this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null
          }, i.push = function (e) {
            this.jobs.push(e), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay))
          }, e
        }(r),
        a = function () {
          function u(e, t, i, n) {
            var r = u.STEP,
              a = new Int32Array(e.buffer),
              s = new Uint8Array(e.byteLength),
              o = 0;
            for (this.asyncStream_ = new l, this.asyncStream_.push(this.decryptChunk_(a.subarray(o, o + r), t, i, s)), o = r; o < a.length; o += r) i = new Uint32Array([g(a[o - 4]), g(a[o - 3]), g(a[o - 2]), g(a[o - 1])]), this.asyncStream_.push(this.decryptChunk_(a.subarray(o, o + r), t, i, s));
            this.asyncStream_.push(function () {
              n(null,
                /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
                function (e) {
                  return e.subarray(0, e.byteLength - e[e.byteLength - 1])
                }(s))
            })
          }
          return u.prototype.decryptChunk_ = function (t, i, n, r) {
            return function () {
              var e = function (e, t, i) {
                var n, r, a, s, o, u, l, c, d, h = new Int32Array(e.buffer, e.byteOffset, e.byteLength >> 2),
                  p = new v(Array.prototype.slice.call(t)),
                  f = new Uint8Array(e.byteLength),
                  m = new Int32Array(f.buffer);
                for (n = i[0], r = i[1], a = i[2], s = i[3], d = 0; d < h.length; d += 4) o = g(h[d]), u = g(h[d + 1]), l = g(h[d + 2]), c = g(h[d + 3]), p.decrypt(o, u, l, c, m, d), m[d] = g(m[d] ^ n), m[d + 1] = g(m[d + 1] ^ r), m[d + 2] = g(m[d + 2] ^ a), m[d + 3] = g(m[d + 3] ^ s), n = o, r = u, a = l, s = c;
                return f
              }(t, i, n);
              r.set(e, t.byteOffset)
            }
          }, t(u, null, [{
            key: "STEP",
            get: function () {
              return 32e3
            }
          }]), u
        }();
      self.onmessage = function (e) {
        var i = e.data,
          t = new Uint8Array(i.encrypted.bytes, i.encrypted.byteOffset, i.encrypted.byteLength),
          n = new Uint32Array(i.key.bytes, i.key.byteOffset, i.key.byteLength / 4),
          r = new Uint32Array(i.iv.bytes, i.iv.byteOffset, i.iv.byteLength / 4);
        new a(t, n, r, function (e, t) {
          self.postMessage(function (i) {
            var n = {};
            return Object.keys(i).forEach(function (e) {
              var t = i[e];
              ArrayBuffer.isView(t) ? n[e] = {
                bytes: t.buffer,
                byteOffset: t.byteOffset,
                byteLength: t.byteLength
              } : n[e] = t
            }), n
          }({
            source: i.source,
            decrypted: t
          }), [t.buffer])
        })
      }
    }))),
    _h = {
      AUDIO: function (u, l) {
        return function () {
          var e = l.segmentLoaders[u],
            t = l.mediaTypes[u],
            i = l.blacklistCurrentPlaylist;
          Yd(e, t);
          var n = t.activeTrack(),
            r = t.activeGroup(),
            a = (r.filter(function (e) {
              return e.default
            })[0] || r[0]).id,
            s = t.tracks[a];
          if (n !== s) {
            for (var o in ya.log.warn("Problem encountered loading the alternate audio track.Switching back to default."), t.tracks) t.tracks[o].enabled = t.tracks[o] === s;
            t.onTrackChanged()
          } else i({
            message: "Problem encountered loading the default audio track."
          })
        }
      },
      SUBTITLES: function (n, r) {
        return function () {
          var e = r.segmentLoaders[n],
            t = r.mediaTypes[n];
          ya.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track."), Yd(e, t);
          var i = t.activeTrack();
          i && (i.mode = "disabled"), t.onTrackChanged()
        }
      }
    },
    bh = {
      AUDIO: function (e, t, i) {
        if (t) {
          var n = i.tech,
            r = i.requestOptions,
            a = i.segmentLoaders[e];
          t.on("loadedmetadata", function () {
            var e = t.media();
            a.playlist(e, r), (!n.paused() || e.endList && "none" !== n.preload()) && a.load()
          }), t.on("loadedplaylist", function () {
            a.playlist(t.media(), r), n.paused() || a.load()
          }), t.on("error", _h[e](e, i))
        }
      },
      SUBTITLES: function (e, t, i) {
        var n = i.tech,
          r = i.requestOptions,
          a = i.segmentLoaders[e],
          s = i.mediaTypes[e];
        t.on("loadedmetadata", function () {
          var e = t.media();
          a.playlist(e, r), a.track(s.activeTrack()), (!n.paused() || e.endList && "none" !== n.preload()) && a.load()
        }), t.on("loadedplaylist", function () {
          a.playlist(t.media(), r), n.paused() || a.load()
        }), t.on("error", _h[e](e, i))
      }
    },
    Th = {
      AUDIO: function (e, t) {
        var i, n, r = t.vhs,
          a = t.sourceType,
          s = t.segmentLoaders[e],
          o = t.requestOptions,
          u = t.master.mediaGroups,
          l = t.mediaTypes[e],
          c = l.groups,
          d = l.tracks,
          h = l.logger_,
          p = t.masterPlaylistLoader,
          f = gc(p.master);
        for (var m in u[e] && 0 !== Object.keys(u[e]).length || (u[e] = {
            main: {
              default: {
                default: !0
              }
            }
          }), u[e])
          for (var g in c[m] || (c[m] = []), u[e][m]) {
            var v = u[e][m][g],
              y = void 0;
            if (y = f ? (h("AUDIO group '" + m + "' label '" + g + "' is a master playlist"), v.isMasterPlaylist = !0, null) : "vhs-json" === a && v.playlists ? new yd(v.playlists[0], r, o) : v.resolvedUri ? new yd(v.resolvedUri, r, o) : v.playlists && "dash" === a ? new Cd(v.playlists[0], r, o, p) : null, v = ya.mergeOptions({
                id: g,
                playlistLoader: y
              }, v), bh[e](e, v.playlistLoader, t), c[m].push(v), "undefined" == typeof d[g]) {
              var _ = new ya.AudioTrack({
                id: g,
                kind: (i = v, n = void 0, n = i.default ? "main" : "alternative", i.characteristics && 0 <= i.characteristics.indexOf("public.accessibility.describes-video") && (n = "main-desc"), n),
                enabled: !1,
                language: v.language,
                default: v.default,
                label: g
              });
              d[g] = _
            }
          }
        s.on("error", _h[e](e, t))
      },
      SUBTITLES: function (e, t) {
        var i = t.tech,
          n = t.vhs,
          r = t.sourceType,
          a = t.segmentLoaders[e],
          s = t.requestOptions,
          o = t.master.mediaGroups,
          u = t.mediaTypes[e],
          l = u.groups,
          c = u.tracks,
          d = t.masterPlaylistLoader;
        for (var h in o[e])
          for (var p in l[h] || (l[h] = []), o[e][h])
            if (!o[e][h][p].forced) {
              var f = o[e][h][p],
                m = void 0;
              if ("hls" === r) m = new yd(f.resolvedUri, n, s);
              else if ("dash" === r) {
                if (!f.playlists.filter(function (e) {
                    return e.excludeUntil !== 1 / 0
                  }).length) return;
                m = new Cd(f.playlists[0], n, s, d)
              } else "vhs-json" === r && (m = new yd(f.playlists ? f.playlists[0] : f.resolvedUri, n, s));
              if (f = ya.mergeOptions({
                  id: p,
                  playlistLoader: m
                }, f), bh[e](e, f.playlistLoader, t), l[h].push(f), "undefined" == typeof c[p]) {
                var g = i.addRemoteTextTrack({
                  id: p,
                  kind: "subtitles",
                  default: f.default && f.autoselect,
                  language: f.language,
                  label: p
                }, !1).track;
                c[p] = g
              }
            } a.on("error", _h[e](e, t))
      },
      "CLOSED-CAPTIONS": function (e, t) {
        var i = t.tech,
          n = t.master.mediaGroups,
          r = t.mediaTypes[e],
          a = r.groups,
          s = r.tracks;
        for (var o in n[e])
          for (var u in a[o] || (a[o] = []), n[e][o]) {
            var l = n[e][o][u];
            if (l.instreamId.match(/CC\d/) && (a[o].push(ya.mergeOptions({
                id: u
              }, l)), "undefined" == typeof s[u])) {
              var c = i.addRemoteTextTrack({
                id: l.instreamId,
                kind: "captions",
                default: l.default && l.autoselect,
                language: l.language,
                label: u
              }, !1).track;
              s[u] = c
            }
          }
      }
    },
    Sh = {
      AUDIO: function (i, n) {
        return function () {
          var e = n.mediaTypes[i].tracks;
          for (var t in e)
            if (e[t].enabled) return e[t];
          return null
        }
      },
      SUBTITLES: function (i, n) {
        return function () {
          var e = n.mediaTypes[i].tracks;
          for (var t in e)
            if ("showing" === e[t].mode || "hidden" === e[t].mode) return e[t];
          return null
        }
      }
    },
    Eh = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred"],
    kh = function (g) {
      function e(e) {
        var t;
        t = g.call(this) || this;
        var i = e.src,
          n = e.handleManifestRedirects,
          r = e.withCredentials,
          a = e.tech,
          s = e.bandwidth,
          o = e.externVhs,
          u = e.useCueTags,
          l = e.blacklistDuration,
          c = e.enableLowInitialPlaylist,
          d = e.sourceType,
          h = e.cacheEncryptionKeys,
          p = e.handlePartialData,
          f = e.experimentalBufferBasedABR;
        if (!i) throw new Error("A non-empty playlist URL or JSON manifest string is required");
        eh = o, t.experimentalBufferBasedABR = Boolean(f), t.withCredentials = r, t.tech_ = a, t.vhs_ = a.vhs, t.sourceType_ = d, t.useCueTags_ = u, t.blacklistDuration = l, t.enableLowInitialPlaylist = c, t.useCueTags_ && (t.cueTagsTrack_ = t.tech_.addTextTrack("metadata", "ad-cues"), t.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), t.requestOptions_ = {
          withCredentials: r,
          handleManifestRedirects: n,
          timeout: null
        }, t.on("error", t.pauseLoading), t.mediaTypes_ = function () {
          var t = {};
          return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function (e) {
            t[e] = {
              groups: {},
              tracks: {},
              activePlaylistLoader: null,
              activeGroup: Bd,
              activeTrack: Bd,
              getActiveGroup: Bd,
              onGroupChanged: Bd,
              onTrackChanged: Bd,
              lastTrack_: null,
              logger_: Hl("MediaGroups[" + e + "]")
            }
          }), t
        }(), t.mediaSource = new Ia.MediaSource, t.handleDurationChange_ = t.handleDurationChange_.bind(Ta(t)), t.handleSourceOpen_ = t.handleSourceOpen_.bind(Ta(t)), t.handleSourceEnded_ = t.handleSourceEnded_.bind(Ta(t)), t.mediaSource.addEventListener("durationchange", t.handleDurationChange_), t.mediaSource.addEventListener("sourceopen", t.handleSourceOpen_), t.mediaSource.addEventListener("sourceended", t.handleSourceEnded_), t.seekable_ = ya.createTimeRanges(), t.hasPlayed_ = !1, t.syncController_ = new gh(e), t.segmentMetadataTrack_ = a.addRemoteTextTrack({
          kind: "metadata",
          label: "segment-metadata"
        }, !1).track, t.decrypter_ = new yh, t.sourceUpdater_ = new hh(t.mediaSource), t.inbandTextTracks_ = {}, t.timelineChangeController_ = new vh;
        var m = {
          vhs: t.vhs_,
          parse708captions: e.parse708captions,
          mediaSource: t.mediaSource,
          currentTime: t.tech_.currentTime.bind(t.tech_),
          seekable: function () {
            return t.seekable()
          },
          seeking: function () {
            return t.tech_.seeking()
          },
          duration: function () {
            return t.duration()
          },
          hasPlayed: function () {
            return t.hasPlayed_
          },
          goalBufferLength: function () {
            return t.goalBufferLength()
          },
          bandwidth: s,
          syncController: t.syncController_,
          decrypter: t.decrypter_,
          sourceType: t.sourceType_,
          inbandTextTracks: t.inbandTextTracks_,
          cacheEncryptionKeys: h,
          handlePartialData: p,
          sourceUpdater: t.sourceUpdater_,
          timelineChangeController: t.timelineChangeController_
        };
        return t.masterPlaylistLoader_ = "dash" === t.sourceType_ ? new Cd(i, t.vhs_, t.requestOptions_) : new yd(i, t.vhs_, t.requestOptions_), t.setupMasterPlaylistLoaderListeners_(), t.mainSegmentLoader_ = new Ud(ya.mergeOptions(m, {
          segmentMetadataTrack: t.segmentMetadataTrack_,
          loaderType: "main"
        }), e), t.audioSegmentLoader_ = new Ud(ya.mergeOptions(m, {
          loaderType: "audio"
        }), e), t.subtitleSegmentLoader_ = new fh(ya.mergeOptions(m, {
          loaderType: "vtt",
          featuresNativeTextTracks: t.tech_.featuresNativeTextTracks
        }), e), t.setupSegmentLoaderListeners_(), t.experimentalBufferBasedABR && (t.masterPlaylistLoader_.one("loadedplaylist", function () {
          return t.startABRTimer_()
        }), t.tech_.on("pause", function () {
          return t.stopABRTimer_()
        }), t.tech_.on("play", function () {
          return t.startABRTimer_()
        })), Eh.forEach(function (e) {
          t[e + "_"] = function (e) {
            return this.audioSegmentLoader_[e] + this.mainSegmentLoader_[e]
          }.bind(Ta(t), e)
        }), t.logger_ = Hl("MPC"), t.triggeredFmp4Usage = !1, "none" === t.tech_.preload() ? (t.loadOnPlay_ = function () {
          t.loadOnPlay_ = null, t.masterPlaylistLoader_.load()
        }, t.tech_.one("play", t.loadOnPlay_)) : t.masterPlaylistLoader_.load(), t
      }
      ka(e, g);
      var t = e.prototype;
      return t.checkABR_ = function () {
        var e = this.selectPlaylist();
        this.shouldSwitchToMedia_(e) && this.switchMedia_(e, "abr")
      }, t.switchMedia_ = function (e, t, i) {
        var n = this.media(),
          r = n && (n.id || n.uri),
          a = e.id || e.uri;
        r && r !== a && (this.logger_("switch media " + r + " -> " + a + " from " + t), this.tech_.trigger({
          type: "usage",
          name: "vhs-rendition-change-" + t
        })), this.masterPlaylistLoader_.media(e, i)
      }, t.startABRTimer_ = function () {
        var e = this;
        this.stopABRTimer_(), this.abrTimer_ = Ia.setInterval(function () {
          return e.checkABR_()
        }, 250)
      }, t.stopABRTimer_ = function () {
        this.tech_.scrubbing && this.tech_.scrubbing() || (Ia.clearInterval(this.abrTimer_), this.abrTimer_ = null)
      }, t.getAudioTrackPlaylists_ = function () {
        var e = this.master();
        if (!e || !e.mediaGroups || !e.mediaGroups.AUDIO) return e && e.playlists || [];
        var t, i = e.mediaGroups.AUDIO,
          n = Object.keys(i);
        if (Object.keys(this.mediaTypes_.AUDIO.groups).length) t = this.mediaTypes_.AUDIO.activeTrack();
        else {
          var r = i.main || n.length && i[n[0]];
          for (var a in r)
            if (r[a].default) {
              t = {
                label: a
              };
              break
            }
        }
        if (!t) return [];
        var s = [];
        for (var o in i)
          if (i[o][t.label]) {
            var u = i[o][t.label];
            u.playlists ? s.push.apply(s, u.playlists) : s.push(u)
          } return s
      }, t.setupMasterPlaylistLoaderListeners_ = function () {
        var i = this;
        this.masterPlaylistLoader_.on("loadedmetadata", function () {
          var e = i.masterPlaylistLoader_.media(),
            t = 1.5 * e.targetDuration * 1e3;
          pc(i.masterPlaylistLoader_.master, i.masterPlaylistLoader_.media()) ? i.requestOptions_.timeout = 0 : i.requestOptions_.timeout = t, e.endList && "none" !== i.tech_.preload() && (i.mainSegmentLoader_.playlist(e, i.requestOptions_), i.mainSegmentLoader_.load()), $d({
            sourceType: i.sourceType_,
            segmentLoaders: {
              AUDIO: i.audioSegmentLoader_,
              SUBTITLES: i.subtitleSegmentLoader_,
              main: i.mainSegmentLoader_
            },
            tech: i.tech_,
            requestOptions: i.requestOptions_,
            masterPlaylistLoader: i.masterPlaylistLoader_,
            vhs: i.vhs_,
            master: i.master(),
            mediaTypes: i.mediaTypes_,
            blacklistCurrentPlaylist: i.blacklistCurrentPlaylist.bind(i)
          }), i.triggerPresenceUsage_(i.master(), e), i.setupFirstPlay(), !i.mediaTypes_.AUDIO.activePlaylistLoader || i.mediaTypes_.AUDIO.activePlaylistLoader.media() ? i.trigger("selectedinitialmedia") : i.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", function () {
            i.trigger("selectedinitialmedia")
          })
        }), this.masterPlaylistLoader_.on("loadedplaylist", function () {
          i.loadOnPlay_ && i.tech_.off("play", i.loadOnPlay_);
          var e = i.masterPlaylistLoader_.media();
          if (!e) {
            var t;
            if (i.excludeUnsupportedVariants_(), i.enableLowInitialPlaylist && (t = i.selectInitialPlaylist()), !(t = t || i.selectPlaylist()) || !i.shouldSwitchToMedia_(t)) return;
            if (i.initialMedia_ = t, i.switchMedia_(i.initialMedia_, "initial"), !("vhs-json" === i.sourceType_ && i.initialMedia_.segments)) return;
            e = i.initialMedia_
          }
          i.handleUpdatedMediaPlaylist(e)
        }), this.masterPlaylistLoader_.on("error", function () {
          i.blacklistCurrentPlaylist(i.masterPlaylistLoader_.error)
        }), this.masterPlaylistLoader_.on("mediachanging", function () {
          i.mainSegmentLoader_.abort(), i.mainSegmentLoader_.pause()
        }), this.masterPlaylistLoader_.on("mediachange", function () {
          var e = i.masterPlaylistLoader_.media(),
            t = 1.5 * e.targetDuration * 1e3;
          pc(i.masterPlaylistLoader_.master, i.masterPlaylistLoader_.media()) ? i.requestOptions_.timeout = 0 : i.requestOptions_.timeout = t, i.mainSegmentLoader_.playlist(e, i.requestOptions_), i.mainSegmentLoader_.load(), i.tech_.trigger({
            type: "mediachange",
            bubbles: !0
          })
        }), this.masterPlaylistLoader_.on("playlistunchanged", function () {
          var e = i.masterPlaylistLoader_.media();
          "playlist-unchanged" !== e.lastExcludeReason_ && i.stuckAtPlaylistEnd_(e) && (i.blacklistCurrentPlaylist({
            message: "Playlist no longer updating.",
            reason: "playlist-unchanged"
          }), i.tech_.trigger("playliststuck"))
        }), this.masterPlaylistLoader_.on("renditiondisabled", function () {
          i.tech_.trigger({
            type: "usage",
            name: "vhs-rendition-disabled"
          }), i.tech_.trigger({
            type: "usage",
            name: "hls-rendition-disabled"
          })
        }), this.masterPlaylistLoader_.on("renditionenabled", function () {
          i.tech_.trigger({
            type: "usage",
            name: "vhs-rendition-enabled"
          }), i.tech_.trigger({
            type: "usage",
            name: "hls-rendition-enabled"
          })
        })
      }, t.handleUpdatedMediaPlaylist = function (e) {
        this.useCueTags_ && this.updateAdCues_(e), this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.updateDuration(!e.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load())
      }, t.triggerPresenceUsage_ = function (e, t) {
        var i = e.mediaGroups || {},
          n = !0,
          r = Object.keys(i.AUDIO);
        for (var a in i.AUDIO)
          for (var s in i.AUDIO[a]) {
            i.AUDIO[a][s].uri || (n = !1)
          }
        n && (this.tech_.trigger({
          type: "usage",
          name: "vhs-demuxed"
        }), this.tech_.trigger({
          type: "usage",
          name: "hls-demuxed"
        })), Object.keys(i.SUBTITLES).length && (this.tech_.trigger({
          type: "usage",
          name: "vhs-webvtt"
        }), this.tech_.trigger({
          type: "usage",
          name: "hls-webvtt"
        })), eh.Playlist.isAes(t) && (this.tech_.trigger({
          type: "usage",
          name: "vhs-aes"
        }), this.tech_.trigger({
          type: "usage",
          name: "hls-aes"
        })), r.length && 1 < Object.keys(i.AUDIO[r[0]]).length && (this.tech_.trigger({
          type: "usage",
          name: "vhs-alternate-audio"
        }), this.tech_.trigger({
          type: "usage",
          name: "hls-alternate-audio"
        })), this.useCueTags_ && (this.tech_.trigger({
          type: "usage",
          name: "vhs-playlist-cue-tags"
        }), this.tech_.trigger({
          type: "usage",
          name: "hls-playlist-cue-tags"
        }))
      }, t.shouldSwitchToMedia_ = function (e) {
        var t = this.masterPlaylistLoader_.media(),
          i = this.tech_.buffered();
        return function (e) {
          var t = e.currentPlaylist,
            i = e.nextPlaylist,
            n = e.forwardBuffer,
            r = e.bufferLowWaterLine,
            a = e.bufferHighWaterLine,
            s = e.duration,
            o = e.experimentalBufferBasedABR,
            u = e.log;
          if (!i) return ya.log.warn("We received no playlist to switch to. Please check your stream."), !1;
          var l = "allowing switch " + (t && t.id || "null") + " -> " + i.id;
          if (!t || !t.endList) return u(l + " as current playlist " + (t ? "is live" : "is not set")), !0;
          if (i.id === t.id) return !1;
          var c = o ? Id.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : Id.MAX_BUFFER_LOW_WATER_LINE;
          if (s < c) return u(l + " as duration < max low water line (" + s + " < " + c + ")"), !0;
          var d = i.attributes.BANDWIDTH,
            h = t.attributes.BANDWIDTH;
          if (d < h && (!o || n < a)) {
            var p = l + " as next bandwidth < current bandwidth (" + d + " < " + h + ")";
            return o && (p += " and forwardBuffer < bufferHighWaterLine (" + n + " < " + a + ")"), u(p), !0
          }
          if ((!o || h < d) && r <= n) {
            var f = l + " as forwardBuffer >= bufferLowWaterLine (" + n + " >= " + r + ")";
            return o && (f += " and next bandwidth > current bandwidth (" + d + " > " + h + ")"), u(f), !0
          }
          return u("not " + l + " as no switching criteria met"), !1
        }({
          currentPlaylist: t,
          nextPlaylist: e,
          forwardBuffer: i.length ? i.end(i.length - 1) - this.tech_.currentTime() : 0,
          bufferLowWaterLine: this.bufferLowWaterLine(),
          bufferHighWaterLine: this.bufferHighWaterLine(),
          duration: this.duration(),
          experimentalBufferBasedABR: this.experimentalBufferBasedABR,
          log: this.logger_
        })
      }, t.setupSegmentLoaderListeners_ = function () {
        var t = this;
        this.experimentalBufferBasedABR || (this.mainSegmentLoader_.on("bandwidthupdate", function () {
          var e = t.selectPlaylist();
          t.shouldSwitchToMedia_(e) && t.switchMedia_(e, "bandwidthupdate"), t.tech_.trigger("bandwidthupdate")
        }), this.mainSegmentLoader_.on("progress", function () {
          t.trigger("progress")
        })), this.mainSegmentLoader_.on("error", function () {
          t.blacklistCurrentPlaylist(t.mainSegmentLoader_.error())
        }), this.mainSegmentLoader_.on("appenderror", function () {
          t.error = t.mainSegmentLoader_.error_, t.trigger("error")
        }), this.mainSegmentLoader_.on("syncinfoupdate", function () {
          t.onSyncInfoUpdate_()
        }), this.mainSegmentLoader_.on("timestampoffset", function () {
          t.tech_.trigger({
            type: "usage",
            name: "vhs-timestamp-offset"
          }), t.tech_.trigger({
            type: "usage",
            name: "hls-timestamp-offset"
          })
        }), this.audioSegmentLoader_.on("syncinfoupdate", function () {
          t.onSyncInfoUpdate_()
        }), this.audioSegmentLoader_.on("appenderror", function () {
          t.error = t.audioSegmentLoader_.error_, t.trigger("error")
        }), this.mainSegmentLoader_.on("ended", function () {
          t.logger_("main segment loader ended"), t.onEndOfStream()
        }), this.mainSegmentLoader_.on("earlyabort", function (e) {
          t.experimentalBufferBasedABR || (t.delegateLoaders_("all", ["abort"]), t.blacklistCurrentPlaylist({
            message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
          }, 120))
        });

        function e() {
          if (!t.sourceUpdater_.hasCreatedSourceBuffers()) return t.tryToCreateSourceBuffers_();
          var e = t.getCodecsOrExclude_();
          e && t.sourceUpdater_.addOrChangeSourceBuffers(e)
        }
        this.mainSegmentLoader_.on("trackinfo", e), this.audioSegmentLoader_.on("trackinfo", e), this.mainSegmentLoader_.on("fmp4", function () {
          t.triggeredFmp4Usage || (t.tech_.trigger({
            type: "usage",
            name: "vhs-fmp4"
          }), t.tech_.trigger({
            type: "usage",
            name: "hls-fmp4"
          }), t.triggeredFmp4Usage = !0)
        }), this.audioSegmentLoader_.on("fmp4", function () {
          t.triggeredFmp4Usage || (t.tech_.trigger({
            type: "usage",
            name: "vhs-fmp4"
          }), t.tech_.trigger({
            type: "usage",
            name: "hls-fmp4"
          }), t.triggeredFmp4Usage = !0)
        }), this.audioSegmentLoader_.on("ended", function () {
          t.logger_("audioSegmentLoader ended"), t.onEndOfStream()
        })
      }, t.mediaSecondsLoaded_ = function () {
        return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded)
      }, t.load = function () {
        this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load()
      }, t.smoothQualityChange_ = function (e) {
        void 0 === e && (e = this.selectPlaylist()), e !== this.masterPlaylistLoader_.media() && (this.switchMedia_(e, "smooth-quality"), this.mainSegmentLoader_.resetLoader())
      }, t.fastQualityChange_ = function (e) {
        var t = this;
        void 0 === e && (e = this.selectPlaylist()), e !== this.masterPlaylistLoader_.media() ? (this.switchMedia_(e, "fast-quality"), this.mainSegmentLoader_.resetEverything(function () {
          ya.browser.IE_VERSION || ya.browser.IS_EDGE ? t.tech_.setCurrentTime(t.tech_.currentTime() + .04) : t.tech_.setCurrentTime(t.tech_.currentTime())
        })) : this.logger_("skipping fastQualityChange because new media is same as old")
      }, t.play = function () {
        if (!this.setupFirstPlay()) {
          this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
          var e = this.tech_.seekable();
          return this.tech_.duration() === 1 / 0 && this.tech_.currentTime() < e.start(0) ? this.tech_.setCurrentTime(e.end(e.length - 1)) : void 0
        }
      }, t.setupFirstPlay = function () {
        var e = this,
          t = this.masterPlaylistLoader_.media();
        if (!t || this.tech_.paused() || this.hasPlayed_) return !1;
        if (!t.endList) {
          var i = this.seekable();
          if (!i.length) return !1;
          if (ya.browser.IE_VERSION && 0 === this.tech_.readyState()) return this.tech_.one("loadedmetadata", function () {
            e.trigger("firstplay"), e.tech_.setCurrentTime(i.end(0)), e.hasPlayed_ = !0
          }), !1;
          this.trigger("firstplay"), this.tech_.setCurrentTime(i.end(0))
        }
        return this.hasPlayed_ = !0, this.load(), !0
      }, t.handleSourceOpen_ = function () {
        if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
          var e = this.tech_.play();
          "undefined" != typeof e && "function" == typeof e.then && e.then(null, function (e) {})
        }
        this.trigger("sourceopen")
      }, t.handleSourceEnded_ = function () {
        if (this.inbandTextTracks_.metadataTrack_) {
          var e = this.inbandTextTracks_.metadataTrack_.cues;
          if (e && e.length) {
            var t = this.duration();
            e[e.length - 1].endTime = isNaN(t) || Math.abs(t) === 1 / 0 ? Number.MAX_VALUE : t
          }
        }
      }, t.handleDurationChange_ = function () {
        this.tech_.trigger("durationchange")
      }, t.onEndOfStream = function () {
        var e = this.mainSegmentLoader_.ended_;
        this.mediaTypes_.AUDIO.activePlaylistLoader && (e = !this.mainSegmentLoader_.currentMediaInfo_ || this.mainSegmentLoader_.currentMediaInfo_.hasVideo ? e && this.audioSegmentLoader_.ended_ : this.audioSegmentLoader_.ended_), e && (this.stopABRTimer_(), this.sourceUpdater_.endOfStream())
      }, t.stuckAtPlaylistEnd_ = function (e) {
        if (!this.seekable().length) return !1;
        var t = this.syncController_.getExpiredTime(e, this.duration());
        if (null === t) return !1;
        var i = eh.Playlist.playlistEnd(e, t),
          n = this.tech_.currentTime(),
          r = this.tech_.buffered();
        if (!r.length) return i - n <= .1;
        var a = r.end(r.length - 1);
        return a - n <= .1 && i - a <= .1
      }, t.blacklistCurrentPlaylist = function (e, t) {
        void 0 === e && (e = {});
        var i = e.playlist || this.masterPlaylistLoader_.media();
        if (t = t || e.blacklistDuration || this.blacklistDuration, !i) return this.error = e, void("open" !== this.mediaSource.readyState ? this.trigger("error") : this.sourceUpdater_.endOfStream("network"));
        var n = this.masterPlaylistLoader_.master.playlists,
          r = n.filter(dc),
          a = 1 === r.length && r[0] === i;
        if (1 === n.length && t !== 1 / 0) return ya.log.warn("Problem encountered with playlist " + i.id + ". Trying again since it is the only playlist."), this.tech_.trigger("retryplaylist"), this.masterPlaylistLoader_.load(a);
        if (a) {
          var s = !1;
          n.forEach(function (e) {
            if (e !== i) {
              var t = e.excludeUntil;
              "undefined" != typeof t && t !== 1 / 0 && (s = !0, delete e.excludeUntil)
            }
          }), s && (ya.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"))
        }
        i.excludeUntil = Date.now() + 1e3 * t, e.reason && (i.lastExcludeReason_ = e.reason), this.tech_.trigger("blacklistplaylist"), this.tech_.trigger({
          type: "usage",
          name: "vhs-rendition-blacklisted"
        }), this.tech_.trigger({
          type: "usage",
          name: "hls-rendition-blacklisted"
        });
        var o = this.selectPlaylist();
        if (!o) return this.error = "Playback cannot continue. No available working or supported playlists.", void this.trigger("error");
        var u = e.internal ? this.logger_ : ya.log.warn,
          l = e.message ? " " + e.message : "";
        u((e.internal ? "Internal problem" : "Problem") + " encountered with playlist " + i.id + "." + l + " Switching to playlist " + o.id + "."), o.attributes.AUDIO !== i.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), o.attributes.SUBTITLES !== i.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
        var c = o.targetDuration / 2 * 1e3 || 5e3,
          d = "number" == typeof o.lastRequest && Date.now() - o.lastRequest <= c;
        return this.switchMedia_(o, "exclude", a || d)
      }, t.pauseLoading = function () {
        this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_()
      }, t.delegateLoaders_ = function (i, e) {
        var n = this,
          r = [],
          t = "all" === i;
        !t && "main" !== i || r.push(this.masterPlaylistLoader_);
        var a = [];
        !t && "audio" !== i || a.push("AUDIO"), !t && "subtitle" !== i || (a.push("CLOSED-CAPTIONS"), a.push("SUBTITLES")), a.forEach(function (e) {
          var t = n.mediaTypes_[e] && n.mediaTypes_[e].activePlaylistLoader;
          t && r.push(t)
        }), ["main", "audio", "subtitle"].forEach(function (e) {
          var t = n[e + "SegmentLoader_"];
          !t || i !== e && "all" !== i || r.push(t)
        }), r.forEach(function (t) {
          return e.forEach(function (e) {
            "function" == typeof t[e] && t[e]()
          })
        })
      }, t.setCurrentTime = function (e) {
        var t = ec(this.tech_.buffered(), e);
        return this.masterPlaylistLoader_ && this.masterPlaylistLoader_.media() && this.masterPlaylistLoader_.media().segments ? t && t.length ? e : (this.mainSegmentLoader_.resetEverything(), this.mainSegmentLoader_.abort(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.resetEverything(), this.audioSegmentLoader_.abort()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.resetEverything(), this.subtitleSegmentLoader_.abort()), void this.load()) : 0
      }, t.duration = function () {
        if (!this.masterPlaylistLoader_) return 0;
        var e = this.masterPlaylistLoader_.media();
        return e ? e.endList ? this.mediaSource ? this.mediaSource.duration : eh.Playlist.duration(e) : 1 / 0 : 0
      }, t.seekable = function () {
        return this.seekable_
      }, t.onSyncInfoUpdate_ = function () {
        var e;
        if (this.masterPlaylistLoader_) {
          var t = this.masterPlaylistLoader_.media();
          if (t) {
            var i = this.syncController_.getExpiredTime(t, this.duration());
            if (null !== i) {
              var n = this.masterPlaylistLoader_.master,
                r = eh.Playlist.seekable(t, i, eh.Playlist.liveEdgeDelay(n, t));
              if (0 !== r.length) {
                if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
                  if (t = this.mediaTypes_.AUDIO.activePlaylistLoader.media(), null === (i = this.syncController_.getExpiredTime(t, this.duration()))) return;
                  if (0 === (e = eh.Playlist.seekable(t, i, eh.Playlist.liveEdgeDelay(n, t))).length) return
                }
                var a, s;
                this.seekable_ && this.seekable_.length && (a = this.seekable_.end(0), s = this.seekable_.start(0)), e ? e.start(0) > r.end(0) || r.start(0) > e.end(0) ? this.seekable_ = r : this.seekable_ = ya.createTimeRanges([
                  [e.start(0) > r.start(0) ? e.start(0) : r.start(0), e.end(0) < r.end(0) ? e.end(0) : r.end(0)]
                ]) : this.seekable_ = r, this.seekable_ && this.seekable_.length && this.seekable_.end(0) === a && this.seekable_.start(0) === s || (this.logger_("seekable updated [" + ic(this.seekable_) + "]"), this.tech_.trigger("seekablechanged"))
              }
            }
          }
        }
      }, t.updateDuration = function (e) {
        if (this.updateDuration_ && (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.updateDuration_ = null), "open" !== this.mediaSource.readyState) return this.updateDuration_ = this.updateDuration.bind(this, e), void this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
        if (e) {
          var t = this.seekable();
          if (!t.length) return;
          (isNaN(this.mediaSource.duration) || this.mediaSource.duration < t.end(t.length - 1)) && this.sourceUpdater_.setDuration(t.end(t.length - 1))
        } else {
          var i = this.tech_.buffered(),
            n = eh.Playlist.duration(this.masterPlaylistLoader_.media());
          0 < i.length && (n = Math.max(n, i.end(i.length - 1))), this.mediaSource.duration !== n && this.sourceUpdater_.setDuration(n)
        }
      }, t.dispose = function () {
        var n = this;
        this.trigger("dispose"), this.decrypter_.terminate(), this.masterPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach(function (e) {
          var t = n.mediaTypes_[e].groups;
          for (var i in t) t[i].forEach(function (e) {
            e.playlistLoader && e.playlistLoader.dispose()
          })
        }), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off()
      }, t.master = function () {
        return this.masterPlaylistLoader_.master
      }, t.media = function () {
        return this.masterPlaylistLoader_.media() || this.initialMedia_
      }, t.areMediaTypesKnown_ = function () {
        var e = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
        return !(!this.mainSegmentLoader_.currentMediaInfo_ || e && !this.audioSegmentLoader_.currentMediaInfo_)
      }, t.getCodecsOrExclude_ = function () {
        var n = this,
          i = {
            main: this.mainSegmentLoader_.currentMediaInfo_ || {},
            audio: this.audioSegmentLoader_.currentMediaInfo_ || {}
          };
        i.video = i.main;
        var e = $c(this.master(), this.media()),
          r = {},
          t = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
        if (i.main.hasVideo && (r.video = e.video || i.main.videoCodec || "avc1.4d400d"), i.main.isMuxed && (r.video += "," + (e.audio || i.main.audioCodec || ts)), (i.main.hasAudio && !i.main.isMuxed || i.audio.hasAudio || t) && (r.audio = e.audio || i.main.audioCodec || i.audio.audioCodec || ts, i.audio.isFmp4 = i.main.hasAudio && !i.main.isMuxed ? i.main.isFmp4 : i.audio.isFmp4), r.audio || r.video) {
          var a, s = {};
          if (["video", "audio"].forEach(function (e) {
              if (r.hasOwnProperty(e) && ! function (e, t) {
                  return e ? za(t) : Ga(t)
                }(i[e].isFmp4, r[e])) {
                var t = i[e].isFmp4 ? "browser" : "muxer";
                s[t] = s[t] || [], s[t].push(r[e]), "audio" === e && (a = t)
              }
            }), t && a && this.media().attributes.AUDIO) {
            var o = this.media().attributes.AUDIO;
            this.master().playlists.forEach(function (e) {
              (e.attributes && e.attributes.AUDIO) === o && e !== n.media() && (e.excludeUntil = 1 / 0)
            }), this.logger_("excluding audio group " + o + " as " + a + ' does not support codec(s): "' + r.audio + '"')
          }
          if (!Object.keys(s).length) {
            if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
              var u = [];
              if (["video", "audio"].forEach(function (e) {
                  var t = (Va(n.sourceUpdater_.codecs[e] || "")[0] || {}).type,
                    i = (Va(r[e] || "")[0] || {}).type;
                  t && i && t.toLowerCase() !== i.toLowerCase() && u.push('"' + n.sourceUpdater_.codecs[e] + '" -> "' + r[e] + '"')
                }), u.length) return void this.blacklistCurrentPlaylist({
                playlist: this.media(),
                message: "Codec switching not supported: " + u.join(", ") + ".",
                blacklistDuration: 1 / 0,
                internal: !0
              })
            }
            return r
          }
          var l = Object.keys(s).reduce(function (e, t) {
            return e && (e += ", "), e += t + ' does not support codec(s): "' + s[t].join(",") + '"'
          }, "") + ".";
          this.blacklistCurrentPlaylist({
            playlist: this.media(),
            internal: !0,
            message: l,
            blacklistDuration: 1 / 0
          })
        } else this.blacklistCurrentPlaylist({
          playlist: this.media(),
          message: "Could not determine codecs for playlist.",
          blacklistDuration: 1 / 0
        })
      }, t.tryToCreateSourceBuffers_ = function () {
        if ("open" === this.mediaSource.readyState && !this.sourceUpdater_.hasCreatedSourceBuffers() && this.areMediaTypesKnown_()) {
          var e = this.getCodecsOrExclude_();
          if (e) {
            this.sourceUpdater_.createSourceBuffers(e);
            var t = [e.video, e.audio].filter(Boolean).join(",");
            this.excludeIncompatibleVariants_(t)
          }
        }
      }, t.excludeUnsupportedVariants_ = function () {
        var r = this,
          a = this.master().playlists,
          s = [];
        Object.keys(a).forEach(function (e) {
          var t = a[e];
          if (-1 === s.indexOf(t.id)) {
            s.push(t.id);
            var i = $c(r.master, t),
              n = [];
            !i.audio || Ga(i.audio) || za(i.audio) || n.push("audio codec " + i.audio), !i.video || Ga(i.video) || za(i.video) || n.push("video codec " + i.video), i.text && "stpp.ttml.im1t" === i.text && n.push("text codec " + i.text), n.length && (t.excludeUntil = 1 / 0, r.logger_("excluding " + t.id + " for unsupported: " + n.join(", ")))
          }
        })
      }, t.excludeIncompatibleVariants_ = function (e) {
        var o = this,
          u = [],
          l = this.master().playlists,
          t = Yc(Va(e)),
          c = Qc(t),
          d = t.video && Va(t.video)[0] || null,
          h = t.audio && Va(t.audio)[0] || null;
        Object.keys(l).forEach(function (e) {
          var t = l[e];
          if (-1 === u.indexOf(t.id) && t.excludeUntil !== 1 / 0) {
            u.push(t.id);
            var i = [],
              n = $c(o.masterPlaylistLoader_.master, t),
              r = Qc(n);
            if (n.audio || n.video) {
              if (r !== c && i.push('codec count "' + r + '" !== "' + c + '"'), !o.sourceUpdater_.canChangeType()) {
                var a = n.video && Va(n.video)[0] || null,
                  s = n.audio && Va(n.audio)[0] || null;
                a && d && a.type.toLowerCase() !== d.type.toLowerCase() && i.push('video codec "' + a.type + '" !== "' + d.type + '"'), s && h && s.type.toLowerCase() !== h.type.toLowerCase() && i.push('audio codec "' + s.type + '" !== "' + h.type + '"')
              }
              i.length && (t.excludeUntil = 1 / 0, o.logger_("blacklisting " + t.id + ": " + i.join(" && ")))
            }
          }
        })
      }, t.updateAdCues_ = function (e) {
        var t = 0,
          i = this.seekable();
        i.length && (t = i.start(0)),
          function (e, t, i) {
            if (void 0 === i && (i = 0), e.segments)
              for (var n, r = i, a = 0; a < e.segments.length; a++) {
                var s = e.segments[a];
                if (n = n || Xd(t, r + s.duration / 2)) {
                  if ("cueIn" in s) {
                    n.endTime = r, n.adEndTime = r, r += s.duration, n = null;
                    continue
                  }
                  if (r < n.endTime) {
                    r += s.duration;
                    continue
                  }
                  n.endTime += s.duration
                } else if ("cueOut" in s && ((n = new Ia.VTTCue(r, r + s.duration, s.cueOut)).adStartTime = r, n.adEndTime = r + parseFloat(s.cueOut), t.addCue(n)), "cueOutCont" in s) {
                  var o = s.cueOutCont.split("/").map(parseFloat),
                    u = o[0],
                    l = o[1];
                  (n = new Ia.VTTCue(r, r + s.duration, "")).adStartTime = r - u, n.adEndTime = n.adStartTime + l, t.addCue(n)
                }
                r += s.duration
              }
          }(e, this.cueTagsTrack_, t)
      }, t.goalBufferLength = function () {
        var e = this.tech_.currentTime(),
          t = Id.GOAL_BUFFER_LENGTH,
          i = Id.GOAL_BUFFER_LENGTH_RATE,
          n = Math.max(t, Id.MAX_GOAL_BUFFER_LENGTH);
        return Math.min(t + e * i, n)
      }, t.bufferLowWaterLine = function () {
        var e = this.tech_.currentTime(),
          t = Id.BUFFER_LOW_WATER_LINE,
          i = Id.BUFFER_LOW_WATER_LINE_RATE,
          n = Math.max(t, Id.MAX_BUFFER_LOW_WATER_LINE),
          r = Math.max(t, Id.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
        return Math.min(t + e * i, this.experimentalBufferBasedABR ? r : n)
      }, t.bufferHighWaterLine = function () {
        return Id.BUFFER_HIGH_WATER_LINE
      }, e
    }(ya.EventTarget),
    wh = ["seeking", "seeked", "pause", "playing", "error"],
    Ch = function () {
      function e(e) {
        var t = this;
        this.masterPlaylistController_ = e.masterPlaylistController, this.tech_ = e.tech, this.seekable = e.seekable, this.allowSeeksWithinUnsafeLiveWindow = e.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = e.liveRangeSafeTimeDelta, this.media = e.media, this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.timer_ = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = Hl("PlaybackWatcher"), this.logger_("initialize");

        function i() {
          return t.monitorCurrentTime_()
        }

        function n() {
          return t.monitorCurrentTime_()
        }

        function r() {
          return t.techWaiting_()
        }

        function a() {
          return t.cancelTimer_()
        }

        function s() {
          return t.fixesBadSeeks_()
        }
        var o = this.masterPlaylistController_,
          u = ["main", "subtitle", "audio"],
          l = {};
        u.forEach(function (e) {
          l[e] = {
            reset: function () {
              return t.resetSegmentDownloads_(e)
            },
            updateend: function () {
              return t.checkSegmentDownloads_(e)
            }
          }, o[e + "SegmentLoader_"].on("appendsdone", l[e].updateend), o[e + "SegmentLoader_"].on("playlistupdate", l[e].reset), t.tech_.on(["seeked", "seeking"], l[e].reset)
        }), this.tech_.on("seekablechanged", s), this.tech_.on("waiting", r), this.tech_.on(wh, a), this.tech_.on("canplay", n), this.tech_.one("play", i), this.dispose = function () {
          t.logger_("dispose"), t.tech_.off("seekablechanged", s), t.tech_.off("waiting", r), t.tech_.off(wh, a), t.tech_.off("canplay", n), t.tech_.off("play", i), u.forEach(function (e) {
            o[e + "SegmentLoader_"].off("appendsdone", l[e].updateend), o[e + "SegmentLoader_"].off("playlistupdate", l[e].reset), t.tech_.off(["seeked", "seeking"], l[e].reset)
          }), t.checkCurrentTimeTimeout_ && Ia.clearTimeout(t.checkCurrentTimeTimeout_), t.cancelTimer_()
        }
      }
      var t = e.prototype;
      return t.monitorCurrentTime_ = function () {
        this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && Ia.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = Ia.setTimeout(this.monitorCurrentTime_.bind(this), 250)
      }, t.resetSegmentDownloads_ = function (e) {
        var t = this.masterPlaylistController_[e + "SegmentLoader_"];
        0 < this[e + "StalledDownloads_"] && this.logger_("resetting possible stalled download count for " + e + " loader"), this[e + "StalledDownloads_"] = 0, this[e + "Buffered_"] = t.buffered_()
      }, t.checkSegmentDownloads_ = function (e) {
        var t = this.masterPlaylistController_,
          i = t[e + "SegmentLoader_"],
          n = i.buffered_(),
          r = function (e, t) {
            if (e === t) return !1;
            if (!e && t || !t && e) return !0;
            if (e.length !== t.length) return !0;
            for (var i = 0; i < e.length; i++)
              if (e.start(i) !== t.start(i) || e.end(i) !== t.end(i)) return !0;
            return !1
          }(this[e + "Buffered_"], n);
        this[e + "Buffered_"] = n, r ? this.resetSegmentDownloads_(e) : (this[e + "StalledDownloads_"]++, this.logger_("found #" + this[e + "StalledDownloads_"] + " " + e + " appends that did not increase buffer (possible stalled download)", {
          playlistId: i.playlist_ && i.playlist_.id,
          buffered: nc(n)
        }), this[e + "StalledDownloads_"] < 10 || (this.logger_(e + " loader stalled download exclusion"), this.resetSegmentDownloads_(e), this.tech_.trigger({
          type: "usage",
          name: "vhs-" + e + "-download-exclusion"
        }), "subtitle" !== e && t.blacklistCurrentPlaylist({
          message: "Excessive " + e + " segment downloading detected."
        }, 1 / 0)))
      }, t.checkCurrentTime_ = function () {
        if (this.tech_.seeking() && this.fixesBadSeeks_()) return this.consecutiveUpdates = 0, void(this.lastRecordedTime = this.tech_.currentTime());
        if (!this.tech_.paused() && !this.tech_.seeking()) {
          var e = this.tech_.currentTime(),
            t = this.tech_.buffered();
          if (this.lastRecordedTime === e && (!t.length || e + .1 >= t.end(t.length - 1))) return this.techWaiting_();
          5 <= this.consecutiveUpdates && e === this.lastRecordedTime ? (this.consecutiveUpdates++, this.waiting_()) : e === this.lastRecordedTime ? this.consecutiveUpdates++ : (this.consecutiveUpdates = 0, this.lastRecordedTime = e)
        }
      }, t.cancelTimer_ = function () {
        this.consecutiveUpdates = 0, this.timer_ && (this.logger_("cancelTimer_"), clearTimeout(this.timer_)), this.timer_ = null
      }, t.fixesBadSeeks_ = function () {
        if (!this.tech_.seeking()) return !1;
        var e, t = this.seekable(),
          i = this.tech_.currentTime();
        this.afterSeekableWindow_(t, i, this.media(), this.allowSeeksWithinUnsafeLiveWindow) && (e = t.end(t.length - 1));
        if (this.beforeSeekableWindow_(t, i)) {
          var n = t.start(0);
          e = n + (n === t.end(0) ? 0 : .1)
        }
        if ("undefined" != typeof e) return this.logger_("Trying to seek outside of seekable at time " + i + " with seekable range " + ic(t) + ". Seeking to " + e + "."), this.tech_.setCurrentTime(e), !0;
        var r = this.tech_.buffered();
        return !! function (e) {
          var t = e.buffered,
            i = e.targetDuration,
            n = e.currentTime;
          return !!t.length && (!(t.end(0) - t.start(0) < 2 * i) && (!(n > t.start(0)) && t.start(0) - n < i))
        }({
          buffered: r,
          targetDuration: this.media().targetDuration,
          currentTime: i
        }) && (e = r.start(0) + .1, this.logger_("Buffered region starts (" + r.start(0) + ")  just beyond seek point (" + i + "). Seeking to " + e + "."), this.tech_.setCurrentTime(e), !0)
      }, t.waiting_ = function () {
        if (!this.techWaiting_()) {
          var e = this.tech_.currentTime(),
            t = this.tech_.buffered(),
            i = ec(t, e);
          return i.length && e + 3 <= i.end(0) ? (this.cancelTimer_(), this.tech_.setCurrentTime(e), this.logger_("Stopped at " + e + " while inside a buffered region [" + i.start(0) + " -> " + i.end(0) + "]. Attempting to resume playback by seeking to the current time."), this.tech_.trigger({
            type: "usage",
            name: "vhs-unknown-waiting"
          }), void this.tech_.trigger({
            type: "usage",
            name: "hls-unknown-waiting"
          })) : void 0
        }
      }, t.techWaiting_ = function () {
        var e = this.seekable(),
          t = this.tech_.currentTime();
        if (this.tech_.seeking() && this.fixesBadSeeks_()) return !0;
        if (this.tech_.seeking() || null !== this.timer_) return !0;
        if (this.beforeSeekableWindow_(e, t)) {
          var i = e.end(e.length - 1);
          return this.logger_("Fell out of live window at time " + t + ". Seeking to live point (seekable end) " + i), this.cancelTimer_(), this.tech_.setCurrentTime(i), this.tech_.trigger({
            type: "usage",
            name: "vhs-live-resync"
          }), this.tech_.trigger({
            type: "usage",
            name: "hls-live-resync"
          }), !0
        }
        var n = this.tech_.vhs.masterPlaylistController_.sourceUpdater_,
          r = this.tech_.buffered();
        if (this.videoUnderflow_({
            audioBuffered: n.audioBuffered(),
            videoBuffered: n.videoBuffered(),
            currentTime: t
          })) return this.cancelTimer_(), this.tech_.setCurrentTime(t), this.tech_.trigger({
          type: "usage",
          name: "vhs-video-underflow"
        }), this.tech_.trigger({
          type: "usage",
          name: "hls-video-underflow"
        }), !0;
        var a = tc(r, t);
        if (0 < a.length) {
          var s = a.start(0) - t;
          return this.logger_("Stopped at " + t + ", setting timer for " + s + ", seeking to " + a.start(0)), this.cancelTimer_(), this.timer_ = setTimeout(this.skipTheGap_.bind(this), 1e3 * s, t), !0
        }
        return !1
      }, t.afterSeekableWindow_ = function (e, t, i, n) {
        if (void 0 === n && (n = !1), !e.length) return !1;
        var r = e.end(e.length - 1) + .1;
        return !i.endList && n && (r = e.end(e.length - 1) + 3 * i.targetDuration), r < t
      }, t.beforeSeekableWindow_ = function (e, t) {
        return !!(e.length && 0 < e.start(0) && t < e.start(0) - this.liveRangeSafeTimeDelta)
      }, t.videoUnderflow_ = function (e) {
        var t = e.videoBuffered,
          i = e.audioBuffered,
          n = e.currentTime;
        if (t) {
          var r;
          if (t.length && i.length) {
            var a = ec(t, n - 3),
              s = ec(t, n),
              o = ec(i, n);
            o.length && !s.length && a.length && (r = {
              start: a.end(0),
              end: o.end(0)
            })
          } else {
            tc(t, n).length || (r = this.gapFromVideoUnderflow_(t, n))
          }
          return !!r && (this.logger_("Encountered a gap in video from " + r.start + " to " + r.end + ". Seeking to current time " + n), !0)
        }
      }, t.skipTheGap_ = function (e) {
        var t = this.tech_.buffered(),
          i = this.tech_.currentTime(),
          n = tc(t, i);
        this.cancelTimer_(), 0 !== n.length && i === e && (this.logger_("skipTheGap_:", "currentTime:", i, "scheduled currentTime:", e, "nextRange start:", n.start(0)), this.tech_.setCurrentTime(n.start(0) + _d), this.tech_.trigger({
          type: "usage",
          name: "vhs-gap-skip"
        }), this.tech_.trigger({
          type: "usage",
          name: "hls-gap-skip"
        }))
      }, t.gapFromVideoUnderflow_ = function (e, t) {
        for (var i = function (e) {
            if (e.length < 2) return ya.createTimeRanges();
            for (var t = [], i = 1; i < e.length; i++) {
              var n = e.end(i - 1),
                r = e.start(i);
              t.push([n, r])
            }
            return ya.createTimeRanges(t)
          }(e), n = 0; n < i.length; n++) {
          var r = i.start(n),
            a = i.end(n);
          if (t - r < 4 && 2 < t - r) return {
            start: r,
            end: a
          }
        }
        return null
      }, e
    }(),
    Ih = {
      errorInterval: 30,
      getSource: function (e) {
        return e(this.tech({
          IWillNotUseThisInPlugins: !0
        }).currentSource_ || this.currentSource())
      }
    },
    xh = {
      PlaylistLoader: yd,
      Playlist: Td,
      utils: kd,
      STANDARD_PLAYLIST_SELECTOR: nd,
      INITIAL_PLAYLIST_SELECTOR: function () {
        var t = this,
          e = this.playlists.master.playlists.filter(Td.isEnabled);
        return ed(e, function (e, t) {
          return td(e, t)
        }), e.filter(function (e) {
          return !!$c(t.playlists.master, e).video
        })[0] || null
      },
      lastBandwidthSelector: nd,
      movingAverageBandwidthSelector: function (t) {
        var i = -1;
        if (t < 0 || 1 < t) throw new Error("Moving average bandwidth decay must be between 0 and 1.");
        return function () {
          var e = this.useDevicePixelRatio && Ia.devicePixelRatio || 1;
          return i < 0 && (i = this.systemBandwidth), i = t * this.systemBandwidth + (1 - t) * i, id(this.playlists.master, i, parseInt(Zc(this.tech_.el(), "width"), 10) * e, parseInt(Zc(this.tech_.el(), "height"), 10) * e, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_)
        }
      },
      comparePlaylistBandwidth: td,
      comparePlaylistResolution: function (e, t) {
        var i, n;
        return e.attributes.RESOLUTION && e.attributes.RESOLUTION.width && (i = e.attributes.RESOLUTION.width), i = i || Ia.Number.MAX_VALUE, t.attributes.RESOLUTION && t.attributes.RESOLUTION.width && (n = t.attributes.RESOLUTION.width), i === (n = n || Ia.Number.MAX_VALUE) && e.attributes.BANDWIDTH && t.attributes.BANDWIDTH ? e.attributes.BANDWIDTH - t.attributes.BANDWIDTH : i - n
      },
      xhr: yc()
    };
  Object.keys(Id).forEach(function (t) {
    Object.defineProperty(xh, t, {
      get: function () {
        return ya.log.warn("using Vhs." + t + " is UNSAFE be sure you know what you are doing"), Id[t]
      },
      set: function (e) {
        ya.log.warn("using Vhs." + t + " is UNSAFE be sure you know what you are doing"), "number" != typeof e || e < 0 ? ya.log.warn("value of Vhs." + t + " must be greater than or equal to 0") : Id[t] = e
      }
    })
  });

  function Ah(e, t) {
    for (var i = t.media(), n = -1, r = 0; r < e.length; r++)
      if (e[r].id === i.id) {
        n = r;
        break
      } e.selectedIndex_ = n, e.trigger({
      selectedIndex: n,
      type: "change"
    })
  }
  var Ph = "videojs-vhs";
  xh.canPlaySource = function () {
    return ya.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.")
  };

  function Lh(e) {
    var n = e.player,
      t = e.sourceKeySystems,
      i = e.audioMedia,
      r = e.mainPlaylists;
    if (!n.eme.initializeMediaKeys) return Promise.resolve();
    var a = function (e, i) {
        return e.reduce(function (e, n) {
          if (!n.contentProtection) return e;
          var t = i.reduce(function (e, t) {
            var i = n.contentProtection[t];
            return i && i.pssh && (e[t] = {
              pssh: i.pssh
            }), e
          }, {});
          return Object.keys(t).length && e.push(t), e
        }, [])
      }(i ? r.concat([i]) : r, Object.keys(t)),
      s = [],
      o = [];
    return a.forEach(function (e) {
      o.push(new Promise(function (e, t) {
        n.tech_.one("keysessioncreated", e)
      })), s.push(new Promise(function (t, i) {
        n.eme.initializeMediaKeys({
          keySystems: e
        }, function (e) {
          e ? i(e) : t()
        })
      }))
    }), Promise.race([Promise.all(s), Promise.race(o)])
  }

  function Oh(e) {
    var t = e.player,
      i = function (e, t, i) {
        if (!e) return e;
        var n = {};
        t && t.attributes && t.attributes.CODECS && (n = Yc(Va(t.attributes.CODECS))), i && i.attributes && i.attributes.CODECS && (n.audio = i.attributes.CODECS);
        var r = Wa(n.video),
          a = Wa(n.audio),
          s = {};
        for (var o in e) s[o] = {}, a && (s[o].audioContentType = a), r && (s[o].videoContentType = r), t.contentProtection && t.contentProtection[o] && t.contentProtection[o].pssh && (s[o].pssh = t.contentProtection[o].pssh), "string" == typeof e[o] && (s[o].url = e[o]);
        return ya.mergeOptions(e, s)
      }(e.sourceKeySystems, e.media, e.audioMedia);
    return !!i && (!((t.currentSource().keySystems = i) && !t.eme) || (ya.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1))
  }

  function Dh() {
    if (!Ia.localStorage) return null;
    var e = Ia.localStorage.getItem(Ph);
    if (!e) return null;
    try {
      return JSON.parse(e)
    } catch (e) {
      return null
    }
  }
  xh.supportsNativeHls = function () {
    if (!Ca || !Ca.createElement) return !1;
    var t = Ca.createElement("video");
    if (!ya.getTech("Html5").isSupported()) return !1;
    return ["application/vnd.apple.mpegurl", "audio/mpegurl", "audio/x-mpegurl", "application/x-mpegurl", "video/x-mpegurl", "video/mpegurl", "application/mpegurl"].some(function (e) {
      return /maybe|probably/i.test(t.canPlayType(e))
    })
  }(), xh.supportsNativeDash = !!(Ca && Ca.createElement && ya.getTech("Html5").isSupported()) && /maybe|probably/i.test(Ca.createElement("video").canPlayType("application/dash+xml")), xh.supportsTypeNatively = function (e) {
    return "hls" === e ? xh.supportsNativeHls : "dash" === e && xh.supportsNativeDash
  }, xh.isSupported = function () {
    return ya.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.")
  };
  var Rh = function (a) {
      function e(e, t, i) {
        var n;
        if (n = a.call(this, t, ya.mergeOptions(i.hls, i.vhs)) || this, i.hls && Object.keys(i.hls).length && ya.log.warn("Using hls options is deprecated. Use vhs instead."), n.logger_ = Hl("VhsHandler"), t.options_ && t.options_.playerId) {
          var r = ya(t.options_.playerId);
          r.hasOwnProperty("hls") || Object.defineProperty(r, "hls", {
            get: function () {
              return ya.log.warn("player.hls is deprecated. Use player.tech().vhs instead."), t.trigger({
                type: "usage",
                name: "hls-player-access"
              }), Ta(n)
            },
            configurable: !0
          }), r.hasOwnProperty("vhs") || Object.defineProperty(r, "vhs", {
            get: function () {
              return ya.log.warn("player.vhs is deprecated. Use player.tech().vhs instead."), t.trigger({
                type: "usage",
                name: "vhs-player-access"
              }), Ta(n)
            },
            configurable: !0
          }), r.hasOwnProperty("dash") || Object.defineProperty(r, "dash", {
            get: function () {
              return ya.log.warn("player.dash is deprecated. Use player.tech().vhs instead."), Ta(n)
            },
            configurable: !0
          }), n.player_ = r
        }
        if (n.tech_ = t, n.source_ = e, n.stats = {}, n.ignoreNextSeekingEvent_ = !1, n.setOptions_(), n.options_.overrideNative && t.overrideNativeAudioTracks && t.overrideNativeVideoTracks) t.overrideNativeAudioTracks(!0), t.overrideNativeVideoTracks(!0);
        else if (n.options_.overrideNative && (t.featuresNativeVideoTracks || t.featuresNativeAudioTracks)) throw new Error("Overriding native HLS requires emulated tracks. See https://git.io/vMpjB");
        return n.on(Ca, ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], function (e) {
          var t = Ca.fullscreenElement || Ca.webkitFullscreenElement || Ca.mozFullScreenElement || Ca.msFullscreenElement;
          t && t.contains(n.tech_.el()) && n.masterPlaylistController_.smoothQualityChange_()
        }), n.on(n.tech_, "seeking", function () {
          this.ignoreNextSeekingEvent_ ? this.ignoreNextSeekingEvent_ = !1 : this.setCurrentTime(this.tech_.currentTime())
        }), n.on(n.tech_, "error", function () {
          this.tech_.error() && this.masterPlaylistController_ && this.masterPlaylistController_.pauseLoading()
        }), n.on(n.tech_, "play", n.play), n
      }
      ka(e, a);
      var t = e.prototype;
      return t.setOptions_ = function () {
        var t = this;
        if (this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.handleManifestRedirects = !1 !== this.options_.handleManifestRedirects, this.options_.limitRenditionByPlayerDimensions = !1 !== this.options_.limitRenditionByPlayerDimensions, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.smoothQualityChange = this.options_.smoothQualityChange || !1, this.options_.useBandwidthFromLocalStorage = "undefined" != typeof this.source_.useBandwidthFromLocalStorage ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, this.options_.handlePartialData = this.options_.handlePartialData || !1, "number" != typeof this.options_.blacklistDuration && (this.options_.blacklistDuration = 300), "number" != typeof this.options_.bandwidth && this.options_.useBandwidthFromLocalStorage) {
          var e = Dh();
          e && e.bandwidth && (this.options_.bandwidth = e.bandwidth, this.tech_.trigger({
            type: "usage",
            name: "vhs-bandwidth-from-local-storage"
          }), this.tech_.trigger({
            type: "usage",
            name: "hls-bandwidth-from-local-storage"
          })), e && e.throughput && (this.options_.throughput = e.throughput, this.tech_.trigger({
            type: "usage",
            name: "vhs-throughput-from-local-storage"
          }), this.tech_.trigger({
            type: "usage",
            name: "hls-throughput-from-local-storage"
          }))
        }
        "number" != typeof this.options_.bandwidth && (this.options_.bandwidth = Id.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Id.INITIAL_BANDWIDTH, ["withCredentials", "useDevicePixelRatio", "limitRenditionByPlayerDimensions", "bandwidth", "smoothQualityChange", "customTagParsers", "customTagMappers", "handleManifestRedirects", "cacheEncryptionKeys", "handlePartialData", "playlistSelector", "initialPlaylistSelector", "experimentalBufferBasedABR", "liveRangeSafeTimeDelta", "experimentalLLHLS"].forEach(function (e) {
          "undefined" != typeof t.source_[e] && (t.options_[e] = t.source_[e])
        }), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio
      }, t.src = function (e, t) {
        var i = this;
        if (e) {
          this.setOptions_(), this.options_.src = function (e) {
            return 0 === e.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") ? JSON.parse(e.substring(e.indexOf(",") + 1)) : e
          }(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = xh, this.options_.sourceType = Xa(t), this.options_.seekTo = function (e) {
            i.tech_.setCurrentTime(e)
          }, this.masterPlaylistController_ = new kh(this.options_);
          var n = ya.mergeOptions({
            liveRangeSafeTimeDelta: .1
          }, this.options_, {
            seekable: function () {
              return i.seekable()
            },
            media: function () {
              return i.masterPlaylistController_.media()
            },
            masterPlaylistController: this.masterPlaylistController_
          });
          this.playbackWatcher_ = new Ch(n), this.masterPlaylistController_.on("error", function () {
            var e = ya.players[i.tech_.options_.playerId],
              t = i.masterPlaylistController_.error;
            "object" != typeof t || t.code ? "string" == typeof t && (t = {
              message: t,
              code: 3
            }) : t.code = 3, e.error(t)
          });
          var r = this.options_.experimentalBufferBasedABR ? xh.movingAverageBandwidthSelector(.55) : xh.STANDARD_PLAYLIST_SELECTOR;
          this.masterPlaylistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : r.bind(this), this.masterPlaylistController_.selectInitialPlaylist = xh.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.masterPlaylistController_.masterPlaylistLoader_, this.mediaSource = this.masterPlaylistController_.mediaSource, Object.defineProperties(this, {
            selectPlaylist: {
              get: function () {
                return this.masterPlaylistController_.selectPlaylist
              },
              set: function (e) {
                this.masterPlaylistController_.selectPlaylist = e.bind(this)
              }
            },
            throughput: {
              get: function () {
                return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate
              },
              set: function (e) {
                this.masterPlaylistController_.mainSegmentLoader_.throughput.rate = e, this.masterPlaylistController_.mainSegmentLoader_.throughput.count = 1
              }
            },
            bandwidth: {
              get: function () {
                return this.masterPlaylistController_.mainSegmentLoader_.bandwidth
              },
              set: function (e) {
                this.masterPlaylistController_.mainSegmentLoader_.bandwidth = e, this.masterPlaylistController_.mainSegmentLoader_.throughput = {
                  rate: 0,
                  count: 0
                }
              }
            },
            systemBandwidth: {
              get: function () {
                var e, t = 1 / (this.bandwidth || 1);
                return e = 0 < this.throughput ? 1 / this.throughput : 0, Math.floor(1 / (t + e))
              },
              set: function () {
                ya.log.error('The "systemBandwidth" property is read-only')
              }
            }
          }), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
            bandwidth: {
              get: function () {
                return i.bandwidth || 0
              },
              enumerable: !0
            },
            mediaRequests: {
              get: function () {
                return i.masterPlaylistController_.mediaRequests_() || 0
              },
              enumerable: !0
            },
            mediaRequestsAborted: {
              get: function () {
                return i.masterPlaylistController_.mediaRequestsAborted_() || 0
              },
              enumerable: !0
            },
            mediaRequestsTimedout: {
              get: function () {
                return i.masterPlaylistController_.mediaRequestsTimedout_() || 0
              },
              enumerable: !0
            },
            mediaRequestsErrored: {
              get: function () {
                return i.masterPlaylistController_.mediaRequestsErrored_() || 0
              },
              enumerable: !0
            },
            mediaTransferDuration: {
              get: function () {
                return i.masterPlaylistController_.mediaTransferDuration_() || 0
              },
              enumerable: !0
            },
            mediaBytesTransferred: {
              get: function () {
                return i.masterPlaylistController_.mediaBytesTransferred_() || 0
              },
              enumerable: !0
            },
            mediaSecondsLoaded: {
              get: function () {
                return i.masterPlaylistController_.mediaSecondsLoaded_() || 0
              },
              enumerable: !0
            },
            buffered: {
              get: function () {
                return nc(i.tech_.buffered())
              },
              enumerable: !0
            },
            currentTime: {
              get: function () {
                return i.tech_.currentTime()
              },
              enumerable: !0
            },
            currentSource: {
              get: function () {
                return i.tech_.currentSource_
              },
              enumerable: !0
            },
            currentTech: {
              get: function () {
                return i.tech_.name_
              },
              enumerable: !0
            },
            duration: {
              get: function () {
                return i.tech_.duration()
              },
              enumerable: !0
            },
            master: {
              get: function () {
                return i.playlists.master
              },
              enumerable: !0
            },
            playerDimensions: {
              get: function () {
                return i.tech_.currentDimensions()
              },
              enumerable: !0
            },
            seekable: {
              get: function () {
                return nc(i.tech_.seekable())
              },
              enumerable: !0
            },
            timestamp: {
              get: function () {
                return Date.now()
              },
              enumerable: !0
            },
            videoPlaybackQuality: {
              get: function () {
                return i.tech_.getVideoPlaybackQuality()
              },
              enumerable: !0
            }
          }), this.tech_.one("canplay", this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_)), this.tech_.on("bandwidthupdate", function () {
            i.options_.useBandwidthFromLocalStorage && function (e) {
              if (!Ia.localStorage) return;
              var t = Dh();
              t = t ? ya.mergeOptions(t, e) : e;
              try {
                Ia.localStorage.setItem(Ph, JSON.stringify(t))
              } catch (e) {
                return
              }
            }({
              bandwidth: i.bandwidth,
              throughput: Math.round(i.throughput)
            })
          }), this.masterPlaylistController_.on("selectedinitialmedia", function () {
            ! function (i) {
              i.representations = function () {
                var e = i.masterPlaylistController_.master(),
                  t = gc(e) ? i.masterPlaylistController_.getAudioTrackPlaylists_() : e.playlists;
                return t ? t.filter(function (e) {
                  return !cc(e)
                }).map(function (e, t) {
                  return new Jd(i, e, e.id)
                }) : []
              }
            }(i)
          }), this.masterPlaylistController_.sourceUpdater_.on("createdsourcebuffers", function () {
            i.setupEme_()
          }), this.on(this.masterPlaylistController_, "progress", function () {
            this.tech_.trigger("progress")
          }), this.on(this.masterPlaylistController_, "firstplay", function () {
            this.ignoreNextSeekingEvent_ = !0
          }), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = Ia.URL.createObjectURL(this.masterPlaylistController_.mediaSource), this.tech_.src(this.mediaSourceUrl_))
        }
      }, t.setupEme_ = function () {
        var t = this,
          e = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader,
          i = Oh({
            player: this.player_,
            sourceKeySystems: this.source_.keySystems,
            media: this.playlists.media(),
            audioMedia: e && e.media()
          });
        11 !== ya.browser.IE_VERSION && i ? (this.logger_("waiting for EME key session creation"), Lh({
          player: this.player_,
          sourceKeySystems: this.source_.keySystems,
          audioMedia: e && e.media(),
          mainPlaylists: this.playlists.master.playlists
        }).then(function () {
          t.logger_("created EME key session"), t.masterPlaylistController_.sourceUpdater_.initializedEme()
        }).catch(function (e) {
          t.logger_("error while creating EME key session", e), t.player_.error({
            message: "Failed to initialize media keys for EME",
            code: 3
          })
        })) : this.masterPlaylistController_.sourceUpdater_.initializedEme()
      }, t.setupQualityLevels_ = function () {
        var e = this,
          t = ya.players[this.tech_.options_.playerId];
        t && t.qualityLevels && !this.qualityLevels_ && (this.qualityLevels_ = t.qualityLevels(), this.masterPlaylistController_.on("selectedinitialmedia", function () {
          ! function (t, e) {
            e.representations().forEach(function (e) {
              t.addQualityLevel(e)
            }), Ah(t, e.playlists)
          }(e.qualityLevels_, e)
        }), this.playlists.on("mediachange", function () {
          Ah(e.qualityLevels_, e.playlists)
        }))
      }, e.version = function () {
        return {
          "@videojs/http-streaming": "2.7.1",
          "mux.js": "5.11.0",
          "mpd-parser": "0.16.0",
          "m3u8-parser": "4.6.0",
          "aes-decrypter": "3.1.2"
        }
      }, t.version = function () {
        return this.constructor.version()
      }, t.canChangeType = function () {
        return hh.canChangeType()
      }, t.play = function () {
        this.masterPlaylistController_.play()
      }, t.setCurrentTime = function (e) {
        this.masterPlaylistController_.setCurrentTime(e)
      }, t.duration = function () {
        return this.masterPlaylistController_.duration()
      }, t.seekable = function () {
        return this.masterPlaylistController_.seekable()
      }, t.dispose = function () {
        this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.masterPlaylistController_ && this.masterPlaylistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.player_ && (delete this.player_.vhs, delete this.player_.dash, delete this.player_.hls), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.tech_ && delete this.tech_.hls, this.mediaSourceUrl_ && Ia.URL.revokeObjectURL && (Ia.URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), a.prototype.dispose.call(this)
      }, t.convertToProgramTime = function (e, t) {
        return Cc({
          playlist: this.masterPlaylistController_.media(),
          time: e,
          callback: t
        })
      }, t.seekToProgramTime = function (e, t, i, n) {
        return void 0 === i && (i = !0), void 0 === n && (n = 2), Ic({
          programTime: e,
          playlist: this.masterPlaylistController_.media(),
          retryCount: n,
          pauseAfterSeek: i,
          seekTo: this.options_.seekTo,
          tech: this.options_.tech,
          callback: t
        })
      }, e
    }(ya.getComponent("Component")),
    Mh = {
      name: "videojs-http-streaming",
      VERSION: "2.7.1",
      canHandleSource: function (e, t) {
        void 0 === t && (t = {});
        var i = ya.mergeOptions(ya.options, t);
        return Mh.canPlayType(e.type, i)
      },
      handleSource: function (e, t, i) {
        void 0 === i && (i = {});
        var n = ya.mergeOptions(ya.options, i);
        return t.vhs = new Rh(e, t, n), ya.hasOwnProperty("hls") || Object.defineProperty(t, "hls", {
          get: function () {
            return ya.log.warn("player.tech().hls is deprecated. Use player.tech().vhs instead."), t.vhs
          },
          configurable: !0
        }), t.vhs.xhr = yc(), t.vhs.src(e.src, e.type), t.vhs
      },
      canPlayType: function (e, t) {
        void 0 === t && (t = {});
        var i = ya.mergeOptions(ya.options, t).vhs.overrideNative,
          n = void 0 === i ? !ya.browser.IS_ANY_SAFARI : i,
          r = Xa(e);
        return r && (!xh.supportsTypeNatively(r) || n) ? "maybe" : ""
      }
    };
  return za("avc1.4d400d,mp4a.40.2") && ya.getTech("Html5").registerSourceHandler(Mh, 0), ya.VhsHandler = Rh, Object.defineProperty(ya, "HlsHandler", {
    get: function () {
      return ya.log.warn("videojs.HlsHandler is deprecated. Use videojs.VhsHandler instead."), Rh
    },
    configurable: !0
  }), ya.VhsSourceHandler = Mh, Object.defineProperty(ya, "HlsSourceHandler", {
    get: function () {
      return ya.log.warn("videojs.HlsSourceHandler is deprecated. Use videojs.VhsSourceHandler instead."), Mh
    },
    configurable: !0
  }), ya.Vhs = xh, Object.defineProperty(ya, "Hls", {
    get: function () {
      return ya.log.warn("videojs.Hls is deprecated. Use videojs.Vhs instead."), xh
    },
    configurable: !0
  }), ya.use || (ya.registerComponent("Hls", xh), ya.registerComponent("Vhs", xh)), ya.options.vhs = ya.options.vhs || {}, ya.options.hls = ya.options.hls || {}, ya.registerPlugin ? ya.registerPlugin("reloadSourceOnError", Zd) : ya.plugin("reloadSourceOnError", Zd), ya
});
